import {
  Faction,
  Item,
  ItemSet,
  ItemSlot,
  ItemSourceName,
  Quality,
  SocketColor,
  Stat,
} from '../Types'

export const Items: Item[] = [
  {
    IconName: 'inv_pants_cloth_14',
    Stats: {
      [Stat.Stamina]: 42,
      [Stat.Intellect]: 68,
      [Stat.Spirit]: 59,
      [Stat.SpellPower]: 61,
    },
    Quality: Quality.Rare,
    Name: 'Leggings of Burning Gleam',
    Id: 35673,
    Phase: 1,
    ItemSlot: ItemSlot.Legs,
  },
  {
    IconName: 'inv_helmet_125',
    Stats: {
      [Stat.Stamina]: 57,
      [Stat.Intellect]: 68,
      [Stat.SpellPower]: 61,
      [Stat.CritRating]: 53,
    },
    Quality: Quality.Rare,
    Name: 'Static Cowl',
    Sources: [ItemSourceName.HallsOfStone],
    Id: 35679,
    Phase: 1,
    ItemSlot: ItemSlot.Head,
  },
  {
    IconName: 'inv_bracer_08',
    Stats: {
      [Stat.Stamina]: 33,
      [Stat.Intellect]: 40,
      [Stat.Spirit]: 25,
      [Stat.SpellPower]: 33,
    },
    Quality: Quality.Rare,
    Name: 'Rune Giant Bindings',
    Id: 35682,
    Phase: 1,
    ItemSlot: ItemSlot.Wrist,
  },
  {
    IconName: 'inv_jewelry_necklace_28naxxramas',
    Stats: {
      [Stat.Stamina]: 27,
      [Stat.Intellect]: 29,
      [Stat.Spirit]: 37,
      [Stat.SpellPower]: 44,
    },
    Quality: Quality.Rare,
    Name: 'Timeless Beads of Eternos',
    Sources: [ItemSourceName.Oculus],
    Id: 36943,
    Phase: 1,
    ItemSlot: ItemSlot.Neck,
  },
  {
    IconName: 'inv_bracer_08',
    Stats: {
      [Stat.Stamina]: 19,
      [Stat.Intellect]: 30,
      [Stat.Spirit]: 29,
      [Stat.SpellPower]: 44,
    },
    Quality: Quality.Rare,
    Sockets: [SocketColor.Yellow],
    SocketBonus: {
      [Stat.Spirit]: 4,
    },
    Name: "Verdisa's Cuffs of Dreaming",
    Id: 36945,
    Phase: 1,
    ItemSlot: ItemSlot.Wrist,
  },
  {
    IconName: 'inv_gauntlets_17',
    Stats: {
      [Stat.Stamina]: 37,
      [Stat.Intellect]: 51,
      [Stat.Spirit]: 40,
      [Stat.SpellPower]: 60,
    },
    Quality: Quality.Rare,
    Name: 'Gloves of the Azure-Lord',
    Id: 36949,
    Phase: 1,
    ItemSlot: ItemSlot.Hands,
  },
  {
    IconName: 'inv_boots_cloth_18',
    Stats: {
      [Stat.Stamina]: 37,
      [Stat.Intellect]: 40,
      [Stat.SpellPower]: 60,
      [Stat.HasteRating]: 54,
    },
    Quality: Quality.Rare,
    Name: "The Conjurer's Slippers",
    Id: 36954,
    Phase: 1,
    ItemSlot: ItemSlot.Feet,
  },
  {
    IconName: 'inv_misc_book_07',
    Stats: {
      [Stat.SpellPower]: 68,
    },
    Quality: Quality.Rare,
    Unique: true,
    Name: 'Tome of Arcane Phenomena',
    Id: 36972,
    Phase: 1,
    ItemSlot: ItemSlot.Trinket,
  },
  {
    IconName: 'inv_chest_cloth_39',
    Stats: {
      [Stat.Stamina]: 51,
      [Stat.Intellect]: 52,
      [Stat.SpellPower]: 81,
      [Stat.CritRating]: 69,
    },
    Quality: Quality.Rare,
    Name: 'Vestments of the Scholar',
    Id: 36973,
    Phase: 1,
    ItemSlot: ItemSlot.Chest,
  },
  {
    IconName: 'inv_staff_69',
    Stats: {
      [Stat.Stamina]: 61,
      [Stat.Intellect]: 55,
      [Stat.Spirit]: 95,
      [Stat.SpellPower]: 314,
    },
    Quality: Quality.Rare,
    Name: "Malygos' Favor",
    Id: 36975,
    Phase: 1,
    ItemSlot: ItemSlot.Weapon,
    IsTwoHand: true,
    Sources: [ItemSourceName.Oculus],
  },
  {
    IconName: 'inv_pants_cloth_22',
    Stats: {
      [Stat.Stamina]: 51,
      [Stat.Intellect]: 68,
      [Stat.Spirit]: 53,
      [Stat.SpellPower]: 80,
    },
    Quality: Quality.Rare,
    Name: "Ring-Lord's Leggings",
    Id: 36976,
    Phase: 1,
    ItemSlot: ItemSlot.Legs,
  },
  {
    IconName: 'inv_shoulder_79',
    Stats: {
      [Stat.Stamina]: 37,
      [Stat.Intellect]: 40,
      [Stat.Spirit]: 51,
      [Stat.SpellPower]: 60,
    },
    Quality: Quality.Rare,
    Name: 'Mantle of Electrical Charges',
    Id: 36982,
    Phase: 1,
    ItemSlot: ItemSlot.Shoulders,
  },
  {
    IconName: 'inv_misc_cape_20',
    Stats: {
      [Stat.Stamina]: 28,
      [Stat.Intellect]: 38,
      [Stat.SpellPower]: 46,
      [Stat.HitRating]: 29,
    },
    Quality: Quality.Rare,
    Name: 'Cape of Seething Steam',
    Id: 36983,
    Phase: 1,
    ItemSlot: ItemSlot.Back,
  },
  {
    IconName: 'inv_helmet_107',
    Stats: {
      [Stat.Stamina]: 51,
      [Stat.Intellect]: 68,
      [Stat.SpellPower]: 81,
      [Stat.HasteRating]: 53,
    },
    Quality: Quality.Rare,
    Name: "Volkhan's Hood",
    Sources: [ItemSourceName.HallsOfLightning],
    Id: 36985,
    Phase: 1,
    ItemSlot: ItemSlot.Head,
  },
  {
    IconName: 'inv_jewelry_necklace_31',
    Stats: {
      [Stat.Stamina]: 28,
      [Stat.Intellect]: 29,
      [Stat.Spirit]: 38,
      [Stat.SpellPower]: 46,
    },
    Quality: Quality.Rare,
    Name: 'Chaotic Spiral Amulet',
    Sources: [ItemSourceName.HallsOfLightning],
    Id: 36988,
    Phase: 1,
    ItemSlot: ItemSlot.Neck,
  },
  {
    IconName: 'inv_torch_unlit',
    Stats: {
      [Stat.Stamina]: 15,
      [Stat.Intellect]: 21,
      [Stat.Spirit]: 12,
      [Stat.SpellPower]: 26,
      [Stat.HitRating]: 11,
    },
    Quality: Quality.Rare,
    Name: 'Ancient Measuring Rod',
    Id: 36989,
    Phase: 1,
    ItemSlot: ItemSlot.Wand,
  },
  {
    IconName: 'inv_chest_cloth_63',
    Stats: {
      [Stat.Stamina]: 51,
      [Stat.Intellect]: 52,
      [Stat.Spirit]: 59,
      [Stat.SpellPower]: 81,
    },
    Quality: Quality.Rare,
    Sockets: [SocketColor.Yellow],
    SocketBonus: {
      [Stat.Stamina]: 6,
    },
    Name: 'Raiments of the Titans',
    Id: 36991,
    Phase: 1,
    ItemSlot: ItemSlot.Chest,
  },
  {
    IconName: 'inv_belt_07',
    Stats: {
      [Stat.Stamina]: 33,
      [Stat.Intellect]: 27,
      [Stat.SpellPower]: 44,
      [Stat.Mp5]: 19,
    },
    Quality: Quality.Rare,
    Name: 'Sash of the Hardened Watcher',
    Id: 36997,
    Phase: 1,
    ItemSlot: ItemSlot.Waist,
  },
  {
    IconName: 'inv_wand_17',
    Stats: {
      [Stat.Stamina]: 15,
      [Stat.Intellect]: 17,
      [Stat.Spirit]: 21,
      [Stat.SpellPower]: 26,
    },
    Quality: Quality.Rare,
    Name: 'Brazier Igniter',
    Id: 37038,
    Phase: 1,
    ItemSlot: ItemSlot.Wand,
  },
  {
    IconName: 'inv_misc_cape_06',
    Stats: {
      [Stat.Stamina]: 28,
      [Stat.Intellect]: 29,
      [Stat.SpellPower]: 44,
      [Stat.Mp5]: 19,
    },
    Quality: Quality.Rare,
    Name: 'Shroud of Resurrection',
    Id: 37048,
    Phase: 1,
    ItemSlot: ItemSlot.Back,
  },
  {
    IconName: 'inv_staff_24',
    Stats: {
      [Stat.Stamina]: 16,
      [Stat.Intellect]: 35,
      [Stat.SpellPower]: 44,
      [Stat.HasteRating]: 38,
    },
    Quality: Quality.Rare,
    Name: 'Seal of Valgarde',
    Sources: [ItemSourceName.UtgardePinnacle],
    Id: 37051,
    Phase: 1,
    ItemSlot: ItemSlot.OffHand,
  },
  {
    IconName: 'inv_shoulder_72',
    Stats: {
      [Stat.Stamina]: 37,
      [Stat.Intellect]: 40,
      [Stat.Spirit]: 51,
      [Stat.SpellPower]: 60,
    },
    Quality: Quality.Rare,
    Name: 'Silken Amice of the Ymirjar',
    Id: 37055,
    Phase: 1,
    ItemSlot: ItemSlot.Shoulders,
  },
  {
    IconName: 'inv_jewelry_ring_62',
    Stats: {
      [Stat.Stamina]: 28,
      [Stat.Intellect]: 29,
      [Stat.SpellPower]: 46,
      [Stat.HasteRating]: 38,
    },
    Quality: Quality.Rare,
    Unique: true,
    Name: 'Signet of Ranulf',
    Id: 37058,
    Phase: 1,
    ItemSlot: ItemSlot.Finger,
  },
  {
    IconName: 'inv_sword_91',
    Stats: {
      [Stat.Stamina]: 21,
      [Stat.Intellect]: 29,
      [Stat.Spirit]: 23,
      [Stat.SpellPower]: 314,
      [Stat.CritRating]: 30,
    },
    Quality: Quality.Rare,
    Name: 'Jeweled Coronation Sword',
    Sources: [ItemSourceName.UtgardePinnacle],
    Id: 37060,
    Phase: 1,
    ItemSlot: ItemSlot.Weapon,
  },
  {
    IconName: 'inv_jewelry_ring_07',
    Stats: {
      [Stat.Stamina]: 33,
      [Stat.Intellect]: 27,
      [Stat.Spirit]: 38,
      [Stat.SpellPower]: 46,
    },
    Quality: Quality.Rare,
    Unique: true,
    Name: 'Enchanted Wire Stitching',
    Id: 37079,
    Phase: 1,
    ItemSlot: ItemSlot.Finger,
  },
  {
    IconName: 'inv_misc_book_11',
    Stats: {
      [Stat.Stamina]: 28,
      [Stat.Intellect]: 21,
      [Stat.Spirit]: 19,
      [Stat.SpellPower]: 46,
      [Stat.CritRating]: 38,
    },
    Quality: Quality.Rare,
    Name: 'Tome of Salramm',
    Sources: [ItemSourceName.CullingOfStratholme],
    Id: 37086,
    Phase: 1,
    ItemSlot: ItemSlot.OffHand,
  },
  {
    IconName: 'inv_staff_71',
    Stats: {
      [Stat.Stamina]: 51,
      [Stat.Intellect]: 68,
      [Stat.Spirit]: 53,
      [Stat.SpellPower]: 314,
      [Stat.CritRating]: 68,
    },
    Quality: Quality.Rare,
    Name: 'Sempiternal Staff',
    Sources: [ItemSourceName.CullingOfStratholmeHeroic],
    Id: 37099,
    Phase: 1,
    ItemSlot: ItemSlot.Weapon,
    IsTwoHand: true,
  },
  {
    IconName: 'inv_bracer_08',
    Stats: {
      [Stat.Stamina]: 27,
      [Stat.Intellect]: 34,
      [Stat.Spirit]: 38,
      [Stat.SpellPower]: 44,
    },
    Quality: Quality.Rare,
    Name: 'Demonic Fabric Bands',
    Id: 37113,
    Phase: 1,
    ItemSlot: ItemSlot.Wrist,
  },
  {
    IconName: 'inv_misc_book_06',
    Stats: {
      [Stat.Stamina]: 24,
      [Stat.Intellect]: 43,
      [Stat.SpellPower]: 50,
      [Stat.HitRating]: 39,
    },
    Quality: Quality.Rare,
    Name: "Telestra's Journal",
    Sources: [ItemSourceName.NexusHeroic],
    Id: 37134,
    Phase: 1,
    ItemSlot: ItemSlot.OffHand,
  },
  {
    IconName: 'inv_jewelry_necklace_30naxxramas',
    Stats: {
      [Stat.Stamina]: 51,
      [Stat.Intellect]: 34,
      [Stat.SpellPower]: 50,
      [Stat.Mp5]: 18,
    },
    Quality: Quality.Rare,
    Name: 'Amulet of Dazzling Light',
    Sources: [ItemSourceName.NexusHeroic],
    Id: 37141,
    Phase: 1,
    ItemSlot: ItemSlot.Neck,
  },
  {
    IconName: 'inv_gauntlets_17',
    Stats: {
      [Stat.Stamina]: 43,
      [Stat.Intellect]: 44,
      [Stat.Spirit]: 58,
      [Stat.SpellPower]: 68,
    },
    Quality: Quality.Rare,
    Name: 'Gloves of the Crystal Gardener',
    Id: 37153,
    Phase: 1,
    ItemSlot: ItemSlot.Hands,
  },
  {
    IconName: 'inv_gauntlets_20',
    Stats: {
      [Stat.Stamina]: 49,
      [Stat.Intellect]: 51,
      [Stat.Spirit]: 44,
      [Stat.SpellPower]: 68,
      [Stat.CritRating]: 36,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Red],
    SocketBonus: {
      [Stat.CritRating]: 4,
    },
    Name: 'Gloves of Glistening Runes',
    Id: 37172,
    Phase: 1,
    ItemSlot: ItemSlot.Hands,
  },
  {
    IconName: 'inv_wand_18',
    Stats: {
      [Stat.SpellPower]: 21,
      [Stat.HitRating]: 14,
      [Stat.HasteRating]: 34,
    },
    Quality: Quality.Rare,
    Name: "Wand of the San'layn",
    Id: 37177,
    Phase: 1,
    ItemSlot: ItemSlot.Wand,
  },
  {
    IconName: 'inv_pants_cloth_19',
    Stats: {
      [Stat.Stamina]: 58,
      [Stat.Intellect]: 74,
      [Stat.Spirit]: 52,
      [Stat.SpellPower]: 73,
    },
    Quality: Quality.Rare,
    Sockets: [SocketColor.Red, SocketColor.Blue],
    SocketBonus: {
      [Stat.HasteRating]: 6,
    },
    Name: 'Breeches of the Caller',
    Id: 37189,
    Phase: 1,
    ItemSlot: ItemSlot.Legs,
  },
  {
    IconName: 'inv_jewelry_ring_79',
    Stats: {
      [Stat.Stamina]: 50,
      [Stat.Intellect]: 33,
      [Stat.SpellPower]: 59,
      [Stat.HasteRating]: 49,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: "Annhylde's Ring",
    Id: 37192,
    Phase: 1,
    ItemSlot: ItemSlot.Finger,
  },
  {
    IconName: 'inv_jewelry_ring_56',
    Stats: {
      [Stat.Stamina]: 37,
      [Stat.Intellect]: 31,
      [Stat.SpellPower]: 50,
      [Stat.Mp5]: 21,
    },
    Quality: Quality.Rare,
    Unique: true,
    Name: 'Band of Enchanted Growth',
    Id: 37195,
    Phase: 1,
    ItemSlot: ItemSlot.Finger,
  },
  {
    IconName: 'inv_shoulder_72',
    Stats: {
      [Stat.Stamina]: 43,
      [Stat.Intellect]: 47,
      [Stat.Spirit]: 44,
      [Stat.SpellPower]: 68,
    },
    Quality: Quality.Rare,
    Sockets: [SocketColor.Yellow],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Name: "Runecaster's Mantle",
    Id: 37196,
    Phase: 1,
    ItemSlot: ItemSlot.Shoulders,
  },
  {
    IconName: 'inv_boots_cloth_09',
    Stats: {
      [Stat.Stamina]: 33,
      [Stat.Intellect]: 52,
      [Stat.SpellPower]: 68,
      [Stat.CritRating]: 57,
    },
    Quality: Quality.Rare,
    Name: 'Stone-Worn Footwraps',
    Id: 37218,
    Phase: 1,
    ItemSlot: ItemSlot.Feet,
  },
  {
    IconName: 'inv_chest_cloth_25',
    Stats: {
      [Stat.Stamina]: 60,
      [Stat.Intellect]: 61,
      [Stat.SpellPower]: 73,
      [Stat.HasteRating]: 62,
    },
    Quality: Quality.Rare,
    Sockets: [SocketColor.Red, SocketColor.Yellow],
    SocketBonus: {
      [Stat.Intellect]: 6,
    },
    Name: 'Egg Sac Robes',
    Id: 37222,
    Phase: 1,
    ItemSlot: ItemSlot.Chest,
  },
  {
    IconName: 'inv_jewelry_ring_39',
    Stats: {
      [Stat.Stamina]: 27,
      [Stat.Intellect]: 34,
      [Stat.SpellPower]: 51,
      [Stat.CritRating]: 43,
    },
    Quality: Quality.Rare,
    Unique: true,
    Name: 'Ring of the Traitor King',
    Id: 37232,
    Phase: 1,
    ItemSlot: ItemSlot.Finger,
  },
  {
    IconName: 'inv_wand_06',
    Stats: {
      [Stat.Stamina]: 21,
      [Stat.Intellect]: 21,
      [Stat.SpellPower]: 33,
      [Stat.CritRating]: 27,
    },
    Quality: Quality.Epic,
    Name: 'Rod of the Fallen Monarch',
    Id: 37238,
    Phase: 1,
    ItemSlot: ItemSlot.Wand,
  },
  {
    IconName: 'inv_belt_10',
    Stats: {
      [Stat.Stamina]: 58,
      [Stat.Intellect]: 52,
      [Stat.SpellPower]: 76,
      [Stat.CritRating]: 64,
    },
    Quality: Quality.Epic,
    Name: 'Sash of the Servant',
    Id: 37242,
    Phase: 1,
    ItemSlot: ItemSlot.Waist,
  },
  {
    IconName: 'inv_chest_cloth_28',
    Stats: {
      [Stat.Stamina]: 49,
      [Stat.Intellect]: 69,
      [Stat.SpellPower]: 73,
      [Stat.HasteRating]: 59,
    },
    Quality: Quality.Rare,
    Sockets: [SocketColor.Yellow, SocketColor.Red],
    SocketBonus: {
      [Stat.Intellect]: 6,
    },
    Name: 'Drakewing Raiments',
    Id: 37258,
    Phase: 1,
    ItemSlot: ItemSlot.Chest,
  },
  {
    IconName: 'inv_misc_enggizmos_12',
    Stats: {
      [Stat.HasteRating]: 74,
    },
    Quality: Quality.Rare,
    Unique: true,
    Name: 'Pendulum of Telluric Currents',
    Id: 37264,
    Phase: 1,
    ItemSlot: ItemSlot.Trinket,
  },
  {
    IconName: 'inv_belt_07',
    Stats: {
      [Stat.Stamina]: 43,
      [Stat.Intellect]: 44,
      [Stat.Spirit]: 57,
      [Stat.SpellPower]: 68,
    },
    Quality: Quality.Rare,
    Name: 'Sash of Phantasmal Images',
    Id: 37289,
    Phase: 1,
    ItemSlot: ItemSlot.Waist,
  },
  {
    IconName: 'inv_jewelry_necklace_ahnqiraj_03',
    Stats: {
      [Stat.Stamina]: 31,
      [Stat.Intellect]: 33,
      [Stat.Spirit]: 43,
      [Stat.SpellPower]: 50,
    },
    Quality: Quality.Rare,
    Unique: true,
    Name: 'Dragon Prow Amulet',
    Sources: [ItemSourceName.UtgardeKeepHeroicBoE],
    Id: 37290,
    Phase: 1,
    ItemSlot: ItemSlot.Neck,
  },
  {
    IconName: 'inv_misc_cape_06',
    Stats: {
      [Stat.Stamina]: 42,
      [Stat.Intellect]: 29,
      [Stat.SpellPower]: 51,
      [Stat.HasteRating]: 42,
    },
    Quality: Quality.Rare,
    Name: 'Ancient Dragon Spirit Cape',
    Id: 37291,
    Phase: 1,
    ItemSlot: ItemSlot.Back,
  },
  {
    IconName: 'inv_helmet_107',
    Stats: {
      [Stat.Stamina]: 46,
      [Stat.Intellect]: 62,
      [Stat.Spirit]: 52,
      [Stat.SpellPower]: 81,
    },
    Quality: Quality.Rare,
    Sockets: [SocketColor.Meta, SocketColor.Yellow],
    SocketBonus: {
      [Stat.CritRating]: 8,
    },
    Name: 'Crown of Unbridled Magic',
    Sources: [ItemSourceName.OculusHeroic],
    Id: 37294,
    Phase: 1,
    ItemSlot: ItemSlot.Head,
  },
  {
    IconName: 'inv_staff_83',
    Stats: {
      [Stat.Stamina]: 67,
      [Stat.Intellect]: 90,
      [Stat.Spirit]: 69,
      [Stat.SpellPower]: 408,
      [Stat.HasteRating]: 88,
    },
    Quality: Quality.Epic,
    Name: 'Staff of Draconic Combat',
    Sources: [ItemSourceName.OculusHeroic],
    Id: 37360,
    Phase: 1,
    ItemSlot: ItemSlot.Weapon,
    IsTwoHand: true,
  },
  {
    IconName: 'inv_bracer_07',
    Stats: {
      [Stat.Stamina]: 37,
      [Stat.Intellect]: 38,
      [Stat.Spirit]: 32,
      [Stat.SpellPower]: 59,
      [Stat.HasteRating]: 33,
    },
    Quality: Quality.Epic,
    Name: 'Cuffs of Winged Levitation',
    Id: 37361,
    Phase: 1,
    ItemSlot: ItemSlot.Wrist,
  },
  {
    IconName: 'inv_misc_orb_02',
    Stats: {
      [Stat.Stamina]: 31,
      [Stat.Intellect]: 33,
      [Stat.SpellPower]: 50,
      [Stat.Mp5]: 21,
    },
    Quality: Quality.Rare,
    Name: 'Frostbridge Orb',
    Sources: [ItemSourceName.OculusBoE],
    Id: 37364,
    Phase: 1,
    ItemSlot: ItemSlot.OffHand,
  },
  {
    IconName: 'inv_pants_cloth_10',
    Stats: {
      [Stat.Stamina]: 66,
      [Stat.Intellect]: 71,
      [Stat.SpellPower]: 82,
      [Stat.CritRating]: 59,
    },
    Quality: Quality.Rare,
    Sockets: [SocketColor.Red],
    SocketBonus: {
      [Stat.CritRating]: 4,
    },
    Name: "Sorrowgrave's Breeches",
    Id: 37369,
    Phase: 1,
    ItemSlot: ItemSlot.Legs,
  },
  {
    IconName: 'inv_bracer_04',
    Stats: {
      [Stat.Stamina]: 37,
      [Stat.Intellect]: 31,
      [Stat.Spirit]: 43,
      [Stat.SpellPower]: 50,
    },
    Quality: Quality.Rare,
    Name: 'Cuffs of the Trussed Hall',
    Id: 37370,
    Phase: 1,
    ItemSlot: ItemSlot.Wrist,
  },
  {
    IconName: 'inv_jewelry_ring_19',
    Stats: {
      [Stat.Stamina]: 42,
      [Stat.Intellect]: 28,
      [Stat.SpellPower]: 51,
      [Stat.HasteRating]: 43,
    },
    Quality: Quality.Rare,
    Unique: true,
    Name: 'Ring of the Frenzied Wolvar',
    Id: 37371,
    Phase: 1,
    ItemSlot: ItemSlot.Finger,
  },
  {
    IconName: 'inv_sword_91',
    Stats: {
      [Stat.Stamina]: 24,
      [Stat.Intellect]: 32,
      [Stat.Spirit]: 26,
      [Stat.SpellPower]: 355,
      [Stat.CritRating]: 34,
    },
    Quality: Quality.Rare,
    Name: 'Netherbreath Spellblade',
    Sources: [ItemSourceName.UtgardePinnacleHeroic],
    Id: 37377,
    Phase: 1,
    ItemSlot: ItemSlot.Weapon,
  },
  {
    IconName: 'inv_staff_69',
    Stats: {
      [Stat.Stamina]: 67,
      [Stat.Intellect]: 77,
      [Stat.Spirit]: 56,
      [Stat.SpellPower]: 355,
      [Stat.HasteRating]: 78,
    },
    Quality: Quality.Rare,
    Name: 'Staff of Wayward Principles',
    Sources: [ItemSourceName.UtgardePinnacleHeroic],
    Id: 37384,
    Phase: 1,
    ItemSlot: ItemSlot.Weapon,
    IsTwoHand: true,
  },
  {
    IconName: 'inv_belt_10',
    Stats: {
      [Stat.Stamina]: 49,
      [Stat.Intellect]: 51,
      [Stat.Spirit]: 38,
      [Stat.SpellPower]: 77,
      [Stat.HitRating]: 48,
    },
    Quality: Quality.Epic,
    Name: 'Girdle of Bane',
    Id: 37408,
    Phase: 1,
    ItemSlot: ItemSlot.Waist,
  },
  {
    IconName: 'inv_helmet_124',
    Stats: {
      [Stat.Stamina]: 58,
      [Stat.Intellect]: 77,
      [Stat.Spirit]: 55,
      [Stat.SpellPower]: 91,
    },
    Quality: Quality.Rare,
    Name: 'Elder Headpiece',
    Sources: [ItemSourceName.AhnkahetTheOldKingdomHeroic],
    Id: 37594,
    Phase: 1,
    ItemSlot: ItemSlot.Head,
  },
  {
    IconName: 'inv_jewelry_necklace_17',
    Stats: {
      [Stat.Stamina]: 43,
      [Stat.Intellect]: 28,
      [Stat.SpellPower]: 50,
      [Stat.HitRating]: 43,
    },
    Quality: Quality.Rare,
    Name: 'Necklace of Taldaram',
    Sources: [ItemSourceName.AhnkahetTheOldKingdomHeroic],
    Id: 37595,
    Phase: 1,
    ItemSlot: ItemSlot.Neck,
  },
  {
    IconName: 'inv_bracer_13',
    Stats: {
      [Stat.Stamina]: 37,
      [Stat.Intellect]: 45,
      [Stat.SpellPower]: 51,
      [Stat.Mp5]: 15,
    },
    Quality: Quality.Rare,
    Name: 'Flame Sphere Bindings',
    Id: 37613,
    Phase: 1,
    ItemSlot: ItemSlot.Wrist,
  },
  {
    IconName: 'inv_staff_37',
    Stats: {
      [Stat.Stamina]: 76,
      [Stat.Intellect]: 77,
      [Stat.Spirit]: 51,
      [Stat.SpellPower]: 355,
      [Stat.HasteRating]: 78,
    },
    Quality: Quality.Rare,
    Name: 'Staff of Sinister Claws',
    Sources: [ItemSourceName.AhnkahetTheOldKingdomHeroic],
    Id: 37617,
    Phase: 1,
    ItemSlot: ItemSlot.Weapon,
    IsTwoHand: true,
  },
  {
    IconName: 'inv_wand_07',
    Stats: {
      [Stat.Stamina]: 24,
      [Stat.Intellect]: 20,
      [Stat.Spirit]: 27,
      [Stat.SpellPower]: 33,
    },
    Quality: Quality.Epic,
    Name: "Wand of Ahn'kahet",
    Id: 37619,
    Phase: 1,
    ItemSlot: ItemSlot.Wand,
  },
  {
    IconName: 'inv_pants_cloth_06',
    Stats: {
      [Stat.Stamina]: 67,
      [Stat.Intellect]: 68,
      [Stat.SpellPower]: 104,
      [Stat.Mp5]: 45,
    },
    Quality: Quality.Epic,
    Name: 'Skirt of the Old Kingdom',
    Id: 37622,
    Phase: 1,
    ItemSlot: ItemSlot.Legs,
  },
  {
    IconName: 'inv_wand_22',
    Stats: {
      [Stat.Stamina]: 18,
      [Stat.Intellect]: 18,
      [Stat.Spirit]: 24,
      [Stat.SpellPower]: 28,
    },
    Quality: Quality.Rare,
    Name: 'Wand of Sseratus',
    Id: 37626,
    Phase: 1,
    ItemSlot: ItemSlot.Wand,
  },
  {
    IconName: 'inv_boots_cloth_15',
    Stats: {
      [Stat.Stamina]: 43,
      [Stat.Intellect]: 44,
      [Stat.SpellPower]: 68,
      [Stat.CritRating]: 57,
    },
    Quality: Quality.Rare,
    Name: 'Slithering Slippers',
    Id: 37629,
    Phase: 1,
    ItemSlot: ItemSlot.Feet,
  },
  {
    IconName: 'inv_misc_cape_19',
    Stats: {
      [Stat.Stamina]: 31,
      [Stat.Intellect]: 43,
      [Stat.Spirit]: 32,
      [Stat.SpellPower]: 51,
    },
    Quality: Quality.Rare,
    Name: 'Shroud of Moorabi',
    Id: 37630,
    Phase: 1,
    ItemSlot: ItemSlot.Back,
  },
  {
    IconName: 'inv_belt_14',
    Stats: {
      [Stat.Stamina]: 45,
      [Stat.Intellect]: 54,
      [Stat.SpellPower]: 59,
      [Stat.CritRating]: 42,
    },
    Quality: Quality.Rare,
    Sockets: [SocketColor.Red],
    SocketBonus: {
      [Stat.CritRating]: 4,
    },
    Name: 'Living Mojo Belt',
    Id: 37637,
    Phase: 1,
    ItemSlot: ItemSlot.Waist,
  },
  {
    IconName: 'inv_chest_cloth_71',
    Stats: {
      [Stat.Stamina]: 58,
      [Stat.Intellect]: 77,
      [Stat.SpellPower]: 91,
      [Stat.CritRating]: 60,
    },
    Quality: Quality.Rare,
    Name: 'Arcane Flame Altar-Garb',
    Id: 37641,
    Phase: 1,
    ItemSlot: ItemSlot.Chest,
  },
  {
    IconName: 'inv_jewelry_ring_42',
    Stats: {
      [Stat.Stamina]: 27,
      [Stat.Intellect]: 29,
      [Stat.HitRating]: 51,
      [Stat.HasteRating]: 43,
    },
    Quality: Quality.Rare,
    Unique: true,
    Name: "The Prospector's Prize",
    Id: 37651,
    Phase: 1,
    ItemSlot: ItemSlot.Finger,
  },
  {
    IconName: 'inv_shoulder_80',
    Stats: {
      [Stat.Stamina]: 45,
      [Stat.Intellect]: 59,
      [Stat.SpellPower]: 68,
      [Stat.HasteRating]: 42,
    },
    Quality: Quality.Rare,
    Name: 'Mantle of the Tribunal',
    Id: 37655,
    Phase: 1,
    ItemSlot: ItemSlot.Shoulders,
  },
  {
    IconName: 'inv_misc_enggizmos_06',
    Stats: {
      [Stat.HasteRating]: 73,
    },
    Quality: Quality.Rare,
    Unique: true,
    Name: 'Spark of Life',
    Id: 37657,
    Phase: 1,
    ItemSlot: ItemSlot.Trinket,
  },
  {
    IconName: 'spell_fire_fire',
    Stats: {
      [Stat.CritRating]: 73,
    },
    Quality: Quality.Rare,
    Unique: true,
    Name: 'Forge Ember',
    Id: 37660,
    Phase: 1,
    ItemSlot: ItemSlot.Trinket,
  },
  {
    IconName: 'inv_shoulder_72',
    Stats: {
      [Stat.Stamina]: 42,
      [Stat.Intellect]: 44,
      [Stat.SpellPower]: 59,
      [Stat.HasteRating]: 50,
    },
    Quality: Quality.Rare,
    Sockets: [SocketColor.Red],
    SocketBonus: {
      [Stat.Spirit]: 4,
    },
    Name: 'Dark Runic Mantle',
    Id: 37673,
    Phase: 1,
    ItemSlot: ItemSlot.Shoulders,
  },
  {
    IconName: 'inv_belt_30',
    Stats: {
      [Stat.Stamina]: 49,
      [Stat.Intellect]: 51,
      [Stat.SpellPower]: 68,
      [Stat.HitRating]: 42,
    },
    Quality: Quality.Rare,
    Name: 'Belt of Unified Souls',
    Id: 37680,
    Phase: 1,
    ItemSlot: ItemSlot.Waist,
  },
  {
    IconName: 'inv_jewelry_necklace_04',
    Stats: {
      [Stat.Stamina]: 24,
      [Stat.Intellect]: 41,
      [Stat.Spirit]: 42,
      [Stat.SpellPower]: 50,
    },
    Quality: Quality.Rare,
    Name: "Necromancer's Amulet",
    Sources: [ItemSourceName.CullingOfStratholmeHeroic],
    Id: 37683,
    Phase: 1,
    ItemSlot: ItemSlot.Neck,
  },
  {
    IconName: 'inv_helmet_107',
    Stats: {
      [Stat.Stamina]: 54,
      [Stat.Intellect]: 44,
      [Stat.Spirit]: 66,
      [Stat.SpellPower]: 82,
    },
    Quality: Quality.Rare,
    Sockets: [SocketColor.Meta, SocketColor.Blue],
    SocketBonus: {
      [Stat.HasteRating]: 8,
    },
    Name: 'Forgotten Shadow Hood',
    Sources: [ItemSourceName.CullingOfStratholmeHeroic],
    Id: 37684,
    Phase: 1,
    ItemSlot: ItemSlot.Head,
  },
  {
    IconName: 'inv_gauntlets_16',
    Stats: {
      [Stat.Stamina]: 42,
      [Stat.Intellect]: 44,
      [Stat.Spirit]: 53,
      [Stat.SpellPower]: 59,
    },
    Quality: Quality.Rare,
    Sockets: [SocketColor.Yellow],
    SocketBonus: {
      [Stat.Stamina]: 6,
    },
    Name: 'Gloves of Distorted Time',
    Id: 37687,
    Phase: 1,
    ItemSlot: ItemSlot.Hands,
  },
  {
    IconName: 'inv_shoulder_72',
    Stats: {
      [Stat.Stamina]: 57,
      [Stat.Intellect]: 54,
      [Stat.Spirit]: 42,
      [Stat.SpellPower]: 68,
    },
    Quality: Quality.Rare,
    Name: 'Mantle of Deceit',
    Id: 37691,
    Phase: 1,
    ItemSlot: ItemSlot.Shoulders,
  },
  {
    IconName: 'inv_jewelry_ring_ahnqiraj_06',
    Stats: {
      [Stat.Stamina]: 49,
      [Stat.Intellect]: 34,
      [Stat.SpellPower]: 59,
      [Stat.HasteRating]: 50,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: 'Band of Guile',
    Id: 37694,
    Phase: 1,
    ItemSlot: ItemSlot.Finger,
  },
  {
    IconName: 'inv_helmet_107',
    Stats: {
      [Stat.Stamina]: 67,
      [Stat.Intellect]: 55,
      [Stat.Spirit]: 78,
      [Stat.SpellPower]: 91,
    },
    Quality: Quality.Rare,
    Name: 'Cowl of the Dire Troll',
    Sources: [ItemSourceName.DrakTharonKeepHeroic],
    Id: 37715,
    Phase: 1,
    ItemSlot: ItemSlot.Head,
  },
  {
    IconName: 'inv_datacrystal01',
    Stats: {
      [Stat.Stamina]: 37,
      [Stat.Intellect]: 31,
      [Stat.SpellPower]: 51,
      [Stat.HasteRating]: 42,
    },
    Quality: Quality.Rare,
    Name: 'Temple Crystal Fragment',
    Sources: [ItemSourceName.DrakTharonKeepHeroic],
    Id: 37718,
    Phase: 1,
    ItemSlot: ItemSlot.OffHand,
  },
  {
    IconName: 'inv_sword_91',
    Stats: {
      [Stat.Stamina]: 28,
      [Stat.Intellect]: 32,
      [Stat.Spirit]: 24,
      [Stat.SpellPower]: 355,
      [Stat.HitRating]: 34,
    },
    Quality: Quality.Rare,
    Name: 'Cursed Lich Blade',
    Sources: [ItemSourceName.DrakTharonKeepHeroic],
    Id: 37721,
    Phase: 1,
    ItemSlot: ItemSlot.Weapon,
  },
  {
    IconName: 'inv_bracer_08',
    Stats: {
      [Stat.Stamina]: 31,
      [Stat.Intellect]: 32,
      [Stat.SpellPower]: 51,
      [Stat.HasteRating]: 43,
    },
    Quality: Quality.Rare,
    Name: 'Savage Wound Wrap',
    Id: 37725,
    Phase: 1,
    ItemSlot: ItemSlot.Wrist,
  },
  {
    IconName: 'inv_boots_cloth_17',
    Stats: {
      [Stat.Stamina]: 31,
      [Stat.Intellect]: 44,
      [Stat.SpellPower]: 59,
      [Stat.HasteRating]: 57,
    },
    Quality: Quality.Rare,
    Sockets: [SocketColor.Red],
    SocketBonus: {
      [Stat.Stamina]: 6,
    },
    Name: "Cleric's Linen Shoes",
    Id: 37730,
    Phase: 1,
    ItemSlot: ItemSlot.Feet,
  },
  {
    IconName: 'inv_pants_cloth_23',
    Stats: {
      [Stat.Stamina]: 58,
      [Stat.Intellect]: 59,
      [Stat.Spirit]: 78,
      [Stat.SpellPower]: 91,
    },
    Quality: Quality.Rare,
    Name: 'Opposed Stasis Leggings',
    Id: 37731,
    Phase: 1,
    ItemSlot: ItemSlot.Legs,
  },
  {
    IconName: 'inv_jewelry_ring_38',
    Stats: {
      [Stat.Stamina]: 24,
      [Stat.Intellect]: 30,
      [Stat.Spirit]: 52,
      [Stat.SpellPower]: 51,
    },
    Quality: Quality.Rare,
    Unique: true,
    Name: 'Spectral Seal of the Prophet',
    Id: 37732,
    Phase: 1,
    ItemSlot: ItemSlot.Finger,
  },
  {
    IconName: 'inv_gauntlets_55',
    Stats: {
      [Stat.Stamina]: 49,
      [Stat.Intellect]: 51,
      [Stat.Spirit]: 66,
      [Stat.SpellPower]: 77,
    },
    Quality: Quality.Epic,
    Name: 'Overlook Handguards',
    Id: 37798,
    Phase: 1,
    ItemSlot: ItemSlot.Hands,
  },
  {
    IconName: 'inv_misc_cape_06',
    Stats: {
      [Stat.Stamina]: 37,
      [Stat.Intellect]: 31,
      [Stat.Spirit]: 38,
      [Stat.SpellPower]: 41,
    },
    Quality: Quality.Rare,
    Sockets: [SocketColor.Red],
    SocketBonus: {
      [Stat.Intellect]: 4,
    },
    Name: "Reanimator's Cloak",
    Id: 37799,
    Phase: 1,
    ItemSlot: ItemSlot.Back,
  },
  {
    IconName: 'inv_gauntlets_06',
    Stats: {
      [Stat.Stamina]: 42,
      [Stat.Intellect]: 53,
      [Stat.SpellPower]: 59,
      [Stat.HasteRating]: 44,
    },
    Quality: Quality.Rare,
    Sockets: [SocketColor.Yellow],
    SocketBonus: {
      [Stat.HasteRating]: 4,
    },
    Name: 'Traditionally Dyed Handguards',
    Id: 37825,
    Phase: 1,
    ItemSlot: ItemSlot.Hands,
  },
  {
    IconName: 'inv_misc_bell_01',
    Stats: {
      [Stat.SpellPower]: 106,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: "Je'Tze's Bell",
    Id: 37835,
    Phase: 1,
    ItemSlot: ItemSlot.Trinket,
  },
  {
    IconName: 'inv_gauntlets_16',
    Stats: {
      [Stat.Stamina]: 42,
      [Stat.Intellect]: 58,
      [Stat.SpellPower]: 68,
      [Stat.CritRating]: 44,
    },
    Quality: Quality.Rare,
    Name: 'Giant-Hair Woven Gloves',
    Id: 37843,
    Phase: 1,
    ItemSlot: ItemSlot.Hands,
  },
  {
    IconName: 'spell_shadow_burningspirit',
    Stats: {
      [Stat.Mp5]: 36,
    },
    Quality: Quality.Rare,
    Unique: true,
    Name: 'Winged Talisman',
    Id: 37844,
    Phase: 1,
    ItemSlot: ItemSlot.Trinket,
  },
  {
    IconName: 'inv_belt_30',
    Stats: {
      [Stat.Stamina]: 42,
      [Stat.Intellect]: 44,
      [Stat.Spirit]: 38,
      [Stat.SpellPower]: 59,
      [Stat.HitRating]: 31,
    },
    Quality: Quality.Rare,
    Sockets: [SocketColor.Red],
    SocketBonus: {
      [Stat.Stamina]: 6,
    },
    Name: 'Flowing Sash of Order',
    Id: 37850,
    Phase: 1,
    ItemSlot: ItemSlot.Waist,
  },
  {
    IconName: 'inv_chest_cloth_17',
    Stats: {
      [Stat.Stamina]: 67,
      [Stat.Intellect]: 74,
      [Stat.SpellPower]: 91,
      [Stat.CritRating]: 60,
    },
    Quality: Quality.Rare,
    Name: 'Ornate Woolen Stola',
    Id: 37851,
    Phase: 1,
    ItemSlot: ItemSlot.Chest,
  },
  {
    IconName: 'inv_pants_cloth_26',
    Stats: {
      [Stat.Stamina]: 67,
      [Stat.Intellect]: 68,
      [Stat.SpellPower]: 105,
      [Stat.CritRating]: 89,
    },
    Quality: Quality.Epic,
    Name: 'Woven Bracae Leggings',
    Id: 37854,
    Phase: 1,
    ItemSlot: ItemSlot.Legs,
  },
  {
    IconName: 'inv_weapon_shortblade_71',
    Stats: {
      [Stat.Stamina]: 25,
      [Stat.CritRating]: 26,
      [Stat.HasteRating]: 46,
    },
    Quality: Quality.Rare,
    Name: "Librarian's Paper Cutter",
    Sources: [ItemSourceName.HallsOfLightningHeroic],
    Id: 37856,
    Phase: 1,
    ItemSlot: ItemSlot.Weapon,
  },
  {
    IconName: 'inv_boots_cloth_19',
    Stats: {
      [Stat.Stamina]: 45,
      [Stat.Intellect]: 57,
      [Stat.Spirit]: 39,
      [Stat.SpellPower]: 59,
    },
    Quality: Quality.Rare,
    Sockets: [SocketColor.Yellow],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Name: 'Footwraps of Teleportation',
    Id: 37867,
    Phase: 1,
    ItemSlot: ItemSlot.Feet,
  },
  {
    IconName: 'inv_jewelry_ring_29',
    Stats: {
      [Stat.Stamina]: 31,
      [Stat.Intellect]: 33,
      [Stat.SpellPower]: 51,
      [Stat.CritRating]: 42,
    },
    Quality: Quality.Rare,
    Unique: true,
    Name: 'Globule Signet',
    Id: 37869,
    Phase: 1,
    ItemSlot: ItemSlot.Finger,
  },
  {
    IconName: 'inv_jewelry_talisman_13',
    Stats: {
      [Stat.HitRating]: 73,
    },
    Quality: Quality.Rare,
    Unique: true,
    Name: 'Mark of the War Prisoner',
    Id: 37873,
    Phase: 1,
    ItemSlot: ItemSlot.Trinket,
  },
  {
    IconName: 'inv_pants_cloth_10',
    Stats: {
      [Stat.Stamina]: 58,
      [Stat.Intellect]: 59,
      [Stat.Spirit]: 78,
      [Stat.SpellPower]: 91,
    },
    Quality: Quality.Rare,
    Name: "Cyanigosa's Leggings",
    Id: 37876,
    Phase: 1,
    ItemSlot: ItemSlot.Legs,
  },
  {
    IconName: 'inv_bracer_17',
    Stats: {
      [Stat.Stamina]: 36,
      [Stat.Intellect]: 38,
      [Stat.SpellPower]: 59,
      [Stat.CritRating]: 50,
    },
    Quality: Quality.Epic,
    Name: 'Azure Cloth Bindings',
    Id: 37884,
    Phase: 1,
    ItemSlot: ItemSlot.Wrist,
  },
  {
    IconName: 'inv_misc_book_08',
    Stats: {
      [Stat.Stamina]: 33,
      [Stat.Intellect]: 42,
      [Stat.Spirit]: 34,
      [Stat.SpellPower]: 51,
    },
    Quality: Quality.Rare,
    Name: 'Prison Manifest',
    Sources: [ItemSourceName.VioletHoldBoE],
    Id: 37889,
    Phase: 1,
    ItemSlot: ItemSlot.OffHand,
  },
  {
    IconName: 'inv_misc_book_09',
    Stats: {
      [Stat.Stamina]: 49,
      [Stat.SpellPower]: 74,
      [Stat.CritRating]: 33,
    },
    Quality: Quality.Epic,
    Name: 'Iron-bound Tome',
    Sources: [ItemSourceName.InscriptionBoE],
    Id: 38322,
    Phase: 1,
    ItemSlot: ItemSlot.OffHand,
  },
  {
    IconName: 'inv_misc_cape_20',
    Stats: {
      [Stat.Intellect]: 23,
      [Stat.SpellPower]: 32,
      [Stat.CritRating]: 30,
    },
    Quality: Quality.Rare,
    Name: 'Oil-Stained Tarp',
    Id: 38354,
    Phase: 1,
    ItemSlot: ItemSlot.Back,
  },
  {
    IconName: 'inv_wand_18',
    Stats: {
      [Stat.Stamina]: 6,
      [Stat.SpellPower]: 18,
      [Stat.CritRating]: 24,
    },
    Quality: Quality.Rare,
    Name: 'Venture Battle Wand',
    Id: 38356,
    Phase: 1,
    ItemSlot: ItemSlot.Wand,
  },
  {
    IconName: 'inv_jewelry_ring_56',
    Stats: {
      [Stat.Stamina]: 31,
      [Stat.Intellect]: 27,
      [Stat.Spirit]: 36,
      [Stat.SpellPower]: 43,
    },
    Quality: Quality.Rare,
    Unique: true,
    Name: 'Ringlet of Repose',
    Id: 38611,
    Phase: 1,
    ItemSlot: ItemSlot.Finger,
  },
  {
    IconName: 'inv_jewelry_necklace_02',
    Stats: {
      [Stat.Stamina]: 36,
      [Stat.Intellect]: 25,
      [Stat.SpellPower]: 42,
      [Stat.Mp5]: 19,
    },
    Quality: Quality.Rare,
    Name: 'Chain of Fiery Orbs',
    Sources: [ItemSourceName.HallsOfStone],
    Id: 38613,
    Phase: 1,
    ItemSlot: ItemSlot.Neck,
  },
  {
    IconName: 'inv_jewelry_ring_28',
    Stats: {
      [Stat.Stamina]: 31,
      [Stat.Intellect]: 22,
      [Stat.SpellPower]: 37,
    },
    Quality: Quality.Uncommon,
    Name: 'Band of the Tender',
    Id: 38743,
    Phase: 1,
    ItemSlot: ItemSlot.Finger,
  },
  {
    IconName: 'inv_misc_candle_01',
    Stats: {
      [Stat.SpellPower]: 56,
    },
    Quality: Quality.Uncommon,
    Name: "Mendicant's Charm",
    Id: 38760,
    Phase: 1,
    ItemSlot: ItemSlot.Trinket,
  },
  {
    IconName: 'spell_fire_playingwithfire',
    Stats: {
      [Stat.CritRating]: 48,
    },
    Quality: Quality.Uncommon,
    Name: 'Insignia of Bloody Fire',
    Id: 38762,
    Phase: 1,
    ItemSlot: ItemSlot.Trinket,
  },
  {
    IconName: 'inv_misc_rune_10',
    Stats: {
      [Stat.SpellPower]: 62,
    },
    Quality: Quality.Uncommon,
    Name: 'Futuresight Rune',
    Id: 38763,
    Phase: 1,
    ItemSlot: ItemSlot.Trinket,
  },
  {
    IconName: 'inv_misc_rune_10',
    Stats: {
      [Stat.CritRating]: 47,
    },
    Quality: Quality.Uncommon,
    Name: 'Rune of Finite Variation',
    Id: 38764,
    Phase: 1,
    ItemSlot: ItemSlot.Trinket,
  },
  {
    IconName: 'inv_misc_rune_10',
    Stats: {
      [Stat.HitRating]: 55,
    },
    Quality: Quality.Uncommon,
    Name: 'Rune of Infinite Power',
    Id: 38765,
    Phase: 1,
    ItemSlot: ItemSlot.Trinket,
  },
  {
    IconName: 'inv_belt_07',
    Stats: {
      [Stat.Stamina]: 49,
      [Stat.Intellect]: 52,
      [Stat.Spirit]: 48,
      [Stat.SpellPower]: 76,
      [Stat.HasteRating]: 38,
    },
    Quality: Quality.Epic,
    Name: 'Agonal Sash',
    Id: 39190,
    Phase: 1,
    ItemSlot: ItemSlot.Waist,
  },
  {
    IconName: 'inv_gauntlets_64',
    Stats: {
      [Stat.Stamina]: 49,
      [Stat.Intellect]: 52,
      [Stat.Spirit]: 50,
      [Stat.SpellPower]: 68,
      [Stat.HitRating]: 25,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Red],
    SocketBonus: {
      [Stat.Spirit]: 4,
    },
    Name: 'Gloves of Dark Gestures',
    Id: 39192,
    Phase: 1,
    ItemSlot: ItemSlot.Hands,
  },
  {
    IconName: 'inv_jewelry_ring_51naxxramas',
    Stats: {
      [Stat.Stamina]: 37,
      [Stat.Intellect]: 38,
      [Stat.SpellPower]: 59,
      [Stat.CritRating]: 33,
      [Stat.Mp5]: 16,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: 'Band of Neglected Pleas',
    Id: 39193,
    Phase: 1,
    ItemSlot: ItemSlot.Finger,
  },
  {
    IconName: 'inv_offhand_naxxramas_03',
    Stats: {
      [Stat.Stamina]: 37,
      [Stat.Intellect]: 38,
      [Stat.Spirit]: 36,
      [Stat.SpellPower]: 59,
      [Stat.HitRating]: 28,
    },
    Quality: Quality.Epic,
    Name: 'Watchful Eye',
    Sources: [ItemSourceName.Naxxramas10],
    Id: 39199,
    Phase: 1,
    ItemSlot: ItemSlot.OffHand,
  },
  {
    IconName: 'inv_sword_61',
    Stats: {
      [Stat.Stamina]: 33,
      [Stat.Intellect]: 40,
      [Stat.SpellPower]: 408,
      [Stat.CritRating]: 37,
      [Stat.HasteRating]: 27,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: 'Grieving Spellblade',
    Sources: [ItemSourceName.Naxxramas10],
    Id: 39200,
    Phase: 1,
    ItemSlot: ItemSlot.Weapon,
  },
  {
    IconName: 'inv_belt_03',
    Stats: {
      [Stat.Stamina]: 49,
      [Stat.Intellect]: 51,
      [Stat.Spirit]: 38,
      [Stat.SpellPower]: 76,
      [Stat.CritRating]: 48,
    },
    Quality: Quality.Epic,
    Name: 'Sash of Mortal Desire',
    Id: 39216,
    Phase: 1,
    ItemSlot: ItemSlot.Waist,
  },
  {
    IconName: 'inv_trinket_naxxramas04',
    Stats: {
      [Stat.SpellPower]: 98,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: 'Embrace of the Spider',
    Id: 39229,
    Phase: 1,
    ItemSlot: ItemSlot.Trinket,
  },
  {
    IconName: 'inv_jewelry_ring_48naxxramas',
    Stats: {
      [Stat.Stamina]: 37,
      [Stat.Intellect]: 38,
      [Stat.Spirit]: 28,
      [Stat.SpellPower]: 59,
      [Stat.CritRating]: 36,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: 'Timeworn Silken Band',
    Id: 39231,
    Phase: 1,
    ItemSlot: ItemSlot.Finger,
  },
  {
    IconName: 'inv_jewelry_necklace_29naxxramas',
    Stats: {
      [Stat.Stamina]: 31,
      [Stat.Intellect]: 41,
      [Stat.SpellPower]: 57,
      [Stat.HasteRating]: 36,
      [Stat.Mp5]: 15,
    },
    Quality: Quality.Epic,
    Name: 'Pendant of Lost Vocations',
    Sources: [ItemSourceName.Naxxramas10],
    Id: 39232,
    Phase: 1,
    ItemSlot: ItemSlot.Neck,
  },
  {
    IconName: 'inv_misc_cape_naxxramas_03',
    Stats: {
      [Stat.Stamina]: 36,
      [Stat.Intellect]: 38,
      [Stat.Spirit]: 36,
      [Stat.SpellPower]: 60,
      [Stat.HitRating]: 28,
    },
    Quality: Quality.Epic,
    Name: 'Dark Shroud of the Scourge',
    Id: 39241,
    Phase: 1,
    ItemSlot: ItemSlot.Back,
  },
  {
    IconName: 'inv_chest_cloth_42',
    Stats: {
      [Stat.Stamina]: 66,
      [Stat.Intellect]: 73,
      [Stat.SpellPower]: 104,
      [Stat.HasteRating]: 42,
      [Stat.Mp5]: 33,
    },
    Quality: Quality.Epic,
    Name: 'Robes of Hoarse Breaths',
    Id: 39242,
    Phase: 1,
    ItemSlot: ItemSlot.Chest,
  },
  {
    IconName: 'inv_jewelry_ring_50naxxramas',
    Stats: {
      [Stat.Stamina]: 39,
      [Stat.Intellect]: 37,
      [Stat.SpellPower]: 42,
      [Stat.CritRating]: 50,
      [Stat.HasteRating]: 28,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: 'Ring of the Fated',
    Id: 39244,
    Phase: 1,
    ItemSlot: ItemSlot.Finger,
  },
  {
    IconName: 'inv_jewelry_ring_50naxxramas',
    Stats: {
      [Stat.Stamina]: 36,
      [Stat.Intellect]: 38,
      [Stat.Spirit]: 29,
      [Stat.SpellPower]: 59,
      [Stat.HasteRating]: 36,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: 'Ring of Holy Cleansing',
    Id: 39250,
    Phase: 1,
    ItemSlot: ItemSlot.Finger,
  },
  {
    IconName: 'inv_bracer_17',
    Stats: {
      [Stat.Stamina]: 36,
      [Stat.Intellect]: 38,
      [Stat.Spirit]: 34,
      [Stat.SpellPower]: 59,
      [Stat.HitRating]: 33,
    },
    Quality: Quality.Epic,
    Name: "Preceptor's Bindings",
    Id: 39252,
    Phase: 1,
    ItemSlot: ItemSlot.Wrist,
  },
  {
    IconName: 'inv_boots_cloth_16',
    Stats: {
      [Stat.Stamina]: 49,
      [Stat.Intellect]: 51,
      [Stat.Spirit]: 51,
      [Stat.SpellPower]: 77,
      [Stat.HasteRating]: 33,
    },
    Quality: Quality.Epic,
    Name: 'Saltarello Shoes',
    Id: 39254,
    Phase: 1,
    ItemSlot: ItemSlot.Feet,
  },
  {
    IconName: 'inv_staff_34',
    Stats: {
      [Stat.Stamina]: 90,
      [Stat.Intellect]: 90,
      [Stat.Spirit]: 89,
      [Stat.SpellPower]: 408,
      [Stat.HitRating]: 59,
    },
    Quality: Quality.Epic,
    Name: 'Sulfur Stave',
    Sources: [ItemSourceName.Naxxramas10],
    Id: 39256,
    Phase: 1,
    ItemSlot: ItemSlot.Weapon,
    IsTwoHand: true,
  },
  {
    IconName: 'inv_knife_1h_stratholme_d_03',
    Stats: {
      [Stat.Stamina]: 31,
      [Stat.Intellect]: 38,
      [Stat.SpellPower]: 408,
      [Stat.CritRating]: 40,
      [Stat.HasteRating]: 27,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: 'Blade of Dormant Memories',
    Sources: [ItemSourceName.Naxxramas10],
    Id: 39271,
    Phase: 1,
    ItemSlot: ItemSlot.Weapon,
  },
  {
    IconName: 'inv_misc_cape_naxxramas_01',
    Stats: {
      [Stat.Stamina]: 42,
      [Stat.Intellect]: 38,
      [Stat.SpellPower]: 59,
      [Stat.HasteRating]: 25,
      [Stat.Mp5]: 18,
    },
    Quality: Quality.Epic,
    Name: 'Drape of Surgery',
    Id: 39272,
    Phase: 1,
    ItemSlot: ItemSlot.Back,
  },
  {
    IconName: 'inv_boots_cloth_11',
    Stats: {
      [Stat.Stamina]: 48,
      [Stat.Intellect]: 50,
      [Stat.Spirit]: 38,
      [Stat.SpellPower]: 76,
      [Stat.CritRating]: 48,
    },
    Quality: Quality.Epic,
    Name: 'Sullen Cloth Boots',
    Id: 39273,
    Phase: 1,
    ItemSlot: ItemSlot.Feet,
  },
  {
    IconName: 'inv_jewelry_necklace_27naxxramas',
    Stats: {
      [Stat.Stamina]: 28,
      [Stat.Intellect]: 33,
      [Stat.Spirit]: 25,
      [Stat.SpellPower]: 57,
      [Stat.CritRating]: 50,
    },
    Quality: Quality.Epic,
    Name: 'Bone-Linked Amulet',
    Sources: [ItemSourceName.Naxxramas10],
    Id: 39282,
    Phase: 1,
    ItemSlot: ItemSlot.Neck,
  },
  {
    IconName: 'inv_shoulder_72',
    Stats: {
      [Stat.Stamina]: 57,
      [Stat.Intellect]: 48,
      [Stat.Spirit]: 43,
      [Stat.SpellPower]: 77,
      [Stat.CritRating]: 45,
    },
    Quality: Quality.Epic,
    Name: 'Miasma Mantle',
    Id: 39284,
    Phase: 1,
    ItemSlot: ItemSlot.Shoulders,
  },
  {
    IconName: 'inv_gauntlets_40',
    Stats: {
      [Stat.Stamina]: 57,
      [Stat.Intellect]: 48,
      [Stat.SpellPower]: 68,
      [Stat.HasteRating]: 44,
      [Stat.Mp5]: 18,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Yellow],
    SocketBonus: {
      [Stat.Mp5]: 2,
    },
    Name: 'Handgrips of Turmoil',
    Id: 39285,
    Phase: 1,
    ItemSlot: ItemSlot.Hands,
  },
  {
    IconName: 'inv_helmet_126',
    Stats: {
      [Stat.Stamina]: 67,
      [Stat.Intellect]: 68,
      [Stat.SpellPower]: 85,
      [Stat.HasteRating]: 48,
      [Stat.Mp5]: 19,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Meta, SocketColor.Yellow],
    SocketBonus: {
      [Stat.SpellPower]: 9,
    },
    Name: 'Cowl of Sheet Lightning',
    Sources: [ItemSourceName.Naxxramas10],
    Id: 39295,
    Phase: 1,
    ItemSlot: ItemSlot.Head,
  },
  {
    IconName: 'inv_pants_cloth_14',
    Stats: {
      [Stat.Stamina]: 67,
      [Stat.Intellect]: 64,
      [Stat.Spirit]: 52,
      [Stat.SpellPower]: 87,
      [Stat.CritRating]: 52,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Red, SocketColor.Blue],
    SocketBonus: {
      [Stat.CritRating]: 6,
    },
    Name: 'Leggings of the Instructor',
    Id: 39309,
    Phase: 1,
    ItemSlot: ItemSlot.Legs,
  },
  {
    IconName: 'inv_shoulder_72',
    Stats: {
      [Stat.Stamina]: 52,
      [Stat.Intellect]: 53,
      [Stat.SpellPower]: 77,
      [Stat.HasteRating]: 44,
      [Stat.Mp5]: 23,
    },
    Quality: Quality.Epic,
    Name: 'Mantle of the Extensive Mind',
    Id: 39310,
    Phase: 1,
    ItemSlot: ItemSlot.Shoulders,
  },
  {
    IconName: 'inv_offhand_naxxramas_02',
    Stats: {
      [Stat.Stamina]: 36,
      [Stat.Intellect]: 34,
      [Stat.SpellPower]: 59,
      [Stat.CritRating]: 38,
      [Stat.Mp5]: 16,
    },
    Quality: Quality.Epic,
    Name: 'Scepter of Murmuring Spirits',
    Sources: [ItemSourceName.Naxxramas10],
    Id: 39311,
    Phase: 1,
    ItemSlot: ItemSlot.OffHand,
  },
  {
    IconName: 'inv_trinket_naxxramas06',
    Stats: {
      [Stat.Spirit]: 84,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: 'Spirit-World Glass',
    Id: 39388,
    Phase: 1,
    ItemSlot: ItemSlot.Trinket,
  },
  {
    IconName: 'inv_jewelry_ring_52naxxramas',
    Stats: {
      [Stat.Stamina]: 49,
      [Stat.Intellect]: 34,
      [Stat.SpellPower]: 46,
      [Stat.HitRating]: 49,
      [Stat.HasteRating]: 33,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: 'Signet of the Malevolent',
    Id: 39389,
    Phase: 1,
    ItemSlot: ItemSlot.Finger,
  },
  {
    IconName: 'inv_bracer_08',
    Stats: {
      [Stat.Stamina]: 37,
      [Stat.Intellect]: 32,
      [Stat.Spirit]: 38,
      [Stat.SpellPower]: 59,
      [Stat.HasteRating]: 33,
    },
    Quality: Quality.Epic,
    Name: 'Resurgent Phantom Bindings',
    Id: 39390,
    Phase: 1,
    ItemSlot: ItemSlot.Wrist,
  },
  {
    IconName: 'inv_jewelry_necklace_30naxxramas',
    Stats: {
      [Stat.Stamina]: 36,
      [Stat.Intellect]: 38,
      [Stat.Spirit]: 34,
      [Stat.SpellPower]: 59,
      [Stat.HasteRating]: 33,
    },
    Quality: Quality.Epic,
    Name: 'Veiled Amulet of Life',
    Sources: [ItemSourceName.Naxxramas10],
    Id: 39392,
    Phase: 1,
    ItemSlot: ItemSlot.Neck,
  },
  {
    IconName: 'inv_staff_31',
    Stats: {
      [Stat.Stamina]: 67,
      [Stat.Intellect]: 68,
      [Stat.Spirit]: 90,
      [Stat.SpellPower]: 408,
      [Stat.HasteRating]: 89,
    },
    Quality: Quality.Epic,
    Name: 'Charmed Cierge',
    Sources: [ItemSourceName.Naxxramas10],
    Id: 39394,
    Phase: 1,
    ItemSlot: ItemSlot.Weapon,
    IsTwoHand: true,
  },
  {
    IconName: 'inv_chest_cloth_49',
    Stats: {
      [Stat.Stamina]: 90,
      [Stat.Intellect]: 68,
      [Stat.SpellPower]: 105,
      [Stat.HitRating]: 45,
      [Stat.HasteRating]: 59,
    },
    Quality: Quality.Epic,
    Name: 'Gown of Blaumeux',
    Id: 39396,
    Phase: 1,
    ItemSlot: ItemSlot.Chest,
  },
  {
    IconName: 'inv_jewelry_ring_49naxxramas',
    Stats: {
      [Stat.Stamina]: 42,
      [Stat.Intellect]: 36,
      [Stat.SpellPower]: 59,
      [Stat.HasteRating]: 34,
      [Stat.Mp5]: 16,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: 'Circle of Life',
    Id: 39407,
    Phase: 1,
    ItemSlot: ItemSlot.Finger,
  },
  {
    IconName: 'inv_pants_cloth_15',
    Stats: {
      [Stat.Stamina]: 57,
      [Stat.Intellect]: 60,
      [Stat.Spirit]: 72,
      [Stat.SpellPower]: 88,
      [Stat.HasteRating]: 41,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Yellow, SocketColor.Red],
    SocketBonus: {
      [Stat.Spirit]: 6,
    },
    Name: 'Leggings of Sapphiron',
    Id: 39408,
    Phase: 1,
    ItemSlot: ItemSlot.Legs,
  },
  {
    IconName: 'inv_helmet_126',
    Stats: {
      [Stat.Stamina]: 88,
      [Stat.Intellect]: 60,
      [Stat.Spirit]: 45,
      [Stat.SpellPower]: 87,
      [Stat.CritRating]: 36,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Meta, SocketColor.Yellow],
    SocketBonus: {
      [Stat.CritRating]: 8,
    },
    Name: 'Cowl of Winged Fear',
    Sources: [ItemSourceName.Naxxramas10],
    Id: 39409,
    Phase: 1,
    ItemSlot: ItemSlot.Head,
  },
  {
    IconName: 'inv_misc_cape_naxxramas_01',
    Stats: {
      [Stat.Stamina]: 42,
      [Stat.Intellect]: 36,
      [Stat.SpellPower]: 58,
      [Stat.CritRating]: 38,
      [Stat.HasteRating]: 25,
    },
    Quality: Quality.Epic,
    Name: 'Shroud of the Citadel',
    Id: 39415,
    Phase: 1,
    ItemSlot: ItemSlot.Back,
  },
  {
    IconName: 'inv_knife_1h_stratholme_d_02',
    Stats: {
      [Stat.Stamina]: 39,
      [Stat.Intellect]: 44,
      [Stat.Spirit]: 42,
      [Stat.SpellPower]: 461,
      [Stat.HitRating]: 30,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: 'The Soulblade',
    Sources: [ItemSourceName.Naxxramas10],
    Id: 39424,
    Phase: 1,
    ItemSlot: ItemSlot.Weapon,
  },
  {
    IconName: 'inv_misc_cape_naxxramas_02',
    Stats: {
      [Stat.Stamina]: 42,
      [Stat.Intellect]: 43,
      [Stat.SpellPower]: 66,
      [Stat.CritRating]: 38,
      [Stat.Mp5]: 19,
    },
    Quality: Quality.Epic,
    Name: 'Cloak of the Dying',
    Id: 39425,
    Phase: 1,
    ItemSlot: ItemSlot.Back,
  },
  {
    IconName: 'inv_wand_1h_stratholme_d_02',
    Stats: {
      [Stat.Stamina]: 22,
      [Stat.Intellect]: 21,
      [Stat.Spirit]: 24,
      [Stat.SpellPower]: 37,
      [Stat.HasteRating]: 20,
    },
    Quality: Quality.Epic,
    Name: 'Wand of the Archlich',
    Id: 39426,
    Phase: 1,
    ItemSlot: ItemSlot.Wand,
  },
  {
    IconName: 'inv_jewelry_necklace_30naxxramas',
    Stats: {
      [Stat.Stamina]: 42,
      [Stat.Intellect]: 33,
      [Stat.SpellPower]: 59,
      [Stat.HitRating]: 34,
      [Stat.HasteRating]: 36,
    },
    Quality: Quality.Epic,
    Name: 'Chain of Latent Energies',
    Sources: [ItemSourceName.Naxxramas10BoE],
    Id: 39472,
    Phase: 1,
    ItemSlot: ItemSlot.Neck,
  },
  {
    IconName: 'inv_wand_1h_stratholme_d_01',
    Stats: {
      [Stat.Stamina]: 27,
      [Stat.Intellect]: 20,
      [Stat.SpellPower]: 33,
      [Stat.CritRating]: 15,
      [Stat.Mp5]: 10,
    },
    Quality: Quality.Epic,
    Name: 'Contortion',
    Id: 39473,
    Phase: 1,
    ItemSlot: ItemSlot.Wand,
  },
  {
    IconName: 'inv_crown_01',
    Stats: {
      [Stat.Stamina]: 87,
      [Stat.Intellect]: 52,
      [Stat.Spirit]: 46,
      [Stat.SpellPower]: 87,
      [Stat.HasteRating]: 48,
    },
    Quality: Quality.Epic,
    Set: ItemSet.T7,
    Sockets: [SocketColor.Meta, SocketColor.Yellow],
    SocketBonus: {
      [Stat.HasteRating]: 8,
    },
    Name: "Heroes' Plagueheart Circlet",
    Sources: [ItemSourceName.Naxxramas10],
    Id: 39496,
    Phase: 1,
    ItemSlot: ItemSlot.Head,
  },
  {
    IconName: 'inv_chest_cloth_43',
    Stats: {
      [Stat.Stamina]: 90,
      [Stat.Intellect]: 59,
      [Stat.Spirit]: 64,
      [Stat.SpellPower]: 87,
      [Stat.HitRating]: 36,
    },
    Quality: Quality.Epic,
    Set: ItemSet.T7,
    Sockets: [SocketColor.Red, SocketColor.Yellow],
    SocketBonus: {
      [Stat.Spirit]: 6,
    },
    Name: "Heroes' Plagueheart Robe",
    Sources: [ItemSourceName.Naxxramas10],
    Id: 39497,
    Phase: 1,
    ItemSlot: ItemSlot.Chest,
  },
  {
    IconName: 'inv_pants_cloth_05',
    Stats: {
      [Stat.Stamina]: 78,
      [Stat.Intellect]: 64,
      [Stat.SpellPower]: 87,
      [Stat.CritRating]: 43,
      [Stat.HasteRating]: 60,
    },
    Quality: Quality.Epic,
    Set: ItemSet.T7,
    Sockets: [SocketColor.Red, SocketColor.Yellow],
    SocketBonus: {
      [Stat.HasteRating]: 6,
    },
    Name: "Heroes' Plagueheart Leggings",
    Sources: [ItemSourceName.Naxxramas10],
    Id: 39498,
    Phase: 1,
    ItemSlot: ItemSlot.Legs,
  },
  {
    IconName: 'inv_shoulder_25',
    Stats: {
      [Stat.Stamina]: 66,
      [Stat.Intellect]: 44,
      [Stat.SpellPower]: 68,
      [Stat.HitRating]: 30,
      [Stat.HasteRating]: 48,
    },
    Quality: Quality.Epic,
    Set: ItemSet.T7,
    Sockets: [SocketColor.Red],
    SocketBonus: {
      [Stat.Stamina]: 6,
    },
    Name: "Heroes' Plagueheart Shoulderpads",
    Sources: [ItemSourceName.Naxxramas10],
    Id: 39499,
    Phase: 1,
    ItemSlot: ItemSlot.Shoulders,
  },
  {
    IconName: 'inv_gauntlets_17',
    Stats: {
      [Stat.Stamina]: 66,
      [Stat.Intellect]: 44,
      [Stat.SpellPower]: 59,
      [Stat.CritRating]: 38,
      [Stat.HasteRating]: 48,
    },
    Quality: Quality.Epic,
    Set: ItemSet.T7,
    Sockets: [SocketColor.Red],
    SocketBonus: {
      [Stat.Stamina]: 6,
    },
    Name: "Heroes' Plagueheart Gloves",
    Sources: [ItemSourceName.Naxxramas10],
    Id: 39500,
    Phase: 1,
    ItemSlot: ItemSlot.Hands,
  },
  {
    IconName: 'inv_gauntlets_19',
    Stats: {
      [Stat.Stamina]: 43,
      [Stat.Intellect]: 51,
      [Stat.SpellPower]: 60,
      [Stat.Mp5]: 19,
    },
    Quality: Quality.Rare,
    Name: 'Thundercloud Grasps',
    Id: 39536,
    Phase: 1,
    ItemSlot: ItemSlot.Hands,
  },
  {
    IconName: 'inv_wand_16',
    Stats: {
      [Stat.Stamina]: 27,
      [Stat.Intellect]: 22,
      [Stat.SpellPower]: 37,
      [Stat.HitRating]: 18,
      [Stat.HasteRating]: 22,
    },
    Quality: Quality.Epic,
    Name: 'Gemmed Wand of the Nerubians',
    Id: 39712,
    Phase: 1,
    ItemSlot: ItemSlot.Wand,
  },
  {
    IconName: 'inv_shoulder_72',
    Stats: {
      [Stat.Stamina]: 57,
      [Stat.Intellect]: 39,
      [Stat.Spirit]: 67,
      [Stat.SpellPower]: 78,
      [Stat.HasteRating]: 39,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Red],
    SocketBonus: {
      [Stat.Intellect]: 4,
    },
    Name: 'Mantle of the Locusts',
    Id: 39719,
    Phase: 1,
    ItemSlot: ItemSlot.Shoulders,
  },
  {
    IconName: 'inv_pants_cloth_14',
    Stats: {
      [Stat.Stamina]: 75,
      [Stat.Intellect]: 78,
      [Stat.SpellPower]: 118,
      [Stat.CritRating]: 76,
      [Stat.HitRating]: 50,
    },
    Quality: Quality.Epic,
    Name: 'Leggings of Atrophy',
    Id: 39720,
    Phase: 1,
    ItemSlot: ItemSlot.Legs,
  },
  {
    IconName: 'inv_belt_07',
    Stats: {
      [Stat.Stamina]: 64,
      [Stat.Intellect]: 57,
      [Stat.SpellPower]: 88,
      [Stat.CritRating]: 37,
      [Stat.Mp5]: 28,
    },
    Quality: Quality.Epic,
    Name: 'Sash of the Parlor',
    Id: 39721,
    Phase: 1,
    ItemSlot: ItemSlot.Waist,
  },
  {
    IconName: 'inv_bracer_13',
    Stats: {
      [Stat.Stamina]: 42,
      [Stat.Intellect]: 43,
      [Stat.Spirit]: 39,
      [Stat.SpellPower]: 66,
      [Stat.HasteRating]: 37,
    },
    Quality: Quality.Epic,
    Name: 'Punctilious Bindings',
    Id: 39731,
    Phase: 1,
    ItemSlot: ItemSlot.Wrist,
  },
  {
    IconName: 'inv_helmet_126',
    Stats: {
      [Stat.Stamina]: 75,
      [Stat.Intellect]: 77,
      [Stat.Spirit]: 72,
      [Stat.SpellPower]: 118,
      [Stat.HitRating]: 58,
    },
    Quality: Quality.Epic,
    Name: "Faerlina's Madness",
    Sources: [ItemSourceName.Naxxramas25],
    Id: 39732,
    Phase: 1,
    ItemSlot: ItemSlot.Head,
  },
  {
    IconName: 'inv_gauntlets_06',
    Stats: {
      [Stat.Stamina]: 57,
      [Stat.Intellect]: 57,
      [Stat.Spirit]: 53,
      [Stat.SpellPower]: 88,
      [Stat.HasteRating]: 43,
    },
    Quality: Quality.Epic,
    Name: 'Gloves of Token Respect',
    Id: 39733,
    Phase: 1,
    ItemSlot: ItemSlot.Hands,
  },
  {
    IconName: 'inv_belt_11',
    Stats: {
      [Stat.Stamina]: 55,
      [Stat.Intellect]: 57,
      [Stat.Spirit]: 55,
      [Stat.SpellPower]: 88,
      [Stat.CritRating]: 43,
    },
    Quality: Quality.Epic,
    Name: 'Belt of False Dignity',
    Id: 39735,
    Phase: 1,
    ItemSlot: ItemSlot.Waist,
  },
  {
    IconName: 'inv_offhand_naxxramas_d_01',
    Stats: {
      [Stat.Stamina]: 42,
      [Stat.Intellect]: 41,
      [Stat.Spirit]: 43,
      [Stat.SpellPower]: 66,
      [Stat.HasteRating]: 32,
    },
    Quality: Quality.Epic,
    Name: "Matriarch's Spawn",
    Sources: [ItemSourceName.Naxxramas25],
    Id: 39766,
    Phase: 1,
    ItemSlot: ItemSlot.OffHand,
  },
  {
    IconName: 'inv_misc_rune_05',
    Stats: {
      [Stat.Intellect]: 46,
    },
    Quality: Quality.Uncommon,
    Name: 'Badge of the Infiltrator',
    Id: 39811,
    Phase: 1,
    ItemSlot: ItemSlot.Trinket,
  },
  {
    IconName: 'inv_misc_rune_05',
    Stats: {
      [Stat.Mp5]: 24,
    },
    Quality: Quality.Uncommon,
    Name: "Spiritist's Focus",
    Id: 39821,
    Phase: 1,
    ItemSlot: ItemSlot.Trinket,
  },
  {
    IconName: 'inv_pants_cloth_26',
    Stats: {
      [Stat.Stamina]: 75,
      [Stat.Intellect]: 77,
      [Stat.Spirit]: 72,
      [Stat.SpellPower]: 118,
      [Stat.HasteRating]: 58,
    },
    Quality: Quality.Epic,
    Name: 'Distorted Limbs',
    Id: 40060,
    Phase: 1,
    ItemSlot: ItemSlot.Legs,
  },
  {
    IconName: 'inv_chest_cloth_44',
    Stats: {
      [Stat.Stamina]: 75,
      [Stat.Intellect]: 69,
      [Stat.Spirit]: 63,
      [Stat.SpellPower]: 118,
      [Stat.CritRating]: 77,
    },
    Quality: Quality.Epic,
    Name: 'Digested Silken Robes',
    Id: 40062,
    Phase: 1,
    ItemSlot: ItemSlot.Chest,
  },
  {
    IconName: 'inv_jewelry_necklace_30naxxramas',
    Stats: {
      [Stat.Stamina]: 55,
      [Stat.Intellect]: 43,
      [Stat.Spirit]: 38,
      [Stat.SpellPower]: 65,
      [Stat.HitRating]: 28,
    },
    Quality: Quality.Epic,
    Name: 'Thunderstorm Amulet',
    Sources: [ItemSourceName.Naxxramas25],
    Id: 40064,
    Phase: 1,
    ItemSlot: ItemSlot.Neck,
  },
  {
    IconName: 'inv_jewelry_necklace_28naxxramas',
    Stats: {
      [Stat.Stamina]: 42,
      [Stat.Intellect]: 43,
      [Stat.SpellPower]: 66,
      [Stat.HasteRating]: 32,
      [Stat.Mp5]: 20,
    },
    Quality: Quality.Epic,
    Name: 'Chains of Adoration',
    Sources: [ItemSourceName.Naxxramas25],
    Id: 40071,
    Phase: 1,
    ItemSlot: ItemSlot.Neck,
  },
  {
    IconName: 'inv_jewelry_ring_51naxxramas',
    Stats: {
      [Stat.Stamina]: 45,
      [Stat.Intellect]: 38,
      [Stat.Spirit]: 37,
      [Stat.SpellPower]: 65,
      [Stat.CritRating]: 42,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: 'Lost Jewel',
    Id: 40080,
    Phase: 1,
    ItemSlot: ItemSlot.Finger,
  },
  {
    IconName: 'inv_jewelry_ring_49naxxramas',
    Stats: {
      [Stat.Stamina]: 42,
      [Stat.Intellect]: 43,
      [Stat.SpellPower]: 66,
      [Stat.CritRating]: 38,
      [Stat.Mp5]: 19,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: 'Seized Beauty',
    Id: 40108,
    Phase: 1,
    ItemSlot: ItemSlot.Finger,
  },
  {
    IconName: 'inv_offhand_utgarde_d_01',
    Stats: {
      [Stat.Stamina]: 42,
      [Stat.Intellect]: 41,
      [Stat.Spirit]: 32,
      [Stat.SpellPower]: 65,
      [Stat.CritRating]: 43,
    },
    Quality: Quality.Epic,
    Name: 'Accursed Spine',
    Sources: [ItemSourceName.Naxxramas25],
    Id: 40192,
    Phase: 1,
    ItemSlot: ItemSlot.OffHand,
  },
  {
    IconName: 'inv_chest_cloth_73',
    Stats: {
      [Stat.Stamina]: 86,
      [Stat.Intellect]: 71,
      [Stat.Spirit]: 66,
      [Stat.SpellPower]: 132,
      [Stat.Mp5]: 16,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Blue],
    SocketBonus: {
      [Stat.HasteRating]: 4,
    },
    Name: 'Blanketing Robes of Snow',
    Id: 40194,
    Phase: 1,
    ItemSlot: ItemSlot.Chest,
  },
  {
    IconName: 'inv_gauntlets_17',
    Stats: {
      [Stat.Stamina]: 57,
      [Stat.Intellect]: 50,
      [Stat.Spirit]: 74,
      [Stat.SpellPower]: 88,
      [Stat.HitRating]: 25,
    },
    Quality: Quality.Epic,
    Name: 'Gloves of the Fallen Wizard',
    Id: 40197,
    Phase: 1,
    ItemSlot: ItemSlot.Hands,
  },
  {
    IconName: 'inv_bracer_13',
    Stats: {
      [Stat.Stamina]: 42,
      [Stat.Intellect]: 39,
      [Stat.Spirit]: 37,
      [Stat.SpellPower]: 56,
      [Stat.CritRating]: 34,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Red],
    SocketBonus: {
      [Stat.Spirit]: 4,
    },
    Name: 'Bands of Impurity',
    Id: 40198,
    Phase: 1,
    ItemSlot: ItemSlot.Wrist,
  },
  {
    IconName: 'inv_chest_cloth_41',
    Stats: {
      [Stat.Stamina]: 99,
      [Stat.Intellect]: 77,
      [Stat.SpellPower]: 99,
      [Stat.HitRating]: 49,
      [Stat.HasteRating]: 51,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Blue, SocketColor.Yellow],
    SocketBonus: {
      [Stat.SpellPower]: 7,
    },
    Name: "Heigan's Putrid Vestments",
    Id: 40234,
    Phase: 1,
    ItemSlot: ItemSlot.Chest,
  },
  {
    IconName: 'inv_boots_cloth_16',
    Stats: {
      [Stat.Stamina]: 57,
      [Stat.Intellect]: 57,
      [Stat.SpellPower]: 88,
      [Stat.CritRating]: 49,
      [Stat.Mp5]: 25,
    },
    Quality: Quality.Epic,
    Name: 'Serene Echoes',
    Id: 40236,
    Phase: 1,
    ItemSlot: ItemSlot.Feet,
  },
  {
    IconName: 'inv_wand_1h_stratholme_d_02',
    Stats: {
      [Stat.Stamina]: 24,
      [Stat.Intellect]: 25,
      [Stat.SpellPower]: 37,
      [Stat.HasteRating]: 18,
      [Stat.Mp5]: 11,
    },
    Quality: Quality.Epic,
    Name: 'Fading Glow',
    Id: 40245,
    Phase: 1,
    ItemSlot: ItemSlot.Wand,
  },
  {
    IconName: 'inv_boots_cloth_12',
    Stats: {
      [Stat.Stamina]: 64,
      [Stat.Intellect]: 57,
      [Stat.SpellPower]: 88,
      [Stat.HitRating]: 37,
      [Stat.HasteRating]: 55,
    },
    Quality: Quality.Epic,
    Name: 'Boots of Impetuous Ideals',
    Id: 40246,
    Phase: 1,
    ItemSlot: ItemSlot.Feet,
  },
  {
    IconName: 'inv_helmet_133',
    Stats: {
      [Stat.Stamina]: 108,
      [Stat.Intellect]: 77,
      [Stat.Spirit]: 58,
      [Stat.SpellPower]: 118,
      [Stat.Mp5]: 25,
    },
    Quality: Quality.Epic,
    Name: 'Cowl of Innocent Delight',
    Sources: [ItemSourceName.Naxxramas25],
    Id: 40247,
    Phase: 1,
    ItemSlot: ItemSlot.Head,
  },
  {
    IconName: 'inv_misc_cape_naxxramas_02',
    Stats: {
      [Stat.Stamina]: 55,
      [Stat.Intellect]: 43,
      [Stat.SpellPower]: 65,
      [Stat.CritRating]: 38,
      [Stat.HasteRating]: 28,
    },
    Quality: Quality.Epic,
    Name: 'Shroud of Luminosity',
    Id: 40251,
    Phase: 1,
    ItemSlot: ItemSlot.Back,
  },
  {
    IconName: 'inv_misc_cape_naxxramas_02',
    Stats: {
      [Stat.Stamina]: 42,
      [Stat.Intellect]: 43,
      [Stat.Spirit]: 38,
      [Stat.SpellPower]: 66,
      [Stat.CritRating]: 37,
    },
    Quality: Quality.Epic,
    Name: 'Shawl of the Old Maid',
    Id: 40253,
    Phase: 1,
    ItemSlot: ItemSlot.Back,
  },
  {
    IconName: 'inv_misc_cape_naxxramas_03',
    Stats: {
      [Stat.Stamina]: 48,
      [Stat.Intellect]: 41,
      [Stat.SpellPower]: 66,
      [Stat.CritRating]: 38,
      [Stat.Mp5]: 19,
    },
    Quality: Quality.Epic,
    Name: 'Cloak of Averted Crisis',
    Id: 40254,
    Phase: 1,
    ItemSlot: ItemSlot.Back,
  },
  {
    IconName: 'inv_trinket_naxxramas03',
    Stats: {
      [Stat.HitRating]: 71,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: 'Dying Curse',
    Id: 40255,
    Phase: 1,
    ItemSlot: ItemSlot.Trinket,
  },
  {
    IconName: 'inv_boots_cloth_12',
    Stats: {
      [Stat.Stamina]: 75,
      [Stat.Intellect]: 50,
      [Stat.Spirit]: 55,
      [Stat.SpellPower]: 78,
      [Stat.CritRating]: 35,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Yellow],
    SocketBonus: {
      [Stat.CritRating]: 4,
    },
    Name: 'Boots of Persuasion',
    Id: 40269,
    Phase: 1,
    ItemSlot: ItemSlot.Feet,
  },
  {
    IconName: 'inv_belt_07',
    Stats: {
      [Stat.Stamina]: 57,
      [Stat.Intellect]: 58,
      [Stat.Spirit]: 37,
      [Stat.SpellPower]: 78,
      [Stat.Mp5]: 23,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Name: 'Sash of Solitude',
    Id: 40271,
    Phase: 1,
    ItemSlot: ItemSlot.Waist,
  },
  {
    IconName: 'inv_offhand_stratholme_a_02',
    Stats: {
      [Stat.Stamina]: 55,
      [Stat.Intellect]: 38,
      [Stat.SpellPower]: 65,
      [Stat.HitRating]: 32,
      [Stat.HasteRating]: 41,
    },
    Quality: Quality.Epic,
    Name: 'Surplus Limb',
    Sources: [ItemSourceName.Naxxramas25],
    Id: 40273,
    Phase: 1,
    ItemSlot: ItemSlot.OffHand,
  },
  {
    IconName: 'inv_wand_1h_stratholme_d_01',
    Stats: {
      [Stat.Stamina]: 22,
      [Stat.Intellect]: 21,
      [Stat.Spirit]: 20,
      [Stat.SpellPower]: 37,
      [Stat.CritRating]: 24,
    },
    Quality: Quality.Epic,
    Name: 'Plague Igniter',
    Id: 40284,
    Phase: 1,
    ItemSlot: ItemSlot.Wand,
  },
  {
    IconName: 'inv_shoulder_72',
    Stats: {
      [Stat.Stamina]: 75,
      [Stat.Intellect]: 50,
      [Stat.SpellPower]: 88,
      [Stat.HitRating]: 37,
      [Stat.HasteRating]: 57,
    },
    Quality: Quality.Epic,
    Name: 'Mantle of the Corrupted',
    Id: 40286,
    Phase: 1,
    ItemSlot: ItemSlot.Shoulders,
  },
  {
    IconName: 'inv_helmet_133',
    Stats: {
      [Stat.Stamina]: 67,
      [Stat.Intellect]: 79,
      [Stat.Spirit]: 63,
      [Stat.SpellPower]: 99,
      [Stat.HasteRating]: 40,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Meta, SocketColor.Red],
    SocketBonus: {
      [Stat.HasteRating]: 8,
    },
    Name: 'Cowl of Vanity',
    Sources: [ItemSourceName.Naxxramas25],
    Id: 40287,
    Phase: 1,
    ItemSlot: ItemSlot.Head,
  },
  {
    IconName: 'inv_shoulder_72',
    Stats: {
      [Stat.Stamina]: 75,
      [Stat.Intellect]: 57,
      [Stat.SpellPower]: 88,
      [Stat.CritRating]: 50,
      [Stat.Mp5]: 19,
    },
    Quality: Quality.Epic,
    Name: 'Sympathetic Amice',
    Id: 40289,
    Phase: 1,
    ItemSlot: ItemSlot.Shoulders,
  },
  {
    IconName: 'inv_staff_82',
    Stats: {
      [Stat.Stamina]: 87,
      [Stat.Intellect]: 101,
      [Stat.SpellPower]: 461,
      [Stat.HasteRating]: 99,
      [Stat.Mp5]: 29,
    },
    Quality: Quality.Epic,
    Name: 'Spire of Sunset',
    Sources: [ItemSourceName.Naxxramas25],
    Id: 40300,
    Phase: 1,
    ItemSlot: ItemSlot.Weapon,
    IsTwoHand: true,
  },
  {
    IconName: 'inv_belt_10',
    Stats: {
      [Stat.Stamina]: 57,
      [Stat.Intellect]: 57,
      [Stat.SpellPower]: 88,
      [Stat.HitRating]: 43,
      [Stat.HasteRating]: 53,
    },
    Quality: Quality.Epic,
    Name: 'Cincture of Polarity',
    Id: 40301,
    Phase: 1,
    ItemSlot: ItemSlot.Waist,
  },
  {
    IconName: 'inv_gauntlets_16',
    Stats: {
      [Stat.Stamina]: 57,
      [Stat.Intellect]: 57,
      [Stat.SpellPower]: 88,
      [Stat.CritRating]: 49,
      [Stat.Mp5]: 25,
    },
    Quality: Quality.Epic,
    Name: 'Wraps of the Persecuted',
    Id: 40303,
    Phase: 1,
    ItemSlot: ItemSlot.Hands,
  },
  {
    IconName: 'inv_bracer_13',
    Stats: {
      [Stat.Stamina]: 55,
      [Stat.Intellect]: 38,
      [Stat.SpellPower]: 65,
      [Stat.CritRating]: 43,
      [Stat.HitRating]: 28,
    },
    Quality: Quality.Epic,
    Name: 'Bindings of the Expansive Mind',
    Id: 40325,
    Phase: 1,
    ItemSlot: ItemSlot.Wrist,
  },
  {
    IconName: 'inv_boots_cloth_16',
    Stats: {
      [Stat.Stamina]: 51,
      [Stat.Intellect]: 50,
      [Stat.Spirit]: 66,
      [Stat.SpellPower]: 78,
      [Stat.HasteRating]: 33,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Yellow],
    SocketBonus: {
      [Stat.Spirit]: 4,
    },
    Name: 'Boots of Forlorn Wishes',
    Id: 40326,
    Phase: 1,
    ItemSlot: ItemSlot.Feet,
  },
  {
    IconName: 'inv_mace_80',
    Stats: {
      [Stat.Stamina]: 22,
      [Stat.Intellect]: 17,
      [Stat.SpellPower]: 37,
      [Stat.CritRating]: 16,
      [Stat.Mp5]: 15,
    },
    Quality: Quality.Epic,
    Name: 'Touch of Horror',
    Id: 40335,
    Phase: 1,
    ItemSlot: ItemSlot.Wand,
  },
  {
    IconName: 'inv_sword_121',
    Stats: {
      [Stat.Stamina]: 42,
      [Stat.Intellect]: 44,
      [Stat.SpellPower]: 461,
      [Stat.CritRating]: 42,
      [Stat.HasteRating]: 29,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: 'Life and Death',
    Sources: [ItemSourceName.Naxxramas25],
    Id: 40336,
    Phase: 1,
    ItemSlot: ItemSlot.Weapon,
  },
  {
    IconName: 'inv_bracer_17',
    Stats: {
      [Stat.Stamina]: 48,
      [Stat.Intellect]: 43,
      [Stat.SpellPower]: 66,
      [Stat.CritRating]: 41,
      [Stat.Mp5]: 14,
    },
    Quality: Quality.Epic,
    Name: 'Bindings of Yearning',
    Id: 40338,
    Phase: 1,
    ItemSlot: ItemSlot.Wrist,
  },
  {
    IconName: 'inv_helmet_133',
    Stats: {
      [Stat.Stamina]: 75,
      [Stat.Intellect]: 72,
      [Stat.SpellPower]: 99,
      [Stat.CritRating]: 42,
      [Stat.HasteRating]: 34,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Meta, SocketColor.Yellow],
    SocketBonus: {
      [Stat.CritRating]: 8,
    },
    Name: "Gothik's Cowl",
    Sources: [ItemSourceName.Naxxramas25],
    Id: 40339,
    Phase: 1,
    ItemSlot: ItemSlot.Head,
  },
  {
    IconName: 'inv_staff_67',
    Stats: {
      [Stat.Stamina]: 111,
      [Stat.Intellect]: 86,
      [Stat.Spirit]: 85,
      [Stat.SpellPower]: 461,
      [Stat.CritRating]: 91,
    },
    Quality: Quality.Epic,
    Name: 'Damnation',
    Sources: [ItemSourceName.Naxxramas25],
    Id: 40348,
    Phase: 1,
    ItemSlot: ItemSlot.Weapon,
    IsTwoHand: true,
  },
  {
    IconName: 'inv_offhand_naxxramas_04',
    Stats: {
      [Stat.Stamina]: 42,
      [Stat.Intellect]: 32,
      [Stat.SpellPower]: 66,
      [Stat.CritRating]: 41,
      [Stat.Mp5]: 21,
    },
    Quality: Quality.Epic,
    Name: 'Urn of Lost Memories',
    Sources: [ItemSourceName.Naxxramas25],
    Id: 40350,
    Phase: 1,
    ItemSlot: ItemSlot.OffHand,
  },
  {
    IconName: 'inv_shoulder_72',
    Stats: {
      [Stat.Stamina]: 55,
      [Stat.Intellect]: 55,
      [Stat.Spirit]: 57,
      [Stat.SpellPower]: 78,
      [Stat.HitRating]: 35,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Name: 'Mantle of the Fatigued Sage',
    Id: 40351,
    Phase: 1,
    ItemSlot: ItemSlot.Shoulders,
  },
  {
    IconName: 'inv_trinket_naxxramas06',
    Stats: {
      [Stat.CritRating]: 95,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: 'Extract of Necromantic Power',
    Id: 40373,
    Phase: 1,
    ItemSlot: ItemSlot.Trinket,
  },
  {
    IconName: 'inv_jewelry_necklace_27naxxramas',
    Stats: {
      [Stat.Stamina]: 48,
      [Stat.Intellect]: 38,
      [Stat.SpellPower]: 65,
      [Stat.CritRating]: 37,
      [Stat.HasteRating]: 41,
    },
    Quality: Quality.Epic,
    Name: 'Cosmic Lights',
    Sources: [ItemSourceName.Naxxramas25],
    Id: 40374,
    Phase: 1,
    ItemSlot: ItemSlot.Neck,
  },
  {
    IconName: 'inv_jewelry_ring_50naxxramas',
    Stats: {
      [Stat.Stamina]: 48,
      [Stat.Intellect]: 40,
      [Stat.SpellPower]: 66,
      [Stat.HasteRating]: 35,
      [Stat.Mp5]: 20,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: 'Ring of Decaying Beauty',
    Id: 40375,
    Phase: 1,
    ItemSlot: ItemSlot.Finger,
  },
  {
    IconName: 'inv_pants_cloth_16',
    Stats: {
      [Stat.Stamina]: 87,
      [Stat.Intellect]: 77,
      [Stat.Spirit]: 56,
      [Stat.SpellPower]: 99,
      [Stat.HitRating]: 50,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Red, SocketColor.Blue],
    SocketBonus: {
      [Stat.HitRating]: 6,
    },
    Name: 'Legwraps of the Defeated Dragon',
    Id: 40376,
    Phase: 1,
    ItemSlot: ItemSlot.Legs,
  },
  {
    IconName: 'inv_jewelry_necklace_29naxxramas',
    Stats: {
      [Stat.Stamina]: 42,
      [Stat.Intellect]: 41,
      [Stat.SpellPower]: 66,
      [Stat.CritRating]: 43,
      [Stat.Mp5]: 16,
    },
    Quality: Quality.Epic,
    Name: 'Ceaseless Pity',
    Sources: [ItemSourceName.Naxxramas25],
    Id: 40378,
    Phase: 1,
    ItemSlot: ItemSlot.Neck,
  },
  {
    IconName: 'inv_gauntlets_14',
    Stats: {
      [Stat.Stamina]: 79,
      [Stat.Intellect]: 57,
      [Stat.SpellPower]: 88,
      [Stat.CritRating]: 43,
      [Stat.HitRating]: 38,
    },
    Quality: Quality.Epic,
    Name: 'Gloves of Grandeur',
    Id: 40380,
    Phase: 1,
    ItemSlot: ItemSlot.Hands,
  },
  {
    IconName: 'inv_chest_cloth_32',
    Stats: {
      [Stat.Stamina]: 75,
      [Stat.Intellect]: 77,
      [Stat.Spirit]: 58,
      [Stat.SpellPower]: 99,
      [Stat.Mp5]: 28,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Yellow, SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 7,
    },
    Name: 'Sympathy',
    Id: 40381,
    Phase: 1,
    ItemSlot: ItemSlot.Chest,
  },
  {
    IconName: 'inv_trinket_naxxramas03',
    Stats: {
      [Stat.CritRating]: 95,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: 'Soul of the Dead',
    Id: 40382,
    Phase: 1,
    ItemSlot: ItemSlot.Trinket,
  },
  {
    IconName: 'inv_sword_130',
    Stats: {
      [Stat.Stamina]: 36,
      [Stat.Intellect]: 50,
      [Stat.SpellPower]: 520,
      [Stat.CritRating]: 37,
      [Stat.HasteRating]: 48,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: 'The Turning Tide',
    Sources: [ItemSourceName.Naxxramas25],
    Id: 40396,
    Phase: 1,
    ItemSlot: ItemSlot.Weapon,
  },
  {
    IconName: 'inv_pants_cloth_26',
    Stats: {
      [Stat.Stamina]: 85,
      [Stat.Intellect]: 85,
      [Stat.Spirit]: 71,
      [Stat.SpellPower]: 115,
      [Stat.CritRating]: 57,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Red, SocketColor.Blue],
    SocketBonus: {
      [Stat.CritRating]: 6,
    },
    Name: 'Leggings of Mortal Arrogance',
    Id: 40398,
    Phase: 1,
    ItemSlot: ItemSlot.Legs,
  },
  {
    IconName: 'inv_jewelry_ring_51naxxramas',
    Stats: {
      [Stat.Stamina]: 46,
      [Stat.Intellect]: 49,
      [Stat.SpellPower]: 74,
      [Stat.CritRating]: 46,
      [Stat.HasteRating]: 36,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: 'Signet of Manifested Pain',
    Id: 40399,
    Phase: 1,
    ItemSlot: ItemSlot.Finger,
  },
  {
    IconName: 'inv_misc_cape_naxxramas_02',
    Stats: {
      [Stat.Stamina]: 46,
      [Stat.Intellect]: 42,
      [Stat.Spirit]: 49,
      [Stat.SpellPower]: 74,
      [Stat.CritRating]: 42,
    },
    Quality: Quality.Epic,
    Name: 'Cape of the Unworthy Wizard',
    Id: 40405,
    Phase: 1,
    ItemSlot: ItemSlot.Back,
  },
  {
    IconName: 'inv_weapon_shortblade_82',
    Stats: {
      [Stat.Stamina]: 40,
      [Stat.Intellect]: 41,
      [Stat.Spirit]: 23,
      [Stat.SpellPower]: 461,
      [Stat.HitRating]: 45,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: 'Haunting Call',
    Sources: [ItemSourceName.Naxxramas25],
    Id: 40408,
    Phase: 1,
    ItemSlot: ItemSlot.Weapon,
  },
  {
    IconName: 'inv_jewelry_necklace_28naxxramas',
    Stats: {
      [Stat.Stamina]: 55,
      [Stat.Intellect]: 38,
      [Stat.Spirit]: 56,
      [Stat.SpellPower]: 50,
      [Stat.CritRating]: 28,
    },
    Quality: Quality.Epic,
    Name: 'Ousted Bead Necklace',
    Sources: [ItemSourceName.Naxxramas25],
    Id: 40412,
    Phase: 1,
    ItemSlot: ItemSlot.Neck,
  },
  {
    IconName: 'inv_gauntlets_17',
    Stats: {
      [Stat.Stamina]: 75,
      [Stat.Intellect]: 50,
      [Stat.SpellPower]: 69,
      [Stat.CritRating]: 43,
      [Stat.HasteRating]: 53,
    },
    Quality: Quality.Epic,
    Set: ItemSet.T7,
    Sockets: [SocketColor.Red],
    SocketBonus: {
      [Stat.Stamina]: 6,
    },
    Name: 'Valorous Plagueheart Gloves',
    Sources: [ItemSourceName.Naxxramas25],
    Id: 40420,
    Phase: 1,
    ItemSlot: ItemSlot.Hands,
  },
  {
    IconName: 'inv_crown_01',
    Stats: {
      [Stat.Stamina]: 99,
      [Stat.Intellect]: 59,
      [Stat.Spirit]: 50,
      [Stat.SpellPower]: 99,
      [Stat.HasteRating]: 56,
    },
    Quality: Quality.Epic,
    Set: ItemSet.T7,
    Sockets: [SocketColor.Meta, SocketColor.Yellow],
    SocketBonus: {
      [Stat.HasteRating]: 8,
    },
    Name: 'Valorous Plagueheart Circlet',
    Sources: [ItemSourceName.Naxxramas25],
    Id: 40421,
    Phase: 1,
    ItemSlot: ItemSlot.Head,
  },
  {
    IconName: 'inv_pants_cloth_05',
    Stats: {
      [Stat.Stamina]: 87,
      [Stat.Intellect]: 72,
      [Stat.SpellPower]: 99,
      [Stat.CritRating]: 51,
      [Stat.HasteRating]: 66,
    },
    Quality: Quality.Epic,
    Set: ItemSet.T7,
    Sockets: [SocketColor.Red, SocketColor.Yellow],
    SocketBonus: {
      [Stat.HasteRating]: 6,
    },
    Name: 'Valorous Plagueheart Leggings',
    Sources: [ItemSourceName.Naxxramas25],
    Id: 40422,
    Phase: 1,
    ItemSlot: ItemSlot.Legs,
  },
  {
    IconName: 'inv_chest_cloth_43',
    Stats: {
      [Stat.Stamina]: 99,
      [Stat.Intellect]: 67,
      [Stat.Spirit]: 66,
      [Stat.SpellPower]: 99,
      [Stat.HitRating]: 51,
    },
    Quality: Quality.Epic,
    Set: ItemSet.T7,
    Sockets: [SocketColor.Red, SocketColor.Yellow],
    SocketBonus: {
      [Stat.Spirit]: 6,
    },
    Name: 'Valorous Plagueheart Robe',
    Sources: [ItemSourceName.Naxxramas25],
    Id: 40423,
    Phase: 1,
    ItemSlot: ItemSlot.Chest,
  },
  {
    IconName: 'inv_shoulder_25',
    Stats: {
      [Stat.Stamina]: 73,
      [Stat.Intellect]: 50,
      [Stat.SpellPower]: 78,
      [Stat.HitRating]: 35,
      [Stat.HasteRating]: 55,
    },
    Quality: Quality.Epic,
    Set: ItemSet.T7,
    Sockets: [SocketColor.Red],
    SocketBonus: {
      [Stat.Stamina]: 6,
    },
    Name: 'Valorous Plagueheart Shoulderpads',
    Sources: [ItemSourceName.Naxxramas25],
    Id: 40424,
    Phase: 1,
    ItemSlot: ItemSlot.Shoulders,
  },
  {
    IconName: 'spell_arcane_blast',
    Stats: {
      [Stat.Stamina]: 48,
      [Stat.Intellect]: 37,
      [Stat.SpellPower]: 53,
      [Stat.CritRating]: 35,
      [Stat.HitRating]: 31,
    },
    Quality: Quality.Epic,
    Name: 'Circle of Arcane Streams',
    Sources: [ItemSourceName.ObsidianSanctum10],
    Id: 40427,
    Phase: 1,
    ItemSlot: ItemSlot.Neck,
  },
  {
    IconName: 'inv_misc_head_dragon_green',
    Quality: Quality.Epic,
    Unique: true,
    Name: 'Majestic Dragon Figurine',
    Id: 40430,
    Phase: 1,
    ItemSlot: ItemSlot.Trinket,
  },
  {
    IconName: 'inv_offhand_hyjal_d_01',
    Quality: Quality.Epic,
    Unique: true,
    Name: 'Illustration of the Dragon Soul',
    Id: 40432,
    Phase: 1,
    ItemSlot: ItemSlot.Trinket,
  },
  {
    IconName: 'inv_jewelry_ring_67',
    Stats: {
      [Stat.Stamina]: 41,
      [Stat.Intellect]: 40,
      [Stat.SpellPower]: 67,
      [Stat.HasteRating]: 32,
      [Stat.Mp5]: 20,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: 'Wyrmrest Band',
    Id: 40433,
    Phase: 1,
    ItemSlot: ItemSlot.Finger,
  },
  {
    IconName: 'inv_staff_81',
    Stats: {
      [Stat.Stamina]: 85,
      [Stat.Intellect]: 108,
      [Stat.Spirit]: 84,
      [Stat.SpellPower]: 461,
      [Stat.CritRating]: 68,
    },
    Quality: Quality.Epic,
    Name: 'Staff of Restraint',
    Sources: [ItemSourceName.ObsidianSanctum25],
    Id: 40455,
    Phase: 1,
    ItemSlot: ItemSlot.Weapon,
    IsTwoHand: true,
  },
  {
    IconName: 'inv_jewelry_necklace_32',
    Stats: {
      [Stat.Stamina]: 51,
      [Stat.Intellect]: 34,
      [Stat.Spirit]: 38,
      [Stat.SpellPower]: 69,
      [Stat.CritRating]: 37,
    },
    Quality: Quality.Epic,
    Name: 'Necklace of the Glittering Chamber',
    Sources: [ItemSourceName.EyeOfEternity10],
    Id: 40486,
    Phase: 1,
    ItemSlot: ItemSlot.Neck,
  },
  {
    IconName: 'inv_staff_83',
    Stats: {
      [Stat.Stamina]: 101,
      [Stat.Intellect]: 77,
      [Stat.SpellPower]: 461,
      [Stat.HitRating]: 95,
      [Stat.HasteRating]: 104,
    },
    Quality: Quality.Epic,
    Name: 'Greatstaff of the Nexus',
    Sources: [ItemSourceName.EyeOfEternity10],
    Id: 40489,
    Phase: 1,
    ItemSlot: ItemSlot.Weapon,
    IsTwoHand: true,
  },
  {
    IconName: 'inv_chest_cloth_73',
    Stats: {
      [Stat.Stamina]: 85,
      [Stat.Intellect]: 70,
      [Stat.SpellPower]: 110,
      [Stat.CritRating]: 50,
      [Stat.HitRating]: 72,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Yellow],
    SocketBonus: {
      [Stat.CritRating]: 3,
    },
    Name: 'Gown of the Spell-Weaver',
    Id: 40526,
    Phase: 1,
    ItemSlot: ItemSlot.Chest,
  },
  {
    IconName: 'inv_shoulder_72',
    Stats: {
      [Stat.Stamina]: 79,
      [Stat.Intellect]: 59,
      [Stat.Spirit]: 52,
      [Stat.SpellPower]: 98,
      [Stat.CritRating]: 60,
    },
    Quality: Quality.Epic,
    Name: 'Mantle of Dissemination',
    Id: 40555,
    Phase: 1,
    ItemSlot: ItemSlot.Shoulders,
  },
  {
    IconName: 'inv_boots_cloth_16',
    Stats: {
      [Stat.Stamina]: 89,
      [Stat.Intellect]: 52,
      [Stat.Spirit]: 62,
      [Stat.SpellPower]: 99,
      [Stat.HasteRating]: 46,
    },
    Quality: Quality.Epic,
    Name: 'Arcanic Tramplers',
    Id: 40558,
    Phase: 1,
    ItemSlot: ItemSlot.Feet,
  },
  {
    IconName: 'inv_pants_cloth_24',
    Stats: {
      [Stat.Stamina]: 73,
      [Stat.Intellect]: 92,
      [Stat.SpellPower]: 132,
      [Stat.HitRating]: 82,
      [Stat.HasteRating]: 66,
    },
    Quality: Quality.Epic,
    Name: 'Leggings of the Wanton Spellcaster',
    Id: 40560,
    Phase: 1,
    ItemSlot: ItemSlot.Legs,
  },
  {
    IconName: 'inv_belt_10',
    Stats: {
      [Stat.Stamina]: 66,
      [Stat.Intellect]: 60,
      [Stat.Spirit]: 48,
      [Stat.SpellPower]: 103,
      [Stat.HasteRating]: 62,
    },
    Quality: Quality.Epic,
    Name: 'Leash of Heedless Magic',
    Id: 40561,
    Phase: 1,
    ItemSlot: ItemSlot.Waist,
  },
  {
    IconName: 'inv_helmet_133',
    Stats: {
      [Stat.Stamina]: 96,
      [Stat.Intellect]: 63,
      [Stat.Spirit]: 81,
      [Stat.SpellPower]: 120,
      [Stat.CritRating]: 50,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Meta, SocketColor.Blue],
    SocketBonus: {
      [Stat.Mp5]: 2,
    },
    Name: 'Hood of Rationality',
    Sources: [ItemSourceName.EyeOfEternity25],
    Id: 40562,
    Phase: 1,
    ItemSlot: ItemSlot.Head,
  },
  {
    IconName: 'inv_jewelry_ring_73',
    Stats: {
      [Stat.Stamina]: 49,
      [Stat.Intellect]: 34,
      [Stat.SpellPower]: 59,
      [Stat.CritRating]: 36,
      [Stat.HasteRating]: 28,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: 'Signet of the Kirin Tor',
    Id: 40585,
    Phase: 1,
    ItemSlot: ItemSlot.Finger,
  },
  {
    IconName: 'inv_chest_cloth_32',
    Stats: {
      [Stat.Stamina]: 75,
      [Stat.Intellect]: 77,
      [Stat.Spirit]: 71,
      [Stat.SpellPower]: 99,
      [Stat.CritRating]: 42,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Red, SocketColor.Yellow],
    SocketBonus: {
      [Stat.Spirit]: 6,
    },
    Name: 'Robes of Mutation',
    Id: 40602,
    Phase: 1,
    ItemSlot: ItemSlot.Chest,
  },
  {
    IconName: 'inv_jewelry_necklace_27naxxramas',
    Stats: {
      [Stat.Stamina]: 49,
      [Stat.Intellect]: 38,
      [Stat.Spirit]: 34,
      [Stat.SpellPower]: 59,
      [Stat.HitRating]: 25,
    },
    Quality: Quality.Epic,
    Name: 'Encircling Burnished Gold Chains',
    Sources: [ItemSourceName.EmblemOfHeroism],
    Id: 40680,
    Phase: 1,
    ItemSlot: ItemSlot.Neck,
  },
  {
    IconName: 'inv_jewelry_necklace_28naxxramas',
    Stats: {
      [Stat.Stamina]: 37,
      [Stat.Intellect]: 38,
      [Stat.SpellPower]: 59,
      [Stat.CritRating]: 34,
      [Stat.Mp5]: 16,
    },
    Quality: Quality.Epic,
    Name: 'Lattice Choker of Light',
    Sources: [ItemSourceName.EmblemOfHeroism],
    Id: 40681,
    Phase: 1,
    ItemSlot: ItemSlot.Neck,
  },
  {
    IconName: 'ability_hunter_readiness',
    Stats: {
      [Stat.CritRating]: 84,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: 'Sundial of the Exiled',
    Id: 40682,
    Phase: 1,
    ItemSlot: ItemSlot.Trinket,
  },
  {
    IconName: 'inv_belt_07',
    Stats: {
      [Stat.Stamina]: 49,
      [Stat.Intellect]: 52,
      [Stat.SpellPower]: 68,
      [Stat.HitRating]: 33,
      [Stat.HasteRating]: 42,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Yellow],
    SocketBonus: {
      [Stat.HitRating]: 4,
    },
    Name: 'Plush Sash of Guzbah',
    Id: 40696,
    Phase: 1,
    ItemSlot: ItemSlot.Waist,
  },
  {
    IconName: 'inv_belt_08',
    Stats: {
      [Stat.Stamina]: 57,
      [Stat.Intellect]: 48,
      [Stat.Spirit]: 43,
      [Stat.SpellPower]: 68,
      [Stat.Mp5]: 16,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Yellow],
    SocketBonus: {
      [Stat.Spirit]: 4,
    },
    Name: "Elegant Temple Gardens' Girdle",
    Id: 40697,
    Phase: 1,
    ItemSlot: ItemSlot.Waist,
  },
  {
    IconName: 'inv_offhand_dalaran_d_01',
    Stats: {
      [Stat.Stamina]: 49,
      [Stat.Intellect]: 34,
      [Stat.SpellPower]: 59,
      [Stat.CritRating]: 25,
      [Stat.HitRating]: 38,
    },
    Quality: Quality.Epic,
    Name: 'Ward of the Violet Citadel',
    Sources: [ItemSourceName.EmblemOfHeroism],
    Id: 40698,
    Phase: 1,
    ItemSlot: ItemSlot.OffHand,
  },
  {
    IconName: 'inv_misc_book_06',
    Stats: {
      [Stat.Stamina]: 43,
      [Stat.Intellect]: 36,
      [Stat.Spirit]: 38,
      [Stat.SpellPower]: 59,
      [Stat.HasteRating]: 25,
    },
    Quality: Quality.Epic,
    Name: 'Handbook of Obscure Remedies',
    Sources: [ItemSourceName.EmblemOfHeroism],
    Id: 40699,
    Phase: 1,
    ItemSlot: ItemSlot.OffHand,
  },
  {
    IconName: 'inv_jewelry_ring_68',
    Stats: {
      [Stat.Stamina]: 42,
      [Stat.Intellect]: 41,
      [Stat.Spirit]: 32,
      [Stat.SpellPower]: 65,
      [Stat.HasteRating]: 43,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: 'Band of Channeled Magic',
    Id: 40719,
    Phase: 1,
    ItemSlot: ItemSlot.Finger,
  },
  {
    IconName: 'inv_jewelry_ring_69',
    Stats: {
      [Stat.Stamina]: 48,
      [Stat.Intellect]: 41,
      [Stat.SpellPower]: 66,
      [Stat.CritRating]: 28,
      [Stat.Mp5]: 21,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: 'Renewal of Life',
    Id: 40720,
    Phase: 1,
    ItemSlot: ItemSlot.Finger,
  },
  {
    IconName: 'inv_misc_cape_18',
    Stats: {
      [Stat.Stamina]: 48,
      [Stat.Intellect]: 38,
      [Stat.Spirit]: 37,
      [Stat.SpellPower]: 65,
      [Stat.HasteRating]: 41,
    },
    Quality: Quality.Epic,
    Name: 'Disguise of the Kumiho',
    Id: 40723,
    Phase: 1,
    ItemSlot: ItemSlot.Back,
  },
  {
    IconName: 'inv_misc_cape_17',
    Stats: {
      [Stat.Stamina]: 42,
      [Stat.Intellect]: 43,
      [Stat.SpellPower]: 66,
      [Stat.HasteRating]: 28,
      [Stat.Mp5]: 21,
    },
    Quality: Quality.Epic,
    Name: 'Cloak of Kea Feathers',
    Id: 40724,
    Phase: 1,
    ItemSlot: ItemSlot.Back,
  },
  {
    IconName: 'inv_bracer_18',
    Stats: {
      [Stat.Stamina]: 48,
      [Stat.Intellect]: 41,
      [Stat.Spirit]: 43,
      [Stat.SpellPower]: 65,
      [Stat.HitRating]: 28,
    },
    Quality: Quality.Epic,
    Name: 'Wraps of the Astral Traveler',
    Id: 40740,
    Phase: 1,
    ItemSlot: ItemSlot.Wrist,
  },
  {
    IconName: 'inv_bracer_07',
    Stats: {
      [Stat.Stamina]: 42,
      [Stat.Intellect]: 43,
      [Stat.SpellPower]: 66,
      [Stat.HasteRating]: 38,
      [Stat.Mp5]: 19,
    },
    Quality: Quality.Epic,
    Name: 'Cuffs of the Shadow Ascendant',
    Id: 40741,
    Phase: 1,
    ItemSlot: ItemSlot.Wrist,
  },
  {
    IconName: 'inv_boots_cloth_03',
    Stats: {
      [Stat.Stamina]: 55,
      [Stat.Intellect]: 57,
      [Stat.Spirit]: 55,
      [Stat.SpellPower]: 88,
      [Stat.HitRating]: 43,
    },
    Quality: Quality.Epic,
    Name: "Xintor's Expeditionary Boots",
    Id: 40750,
    Phase: 1,
    ItemSlot: ItemSlot.Feet,
  },
  {
    IconName: 'inv_boots_cloth_09',
    Stats: {
      [Stat.Stamina]: 64,
      [Stat.Intellect]: 55,
      [Stat.Spirit]: 57,
      [Stat.SpellPower]: 88,
      [Stat.HasteRating]: 37,
    },
    Quality: Quality.Epic,
    Name: 'Slippers of the Holy Light',
    Id: 40751,
    Phase: 1,
    ItemSlot: ItemSlot.Feet,
  },
  {
    IconName: 'spell_nature_lightningoverload',
    Stats: {
      [Stat.CritRating]: 84,
    },
    Quality: Quality.Rare,
    Name: 'Gnomish Lightning Generator',
    Id: 41121,
    Phase: 1,
    ItemSlot: ItemSlot.Trinket,
  },
  {
    IconName: 'inv_gauntlets_06',
    Stats: {
      [Stat.Stamina]: 51,
      [Stat.Intellect]: 34,
      [Stat.SpellPower]: 60,
      [Stat.CritRating]: 34,
      [Stat.ResilienceRating]: 34,
    },
    Quality: Quality.Rare,
    Set: ItemSet.FrostsavageBattlegear,
    Name: 'Frostsavage Gloves',
    Sources: [ItemSourceName.TailoringBoE],
    Id: 41516,
    Phase: 1,
    ItemSlot: ItemSlot.Hands,
  },
  {
    IconName: 'inv_pants_cloth_11',
    Stats: {
      [Stat.Stamina]: 60,
      [Stat.Intellect]: 50,
      [Stat.SpellPower]: 81,
      [Stat.HasteRating]: 69,
    },
    Quality: Quality.Rare,
    Set: ItemSet.Duskweaver,
    Name: 'Black Duskweave Leggings',
    Id: 41553,
    Phase: 1,
    ItemSlot: ItemSlot.Legs,
  },
  {
    IconName: 'inv_chest_cloth_19',
    Stats: {
      [Stat.Stamina]: 67,
      [Stat.Intellect]: 46,
      [Stat.SpellPower]: 80,
      [Stat.HasteRating]: 70,
    },
    Quality: Quality.Rare,
    Set: ItemSet.Duskweaver,
    Name: 'Black Duskweave Robe',
    Id: 41554,
    Phase: 1,
    ItemSlot: ItemSlot.Chest,
  },
  {
    IconName: 'inv_bracer_11',
    Stats: {
      [Stat.Stamina]: 33,
      [Stat.Intellect]: 27,
      [Stat.SpellPower]: 46,
      [Stat.HasteRating]: 38,
    },
    Quality: Quality.Rare,
    Set: ItemSet.Duskweaver,
    Name: 'Black Duskweave Wristwraps',
    Id: 41555,
    Phase: 1,
    ItemSlot: ItemSlot.Wrist,
  },
  {
    IconName: 'inv_misc_cape_02',
    Stats: {
      [Stat.Stamina]: 43,
      [Stat.Intellect]: 36,
      [Stat.SpellPower]: 59,
      [Stat.Mp5]: 25,
    },
    Quality: Quality.Epic,
    Name: 'Wispcloak',
    Id: 41609,
    Phase: 1,
    ItemSlot: ItemSlot.Back,
  },
  {
    IconName: 'inv_misc_cape_02',
    Stats: {
      [Stat.SpellPower]: 59,
      [Stat.CritRating]: 43,
      [Stat.HasteRating]: 53,
    },
    Quality: Quality.Epic,
    Name: 'Deathchill Cloak',
    Id: 41610,
    Phase: 1,
    ItemSlot: ItemSlot.Back,
  },
  {
    IconName: 'inv_helmet_29',
    Stats: {
      [Stat.Stamina]: 69,
      [Stat.Intellect]: 46,
      [Stat.SpellPower]: 53,
      [Stat.HitRating]: 44,
    },
    Quality: Quality.Rare,
    Sockets: [SocketColor.Meta, SocketColor.Red],
    SocketBonus: {
      [Stat.Intellect]: 8,
    },
    Name: 'Hat of Wintry Doom',
    Sources: [ItemSourceName.TailoringBoE],
    Id: 41984,
    Phase: 1,
    ItemSlot: ItemSlot.Head,
  },
  {
    IconName: 'inv_boots_cloth_19',
    Stats: {
      [Stat.Stamina]: 76,
      [Stat.SpellPower]: 60,
      [Stat.CritRating]: 37,
      [Stat.HasteRating]: 29,
    },
    Quality: Quality.Rare,
    Name: 'Silky Iceshard Boots',
    Id: 41985,
    Phase: 1,
    ItemSlot: ItemSlot.Feet,
  },
  {
    IconName: 'inv_belt_31',
    Stats: {
      [Stat.Stamina]: 43,
      [Stat.Intellect]: 50,
      [Stat.SpellPower]: 61,
      [Stat.CritRating]: 36,
    },
    Quality: Quality.Rare,
    Name: 'Deep Frozen Cord',
    Id: 41986,
    Phase: 1,
    ItemSlot: ItemSlot.Waist,
  },
  {
    IconName: 'inv_helmet_139',
    Stats: {
      [Stat.Stamina]: 88,
      [Stat.Intellect]: 39,
      [Stat.SpellPower]: 73,
      [Stat.CritRating]: 36,
      [Stat.ResilienceRating]: 36,
    },
    Quality: Quality.Rare,
    Set: ItemSet.GladiatorsFelshroud,
    Sockets: [SocketColor.Meta, SocketColor.Red],
    SocketBonus: {
      [Stat.ResilienceRating]: 8,
    },
    Name: "Savage Gladiator's Felweave Cowl",
    Id: 41990,
    Phase: 1,
    ItemSlot: ItemSlot.Head,
  },
  {
    IconName: 'inv_helmet_139',
    Stats: {
      [Stat.Stamina]: 102,
      [Stat.Intellect]: 45,
      [Stat.SpellPower]: 87,
      [Stat.CritRating]: 44,
      [Stat.ResilienceRating]: 43,
    },
    Quality: Quality.Epic,
    Set: ItemSet.GladiatorsFelshroud,
    Sockets: [SocketColor.Meta, SocketColor.Red],
    SocketBonus: {
      [Stat.ResilienceRating]: 8,
    },
    Name: "Hateful Gladiator's Felweave Cowl",
    Id: 41991,
    Phase: 1,
    ItemSlot: ItemSlot.Head,
  },
  {
    IconName: 'inv_helmet_139',
    Stats: {
      [Stat.Stamina]: 115,
      [Stat.Intellect]: 50,
      [Stat.SpellPower]: 99,
      [Stat.CritRating]: 51,
      [Stat.ResilienceRating]: 50,
    },
    Quality: Quality.Epic,
    Set: ItemSet.GladiatorsFelshroud,
    Sockets: [SocketColor.Meta, SocketColor.Red],
    SocketBonus: {
      [Stat.ResilienceRating]: 8,
    },
    Name: "Deadly Gladiator's Felweave Cowl",
    Id: 41992,
    Phase: 1,
    ItemSlot: ItemSlot.Head,
  },
  {
    IconName: 'inv_helmet_137',
    Stats: {
      [Stat.Stamina]: 138,
      [Stat.Intellect]: 60,
      [Stat.SpellPower]: 123,
      [Stat.CritRating]: 64,
      [Stat.ResilienceRating]: 64,
    },
    Quality: Quality.Epic,
    Set: ItemSet.GladiatorsFelshroud,
    Sockets: [SocketColor.Meta, SocketColor.Red],
    SocketBonus: {
      [Stat.ResilienceRating]: 8,
    },
    Name: "Furious Gladiator's Felweave Cowl",
    Id: 41993,
    Phase: 1,
    ItemSlot: ItemSlot.Head,
  },
  {
    IconName: 'inv_helmet_137',
    Stats: {
      [Stat.Stamina]: 164,
      [Stat.Intellect]: 73,
      [Stat.SpellPower]: 149,
      [Stat.CritRating]: 80,
      [Stat.ResilienceRating]: 80,
    },
    Quality: Quality.Epic,
    Set: ItemSet.GladiatorsFelshroud,
    Sockets: [SocketColor.Meta, SocketColor.Red],
    SocketBonus: {
      [Stat.ResilienceRating]: 8,
    },
    Name: "Relentless Gladiator's Felweave Cowl",
    Id: 41994,
    Phase: 1,
    ItemSlot: ItemSlot.Head,
  },
  {
    IconName: 'inv_chest_cloth_63',
    Stats: {
      [Stat.Stamina]: 88,
      [Stat.Intellect]: 39,
      [Stat.SpellPower]: 73,
      [Stat.CritRating]: 36,
      [Stat.ResilienceRating]: 51,
    },
    Quality: Quality.Rare,
    Set: ItemSet.GladiatorsFelshroud,
    Sockets: [SocketColor.Red, SocketColor.Yellow],
    SocketBonus: {
      [Stat.Stamina]: 9,
    },
    Name: "Savage Gladiator's Felweave Raiment",
    Id: 41996,
    Phase: 1,
    ItemSlot: ItemSlot.Chest,
  },
  {
    IconName: 'inv_chest_cloth_63',
    Stats: {
      [Stat.Stamina]: 115,
      [Stat.Intellect]: 50,
      [Stat.SpellPower]: 98,
      [Stat.CritRating]: 51,
      [Stat.ResilienceRating]: 66,
    },
    Quality: Quality.Epic,
    Set: ItemSet.GladiatorsFelshroud,
    Sockets: [SocketColor.Red, SocketColor.Yellow],
    SocketBonus: {
      [Stat.Stamina]: 9,
    },
    Name: "Deadly Gladiator's Felweave Raiment",
    Id: 41997,
    Phase: 1,
    ItemSlot: ItemSlot.Chest,
  },
  {
    IconName: 'inv_chest_cloth_63',
    Stats: {
      [Stat.Stamina]: 138,
      [Stat.Intellect]: 60,
      [Stat.SpellPower]: 123,
      [Stat.CritRating]: 64,
      [Stat.ResilienceRating]: 80,
    },
    Quality: Quality.Epic,
    Set: ItemSet.GladiatorsFelshroud,
    Sockets: [SocketColor.Red, SocketColor.Yellow],
    SocketBonus: {
      [Stat.Stamina]: 9,
    },
    Name: "Furious Gladiator's Felweave Raiment",
    Id: 41998,
    Phase: 1,
    ItemSlot: ItemSlot.Chest,
  },
  {
    IconName: 'inv_chest_cloth_74',
    Stats: {
      [Stat.Stamina]: 164,
      [Stat.Intellect]: 73,
      [Stat.SpellPower]: 149,
      [Stat.CritRating]: 80,
      [Stat.ResilienceRating]: 96,
    },
    Quality: Quality.Epic,
    Set: ItemSet.GladiatorsFelshroud,
    Sockets: [SocketColor.Red, SocketColor.Yellow],
    SocketBonus: {
      [Stat.Stamina]: 9,
    },
    Name: "Relentless Gladiator's Felweave Raiment",
    Id: 41999,
    Phase: 1,
    ItemSlot: ItemSlot.Chest,
  },
  {
    IconName: 'inv_chest_cloth_63',
    Stats: {
      [Stat.Stamina]: 102,
      [Stat.Intellect]: 45,
      [Stat.SpellPower]: 87,
      [Stat.CritRating]: 44,
      [Stat.ResilienceRating]: 59,
    },
    Quality: Quality.Epic,
    Set: ItemSet.GladiatorsFelshroud,
    Sockets: [SocketColor.Red, SocketColor.Yellow],
    SocketBonus: {
      [Stat.Stamina]: 9,
    },
    Name: "Hateful Gladiator's Felweave Raiment",
    Id: 42001,
    Phase: 1,
    ItemSlot: ItemSlot.Chest,
  },
  {
    IconName: 'inv_pants_cloth_28',
    Stats: {
      [Stat.Stamina]: 88,
      [Stat.Intellect]: 39,
      [Stat.SpellPower]: 73,
      [Stat.CritRating]: 36,
      [Stat.ResilienceRating]: 52,
    },
    Quality: Quality.Rare,
    Set: ItemSet.GladiatorsFelshroud,
    Sockets: [SocketColor.Red, SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 7,
    },
    Name: "Savage Gladiator's Felweave Trousers",
    Id: 42002,
    Phase: 1,
    ItemSlot: ItemSlot.Legs,
  },
  {
    IconName: 'inv_pants_cloth_28',
    Stats: {
      [Stat.Stamina]: 102,
      [Stat.Intellect]: 45,
      [Stat.SpellPower]: 87,
      [Stat.CritRating]: 44,
      [Stat.ResilienceRating]: 59,
    },
    Quality: Quality.Epic,
    Set: ItemSet.GladiatorsFelshroud,
    Sockets: [SocketColor.Red, SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 7,
    },
    Name: "Hateful Gladiator's Felweave Trousers",
    Id: 42003,
    Phase: 1,
    ItemSlot: ItemSlot.Legs,
  },
  {
    IconName: 'inv_pants_cloth_28',
    Stats: {
      [Stat.Stamina]: 115,
      [Stat.Intellect]: 50,
      [Stat.SpellPower]: 99,
      [Stat.CritRating]: 51,
      [Stat.ResilienceRating]: 66,
    },
    Quality: Quality.Epic,
    Set: ItemSet.GladiatorsFelshroud,
    Sockets: [SocketColor.Red, SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 7,
    },
    Name: "Deadly Gladiator's Felweave Trousers",
    Id: 42004,
    Phase: 1,
    ItemSlot: ItemSlot.Legs,
  },
  {
    IconName: 'inv_pants_cloth_24',
    Stats: {
      [Stat.Stamina]: 138,
      [Stat.Intellect]: 60,
      [Stat.SpellPower]: 123,
      [Stat.CritRating]: 64,
      [Stat.ResilienceRating]: 80,
    },
    Quality: Quality.Epic,
    Set: ItemSet.GladiatorsFelshroud,
    Sockets: [SocketColor.Red, SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 7,
    },
    Name: "Furious Gladiator's Felweave Trousers",
    Id: 42005,
    Phase: 1,
    ItemSlot: ItemSlot.Legs,
  },
  {
    IconName: 'inv_pants_cloth_30',
    Stats: {
      [Stat.Stamina]: 164,
      [Stat.Intellect]: 73,
      [Stat.SpellPower]: 149,
      [Stat.CritRating]: 80,
      [Stat.ResilienceRating]: 96,
    },
    Quality: Quality.Epic,
    Set: ItemSet.GladiatorsFelshroud,
    Sockets: [SocketColor.Red, SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 7,
    },
    Name: "Relentless Gladiator's Felweave Trousers",
    Id: 42006,
    Phase: 1,
    ItemSlot: ItemSlot.Legs,
  },
  {
    IconName: 'inv_shoulder_99',
    Stats: {
      [Stat.Stamina]: 66,
      [Stat.Intellect]: 28,
      [Stat.SpellPower]: 59,
      [Stat.CritRating]: 31,
      [Stat.ResilienceRating]: 38,
    },
    Quality: Quality.Rare,
    Set: ItemSet.GladiatorsFelshroud,
    Sockets: [SocketColor.Yellow],
    SocketBonus: {
      [Stat.Stamina]: 6,
    },
    Name: "Savage Gladiator's Felweave Amice",
    Id: 42008,
    Phase: 1,
    ItemSlot: ItemSlot.Shoulders,
  },
  {
    IconName: 'inv_shoulder_99',
    Stats: {
      [Stat.Stamina]: 76,
      [Stat.Intellect]: 33,
      [Stat.SpellPower]: 68,
      [Stat.CritRating]: 36,
      [Stat.ResilienceRating]: 44,
    },
    Quality: Quality.Epic,
    Set: ItemSet.GladiatorsFelshroud,
    Sockets: [SocketColor.Yellow],
    SocketBonus: {
      [Stat.Stamina]: 6,
    },
    Name: "Hateful Gladiator's Felweave Amice",
    Id: 42009,
    Phase: 1,
    ItemSlot: ItemSlot.Shoulders,
  },
  {
    IconName: 'inv_shoulder_99',
    Stats: {
      [Stat.Stamina]: 85,
      [Stat.Intellect]: 37,
      [Stat.SpellPower]: 78,
      [Stat.CritRating]: 42,
      [Stat.ResilienceRating]: 50,
    },
    Quality: Quality.Epic,
    Set: ItemSet.GladiatorsFelshroud,
    Sockets: [SocketColor.Yellow],
    SocketBonus: {
      [Stat.Stamina]: 6,
    },
    Name: "Deadly Gladiator's Felweave Amice",
    Id: 42010,
    Phase: 1,
    ItemSlot: ItemSlot.Shoulders,
  },
  {
    IconName: 'inv_shoulder_101',
    Stats: {
      [Stat.Stamina]: 102,
      [Stat.Intellect]: 45,
      [Stat.SpellPower]: 96,
      [Stat.CritRating]: 51,
      [Stat.ResilienceRating]: 60,
    },
    Quality: Quality.Epic,
    Set: ItemSet.GladiatorsFelshroud,
    Sockets: [SocketColor.Yellow],
    SocketBonus: {
      [Stat.Stamina]: 6,
    },
    Name: "Furious Gladiator's Felweave Amice",
    Id: 42011,
    Phase: 1,
    ItemSlot: ItemSlot.Shoulders,
  },
  {
    IconName: 'inv_shoulder_106',
    Stats: {
      [Stat.Stamina]: 122,
      [Stat.Intellect]: 54,
      [Stat.SpellPower]: 116,
      [Stat.CritRating]: 63,
      [Stat.ResilienceRating]: 71,
    },
    Quality: Quality.Epic,
    Set: ItemSet.GladiatorsFelshroud,
    Sockets: [SocketColor.Yellow],
    SocketBonus: {
      [Stat.Stamina]: 6,
    },
    Name: "Relentless Gladiator's Felweave Amice",
    Id: 42012,
    Phase: 1,
    ItemSlot: ItemSlot.Shoulders,
  },
  {
    IconName: 'inv_gauntlets_64',
    Stats: {
      [Stat.Stamina]: 66,
      [Stat.Intellect]: 28,
      [Stat.SpellPower]: 59,
      [Stat.CritRating]: 22,
      [Stat.ResilienceRating]: 30,
    },
    Quality: Quality.Rare,
    Set: ItemSet.GladiatorsFelshroud,
    Sockets: [SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Name: "Savage Gladiator's Felweave Handguards",
    Id: 42014,
    Phase: 1,
    ItemSlot: ItemSlot.Hands,
  },
  {
    IconName: 'inv_gauntlets_64',
    Stats: {
      [Stat.Stamina]: 76,
      [Stat.Intellect]: 33,
      [Stat.SpellPower]: 68,
      [Stat.CritRating]: 27,
      [Stat.ResilienceRating]: 35,
    },
    Quality: Quality.Epic,
    Set: ItemSet.GladiatorsFelshroud,
    Sockets: [SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Name: "Hateful Gladiator's Felweave Handguards",
    Id: 42015,
    Phase: 1,
    ItemSlot: ItemSlot.Hands,
  },
  {
    IconName: 'inv_gauntlets_64',
    Stats: {
      [Stat.Stamina]: 85,
      [Stat.Intellect]: 37,
      [Stat.SpellPower]: 78,
      [Stat.CritRating]: 32,
      [Stat.ResilienceRating]: 39,
    },
    Quality: Quality.Epic,
    Set: ItemSet.GladiatorsFelshroud,
    Sockets: [SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Name: "Deadly Gladiator's Felweave Handguards",
    Id: 42016,
    Phase: 1,
    ItemSlot: ItemSlot.Hands,
  },
  {
    IconName: 'inv_gauntlets_72',
    Stats: {
      [Stat.Stamina]: 102,
      [Stat.Intellect]: 45,
      [Stat.SpellPower]: 96,
      [Stat.CritRating]: 39,
      [Stat.ResilienceRating]: 47,
    },
    Quality: Quality.Epic,
    Set: ItemSet.GladiatorsFelshroud,
    Sockets: [SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Name: "Furious Gladiator's Felweave Handguards",
    Id: 42017,
    Phase: 1,
    ItemSlot: ItemSlot.Hands,
  },
  {
    IconName: 'inv_gauntlets_49',
    Stats: {
      [Stat.Stamina]: 122,
      [Stat.Intellect]: 54,
      [Stat.SpellPower]: 116,
      [Stat.CritRating]: 63,
      [Stat.ResilienceRating]: 71,
    },
    Quality: Quality.Epic,
    Set: ItemSet.GladiatorsFelshroud,
    Sockets: [SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Name: "Relentless Gladiator's Felweave Handguards",
    Id: 42018,
    Phase: 1,
    ItemSlot: ItemSlot.Hands,
  },
  {
    IconName: 'inv_jewelry_necklace_36',
    Stats: {
      [Stat.Stamina]: 66,
      [Stat.Intellect]: 29,
      [Stat.SpellPower]: 66,
      [Stat.CritRating]: 38,
      [Stat.ResilienceRating]: 37,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: "Deadly Gladiator's Pendant of Dominance",
    Id: 42029,
    Phase: 1,
    ItemSlot: ItemSlot.Neck,
  },
  {
    IconName: 'inv_jewelry_necklace_36',
    Stats: {
      [Stat.Stamina]: 66,
      [Stat.Intellect]: 29,
      [Stat.SpellPower]: 66,
      [Stat.HitRating]: 38,
      [Stat.ResilienceRating]: 37,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: "Deadly Gladiator's Pendant of Ascendancy",
    Id: 42030,
    Phase: 1,
    ItemSlot: ItemSlot.Neck,
  },
  {
    IconName: 'inv_jewelry_necklace_36',
    Stats: {
      [Stat.Stamina]: 66,
      [Stat.Intellect]: 29,
      [Stat.SpellPower]: 66,
      [Stat.ResilienceRating]: 37,
      [Stat.HasteRating]: 38,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: "Deadly Gladiator's Pendant of Subjugation",
    Id: 42031,
    Phase: 1,
    ItemSlot: ItemSlot.Neck,
  },
  {
    IconName: 'inv_jewelry_necklace_36',
    Stats: {
      [Stat.Stamina]: 66,
      [Stat.Intellect]: 29,
      [Stat.Spirit]: 38,
      [Stat.SpellPower]: 66,
      [Stat.ResilienceRating]: 37,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: "Deadly Gladiator's Pendant of Deliverance",
    Id: 42032,
    Phase: 1,
    ItemSlot: ItemSlot.Neck,
  },
  {
    IconName: 'inv_jewelry_necklace_36',
    Stats: {
      [Stat.Stamina]: 66,
      [Stat.Intellect]: 29,
      [Stat.SpellPower]: 66,
      [Stat.ResilienceRating]: 37,
      [Stat.Mp5]: 19,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: "Deadly Gladiator's Pendant of Salvation",
    Id: 42033,
    Phase: 1,
    ItemSlot: ItemSlot.Neck,
  },
  {
    IconName: 'inv_jewelry_necklace_36',
    Stats: {
      [Stat.Stamina]: 73,
      [Stat.Intellect]: 31,
      [Stat.SpellPower]: 73,
      [Stat.CritRating]: 42,
      [Stat.ResilienceRating]: 42,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: "Furious Gladiator's Pendant of Dominance",
    Id: 42036,
    Phase: 1,
    ItemSlot: ItemSlot.Neck,
  },
  {
    IconName: 'inv_jewelry_necklace_36',
    Stats: {
      [Stat.Stamina]: 73,
      [Stat.Intellect]: 31,
      [Stat.SpellPower]: 73,
      [Stat.HitRating]: 42,
      [Stat.ResilienceRating]: 42,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: "Furious Gladiator's Pendant of Ascendancy",
    Id: 42037,
    Phase: 1,
    ItemSlot: ItemSlot.Neck,
  },
  {
    IconName: 'inv_jewelry_necklace_36',
    Stats: {
      [Stat.Stamina]: 73,
      [Stat.Intellect]: 31,
      [Stat.SpellPower]: 73,
      [Stat.ResilienceRating]: 42,
      [Stat.HasteRating]: 42,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: "Furious Gladiator's Pendant of Subjugation",
    Id: 42038,
    Phase: 1,
    ItemSlot: ItemSlot.Neck,
  },
  {
    IconName: 'inv_jewelry_necklace_36',
    Stats: {
      [Stat.Stamina]: 73,
      [Stat.Intellect]: 31,
      [Stat.Spirit]: 42,
      [Stat.SpellPower]: 73,
      [Stat.ResilienceRating]: 42,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: "Furious Gladiator's Pendant of Deliverance",
    Id: 42039,
    Phase: 1,
    ItemSlot: ItemSlot.Neck,
  },
  {
    IconName: 'inv_jewelry_necklace_36',
    Stats: {
      [Stat.Stamina]: 73,
      [Stat.Intellect]: 31,
      [Stat.SpellPower]: 73,
      [Stat.ResilienceRating]: 42,
      [Stat.Mp5]: 21,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: "Furious Gladiator's Pendant of Salvation",
    Id: 42040,
    Phase: 1,
    ItemSlot: ItemSlot.Neck,
  },
  {
    IconName: 'inv_jewelry_necklace_36',
    Stats: {
      [Stat.Stamina]: 86,
      [Stat.Intellect]: 38,
      [Stat.SpellPower]: 89,
      [Stat.CritRating]: 50,
      [Stat.ResilienceRating]: 50,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: "Relentless Gladiator's Pendant of Dominance",
    Id: 42043,
    Phase: 1,
    ItemSlot: ItemSlot.Neck,
  },
  {
    IconName: 'inv_jewelry_necklace_36',
    Stats: {
      [Stat.Stamina]: 86,
      [Stat.Intellect]: 38,
      [Stat.SpellPower]: 89,
      [Stat.HitRating]: 50,
      [Stat.ResilienceRating]: 50,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: "Relentless Gladiator's Pendant of Ascendancy",
    Id: 42044,
    Phase: 1,
    ItemSlot: ItemSlot.Neck,
  },
  {
    IconName: 'inv_jewelry_necklace_36',
    Stats: {
      [Stat.Stamina]: 86,
      [Stat.Intellect]: 38,
      [Stat.SpellPower]: 89,
      [Stat.ResilienceRating]: 50,
      [Stat.HasteRating]: 50,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: "Relentless Gladiator's Pendant of Subjugation",
    Id: 42045,
    Phase: 1,
    ItemSlot: ItemSlot.Neck,
  },
  {
    IconName: 'inv_jewelry_necklace_36',
    Stats: {
      [Stat.Stamina]: 86,
      [Stat.Intellect]: 38,
      [Stat.Spirit]: 50,
      [Stat.SpellPower]: 89,
      [Stat.ResilienceRating]: 50,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: "Relentless Gladiator's Pendant of Deliverance",
    Id: 42046,
    Phase: 1,
    ItemSlot: ItemSlot.Neck,
  },
  {
    IconName: 'inv_jewelry_necklace_36',
    Stats: {
      [Stat.Stamina]: 86,
      [Stat.Intellect]: 38,
      [Stat.SpellPower]: 89,
      [Stat.ResilienceRating]: 50,
      [Stat.Mp5]: 25,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: "Relentless Gladiator's Pendant of Salvation",
    Id: 42047,
    Phase: 1,
    ItemSlot: ItemSlot.Neck,
  },
  {
    IconName: 'inv_misc_cape_19',
    Stats: {
      [Stat.Stamina]: 66,
      [Stat.Intellect]: 29,
      [Stat.SpellPower]: 66,
      [Stat.CritRating]: 38,
      [Stat.ResilienceRating]: 37,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: "Deadly Gladiator's Cloak of Dominance",
    Id: 42062,
    Phase: 1,
    ItemSlot: ItemSlot.Back,
  },
  {
    IconName: 'inv_misc_cape_19',
    Stats: {
      [Stat.Stamina]: 66,
      [Stat.Intellect]: 29,
      [Stat.SpellPower]: 66,
      [Stat.ResilienceRating]: 37,
      [Stat.HasteRating]: 38,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: "Deadly Gladiator's Cloak of Subjugation",
    Id: 42063,
    Phase: 1,
    ItemSlot: ItemSlot.Back,
  },
  {
    IconName: 'inv_misc_cape_19',
    Stats: {
      [Stat.Stamina]: 66,
      [Stat.Intellect]: 29,
      [Stat.SpellPower]: 66,
      [Stat.HitRating]: 38,
      [Stat.ResilienceRating]: 37,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: "Deadly Gladiator's Cloak of Ascendancy",
    Id: 42064,
    Phase: 1,
    ItemSlot: ItemSlot.Back,
  },
  {
    IconName: 'inv_misc_cape_19',
    Stats: {
      [Stat.Stamina]: 66,
      [Stat.Intellect]: 29,
      [Stat.SpellPower]: 66,
      [Stat.ResilienceRating]: 37,
      [Stat.Mp5]: 19,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: "Deadly Gladiator's Cloak of Salvation",
    Id: 42065,
    Phase: 1,
    ItemSlot: ItemSlot.Back,
  },
  {
    IconName: 'inv_misc_cape_19',
    Stats: {
      [Stat.Stamina]: 66,
      [Stat.Intellect]: 29,
      [Stat.Spirit]: 38,
      [Stat.SpellPower]: 66,
      [Stat.ResilienceRating]: 37,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: "Deadly Gladiator's Cloak of Deliverance",
    Id: 42066,
    Phase: 1,
    ItemSlot: ItemSlot.Back,
  },
  {
    IconName: 'inv_misc_cape_19',
    Stats: {
      [Stat.Stamina]: 73,
      [Stat.Intellect]: 31,
      [Stat.SpellPower]: 73,
      [Stat.CritRating]: 42,
      [Stat.ResilienceRating]: 42,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: "Furious Gladiator's Cloak of Dominance",
    Id: 42069,
    Phase: 1,
    ItemSlot: ItemSlot.Back,
  },
  {
    IconName: 'inv_misc_cape_19',
    Stats: {
      [Stat.Stamina]: 73,
      [Stat.Intellect]: 31,
      [Stat.SpellPower]: 73,
      [Stat.ResilienceRating]: 42,
      [Stat.HasteRating]: 42,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: "Furious Gladiator's Cloak of Subjugation",
    Id: 42070,
    Phase: 1,
    ItemSlot: ItemSlot.Back,
  },
  {
    IconName: 'inv_misc_cape_19',
    Stats: {
      [Stat.Stamina]: 73,
      [Stat.Intellect]: 31,
      [Stat.SpellPower]: 73,
      [Stat.HitRating]: 42,
      [Stat.ResilienceRating]: 42,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: "Furious Gladiator's Cloak of Ascendancy",
    Id: 42071,
    Phase: 1,
    ItemSlot: ItemSlot.Back,
  },
  {
    IconName: 'inv_misc_cape_19',
    Stats: {
      [Stat.Stamina]: 73,
      [Stat.Intellect]: 31,
      [Stat.SpellPower]: 73,
      [Stat.ResilienceRating]: 42,
      [Stat.Mp5]: 21,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: "Furious Gladiator's Cloak of Salvation",
    Id: 42072,
    Phase: 1,
    ItemSlot: ItemSlot.Back,
  },
  {
    IconName: 'inv_misc_cape_19',
    Stats: {
      [Stat.Stamina]: 73,
      [Stat.Intellect]: 31,
      [Stat.Spirit]: 42,
      [Stat.SpellPower]: 73,
      [Stat.ResilienceRating]: 42,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: "Furious Gladiator's Cloak of Deliverance",
    Id: 42073,
    Phase: 1,
    ItemSlot: ItemSlot.Back,
  },
  {
    IconName: 'inv_misc_cape_20',
    Stats: {
      [Stat.Stamina]: 86,
      [Stat.Intellect]: 38,
      [Stat.SpellPower]: 89,
      [Stat.CritRating]: 50,
      [Stat.ResilienceRating]: 50,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: "Relentless Gladiator's Cloak of Dominance",
    Id: 42076,
    Phase: 1,
    ItemSlot: ItemSlot.Back,
  },
  {
    IconName: 'inv_misc_cape_16',
    Stats: {
      [Stat.Stamina]: 86,
      [Stat.Intellect]: 38,
      [Stat.SpellPower]: 89,
      [Stat.ResilienceRating]: 50,
      [Stat.HasteRating]: 50,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: "Relentless Gladiator's Cloak of Subjugation",
    Id: 42077,
    Phase: 1,
    ItemSlot: ItemSlot.Back,
  },
  {
    IconName: 'inv_misc_cape_06',
    Stats: {
      [Stat.Stamina]: 86,
      [Stat.Intellect]: 38,
      [Stat.SpellPower]: 89,
      [Stat.HitRating]: 50,
      [Stat.ResilienceRating]: 50,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: "Relentless Gladiator's Cloak of Ascendancy",
    Id: 42078,
    Phase: 1,
    ItemSlot: ItemSlot.Back,
  },
  {
    IconName: 'inv_misc_cape_16',
    Stats: {
      [Stat.Stamina]: 86,
      [Stat.Intellect]: 38,
      [Stat.SpellPower]: 89,
      [Stat.ResilienceRating]: 50,
      [Stat.Mp5]: 25,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: "Relentless Gladiator's Cloak of Salvation",
    Id: 42079,
    Phase: 1,
    ItemSlot: ItemSlot.Back,
  },
  {
    IconName: 'inv_misc_cape_20',
    Stats: {
      [Stat.Stamina]: 86,
      [Stat.Intellect]: 38,
      [Stat.Spirit]: 50,
      [Stat.SpellPower]: 89,
      [Stat.ResilienceRating]: 50,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: "Relentless Gladiator's Cloak of Deliverance",
    Id: 42080,
    Phase: 1,
    ItemSlot: ItemSlot.Back,
  },
  {
    IconName: 'inv_pants_cloth_11',
    Stats: {
      [Stat.Stamina]: 60,
      [Stat.Intellect]: 50,
      [Stat.Spirit]: 68,
      [Stat.SpellPower]: 61,
    },
    Quality: Quality.Rare,
    Name: 'Frostmoon Pants',
    Id: 42093,
    Phase: 1,
    ItemSlot: ItemSlot.Legs,
  },
  {
    IconName: 'inv_gauntlets_06',
    Stats: {
      [Stat.Stamina]: 43,
      [Stat.Intellect]: 37,
      [Stat.Spirit]: 52,
      [Stat.SpellPower]: 59,
    },
    Quality: Quality.Rare,
    Name: 'Light Blessed Mittens',
    Id: 42095,
    Phase: 1,
    ItemSlot: ItemSlot.Hands,
  },
  {
    IconName: 'inv_boots_cloth_01',
    Stats: {
      [Stat.Stamina]: 37,
      [Stat.Intellect]: 40,
      [Stat.Spirit]: 51,
      [Stat.SpellPower]: 60,
    },
    Quality: Quality.Rare,
    Name: 'Aurora Slippers',
    Id: 42096,
    Phase: 1,
    ItemSlot: ItemSlot.Feet,
  },
  {
    IconName: 'inv_chest_cloth_04',
    Stats: {
      [Stat.Stamina]: 67,
      [Stat.Intellect]: 68,
      [Stat.Spirit]: 89,
      [Stat.SpellPower]: 105,
    },
    Quality: Quality.Epic,
    Name: 'Moonshroud Robe',
    Id: 42100,
    Phase: 1,
    ItemSlot: ItemSlot.Chest,
  },
  {
    IconName: 'inv_chest_cloth_48',
    Stats: {
      [Stat.Stamina]: 67,
      [Stat.Intellect]: 89,
      [Stat.SpellPower]: 105,
      [Stat.HitRating]: 68,
    },
    Quality: Quality.Epic,
    Name: 'Ebonweave Robe',
    Id: 42101,
    Phase: 1,
    ItemSlot: ItemSlot.Chest,
  },
  {
    IconName: 'inv_chest_cloth_41',
    Stats: {
      [Stat.Intellect]: 64,
      [Stat.Spirit]: 52,
      [Stat.SpellPower]: 104,
      [Stat.HasteRating]: 90,
    },
    Quality: Quality.Epic,
    Name: 'Spellweave Robe',
    Id: 42102,
    Phase: 1,
    ItemSlot: ItemSlot.Chest,
  },
  {
    IconName: 'inv_gauntlets_06',
    Stats: {
      [Stat.Stamina]: 49,
      [Stat.Intellect]: 51,
      [Stat.Spirit]: 67,
      [Stat.SpellPower]: 76,
    },
    Quality: Quality.Epic,
    Name: 'Moonshroud Gloves',
    Id: 42103,
    Phase: 1,
    ItemSlot: ItemSlot.Hands,
  },
  {
    IconName: 'inv_gauntlets_06',
    Stats: {
      [Stat.Stamina]: 49,
      [Stat.Intellect]: 66,
      [Stat.SpellPower]: 77,
      [Stat.HitRating]: 51,
    },
    Quality: Quality.Epic,
    Name: 'Ebonweave Gloves',
    Id: 42111,
    Phase: 1,
    ItemSlot: ItemSlot.Hands,
  },
  {
    IconName: 'inv_gauntlets_06',
    Stats: {
      [Stat.Intellect]: 48,
      [Stat.Spirit]: 39,
      [Stat.SpellPower]: 77,
      [Stat.HasteRating]: 65,
    },
    Quality: Quality.Epic,
    Name: 'Spellweave Gloves',
    Id: 42113,
    Phase: 1,
    ItemSlot: ItemSlot.Hands,
  },
  {
    IconName: 'inv_jewelry_ring_60',
    Stats: {
      [Stat.Stamina]: 66,
      [Stat.Intellect]: 29,
      [Stat.SpellPower]: 66,
      [Stat.HitRating]: 38,
      [Stat.ResilienceRating]: 37,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: "Deadly Gladiator's Band of Ascendancy",
    Id: 42114,
    Phase: 1,
    ItemSlot: ItemSlot.Finger,
  },
  {
    IconName: 'inv_jewelry_ring_60',
    Stats: {
      [Stat.Stamina]: 73,
      [Stat.Intellect]: 31,
      [Stat.SpellPower]: 73,
      [Stat.CritRating]: 42,
      [Stat.ResilienceRating]: 42,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: "Furious Gladiator's Band of Dominance",
    Id: 42116,
    Phase: 1,
    ItemSlot: ItemSlot.Finger,
  },
  {
    IconName: 'inv_jewelry_ring_60',
    Stats: {
      [Stat.Stamina]: 86,
      [Stat.Intellect]: 38,
      [Stat.SpellPower]: 89,
      [Stat.HitRating]: 50,
      [Stat.ResilienceRating]: 50,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: "Relentless Gladiator's Band of Ascendancy",
    Id: 42118,
    Phase: 1,
    ItemSlot: ItemSlot.Finger,
  },
  {
    IconName: 'ability_warrior_endlessrage',
    Stats: {
      [Stat.CritRating]: 95,
    },
    Quality: Quality.Epic,
    Name: "Battlemaster's Hostility",
    Id: 42128,
    Phase: 1,
    ItemSlot: ItemSlot.Trinket,
  },
  {
    IconName: 'ability_warrior_endlessrage',
    Stats: {
      [Stat.HitRating]: 95,
    },
    Quality: Quality.Epic,
    Name: "Battlemaster's Accuracy",
    Id: 42129,
    Phase: 1,
    ItemSlot: ItemSlot.Trinket,
  },
  {
    IconName: 'ability_warrior_endlessrage',
    Stats: {
      [Stat.HasteRating]: 95,
    },
    Quality: Quality.Epic,
    Name: "Battlemaster's Avidity",
    Id: 42130,
    Phase: 1,
    ItemSlot: ItemSlot.Trinket,
  },
  {
    IconName: 'ability_warrior_endlessrage',
    Stats: {
      [Stat.SpellPower]: 111,
    },
    Quality: Quality.Epic,
    Name: "Battlemaster's Bravery",
    Id: 42132,
    Phase: 1,
    ItemSlot: ItemSlot.Trinket,
  },
  {
    IconName: 'ability_warrior_endlessrage',
    Stats: {
      [Stat.CritRating]: 128,
    },
    Quality: Quality.Epic,
    Name: "Battlemaster's Fury",
    Id: 42133,
    Phase: 1,
    ItemSlot: ItemSlot.Trinket,
  },
  {
    IconName: 'ability_warrior_endlessrage',
    Stats: {
      [Stat.HitRating]: 128,
    },
    Quality: Quality.Epic,
    Name: "Battlemaster's Precision",
    Id: 42134,
    Phase: 1,
    ItemSlot: ItemSlot.Trinket,
  },
  {
    IconName: 'ability_warrior_endlessrage',
    Stats: {
      [Stat.HasteRating]: 128,
    },
    Quality: Quality.Epic,
    Name: "Battlemaster's Vivacity",
    Id: 42135,
    Phase: 1,
    ItemSlot: ItemSlot.Trinket,
  },
  {
    IconName: 'ability_warrior_endlessrage',
    Stats: {
      [Stat.SpellPower]: 150,
    },
    Quality: Quality.Epic,
    Name: "Battlemaster's Ruination",
    Id: 42137,
    Phase: 1,
    ItemSlot: ItemSlot.Trinket,
  },
  {
    IconName: 'inv_jewelcrafting_purpleserpent',
    Stats: {
      [Stat.HitRating]: 42,
    },
    Quality: Quality.Rare,
    Unique: true,
    Sockets: [SocketColor.Red, SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 7,
    },
    Name: 'Figurine - Twilight Serpent',
    Id: 42395,
    Phase: 1,
    ItemSlot: ItemSlot.Trinket,
  },
  {
    IconName: 'inv_jewelcrafting_azureowl',
    Stats: {
      [Stat.Intellect]: 42,
    },
    Quality: Quality.Rare,
    Unique: true,
    Sockets: [SocketColor.Blue, SocketColor.Blue],
    SocketBonus: {
      [Stat.Mp5]: 2,
    },
    Name: 'Figurine - Sapphire Owl',
    Id: 42413,
    Phase: 1,
    ItemSlot: ItemSlot.Trinket,
  },
  {
    IconName: 'inv_gizmo_newgoggles',
    Stats: {
      [Stat.Stamina]: 55,
      [Stat.Intellect]: 60,
      [Stat.SpellPower]: 87,
      [Stat.CritRating]: 73,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Meta, SocketColor.Yellow],
    SocketBonus: {
      [Stat.CritRating]: 8,
    },
    Name: 'Visage Liquification Goggles',
    Sources: [ItemSourceName.Engineering],
    Id: 42553,
    Phase: 1,
    ItemSlot: ItemSlot.Head,
  },
  {
    IconName: 'inv_jewelry_ring_63',
    Stats: {
      [Stat.Stamina]: 48,
      [Stat.Intellect]: 33,
      [Stat.SpellPower]: 49,
      [Stat.CritRating]: 42,
    },
    Quality: Quality.Epic,
    Unique: true,
    Sockets: [SocketColor.Red],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Name: 'Titanium Spellshock Ring',
    Id: 42644,
    Phase: 1,
    ItemSlot: ItemSlot.Finger,
  },
  {
    IconName: 'inv_jewelry_necklace_35',
    Stats: {
      [Stat.Stamina]: 43,
      [Stat.Intellect]: 36,
      [Stat.SpellPower]: 49,
      [Stat.CritRating]: 41,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Red],
    SocketBonus: {
      [Stat.Intellect]: 4,
    },
    Name: 'Titanium Spellshock Necklace',
    Id: 42647,
    Phase: 1,
    ItemSlot: ItemSlot.Neck,
  },
  {
    IconName: 'inv_chest_cloth_25',
    Stats: {
      [Stat.Stamina]: 80,
      [Stat.Intellect]: 44,
      [Stat.SpellPower]: 76,
      [Stat.HitRating]: 55,
    },
    Quality: Quality.Rare,
    Name: 'Robes of Lightning',
    Id: 42844,
    Phase: 1,
    ItemSlot: ItemSlot.Chest,
  },
  {
    IconName: 'inv_inscription_tarotillusion',
    Stats: {
      [Stat.SpellPower]: 100,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: 'Darkmoon Card: Illusion',
    Id: 42988,
    Phase: 1,
    ItemSlot: ItemSlot.Trinket,
  },
  {
    IconName: 'inv_inscription_tarotberserker',
    Stats: {
      [Stat.ResilienceRating]: 100,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: 'Darkmoon Card: Berserker!',
    Id: 42989,
    Phase: 1,
    ItemSlot: ItemSlot.Trinket,
  },
  {
    IconName: 'inv_inscription_tarotdeath',
    Stats: {
      [Stat.CritRating]: 85,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: 'Darkmoon Card: Death',
    Id: 42990,
    Phase: 1,
    ItemSlot: ItemSlot.Trinket,
  },
  {
    IconName: 'inv_jewelry_ring_19',
    Stats: {
      [Stat.Stamina]: 29,
      [Stat.Intellect]: 20,
      [Stat.Spirit]: 20,
      [Stat.SpellPower]: 55,
    },
    Quality: Quality.Rare,
    Name: "Lion's Head Ring",
    Id: 43180,
    Phase: 1,
    ItemSlot: ItemSlot.Finger,
  },
  {
    IconName: 'inv_jewelry_ring_61',
    Stats: {
      [Stat.Stamina]: 27,
      [Stat.CritRating]: 35,
      [Stat.HasteRating]: 35,
    },
    Quality: Quality.Rare,
    Unique: true,
    Sockets: [SocketColor.Blue],
    SocketBonus: {
      [Stat.CritRating]: 4,
    },
    Name: 'Windfire Band',
    Id: 43252,
    Phase: 1,
    ItemSlot: ItemSlot.Finger,
  },
  {
    IconName: 'inv_jewelry_ring_38',
    Stats: {
      [Stat.SpellPower]: 36,
      [Stat.CritRating]: 39,
      [Stat.HitRating]: 31,
    },
    Quality: Quality.Rare,
    Unique: true,
    Sockets: [SocketColor.Blue],
    SocketBonus: {
      [Stat.HitRating]: 4,
    },
    Name: 'Ring of Northern Tears',
    Id: 43253,
    Phase: 1,
    ItemSlot: ItemSlot.Finger,
  },
  {
    IconName: 'inv_misc_cape_05',
    Stats: {
      [Stat.Stamina]: 31,
      [Stat.Intellect]: 26,
      [Stat.Spirit]: 54,
      [Stat.SpellPower]: 43,
    },
    Quality: Quality.Rare,
    Name: 'Subterranean Waterfall Shroud',
    Id: 43283,
    Phase: 1,
    ItemSlot: ItemSlot.Back,
  },
  {
    IconName: 'inv_jewelry_necklace_ahnqiraj_01',
    Stats: {
      [Stat.Stamina]: 40,
      [Stat.Intellect]: 31,
      [Stat.SpellPower]: 50,
      [Stat.CritRating]: 42,
    },
    Quality: Quality.Rare,
    Name: 'Amulet of the Spell Flinger',
    Sources: [ItemSourceName.AhnkahetTheOldKingdomHeroic],
    Id: 43285,
    Phase: 1,
    ItemSlot: ItemSlot.Neck,
  },
  {
    IconName: 'inv_gauntlets_16',
    Stats: {
      [Stat.Stamina]: 49,
      [Stat.Intellect]: 41,
      [Stat.SpellPower]: 59,
      [Stat.HasteRating]: 50,
    },
    Quality: Quality.Rare,
    Sockets: [SocketColor.Yellow],
    SocketBonus: {
      [Stat.Intellect]: 4,
    },
    Name: 'Silken Bridge Handwraps',
    Id: 43287,
    Phase: 1,
    ItemSlot: ItemSlot.Hands,
  },
  {
    IconName: 'inv_pants_cloth_20',
    Stats: {
      [Stat.Stamina]: 55,
      [Stat.Intellect]: 45,
      [Stat.SpellPower]: 73,
      [Stat.Mp5]: 31,
    },
    Quality: Quality.Rare,
    Sockets: [SocketColor.Blue, SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 7,
    },
    Name: 'Leggings of the Ruins Dweller',
    Id: 43313,
    Phase: 1,
    ItemSlot: ItemSlot.Legs,
  },
  {
    IconName: 'inv_chest_cloth_41',
    Stats: {
      [Stat.Stamina]: 58,
      [Stat.Intellect]: 60,
      [Stat.SpellPower]: 73,
      [Stat.HitRating]: 62,
    },
    Quality: Quality.Rare,
    Sockets: [SocketColor.Blue, SocketColor.Red],
    SocketBonus: {
      [Stat.HitRating]: 6,
    },
    Name: 'Water-Drenched Robe',
    Id: 43401,
    Phase: 1,
    ItemSlot: ItemSlot.Chest,
  },
  {
    IconName: 'inv_jewelry_necklace_32',
    Stats: {
      [Stat.Stamina]: 64,
      [Stat.Intellect]: 28,
      [Stat.Spirit]: 29,
      [Stat.SpellPower]: 50,
    },
    Quality: Quality.Rare,
    Unique: true,
    Name: "Zuramat's Necklace",
    Sources: [ItemSourceName.VioletHoldHeroic],
    Id: 43404,
    Phase: 1,
    ItemSlot: ItemSlot.Neck,
  },
  {
    IconName: 'inv_jewelry_ring_55',
    Stats: {
      [Stat.Stamina]: 37,
      [Stat.Intellect]: 31,
      [Stat.SpellPower]: 50,
      [Stat.HasteRating]: 43,
    },
    Quality: Quality.Rare,
    Unique: true,
    Name: 'Solitaire of Reflecting Beams',
    Id: 43408,
    Phase: 1,
    ItemSlot: ItemSlot.Finger,
  },
  {
    IconName: 'inv_jewelry_ring_38',
    Stats: {
      [Stat.Stamina]: 48,
      [Stat.SpellPower]: 19,
      [Stat.ResilienceRating]: 32,
      [Stat.HasteRating]: 33,
    },
    Quality: Quality.Rare,
    Unique: true,
    Sockets: [SocketColor.Red],
    SocketBonus: {
      [Stat.HasteRating]: 4,
    },
    Name: 'Savage Titanium Band',
    Id: 43498,
    Phase: 1,
    ItemSlot: ItemSlot.Finger,
  },
  {
    IconName: 'inv_jewelry_talisman_03',
    Stats: {
      [Stat.HasteRating]: 43,
    },
    Quality: Quality.Uncommon,
    Name: 'Thorny Rose Brooch',
    Id: 43836,
    Phase: 1,
    ItemSlot: ItemSlot.Trinket,
  },
  {
    IconName: 'achievement_dungeon_ulduar77',
    Stats: {
      [Stat.Spirit]: 33,
    },
    Quality: Quality.Uncommon,
    Name: 'Softly Glowing Orb',
    Id: 43837,
    Phase: 1,
    ItemSlot: ItemSlot.Trinket,
  },
  {
    IconName: 'inv_belt_16',
    Stats: {
      [Stat.Stamina]: 51,
      [Stat.Intellect]: 34,
      [Stat.SpellPower]: 60,
      [Stat.CritRating]: 34,
      [Stat.ResilienceRating]: 34,
    },
    Quality: Quality.Rare,
    Set: ItemSet.FrostsavageBattlegear,
    Name: 'Frostsavage Belt',
    Sources: [ItemSourceName.TailoringBoE],
    Id: 43969,
    Phase: 1,
    ItemSlot: ItemSlot.Waist,
  },
  {
    IconName: 'inv_boots_09',
    Stats: {
      [Stat.Stamina]: 51,
      [Stat.Intellect]: 34,
      [Stat.SpellPower]: 60,
      [Stat.CritRating]: 34,
      [Stat.ResilienceRating]: 34,
    },
    Quality: Quality.Rare,
    Set: ItemSet.FrostsavageBattlegear,
    Name: 'Frostsavage Boots',
    Sources: [ItemSourceName.TailoringBoE],
    Id: 43970,
    Phase: 1,
    ItemSlot: ItemSlot.Feet,
  },
  {
    IconName: 'inv_helmet_125',
    Stats: {
      [Stat.Stamina]: 69,
      [Stat.Intellect]: 46,
      [Stat.SpellPower]: 81,
      [Stat.CritRating]: 46,
      [Stat.ResilienceRating]: 46,
    },
    Quality: Quality.Rare,
    Set: ItemSet.FrostsavageBattlegear,
    Name: 'Frostsavage Cowl',
    Sources: [ItemSourceName.TailoringBoE],
    Id: 43971,
    Phase: 1,
    ItemSlot: ItemSlot.Head,
  },
  {
    IconName: 'inv_chest_cloth_51',
    Stats: {
      [Stat.Stamina]: 69,
      [Stat.Intellect]: 46,
      [Stat.SpellPower]: 81,
      [Stat.CritRating]: 46,
      [Stat.ResilienceRating]: 46,
    },
    Quality: Quality.Rare,
    Set: ItemSet.FrostsavageBattlegear,
    Name: 'Frostsavage Robe',
    Sources: [ItemSourceName.TailoringBoE],
    Id: 43972,
    Phase: 1,
    ItemSlot: ItemSlot.Chest,
  },
  {
    IconName: 'inv_shoulder_72',
    Stats: {
      [Stat.Stamina]: 51,
      [Stat.Intellect]: 34,
      [Stat.SpellPower]: 60,
      [Stat.CritRating]: 34,
      [Stat.ResilienceRating]: 34,
    },
    Quality: Quality.Rare,
    Set: ItemSet.FrostsavageBattlegear,
    Name: 'Frostsavage Shoulders',
    Sources: [ItemSourceName.TailoringBoE],
    Id: 43973,
    Phase: 1,
    ItemSlot: ItemSlot.Shoulders,
  },
  {
    IconName: 'inv_bracer_07',
    Stats: {
      [Stat.Stamina]: 39,
      [Stat.Intellect]: 26,
      [Stat.SpellPower]: 44,
      [Stat.CritRating]: 25,
      [Stat.ResilienceRating]: 26,
    },
    Quality: Quality.Rare,
    Set: ItemSet.FrostsavageBattlegear,
    Name: 'Frostsavage Bracers',
    Sources: [ItemSourceName.TailoringBoE],
    Id: 43974,
    Phase: 1,
    ItemSlot: ItemSlot.Wrist,
  },
  {
    IconName: 'inv_pants_cloth_24',
    Stats: {
      [Stat.Stamina]: 69,
      [Stat.Intellect]: 46,
      [Stat.SpellPower]: 81,
      [Stat.CritRating]: 46,
      [Stat.ResilienceRating]: 46,
    },
    Quality: Quality.Rare,
    Set: ItemSet.FrostsavageBattlegear,
    Name: 'Frostsavage Leggings',
    Sources: [ItemSourceName.TailoringBoE],
    Id: 43975,
    Phase: 1,
    ItemSlot: ItemSlot.Legs,
  },
  {
    IconName: 'inv_jewelry_necklace_41',
    Stats: {
      [Stat.Stamina]: 37,
      [Stat.Intellect]: 38,
      [Stat.SpellPower]: 49,
      [Stat.CritRating]: 26,
      [Stat.Mp5]: 16,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Yellow],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Name: 'Volitant Amulet',
    Sources: [ItemSourceName.ObsidianSanctum10],
    Id: 43992,
    Phase: 1,
    ItemSlot: ItemSlot.Neck,
  },
  {
    IconName: 'inv_helmet_133',
    Stats: {
      [Stat.Stamina]: 67,
      [Stat.Intellect]: 63,
      [Stat.Spirit]: 79,
      [Stat.SpellPower]: 99,
      [Stat.CritRating]: 40,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Meta, SocketColor.Yellow],
    SocketBonus: {
      [Stat.SpellPower]: 9,
    },
    Name: 'Enamored Cowl',
    Sources: [ItemSourceName.ObsidianSanctum10],
    Id: 43995,
    Phase: 1,
    ItemSlot: ItemSlot.Head,
  },
  {
    IconName: 'inv_chest_cloth_63',
    Stats: {
      [Stat.Stamina]: 75,
      [Stat.Intellect]: 77,
      [Stat.Spirit]: 51,
      [Stat.SpellPower]: 99,
      [Stat.HasteRating]: 66,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Red, SocketColor.Blue],
    SocketBonus: {
      [Stat.HasteRating]: 6,
    },
    Name: "The Sanctum's Flowing Vestments",
    Id: 44002,
    Phase: 1,
    ItemSlot: ItemSlot.Chest,
  },
  {
    IconName: 'inv_misc_cape_naxxramas_02',
    Stats: {
      [Stat.Stamina]: 54,
      [Stat.Intellect]: 46,
      [Stat.SpellPower]: 64,
      [Stat.CritRating]: 34,
      [Stat.HasteRating]: 42,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Name: 'Pennant Cloak',
    Id: 44005,
    Phase: 1,
    ItemSlot: ItemSlot.Back,
  },
  {
    IconName: 'inv_bracer_17',
    Stats: {
      [Stat.Stamina]: 54,
      [Stat.Intellect]: 46,
      [Stat.Spirit]: 42,
      [Stat.SpellPower]: 64,
      [Stat.HasteRating]: 34,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Red],
    SocketBonus: {
      [Stat.Spirit]: 4,
    },
    Name: 'Unsullied Cuffs',
    Id: 44008,
    Phase: 1,
    ItemSlot: ItemSlot.Wrist,
  },
  {
    IconName: 'inv_belt_03',
    Stats: {
      [Stat.Stamina]: 42,
      [Stat.Intellect]: 37,
      [Stat.Spirit]: 51,
      [Stat.SpellPower]: 60,
    },
    Quality: Quality.Rare,
    Name: 'Fishy Cinch',
    Id: 44104,
    Phase: 1,
    ItemSlot: ItemSlot.Waist,
  },
  {
    IconName: 'inv_wand_12',
    Stats: {
      [Stat.Stamina]: 31,
      [Stat.SpellPower]: 26,
      [Stat.CritRating]: 16,
    },
    Quality: Quality.Rare,
    Name: 'Shinygem Rod',
    Id: 44108,
    Phase: 1,
    ItemSlot: ItemSlot.Wand,
  },
  {
    IconName: 'inv_gauntlets_49',
    Stats: {
      [Stat.Stamina]: 37,
      [Stat.Intellect]: 40,
      [Stat.Spirit]: 51,
      [Stat.SpellPower]: 60,
    },
    Quality: Quality.Rare,
    Name: 'Muddied Crimson Gloves',
    Id: 44116,
    Phase: 1,
    ItemSlot: ItemSlot.Hands,
  },
  {
    IconName: 'inv_misc_cape_06',
    Stats: {
      [Stat.Stamina]: 28,
      [Stat.Intellect]: 29,
      [Stat.SpellPower]: 46,
      [Stat.HasteRating]: 38,
    },
    Quality: Quality.Rare,
    Name: 'Shroud of Dedicated Research',
    Id: 44167,
    Phase: 1,
    ItemSlot: ItemSlot.Back,
  },
  {
    IconName: 'inv_sword_91',
    Stats: {
      [Stat.Stamina]: 28,
      [Stat.Intellect]: 33,
      [Stat.SpellPower]: 355,
      [Stat.CritRating]: 25,
      [Stat.HitRating]: 34,
    },
    Quality: Quality.Rare,
    Name: 'Flameheart Spell Scalpel',
    Sources: [ItemSourceName.KirinTorRevered],
    Id: 44173,
    Phase: 1,
    ItemSlot: ItemSlot.Weapon,
  },
  {
    IconName: 'inv_chest_cloth_24',
    Stats: {
      [Stat.Stamina]: 66,
      [Stat.Intellect]: 73,
      [Stat.SpellPower]: 104,
      [Stat.HasteRating]: 42,
      [Stat.Mp5]: 33,
    },
    Quality: Quality.Epic,
    Name: 'Robes of Crackling Flame',
    Id: 44180,
    Phase: 1,
    ItemSlot: ItemSlot.Chest,
  },
  {
    IconName: 'inv_belt_22',
    Stats: {
      [Stat.Stamina]: 37,
      [Stat.Intellect]: 51,
      [Stat.SpellPower]: 60,
      [Stat.HitRating]: 40,
    },
    Quality: Quality.Rare,
    Name: 'Sash of the Wizened Wyrm',
    Id: 44196,
    Phase: 1,
    ItemSlot: ItemSlot.Waist,
  },
  {
    IconName: 'inv_bracer_05',
    Stats: {
      [Stat.Stamina]: 31,
      [Stat.Intellect]: 33,
      [Stat.Spirit]: 27,
      [Stat.SpellPower]: 50,
    },
    Quality: Quality.Rare,
    Sockets: [SocketColor.Blue],
    SocketBonus: {
      [Stat.Intellect]: 4,
    },
    Name: 'Ancestral Sinew Wristguards',
    Id: 44200,
    Phase: 1,
    ItemSlot: ItemSlot.Wrist,
  },
  {
    IconName: 'inv_boots_cloth_16',
    Stats: {
      [Stat.Stamina]: 49,
      [Stat.Intellect]: 50,
      [Stat.SpellPower]: 77,
      [Stat.HasteRating]: 51,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Blue],
    SocketBonus: {
      [Stat.Intellect]: 4,
    },
    Name: 'Sandals of Crimson Fury',
    Id: 44202,
    Phase: 1,
    ItemSlot: ItemSlot.Feet,
  },
  {
    IconName: 'inv_misc_book_09',
    Stats: {
      [Stat.Intellect]: 42,
      [Stat.Spirit]: 42,
      [Stat.SpellPower]: 49,
      [Stat.CritRating]: 42,
    },
    Quality: Quality.Epic,
    Name: 'Faces of Doom',
    Sources: [ItemSourceName.InscriptionBoE],
    Id: 44210,
    Phase: 1,
    ItemSlot: ItemSlot.OffHand,
  },
  {
    IconName: 'inv_wand_11',
    Stats: {
      [Stat.Stamina]: 21,
      [Stat.SpellPower]: 26,
      [Stat.Mp5]: 10,
    },
    Quality: Quality.Rare,
    Name: 'Purifying Torch',
    Id: 44214,
    Phase: 1,
    ItemSlot: ItemSlot.Wand,
  },
  {
    IconName: 'inv_misc_cape_21',
    Stats: {
      [Stat.Stamina]: 28,
      [Stat.Intellect]: 38,
      [Stat.SpellPower]: 46,
      [Stat.HitRating]: 29,
    },
    Quality: Quality.Rare,
    Name: 'Dark Soldier Cape',
    Id: 44242,
    Phase: 1,
    ItemSlot: ItemSlot.Back,
  },
  {
    IconName: 'inv_inscription_tarotgreatness',
    Stats: {
      [Stat.Spirit]: 90,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: 'Darkmoon Card: Greatness',
    Id: 44254,
    Phase: 1,
    ItemSlot: ItemSlot.Trinket,
  },
  {
    IconName: 'inv_inscription_tarotgreatness',
    Stats: {
      [Stat.Intellect]: 90,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: 'Darkmoon Card: Greatness',
    Id: 44255,
    Phase: 1,
    ItemSlot: ItemSlot.Trinket,
  },
  {
    IconName: 'inv_gauntlets_17',
    Stats: {
      [Stat.Stamina]: 49,
      [Stat.Intellect]: 58,
      [Stat.Spirit]: 41,
      [Stat.SpellPower]: 68,
    },
    Quality: Quality.Rare,
    Name: 'Sterile Flesh-Handling Gloves',
    Id: 44256,
    Phase: 1,
    ItemSlot: ItemSlot.Hands,
  },
  {
    IconName: 'inv_jewelry_ring_70',
    Stats: {
      [Stat.Stamina]: 42,
      [Stat.Intellect]: 50,
      [Stat.SpellPower]: 58,
      [Stat.HasteRating]: 36,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: 'Signet of Hopeful Light',
    Id: 44283,
    Phase: 1,
    ItemSlot: ItemSlot.Finger,
  },
  {
    IconName: 'inv_belt_13',
    Stats: {
      [Stat.Stamina]: 64,
      [Stat.Intellect]: 50,
      [Stat.SpellPower]: 77,
      [Stat.HasteRating]: 55,
    },
    Quality: Quality.Epic,
    Name: 'Belt of Dark Mending',
    Id: 44302,
    Phase: 1,
    ItemSlot: ItemSlot.Waist,
  },
  {
    IconName: 'inv_belt_40',
    Stats: {
      [Stat.Stamina]: 44,
      [Stat.Intellect]: 55,
      [Stat.Spirit]: 55,
      [Stat.SpellPower]: 66,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Red],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Name: 'Sash of Jordan',
    Id: 44309,
    Phase: 1,
    ItemSlot: ItemSlot.Waist,
  },
  {
    IconName: 'spell_holy_aspiration',
    Stats: {
      [Stat.SpellPower]: 59,
      [Stat.HasteRating]: 50,
    },
    Quality: Quality.Rare,
    Unique: true,
    Name: 'Mercurial Alchemist Stone',
    Id: 44322,
    Phase: 1,
    ItemSlot: ItemSlot.Trinket,
  },
  {
    IconName: 'inv_chest_cloth_26',
    Stats: {
      [Stat.Stamina]: 49,
      [Stat.Intellect]: 51,
      [Stat.Spirit]: 66,
      [Stat.SpellPower]: 77,
    },
    Quality: Quality.Rare,
    Name: 'Robes of Refrained Celebration',
    Id: 44382,
    Phase: 1,
    ItemSlot: ItemSlot.Chest,
  },
  {
    IconName: 'inv_gauntlets_06',
    Stats: {
      [Stat.Stamina]: 33,
      [Stat.Intellect]: 41,
      [Stat.Spirit]: 51,
      [Stat.SpellPower]: 60,
    },
    Quality: Quality.Rare,
    Name: 'Gloves of the Time Guardian',
    Id: 44396,
    Phase: 1,
    ItemSlot: ItemSlot.Hands,
  },
  {
    IconName: 'inv_chest_cloth_29',
    Stats: {
      [Stat.Stamina]: 43,
      [Stat.Intellect]: 55,
      [Stat.Spirit]: 68,
      [Stat.SpellPower]: 81,
    },
    Quality: Quality.Rare,
    Name: 'Bauble-Woven Gown',
    Id: 44404,
    Phase: 1,
    ItemSlot: ItemSlot.Chest,
  },
  {
    IconName: 'inv_helmet_107',
    Stats: {
      [Stat.Stamina]: 51,
      [Stat.Intellect]: 69,
      [Stat.SpellPower]: 81,
      [Stat.HasteRating]: 52,
    },
    Quality: Quality.Rare,
    Name: 'Cowl of the Vindictive Captain',
    Sources: [ItemSourceName.Quest],
    Id: 44408,
    Phase: 1,
    ItemSlot: ItemSlot.Head,
  },
  {
    IconName: 'inv_jewelry_necklace_17',
    Stats: {
      [Stat.Stamina]: 42,
      [Stat.Intellect]: 43,
      [Stat.SpellPower]: 56,
      [Stat.CritRating]: 30,
      [Stat.Mp5]: 19,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Yellow],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Name: 'Torque of the Red Dragonflight',
    Sources: [ItemSourceName.EyeOfEternity10],
    Id: 44657,
    Phase: 1,
    ItemSlot: ItemSlot.Neck,
  },
  {
    IconName: 'inv_jewelry_necklace_32',
    Stats: {
      [Stat.Stamina]: 42,
      [Stat.Intellect]: 43,
      [Stat.SpellPower]: 56,
      [Stat.HitRating]: 30,
      [Stat.HasteRating]: 37,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Name: 'Chain of the Ancient Wyrm',
    Sources: [ItemSourceName.EyeOfEternity10],
    Id: 44658,
    Phase: 1,
    ItemSlot: ItemSlot.Neck,
  },
  {
    IconName: 'inv_jewelry_amulet_05',
    Stats: {
      [Stat.Stamina]: 46,
      [Stat.Intellect]: 48,
      [Stat.SpellPower]: 64,
      [Stat.HitRating]: 33,
      [Stat.HasteRating]: 43,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Name: 'Wyrmrest Necklace of Power',
    Sources: [ItemSourceName.EyeOfEternity25],
    Id: 44661,
    Phase: 1,
    ItemSlot: ItemSlot.Neck,
  },
  {
    IconName: 'inv_jewelry_talisman_09',
    Stats: {
      [Stat.Stamina]: 46,
      [Stat.Intellect]: 48,
      [Stat.SpellPower]: 64,
      [Stat.CritRating]: 35,
      [Stat.Mp5]: 20,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Yellow],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Name: "Life-Binder's Locket",
    Sources: [ItemSourceName.EyeOfEternity25],
    Id: 44662,
    Phase: 1,
    ItemSlot: ItemSlot.Neck,
  },
  {
    // TODO random enchantments
    IconName: 'inv_misc_gear_01',
    Quality: Quality.Rare,
    Unique: true,
    Name: 'Titanium Brain-Gear',
    Id: 44681,
    Phase: 1,
    ItemSlot: ItemSlot.Finger,
  },
  {
    // TODO random enchantments
    IconName: 'inv_jewelry_necklace_30',
    Quality: Quality.Rare,
    Name: 'Time-Forward Talisman',
    Sources: [ItemSourceName.BoE],
    Id: 44682,
    Phase: 1,
    ItemSlot: ItemSlot.Neck,
  },
  {
    IconName: 'spell_arcane_arcanetorrent',
    Stats: {
      [Stat.ResilienceRating]: 84,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: 'Flow of Knowledge',
    Id: 44912,
    Phase: 1,
    ItemSlot: ItemSlot.Trinket,
  },
  {
    IconName: 'inv_jewelry_ring_73',
    Stats: {
      [Stat.Stamina]: 49,
      [Stat.Intellect]: 34,
      [Stat.Spirit]: 36,
      [Stat.SpellPower]: 59,
      [Stat.Mp5]: 14,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: 'Loop of the Kirin Tor',
    Id: 44934,
    Phase: 1,
    ItemSlot: ItemSlot.Finger,
  },
  {
    IconName: 'inv_weapon_shortblade_96',
    Stats: {
      [Stat.Stamina]: 28,
      [Stat.Intellect]: 38,
      [Stat.Spirit]: 38,
      [Stat.SpellPower]: 408,
      [Stat.HasteRating]: 30,
    },
    Quality: Quality.Epic,
    Faction: Faction.Alliance,
    Name: 'Dagger of Lunar Purity',
    Sources: [ItemSourceName.ChampionsSeal],
    Id: 45078,
    Phase: 1,
    ItemSlot: ItemSlot.Weapon,
  },
  {
    IconName: 'inv_sword_73',
    Stats: {
      [Stat.Stamina]: 34,
      [Stat.SpellPower]: 408,
      [Stat.CritRating]: 53,
      [Stat.HitRating]: 30,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: 'Titansteel Spellblade',
    Sources: [ItemSourceName.BlacksmithingBoE],
    Id: 45085,
    Phase: 1,
    ItemSlot: ItemSlot.Weapon,
  },
  {
    IconName: 'inv_jewelry_ring_49naxxramas',
    Stats: {
      [Stat.Stamina]: 46,
      [Stat.Intellect]: 49,
      [Stat.Spirit]: 44,
      [Stat.SpellPower]: 74,
      [Stat.CritRating]: 39,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: 'Glowing Ring of Reclamation',
    Id: 45113,
    Phase: 1,
    ItemSlot: ItemSlot.Finger,
  },
  {
    IconName: 'inv_offhand_ulduarraid_d_02',
    Stats: {
      [Stat.Stamina]: 49,
      [Stat.Intellect]: 46,
      [Stat.Spirit]: 42,
      [Stat.SpellPower]: 75,
      [Stat.HitRating]: 41,
    },
    Quality: Quality.Epic,
    Name: 'Leviathan Fueling Manual',
    Sources: [ItemSourceName.Ulduar25],
    Id: 45115,
    Phase: 1,
    ItemSlot: ItemSlot.OffHand,
  },
  {
    IconName: 'inv_jewelry_necklace_29naxxramas',
    Stats: {
      [Stat.Stamina]: 49,
      [Stat.Intellect]: 46,
      [Stat.SpellPower]: 74,
      [Stat.HasteRating]: 39,
      [Stat.Mp5]: 23,
    },
    Quality: Quality.Epic,
    Name: "Freya's Choker of Warding",
    Sources: [ItemSourceName.Ulduar25],
    Id: 45116,
    Phase: 1,
    ItemSlot: ItemSlot.Neck,
  },
  {
    IconName: 'inv_gauntlets_64',
    Stats: {
      [Stat.Stamina]: 73,
      [Stat.Intellect]: 62,
      [Stat.Spirit]: 53,
      [Stat.SpellPower]: 99,
      [Stat.CritRating]: 58,
    },
    Quality: Quality.Epic,
    Name: "Constructor's Handwraps",
    Id: 45117,
    Phase: 1,
    ItemSlot: ItemSlot.Hands,
  },
  {
    IconName: 'inv_belt_49',
    Stats: {
      [Stat.Stamina]: 63,
      [Stat.Intellect]: 64,
      [Stat.Spirit]: 62,
      [Stat.SpellPower]: 99,
      [Stat.HasteRating]: 49,
    },
    Quality: Quality.Epic,
    Name: 'Embrace of the Leviathan',
    Id: 45119,
    Phase: 1,
    ItemSlot: ItemSlot.Waist,
  },
  {
    IconName: 'inv_sword_58',
    Stats: {
      [Stat.Stamina]: 45,
      [Stat.Intellect]: 43,
      [Stat.SpellPower]: 408,
      [Stat.CritRating]: 22,
      [Stat.HitRating]: 29,
    },
    Quality: Quality.Epic,
    Unique: true,
    Faction: Faction.Alliance,
    Name: 'Gnomeregan Bonechopper',
    Sources: [ItemSourceName.ChampionsSeal],
    Id: 45129,
    Phase: 1,
    ItemSlot: ItemSlot.Weapon,
  },
  {
    IconName: 'inv_banner_02',
    Stats: {
      [Stat.ResilienceRating]: 73,
    },
    Quality: Quality.Rare,
    Unique: true,
    Name: "Jouster's Fury",
    Id: 45131,
    Phase: 1,
    ItemSlot: ItemSlot.Trinket,
  },
  {
    IconName: 'inv_jewelry_necklace_31',
    Stats: {
      [Stat.Stamina]: 61,
      [Stat.Intellect]: 51,
      [Stat.SpellPower]: 75,
      [Stat.HitRating]: 46,
      [Stat.HasteRating]: 41,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Yellow],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Name: 'Pendant of Fiery Havoc',
    Sources: [ItemSourceName.Ulduar25Heroic],
    Id: 45133,
    Phase: 1,
    ItemSlot: ItemSlot.Neck,
  },
  {
    IconName: 'inv_boots_cloth_19',
    Stats: {
      [Stat.Stamina]: 72,
      [Stat.Intellect]: 72,
      [Stat.Spirit]: 64,
      [Stat.SpellPower]: 102,
      [Stat.HasteRating]: 55,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Red, SocketColor.Yellow],
    SocketBonus: {
      [Stat.HasteRating]: 6,
    },
    Name: 'Boots of Fiery Resolution',
    Id: 45135,
    Phase: 1,
    ItemSlot: ItemSlot.Feet,
  },
  {
    IconName: 'inv_bracer_27',
    Stats: {
      [Stat.Stamina]: 46,
      [Stat.Intellect]: 42,
      [Stat.Spirit]: 49,
      [Stat.SpellPower]: 74,
      [Stat.CritRating]: 42,
    },
    Quality: Quality.Epic,
    Name: 'Shackles of the Odalisque',
    Id: 45146,
    Phase: 1,
    ItemSlot: ItemSlot.Wrist,
  },
  {
    IconName: 'spell_fire_burnout',
    Stats: {
      [Stat.HitRating]: 107,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: 'Living Flame',
    Id: 45148,
    Phase: 1,
    ItemSlot: ItemSlot.Trinket,
  },
  {
    IconName: 'inv_helmet_133',
    Stats: {
      [Stat.Stamina]: 85,
      [Stat.Intellect]: 87,
      [Stat.SpellPower]: 114,
      [Stat.HitRating]: 51,
      [Stat.HasteRating]: 68,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Meta, SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 9,
    },
    Name: 'Collar of the Wyrmhunter',
    Sources: [ItemSourceName.Ulduar25],
    Id: 45150,
    Phase: 1,
    ItemSlot: ItemSlot.Head,
  },
  {
    IconName: 'inv_jewelry_necklace_15',
    Stats: {
      [Stat.Stamina]: 33,
      [Stat.Intellect]: 21,
      [Stat.Spirit]: 50,
      [Stat.SpellPower]: 50,
    },
    Quality: Quality.Rare,
    Faction: Faction.Alliance,
    Name: 'Necklace of Valiant Blood',
    Sources: [ItemSourceName.ChampionsSeal],
    Id: 45154,
    Phase: 1,
    ItemSlot: ItemSlot.Neck,
  },
  {
    IconName: 'inv_jewelry_necklace_31',
    Stats: {
      [Stat.Stamina]: 42,
      [Stat.Intellect]: 29,
      [Stat.SpellPower]: 52,
      [Stat.HitRating]: 43,
    },
    Quality: Quality.Rare,
    Faction: Faction.Alliance,
    Name: 'Choker of Spiral Focus',
    Sources: [ItemSourceName.ChampionsSeal],
    Id: 45155,
    Phase: 1,
    ItemSlot: ItemSlot.Neck,
  },
  {
    IconName: 'inv_belt_42b',
    Stats: {
      [Stat.Stamina]: 38,
      [Stat.Intellect]: 42,
      [Stat.SpellPower]: 67,
      [Stat.HasteRating]: 50,
    },
    Quality: Quality.Rare,
    Sockets: [SocketColor.Blue],
    SocketBonus: {
      [Stat.HasteRating]: 4,
    },
    Faction: Faction.Alliance,
    Name: 'Sash of Shattering Hearts',
    Id: 45156,
    Phase: 1,
    ItemSlot: ItemSlot.Waist,
  },
  {
    IconName: 'inv_jewelry_ring_71',
    Stats: {
      [Stat.Stamina]: 63,
      [Stat.Intellect]: 42,
      [Stat.SpellPower]: 74,
      [Stat.CritRating]: 46,
      [Stat.HasteRating]: 36,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: 'Pyrelight Circle',
    Id: 45168,
    Phase: 1,
    ItemSlot: ItemSlot.Finger,
  },
  {
    IconName: 'inv_wand_29',
    Stats: {
      [Stat.Stamina]: 39,
      [Stat.Intellect]: 26,
      [Stat.Spirit]: 25,
      [Stat.SpellPower]: 44,
      [Stat.CritRating]: 24,
    },
    Quality: Quality.Epic,
    Name: 'Scepter of Creation',
    Id: 45170,
    Phase: 1,
    ItemSlot: ItemSlot.Wand,
  },
  {
    IconName: 'inv_staff_95',
    Stats: {
      [Stat.Stamina]: 105,
      [Stat.Intellect]: 121,
      [Stat.Spirit]: 86,
      [Stat.SpellPower]: 550,
      [Stat.HitRating]: 120,
    },
    Quality: Quality.Epic,
    Name: 'Intensity',
    Sources: [ItemSourceName.Ulduar25],
    Id: 45171,
    Phase: 1,
    ItemSlot: ItemSlot.Weapon,
    IsTwoHand: true,
  },
  {
    IconName: 'inv_shoulder_97',
    Stats: {
      [Stat.Stamina]: 64,
      [Stat.Intellect]: 65,
      [Stat.Spirit]: 49,
      [Stat.SpellPower]: 90,
      [Stat.HitRating]: 52,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Name: 'Soot-Covered Mantle',
    Id: 45186,
    Phase: 1,
    ItemSlot: ItemSlot.Shoulders,
  },
  {
    IconName: 'inv_jewelry_necklace_19',
    Stats: {
      [Stat.Stamina]: 42,
      [Stat.Intellect]: 29,
      [Stat.SpellPower]: 52,
      [Stat.HitRating]: 43,
    },
    Quality: Quality.Rare,
    Faction: Faction.Horde,
    Name: 'Necklace of Stolen Skulls',
    Sources: [ItemSourceName.ChampionsSeal],
    Id: 45207,
    Phase: 1,
    ItemSlot: ItemSlot.Neck,
  },
  {
    IconName: 'inv_sword_61',
    Stats: {
      [Stat.Stamina]: 45,
      [Stat.Intellect]: 43,
      [Stat.SpellPower]: 408,
      [Stat.CritRating]: 22,
      [Stat.HitRating]: 29,
    },
    Quality: Quality.Epic,
    Unique: true,
    Faction: Faction.Horde,
    Name: 'Blade of the Keening Banshee',
    Sources: [ItemSourceName.ChampionsSeal],
    Id: 45208,
    Phase: 1,
    ItemSlot: ItemSlot.Weapon,
  },
  {
    IconName: 'inv_belt_38c',
    Stats: {
      [Stat.Stamina]: 38,
      [Stat.Intellect]: 42,
      [Stat.SpellPower]: 67,
      [Stat.HasteRating]: 50,
    },
    Quality: Quality.Rare,
    Sockets: [SocketColor.Blue],
    SocketBonus: {
      [Stat.HasteRating]: 4,
    },
    Faction: Faction.Horde,
    Name: 'Sash of Trumpted Pride',
    Id: 45209,
    Phase: 1,
    ItemSlot: ItemSlot.Waist,
  },
  {
    IconName: 'inv_jewelry_necklace_42',
    Stats: {
      [Stat.Stamina]: 33,
      [Stat.Intellect]: 21,
      [Stat.Spirit]: 50,
      [Stat.SpellPower]: 50,
    },
    Quality: Quality.Rare,
    Faction: Faction.Horde,
    Name: 'Pendant of Emerald Crusader',
    Sources: [ItemSourceName.ChampionsSeal],
    Id: 45213,
    Phase: 1,
    ItemSlot: ItemSlot.Neck,
  },
  {
    IconName: 'inv_weapon_shortblade_76',
    Stats: {
      [Stat.Stamina]: 28,
      [Stat.Intellect]: 38,
      [Stat.Spirit]: 38,
      [Stat.SpellPower]: 408,
      [Stat.HasteRating]: 30,
    },
    Quality: Quality.Epic,
    Faction: Faction.Horde,
    Name: 'Scalpel of the Royal Apothecary',
    Sources: [ItemSourceName.ChampionsSeal],
    Id: 45214,
    Phase: 1,
    ItemSlot: ItemSlot.Weapon,
  },
  {
    IconName: 'inv_banner_03',
    Stats: {
      [Stat.ResilienceRating]: 73,
    },
    Quality: Quality.Rare,
    Unique: true,
    Name: "Jouster's Fury",
    Id: 45219,
    Phase: 1,
    ItemSlot: ItemSlot.Trinket,
  },
  {
    IconName: 'inv_staff_93',
    Stats: {
      [Stat.Stamina]: 120,
      [Stat.Intellect]: 119,
      [Stat.Spirit]: 121,
      [Stat.SpellPower]: 550,
      [Stat.CritRating]: 81,
    },
    Quality: Quality.Epic,
    Name: 'Rapture',
    Sources: [ItemSourceName.Ulduar25],
    Id: 45234,
    Phase: 1,
    ItemSlot: ItemSlot.Weapon,
    IsTwoHand: true,
  },
  {
    IconName: 'inv_jewelry_ring_64',
    Stats: {
      [Stat.Stamina]: 63,
      [Stat.Intellect]: 42,
      [Stat.SpellPower]: 74,
      [Stat.HasteRating]: 46,
      [Stat.Mp5]: 18,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: 'Radiant Seal',
    Id: 45235,
    Phase: 1,
    ItemSlot: ItemSlot.Finger,
  },
  {
    IconName: 'inv_misc_gem_lionseye_01',
    Stats: {
      [Stat.Stamina]: 46,
      [Stat.Intellect]: 43,
      [Stat.Spirit]: 41,
      [Stat.SpellPower]: 74,
      [Stat.CritRating]: 49,
    },
    Quality: Quality.Epic,
    Name: 'Unblinking Eye',
    Sources: [ItemSourceName.Ulduar25],
    Id: 45236,
    Phase: 1,
    ItemSlot: ItemSlot.Neck,
  },
  {
    IconName: 'inv_pants_cloth_28',
    Stats: {
      [Stat.Stamina]: 85,
      [Stat.Intellect]: 86,
      [Stat.SpellPower]: 132,
      [Stat.HitRating]: 81,
      [Stat.HasteRating]: 66,
    },
    Quality: Quality.Epic,
    Name: 'Overload Legwraps',
    Id: 45238,
    Phase: 1,
    ItemSlot: ItemSlot.Legs,
  },
  {
    IconName: 'inv_chest_cloth_65',
    Stats: {
      [Stat.Stamina]: 99,
      [Stat.Intellect]: 81,
      [Stat.Spirit]: 57,
      [Stat.SpellPower]: 115,
      [Stat.HasteRating]: 70,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Blue, SocketColor.Red],
    SocketBonus: {
      [Stat.HasteRating]: 6,
    },
    Name: 'Raiments of the Iron Council',
    Id: 45240,
    Phase: 1,
    ItemSlot: ItemSlot.Chest,
  },
  {
    IconName: 'inv_misc_cape_13',
    Stats: {
      [Stat.Stamina]: 61,
      [Stat.Intellect]: 51,
      [Stat.SpellPower]: 75,
      [Stat.CritRating]: 43,
      [Stat.HitRating]: 41,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Yellow],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Name: 'Drape of Mortal Downfall',
    Id: 45242,
    Phase: 1,
    ItemSlot: ItemSlot.Back,
  },
  {
    IconName: 'inv_jewelry_necklace_30naxxramas',
    Stats: {
      [Stat.Stamina]: 70,
      [Stat.Intellect]: 48,
      [Stat.Spirit]: 47,
      [Stat.SpellPower]: 75,
      [Stat.HasteRating]: 35,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Red],
    SocketBonus: {
      [Stat.Spirit]: 4,
    },
    Name: 'Sapphire Amulet of Renewal',
    Sources: [ItemSourceName.Ulduar25],
    Id: 45243,
    Phase: 1,
    ItemSlot: ItemSlot.Neck,
  },
  {
    IconName: 'inv_shoulder_94',
    Stats: {
      [Stat.Stamina]: 84,
      [Stat.Intellect]: 56,
      [Stat.Spirit]: 62,
      [Stat.SpellPower]: 99,
      [Stat.HasteRating]: 49,
    },
    Quality: Quality.Epic,
    Name: 'Mantle of Wavering Calm',
    Id: 45253,
    Phase: 1,
    ItemSlot: ItemSlot.Shoulders,
  },
  {
    IconName: 'inv_wand_28',
    Stats: {
      [Stat.Stamina]: 33,
      [Stat.Intellect]: 25,
      [Stat.Spirit]: 24,
      [Stat.SpellPower]: 44,
      [Stat.HitRating]: 27,
    },
    Quality: Quality.Epic,
    Name: 'Quartz Crystal Wand',
    Id: 45257,
    Phase: 1,
    ItemSlot: ItemSlot.Wand,
  },
  {
    IconName: 'inv_boots_cloth_16',
    Stats: {
      [Stat.Stamina]: 73,
      [Stat.Intellect]: 60,
      [Stat.SpellPower]: 99,
      [Stat.CritRating]: 56,
      [Stat.HitRating]: 57,
    },
    Quality: Quality.Epic,
    Name: 'Sandals of Rash Temperament',
    Id: 45258,
    Phase: 1,
    ItemSlot: ItemSlot.Feet,
  },
  {
    IconName: 'inv_offhand_ulduarraid_d_02',
    Stats: {
      [Stat.Stamina]: 54,
      [Stat.Intellect]: 47,
      [Stat.Spirit]: 45,
      [Stat.SpellPower]: 74,
      [Stat.HasteRating]: 36,
    },
    Quality: Quality.Epic,
    Name: 'Ironmender',
    Sources: [ItemSourceName.Ulduar25],
    Id: 45271,
    Phase: 1,
    ItemSlot: ItemSlot.OffHand,
  },
  {
    IconName: 'inv_chest_cloth_64',
    Stats: {
      [Stat.Stamina]: 85,
      [Stat.Intellect]: 86,
      [Stat.SpellPower]: 123,
      [Stat.CritRating]: 58,
      [Stat.HasteRating]: 82,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Yellow],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Name: 'Robes of the Umbral Brute',
    Id: 45272,
    Phase: 1,
    ItemSlot: ItemSlot.Chest,
  },
  {
    IconName: 'inv_gauntlets_57',
    Stats: {
      [Stat.Stamina]: 73,
      [Stat.Intellect]: 62,
      [Stat.Spirit]: 56,
      [Stat.SpellPower]: 99,
      [Stat.HasteRating]: 56,
    },
    Quality: Quality.Epic,
    Name: 'Handwraps of Plentiful Recovery',
    Id: 45273,
    Phase: 1,
    ItemSlot: ItemSlot.Hands,
  },
  {
    IconName: 'inv_bracer_32a',
    Stats: {
      [Stat.Stamina]: 63,
      [Stat.Intellect]: 46,
      [Stat.SpellPower]: 74,
      [Stat.HitRating]: 36,
      [Stat.HasteRating]: 42,
    },
    Quality: Quality.Epic,
    Name: 'Bracers of Unleashed Magic',
    Id: 45275,
    Phase: 1,
    ItemSlot: ItemSlot.Wrist,
  },
  {
    IconName: 'inv_sword_134',
    Stats: {
      [Stat.Stamina]: 67,
      [Stat.Intellect]: 46,
      [Stat.SpellPower]: 487,
      [Stat.HitRating]: 34,
      [Stat.HasteRating]: 26,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: 'Firesoul',
    Sources: [ItemSourceName.Ulduar10],
    Id: 45287,
    Phase: 1,
    ItemSlot: ItemSlot.Weapon,
  },
  {
    IconName: 'inv_helmet_87',
    Stats: {
      [Stat.Stamina]: 93,
      [Stat.Intellect]: 73,
      [Stat.Spirit]: 45,
      [Stat.SpellPower]: 105,
      [Stat.HasteRating]: 63,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Meta, SocketColor.Blue],
    SocketBonus: {
      [Stat.Spirit]: 8,
    },
    Name: 'Lifespark Visage',
    Sources: [ItemSourceName.Ulduar10],
    Id: 45289,
    Phase: 1,
    ItemSlot: ItemSlot.Head,
  },
  {
    IconName: 'inv_bracer_25a',
    Stats: {
      [Stat.Stamina]: 54,
      [Stat.Intellect]: 41,
      [Stat.Spirit]: 44,
      [Stat.SpellPower]: 70,
      [Stat.HitRating]: 32,
    },
    Quality: Quality.Epic,
    Name: 'Combustion Bracers',
    Id: 45291,
    Phase: 1,
    ItemSlot: ItemSlot.Wrist,
  },
  {
    IconName: 'ability_druid_typhoon',
    Stats: {
      [Stat.Mp5]: 54,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: 'Energy Siphon',
    Id: 45292,
    Phase: 1,
    ItemSlot: ItemSlot.Trinket,
  },
  {
    IconName: 'inv_wand_29',
    Stats: {
      [Stat.Stamina]: 26,
      [Stat.Intellect]: 19,
      [Stat.Spirit]: 22,
      [Stat.SpellPower]: 45,
      [Stat.HitRating]: 29,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Yellow],
    SocketBonus: {
      [Stat.Spirit]: 4,
    },
    Name: 'Petrified Ivy Sprig',
    Id: 45294,
    Phase: 1,
    ItemSlot: ItemSlot.Wand,
  },
  {
    IconName: 'inv_jewelry_ring_63',
    Stats: {
      [Stat.Stamina]: 63,
      [Stat.Intellect]: 42,
      [Stat.Spirit]: 22,
      [Stat.SpellPower]: 74,
      [Stat.HitRating]: 42,
    },
    Quality: Quality.Epic,
    Unique: true,
    Sockets: [SocketColor.Red],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Name: 'Shimmering Seal',
    Id: 45297,
    Phase: 1,
    ItemSlot: ItemSlot.Finger,
  },
  {
    IconName: 'inv_belt_49a',
    Stats: {
      [Stat.Stamina]: 69,
      [Stat.Intellect]: 46,
      [Stat.Spirit]: 58,
      [Stat.SpellPower]: 91,
      [Stat.CritRating]: 57,
    },
    Quality: Quality.Epic,
    Name: 'Binding of the Dragon Matriarch',
    Id: 45306,
    Phase: 1,
    ItemSlot: ItemSlot.Waist,
  },
  {
    IconName: 'inv_misc_eye_02',
    Stats: {
      [Stat.CritRating]: 87,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: 'Eye of the Broodmother',
    Id: 45308,
    Phase: 1,
    ItemSlot: ItemSlot.Trinket,
  },
  {
    IconName: 'inv_offhand_ulduarraid_d_03',
    Stats: {
      [Stat.Stamina]: 44,
      [Stat.Intellect]: 45,
      [Stat.Spirit]: 36,
      [Stat.SpellPower]: 64,
      [Stat.CritRating]: 47,
    },
    Quality: Quality.Epic,
    Name: 'Igniter Rod',
    Sources: [ItemSourceName.Ulduar10],
    Id: 45314,
    Phase: 1,
    ItemSlot: ItemSlot.OffHand,
  },
  {
    IconName: 'inv_misc_cape_09',
    Stats: {
      [Stat.Stamina]: 65,
      [Stat.Intellect]: 35,
      [Stat.SpellPower]: 74,
      [Stat.HasteRating]: 39,
      [Stat.Mp5]: 15,
    },
    Quality: Quality.Epic,
    Name: 'Shawl of the Caretaker',
    Id: 45317,
    Phase: 1,
    ItemSlot: ItemSlot.Back,
  },
  {
    IconName: 'inv_weapon_shortblade_79',
    Stats: {
      [Stat.Stamina]: 33,
      [Stat.Intellect]: 35,
      [Stat.Spirit]: 34,
      [Stat.SpellPower]: 487,
      [Stat.HasteRating]: 53,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: 'Stormtip',
    Sources: [ItemSourceName.Ulduar10],
    Id: 45332,
    Phase: 1,
    ItemSlot: ItemSlot.Weapon,
  },
  {
    IconName: 'inv_helmet_131',
    Stats: {
      [Stat.Stamina]: 81,
      [Stat.Intellect]: 71,
      [Stat.Spirit]: 37,
      [Stat.SpellPower]: 105,
      [Stat.CritRating]: 81,
    },
    Quality: Quality.Epic,
    Set: ItemSet.T8,
    Sockets: [SocketColor.Meta, SocketColor.Blue],
    SocketBonus: {
      [Stat.CritRating]: 8,
    },
    Name: 'Valorous Deathbringer Hood',
    Sources: [ItemSourceName.Ulduar10],
    Id: 45417,
    Phase: 1,
    ItemSlot: ItemSlot.Head,
  },
  {
    IconName: 'inv_jewelry_ring_63',
    Stats: {
      [Stat.Stamina]: 51,
      [Stat.Intellect]: 43,
      [Stat.Spirit]: 44,
      [Stat.SpellPower]: 71,
      [Stat.HasteRating]: 32,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: "Lady Maye's Sapphire Ring",
    Id: 45418,
    Phase: 1,
    ItemSlot: ItemSlot.Finger,
  },
  {
    IconName: 'inv_gauntlets_17',
    Stats: {
      [Stat.Stamina]: 69,
      [Stat.Intellect]: 57,
      [Stat.Spirit]: 25,
      [Stat.SpellPower]: 92,
      [Stat.HitRating]: 59,
    },
    Quality: Quality.Epic,
    Set: ItemSet.T8,
    Sockets: [SocketColor.Blue],
    SocketBonus: {
      [Stat.CritRating]: 4,
    },
    Name: 'Valorous Deathbringer Gloves',
    Sources: [ItemSourceName.Ulduar10],
    Id: 45419,
    Phase: 1,
    ItemSlot: ItemSlot.Hands,
  },
  {
    IconName: 'inv_pants_cloth_05',
    Stats: {
      [Stat.Stamina]: 80,
      [Stat.Intellect]: 81,
      [Stat.Spirit]: 44,
      [Stat.SpellPower]: 124,
      [Stat.HasteRating]: 62,
    },
    Quality: Quality.Epic,
    Set: ItemSet.T8,
    Sockets: [SocketColor.Blue, SocketColor.Yellow],
    SocketBonus: {
      [Stat.HasteRating]: 6,
    },
    Name: 'Valorous Deathbringer Leggings',
    Sources: [ItemSourceName.Ulduar10],
    Id: 45420,
    Phase: 1,
    ItemSlot: ItemSlot.Legs,
  },
  {
    IconName: 'inv_chest_cloth_43',
    Stats: {
      [Stat.Stamina]: 77,
      [Stat.Intellect]: 71,
      [Stat.SpellPower]: 115,
      [Stat.CritRating]: 62,
      [Stat.HitRating]: 68,
    },
    Quality: Quality.Epic,
    Set: ItemSet.T8,
    Sockets: [SocketColor.Red, SocketColor.Yellow],
    SocketBonus: {
      [Stat.SpellPower]: 7,
    },
    Name: 'Valorous Deathbringer Robe',
    Sources: [ItemSourceName.Ulduar10],
    Id: 45421,
    Phase: 1,
    ItemSlot: ItemSlot.Chest,
  },
  {
    IconName: 'inv_shoulder_25',
    Stats: {
      [Stat.Stamina]: 63,
      [Stat.Intellect]: 57,
      [Stat.SpellPower]: 92,
      [Stat.CritRating]: 53,
      [Stat.HasteRating]: 38,
    },
    Quality: Quality.Epic,
    Set: ItemSet.T8,
    Sockets: [SocketColor.Yellow],
    SocketBonus: {
      [Stat.HitRating]: 4,
    },
    Name: 'Valorous Deathbringer Shoulderpads',
    Sources: [ItemSourceName.Ulduar10],
    Id: 45422,
    Phase: 1,
    ItemSlot: ItemSlot.Shoulders,
  },
  {
    IconName: 'inv_bracer_24b',
    Stats: {
      [Stat.Stamina]: 52,
      [Stat.Intellect]: 42,
      [Stat.Spirit]: 29,
      [Stat.SpellPower]: 69,
      [Stat.CritRating]: 46,
    },
    Quality: Quality.Epic,
    Name: 'Runetouch Wristwraps',
    Id: 45423,
    Phase: 1,
    ItemSlot: ItemSlot.Wrist,
  },
  {
    IconName: 'inv_helmet_133',
    Stats: {
      [Stat.Stamina]: 72,
      [Stat.Intellect]: 91,
      [Stat.Spirit]: 57,
      [Stat.SpellPower]: 133,
      [Stat.HitRating]: 86,
    },
    Quality: Quality.Epic,
    Name: 'Cowl of the Absolute',
    Sources: [ItemSourceName.Ulduar25],
    Id: 45435,
    Phase: 1,
    ItemSlot: ItemSlot.Head,
  },
  {
    IconName: 'inv_sword_134',
    Stats: {
      [Stat.Stamina]: 43,
      [Stat.Intellect]: 51,
      [Stat.Spirit]: 37,
      [Stat.SpellPower]: 550,
      [Stat.CritRating]: 52,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: 'Runescribed Blade',
    Sources: [ItemSourceName.Ulduar25],
    Id: 45437,
    Phase: 1,
    ItemSlot: ItemSlot.Weapon,
  },
  {
    IconName: 'inv_jewelry_ring_43',
    Stats: {
      [Stat.Stamina]: 63,
      [Stat.Intellect]: 42,
      [Stat.SpellPower]: 74,
      [Stat.CritRating]: 36,
      [Stat.Mp5]: 23,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: 'Ring of the Faithful Servant',
    Id: 45438,
    Phase: 1,
    ItemSlot: ItemSlot.Finger,
  },
  {
    IconName: 'inv_boots_cloth_21',
    Stats: {
      [Stat.Stamina]: 63,
      [Stat.Intellect]: 64,
      [Stat.Spirit]: 62,
      [Stat.SpellPower]: 99,
      [Stat.CritRating]: 49,
    },
    Quality: Quality.Epic,
    Name: 'Sandals of the Ancient Keeper',
    Id: 45441,
    Phase: 1,
    ItemSlot: ItemSlot.Feet,
  },
  {
    IconName: 'inv_jewelry_amulet_02',
    Stats: {
      [Stat.Stamina]: 61,
      [Stat.Intellect]: 51,
      [Stat.SpellPower]: 75,
      [Stat.HasteRating]: 40,
      [Stat.Mp5]: 24,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Name: 'Charm of Meticulous Timing',
    Sources: [ItemSourceName.Ulduar25Heroic],
    Id: 45443,
    Phase: 1,
    ItemSlot: ItemSlot.Neck,
  },
  {
    IconName: 'inv_bracer_24b',
    Stats: {
      [Stat.Stamina]: 63,
      [Stat.Intellect]: 52,
      [Stat.Spirit]: 48,
      [Stat.SpellPower]: 75,
      [Stat.HasteRating]: 39,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Red],
    SocketBonus: {
      [Stat.Spirit]: 4,
    },
    Name: 'Grasps of Reason',
    Id: 45446,
    Phase: 1,
    ItemSlot: ItemSlot.Wrist,
  },
  {
    IconName: 'inv_jewelry_ring_45',
    Stats: {
      [Stat.Stamina]: 51,
      [Stat.Intellect]: 36,
      [Stat.Spirit]: 37,
      [Stat.SpellPower]: 74,
      [Stat.HasteRating]: 40,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Yellow],
    SocketBonus: {
      [Stat.CritRating]: 4,
    },
    Name: 'Watchful Eye of Fate',
    Sources: [ItemSourceName.Ulduar10],
    Id: 45447,
    Phase: 1,
    ItemSlot: ItemSlot.Neck,
  },
  {
    IconName: 'inv_jewelry_ring_57',
    Stats: {
      [Stat.Stamina]: 49,
      [Stat.Intellect]: 46,
      [Stat.SpellPower]: 74,
      [Stat.HitRating]: 46,
      [Stat.HasteRating]: 36,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: 'Frozen Loop',
    Id: 45451,
    Phase: 1,
    ItemSlot: ItemSlot.Finger,
  },
  {
    IconName: 'inv_staff_94',
    Stats: {
      [Stat.Stamina]: 111,
      [Stat.Intellect]: 128,
      [Stat.Spirit]: 84,
      [Stat.SpellPower]: 587,
      [Stat.CritRating]: 104,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Blue, SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 9,
    },
    Name: 'Staff of Endless Winter',
    Sources: [ItemSourceName.Ulduar25],
    Id: 45457,
    Phase: 1,
    ItemSlot: ItemSlot.Weapon,
    IsTwoHand: true,
  },
  {
    IconName: 'inv_helmet_136',
    Stats: {
      [Stat.Stamina]: 78,
      [Stat.Intellect]: 74,
      [Stat.Spirit]: 48,
      [Stat.SpellPower]: 115,
      [Stat.HitRating]: 60,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Meta, SocketColor.Yellow],
    SocketBonus: {
      [Stat.HitRating]: 8,
    },
    Name: 'Cowl of Icy Breaths',
    Sources: [ItemSourceName.Ulduar10],
    Id: 45464,
    Phase: 1,
    ItemSlot: ItemSlot.Head,
  },
  {
    IconName: 'inv_spiritshard_02',
    Stats: {
      [Stat.SpellPower]: 125,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: 'Scale of Fates',
    Id: 45466,
    Phase: 1,
    ItemSlot: ItemSlot.Trinket,
  },
  {
    IconName: 'inv_pants_cloth_27',
    Stats: {
      [Stat.Stamina]: 99,
      [Stat.Intellect]: 81,
      [Stat.Spirit]: 86,
      [Stat.SpellPower]: 115,
      [Stat.HasteRating]: 41,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Red, SocketColor.Blue],
    SocketBonus: {
      [Stat.Spirit]: 6,
    },
    Name: 'Leggings of Lost Love',
    Id: 45468,
    Phase: 1,
    ItemSlot: ItemSlot.Legs,
  },
  {
    IconName: 'inv_staff_93',
    Stats: {
      [Stat.Stamina]: 120,
      [Stat.Intellect]: 121,
      [Stat.Spirit]: 80,
      [Stat.SpellPower]: 550,
      [Stat.HasteRating]: 120,
    },
    Quality: Quality.Epic,
    Name: 'The Lifebinder',
    Sources: [ItemSourceName.Ulduar25],
    Id: 45479,
    Phase: 1,
    ItemSlot: ItemSlot.Weapon,
    IsTwoHand: true,
  },
  {
    IconName: 'inv_boots_cloth_03',
    Stats: {
      [Stat.Stamina]: 73,
      [Stat.Intellect]: 56,
      [Stat.Spirit]: 48,
      [Stat.SpellPower]: 90,
      [Stat.HasteRating]: 62,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Name: 'Boots of the Servant',
    Id: 45483,
    Phase: 1,
    ItemSlot: ItemSlot.Feet,
  },
  {
    IconName: 'inv_misc_cape_naxxramas_02',
    Stats: {
      [Stat.Stamina]: 61,
      [Stat.Intellect]: 51,
      [Stat.SpellPower]: 75,
      [Stat.CritRating]: 40,
      [Stat.Mp5]: 24,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Yellow],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Name: 'Drape of the Sullen Goddess',
    Id: 45486,
    Phase: 1,
    ItemSlot: ItemSlot.Back,
  },
  {
    IconName: 'inv_pants_cloth_27',
    Stats: {
      [Stat.Stamina]: 96,
      [Stat.Intellect]: 98,
      [Stat.SpellPower]: 122,
      [Stat.CritRating]: 77,
      [Stat.HitRating]: 70,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Red, SocketColor.Yellow, SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 9,
    },
    Name: 'Leggings of the Enslaved Idol',
    Id: 45488,
    Phase: 1,
    ItemSlot: ItemSlot.Legs,
  },
  {
    IconName: 'achievement_dungeon_ulduar77_25man',
    Stats: {
      [Stat.Intellect]: 108,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: "Pandora's Plea",
    Id: 45490,
    Phase: 1,
    ItemSlot: ItemSlot.Trinket,
  },
  {
    IconName: 'inv_misc_cape_16',
    Stats: {
      [Stat.Stamina]: 46,
      [Stat.Intellect]: 42,
      [Stat.Spirit]: 42,
      [Stat.SpellPower]: 74,
      [Stat.CritRating]: 49,
    },
    Quality: Quality.Epic,
    Name: "Asimov's Drape",
    Id: 45493,
    Phase: 1,
    ItemSlot: ItemSlot.Back,
  },
  {
    IconName: 'inv_jewelry_ring_66',
    Stats: {
      [Stat.Stamina]: 52,
      [Stat.Intellect]: 48,
      [Stat.Spirit]: 39,
      [Stat.SpellPower]: 75,
      [Stat.HasteRating]: 55,
    },
    Quality: Quality.Epic,
    Unique: true,
    Sockets: [SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Name: 'Conductive Seal',
    Id: 45495,
    Phase: 1,
    ItemSlot: ItemSlot.Finger,
  },
  {
    IconName: 'inv_helmet_99',
    Stats: {
      [Stat.Stamina]: 111,
      [Stat.Intellect]: 92,
      [Stat.Spirit]: 70,
      [Stat.SpellPower]: 131,
      [Stat.CritRating]: 69,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Meta, SocketColor.Red],
    SocketBonus: {
      [Stat.Spirit]: 8,
    },
    Name: 'Crown of Luminescence',
    Sources: [ItemSourceName.Ulduar25],
    Id: 45497,
    Phase: 1,
    ItemSlot: ItemSlot.Head,
  },
  {
    IconName: 'inv_belt_10',
    Stats: {
      [Stat.Stamina]: 64,
      [Stat.Intellect]: 63,
      [Stat.Spirit]: 49,
      [Stat.SpellPower]: 90,
      [Stat.HitRating]: 56,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Name: 'Belt of the Darkspeaker',
    Id: 45508,
    Phase: 1,
    ItemSlot: ItemSlot.Waist,
  },
  {
    IconName: 'inv_wand_28',
    Stats: {
      [Stat.Stamina]: 37,
      [Stat.Intellect]: 26,
      [Stat.SpellPower]: 44,
      [Stat.CritRating]: 18,
      [Stat.HasteRating]: 29,
    },
    Quality: Quality.Epic,
    Name: 'Scepter of Lost Souls',
    Id: 45511,
    Phase: 1,
    ItemSlot: ItemSlot.Wand,
  },
  {
    IconName: 'inv_shoulder_94',
    Stats: {
      [Stat.Stamina]: 73,
      [Stat.Intellect]: 56,
      [Stat.Spirit]: 62,
      [Stat.SpellPower]: 90,
      [Stat.CritRating]: 41,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Yellow],
    SocketBonus: {
      [Stat.Intellect]: 4,
    },
    Name: 'Mantle of the Unknowing',
    Id: 45514,
    Phase: 1,
    ItemSlot: ItemSlot.Shoulders,
  },
  {
    IconName: 'inv_jewelry_ring_ahnqiraj_02',
    Stats: {
      [Stat.Stamina]: 54,
      [Stat.Intellect]: 46,
      [Stat.Spirit]: 42,
      [Stat.SpellPower]: 74,
      [Stat.HitRating]: 42,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: 'Ring of the Vacant Eye',
    Id: 45515,
    Phase: 1,
    ItemSlot: ItemSlot.Finger,
  },
  {
    IconName: 'spell_holy_summonlightwell',
    Stats: {
      [Stat.CritRating]: 120,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: 'Flare of the Heavens',
    Id: 45518,
    Phase: 1,
    ItemSlot: ItemSlot.Trinket,
  },
  {
    IconName: 'inv_gauntlets_71',
    Stats: {
      [Stat.Stamina]: 72,
      [Stat.Intellect]: 72,
      [Stat.Spirit]: 51,
      [Stat.SpellPower]: 92,
      [Stat.CritRating]: 59,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Yellow, SocketColor.Yellow],
    SocketBonus: {
      [Stat.SpellPower]: 7,
    },
    Name: 'Handwraps of the Vigilant',
    Id: 45520,
    Phase: 1,
    ItemSlot: ItemSlot.Hands,
  },
  {
    IconName: 'inv_weapon_shortblade_80',
    Stats: {
      [Stat.Stamina]: 54,
      [Stat.Intellect]: 49,
      [Stat.SpellPower]: 550,
      [Stat.CritRating]: 28,
      [Stat.HasteRating]: 48,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: 'Soulscribe',
    Sources: [ItemSourceName.Ulduar25],
    Id: 45527,
    Phase: 1,
    ItemSlot: ItemSlot.Weapon,
  },
  {
    IconName: 'inv_misc_cape_16',
    Stats: {
      [Stat.Stamina]: 46,
      [Stat.Intellect]: 46,
      [Stat.Spirit]: 49,
      [Stat.SpellPower]: 74,
      [Stat.CritRating]: 36,
    },
    Quality: Quality.Epic,
    Name: 'Shawl of Haunted Memories',
    Id: 45529,
    Phase: 1,
    ItemSlot: ItemSlot.Back,
  },
  {
    IconName: 'inv_jewelry_ring_80',
    Stats: {
      [Stat.Stamina]: 63,
      [Stat.Intellect]: 42,
      [Stat.SpellPower]: 74,
      [Stat.HasteRating]: 31,
      [Stat.Mp5]: 25,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: "Sanity's Bond",
    Id: 45530,
    Phase: 1,
    ItemSlot: ItemSlot.Finger,
  },
  {
    IconName: 'inv_helmet_136',
    Stats: {
      [Stat.Stamina]: 85,
      [Stat.Intellect]: 66,
      [Stat.Spirit]: 80,
      [Stat.SpellPower]: 115,
      [Stat.CritRating]: 59,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Meta, SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 9,
    },
    Name: 'Cowl of Dark Whispers',
    Sources: [ItemSourceName.Ulduar25],
    Id: 45532,
    Phase: 1,
    ItemSlot: ItemSlot.Head,
  },
  {
    IconName: 'spell_holy_improvedresistanceauras',
    Stats: {
      [Stat.SpellPower]: 140,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: 'Show of Faith',
    Id: 45535,
    Phase: 1,
    ItemSlot: ItemSlot.Trinket,
  },
  {
    IconName: 'inv_boots_cloth_17',
    Stats: {
      [Stat.Stamina]: 82,
      [Stat.Intellect]: 69,
      [Stat.SpellPower]: 92,
      [Stat.CritRating]: 61,
      [Stat.HasteRating]: 47,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Red, SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 7,
    },
    Name: 'Treads of the False Oracle',
    Id: 45537,
    Phase: 1,
    ItemSlot: ItemSlot.Feet,
  },
  {
    IconName: 'inv_jewelry_necklace_40',
    Stats: {
      [Stat.Stamina]: 63,
      [Stat.Intellect]: 42,
      [Stat.Spirit]: 36,
      [Stat.SpellPower]: 74,
      [Stat.HitRating]: 46,
    },
    Quality: Quality.Epic,
    Name: 'Pendant of Focused Energies',
    Sources: [ItemSourceName.Ulduar25],
    Id: 45539,
    Phase: 1,
    ItemSlot: ItemSlot.Neck,
  },
  {
    IconName: 'inv_misc_cape_05',
    Stats: {
      [Stat.Stamina]: 46,
      [Stat.Intellect]: 49,
      [Stat.SpellPower]: 74,
      [Stat.HasteRating]: 36,
      [Stat.Mp5]: 23,
    },
    Quality: Quality.Epic,
    Name: 'Shroud of Alteration',
    Id: 45541,
    Phase: 1,
    ItemSlot: ItemSlot.Back,
  },
  {
    IconName: 'inv_bracer_31b',
    Stats: {
      [Stat.Stamina]: 46,
      [Stat.Intellect]: 49,
      [Stat.Spirit]: 46,
      [Stat.SpellPower]: 74,
      [Stat.HitRating]: 36,
    },
    Quality: Quality.Epic,
    Name: 'Grips of Chaos',
    Id: 45549,
    Phase: 1,
    ItemSlot: ItemSlot.Wrist,
  },
  {
    IconName: 'inv_belt_10',
    Stats: {
      [Stat.Stamina]: 63,
      [Stat.Intellect]: 64,
      [Stat.SpellPower]: 81,
      [Stat.HitRating]: 43,
      [Stat.HasteRating]: 49,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Blue, SocketColor.Red],
    SocketBonus: {
      [Stat.SpellPower]: 7,
    },
    Name: 'Sash of Ancient Power',
    Id: 45557,
    Phase: 1,
    ItemSlot: ItemSlot.Waist,
  },
  {
    IconName: 'inv_belt_40b',
    Stats: {
      [Stat.Stamina]: 73,
      [Stat.Intellect]: 62,
      [Stat.Spirit]: 48,
      [Stat.SpellPower]: 81,
      [Stat.CritRating]: 48,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Red, SocketColor.Yellow],
    SocketBonus: {
      [Stat.SpellPower]: 7,
    },
    Name: 'Cord of the White Dawn',
    Id: 45558,
    Phase: 1,
    ItemSlot: ItemSlot.Waist,
  },
  {
    IconName: 'inv_boots_cloth_03',
    Stats: {
      [Stat.Stamina]: 63,
      [Stat.Intellect]: 64,
      [Stat.Spirit]: 41,
      [Stat.SpellPower]: 81,
      [Stat.HasteRating]: 56,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Blue, SocketColor.Red],
    SocketBonus: {
      [Stat.SpellPower]: 7,
    },
    Name: "Spellslinger's Slippers",
    Id: 45566,
    Phase: 1,
    ItemSlot: ItemSlot.Feet,
  },
  {
    IconName: 'inv_boots_cloth_21',
    Stats: {
      [Stat.Stamina]: 73,
      [Stat.Intellect]: 60,
      [Stat.Spirit]: 57,
      [Stat.SpellPower]: 81,
      [Stat.CritRating]: 40,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Red, SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 7,
    },
    Name: "Savior's Slippers",
    Id: 45567,
    Phase: 1,
    ItemSlot: ItemSlot.Feet,
  },
  {
    IconName: 'inv_jewelry_ring_31',
    Stats: {
      [Stat.Stamina]: 61,
      [Stat.Intellect]: 51,
      [Stat.SpellPower]: 75,
      [Stat.HasteRating]: 39,
      [Stat.Mp5]: 24,
    },
    Quality: Quality.Epic,
    Unique: true,
    Sockets: [SocketColor.Yellow],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Name: 'Starshine Circle',
    Id: 45614,
    Phase: 1,
    ItemSlot: ItemSlot.Finger,
  },
  {
    IconName: 'inv_offhand_ulduarraid_d_03',
    Stats: {
      [Stat.Stamina]: 52,
      [Stat.Intellect]: 55,
      [Stat.SpellPower]: 84,
      [Stat.CritRating]: 41,
      [Stat.HitRating]: 51,
    },
    Quality: Quality.Epic,
    Name: 'Cosmos',
    Sources: [ItemSourceName.Ulduar25],
    Id: 45617,
    Phase: 1,
    ItemSlot: ItemSlot.OffHand,
  },
  {
    IconName: 'inv_misc_cape_06',
    Stats: {
      [Stat.Stamina]: 70,
      [Stat.Intellect]: 48,
      [Stat.Spirit]: 48,
      [Stat.SpellPower]: 75,
      [Stat.HasteRating]: 39,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Name: 'Sunglimmer Cloak',
    Id: 45618,
    Phase: 1,
    ItemSlot: ItemSlot.Back,
  },
  {
    IconName: 'inv_belt_46',
    Stats: {
      [Stat.Stamina]: 82,
      [Stat.Intellect]: 69,
      [Stat.Spirit]: 64,
      [Stat.SpellPower]: 92,
      [Stat.CritRating]: 47,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Yellow, SocketColor.Yellow],
    SocketBonus: {
      [Stat.SpellPower]: 7,
    },
    Name: "Starwatcher's Binding",
    Id: 45619,
    Phase: 1,
    ItemSlot: ItemSlot.Waist,
  },
  {
    IconName: 'inv_weapon_shortblade_92',
    Stats: {
      [Stat.Stamina]: 40,
      [Stat.Intellect]: 55,
      [Stat.Spirit]: 43,
      [Stat.SpellPower]: 587,
      [Stat.HitRating]: 39,
    },
    Quality: Quality.Epic,
    Unique: true,
    Sockets: [SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Name: 'Starshard Edge',
    Sources: [ItemSourceName.Ulduar25],
    Id: 45620,
    Phase: 1,
    ItemSlot: ItemSlot.Weapon,
  },
  {
    IconName: 'inv_gauntlets_61',
    Stats: {
      [Stat.Stamina]: 72,
      [Stat.Intellect]: 72,
      [Stat.SpellPower]: 92,
      [Stat.CritRating]: 64,
      [Stat.HasteRating]: 74,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Blue, SocketColor.Yellow],
    SocketBonus: {
      [Stat.SpellPower]: 7,
    },
    Name: 'Pharos Gloves',
    Id: 45665,
    Phase: 1,
    ItemSlot: ItemSlot.Hands,
  },
  {
    IconName: 'inv_weapon_shortblade_80',
    Stats: {
      [Stat.Stamina]: 34,
      [Stat.Intellect]: 45,
      [Stat.Spirit]: 46,
      [Stat.SpellPower]: 487,
      [Stat.CritRating]: 35,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: 'Plasma Foil',
    Sources: [ItemSourceName.Ulduar10],
    Id: 45685,
    Phase: 1,
    ItemSlot: ItemSlot.Weapon,
  },
  {
    IconName: 'inv_jewelry_ring_73',
    Stats: {
      [Stat.Stamina]: 55,
      [Stat.Intellect]: 38,
      [Stat.Spirit]: 38,
      [Stat.SpellPower]: 66,
      [Stat.Mp5]: 19,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: 'Inscribed Loop of the Kirin Tor',
    Id: 45689,
    Phase: 1,
    ItemSlot: ItemSlot.Finger,
  },
  {
    IconName: 'inv_jewelry_ring_73',
    Stats: {
      [Stat.Stamina]: 55,
      [Stat.Intellect]: 38,
      [Stat.SpellPower]: 66,
      [Stat.CritRating]: 37,
      [Stat.HasteRating]: 38,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: 'Inscribed Signet of the Kirin Tor',
    Id: 45691,
    Phase: 1,
    ItemSlot: ItemSlot.Finger,
  },
  {
    IconName: 'inv_belt_44',
    Stats: {
      [Stat.Stamina]: 75,
      [Stat.Intellect]: 54,
      [Stat.Spirit]: 60,
      [Stat.SpellPower]: 93,
      [Stat.CritRating]: 41,
    },
    Quality: Quality.Epic,
    Name: 'Conductive Cord',
    Id: 45694,
    Phase: 1,
    ItemSlot: ItemSlot.Waist,
  },
  {
    IconName: 'inv_jewelry_necklace_44',
    Stats: {
      [Stat.Stamina]: 47,
      [Stat.Intellect]: 45,
      [Stat.SpellPower]: 69,
      [Stat.HitRating]: 46,
      [Stat.HasteRating]: 29,
    },
    Quality: Quality.Epic,
    Name: 'Pendant of the Piercing Glare',
    Sources: [ItemSourceName.Ulduar10],
    Id: 45699,
    Phase: 1,
    ItemSlot: ItemSlot.Neck,
  },
  {
    IconName: 'inv_jewelry_ring_74',
    Stats: {
      [Stat.Stamina]: 38,
      [Stat.Intellect]: 48,
      [Stat.Spirit]: 43,
      [Stat.SpellPower]: 70,
      [Stat.HitRating]: 34,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: 'Emerald Signet Ring',
    Id: 45702,
    Phase: 1,
    ItemSlot: ItemSlot.Finger,
  },
  {
    IconName: 'spell_nature_invisibilitytotem',
    Stats: {
      [Stat.Spirit]: 100,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: 'Spark of Hope',
    Id: 45703,
    Phase: 1,
    ItemSlot: ItemSlot.Trinket,
  },
  {
    IconName: 'inv_wand_28',
    Stats: {
      [Stat.Stamina]: 29,
      [Stat.Intellect]: 26,
      [Stat.Spirit]: 24,
      [Stat.SpellPower]: 39,
      [Stat.CritRating]: 20,
    },
    Quality: Quality.Epic,
    Name: 'Nurturing Touch',
    Id: 45713,
    Phase: 1,
    ItemSlot: ItemSlot.Wand,
  },
  {
    IconName: 'inv_jewelry_ring_34',
    Stats: {
      [Stat.Stamina]: 43,
      [Stat.Intellect]: 28,
      [Stat.SpellPower]: 50,
      [Stat.CritRating]: 28,
      [Stat.ResilienceRating]: 29,
    },
    Quality: Quality.Rare,
    Name: 'Runed Mana Band',
    Id: 45808,
    Phase: 1,
    ItemSlot: ItemSlot.Finger,
  },
  {
    IconName: 'inv_misc_cape_19',
    Stats: {
      [Stat.Stamina]: 42,
      [Stat.Intellect]: 29,
      [Stat.SpellPower]: 50,
      [Stat.CritRating]: 28,
      [Stat.ResilienceRating]: 29,
    },
    Quality: Quality.Rare,
    Name: 'Cloak of Crimson Snow',
    Id: 45810,
    Phase: 1,
    ItemSlot: ItemSlot.Back,
  },
  {
    IconName: 'inv_jewelry_necklace_16',
    Stats: {
      [Stat.Stamina]: 42,
      [Stat.Intellect]: 29,
      [Stat.SpellPower]: 50,
      [Stat.CritRating]: 28,
      [Stat.ResilienceRating]: 29,
    },
    Quality: Quality.Rare,
    Name: 'Sky Sapphire Amulet',
    Sources: [ItemSourceName.JewelcraftingBoE],
    Id: 45813,
    Phase: 1,
    ItemSlot: ItemSlot.Neck,
  },
  {
    IconName: 'inv_jewelry_necklace_41',
    Stats: {
      [Stat.Stamina]: 63,
      [Stat.Intellect]: 43,
      [Stat.Spirit]: 41,
      [Stat.SpellPower]: 74,
      [Stat.HasteRating]: 42,
    },
    Quality: Quality.Epic,
    Name: "Evoker's Charm",
    Sources: [ItemSourceName.EmblemOfConquest],
    Id: 45822,
    Phase: 1,
    ItemSlot: ItemSlot.Neck,
  },
  {
    IconName: 'inv_jewelry_amulet_04',
    Stats: {
      [Stat.Stamina]: 63,
      [Stat.Intellect]: 43,
      [Stat.SpellPower]: 74,
      [Stat.CritRating]: 41,
      [Stat.Mp5]: 21,
    },
    Quality: Quality.Epic,
    Name: 'Frozen Tear of Elune',
    Sources: [ItemSourceName.EmblemOfConquest],
    Id: 45823,
    Phase: 1,
    ItemSlot: ItemSlot.Neck,
  },
  {
    IconName: 'inv_belt_10',
    Stats: {
      [Stat.Stamina]: 73,
      [Stat.Intellect]: 60,
      [Stat.Spirit]: 60,
      [Stat.SpellPower]: 100,
      [Stat.CritRating]: 40,
    },
    Quality: Quality.Epic,
    Name: 'Sash of Potent Incantations',
    Id: 45831,
    Phase: 1,
    ItemSlot: ItemSlot.Waist,
  },
  {
    IconName: 'inv_shoulder_94',
    Stats: {
      [Stat.Stamina]: 72,
      [Stat.Intellect]: 56,
      [Stat.Spirit]: 46,
      [Stat.SpellPower]: 91,
      [Stat.CritRating]: 57,
    },
    Quality: Quality.Epic,
    Name: 'Mantle of the Preserver',
    Id: 45832,
    Phase: 1,
    ItemSlot: ItemSlot.Shoulders,
  },
  {
    IconName: 'inv_gauntlets_17',
    Stats: {
      [Stat.Stamina]: 73,
      [Stat.Intellect]: 60,
      [Stat.Spirit]: 60,
      [Stat.SpellPower]: 100,
      [Stat.HasteRating]: 49,
    },
    Quality: Quality.Epic,
    Name: 'Touch of the Occult',
    Id: 45840,
    Phase: 1,
    ItemSlot: ItemSlot.Hands,
  },
  {
    IconName: 'inv_pants_cloth_24',
    Stats: {
      [Stat.Stamina]: 99,
      [Stat.Intellect]: 81,
      [Stat.Spirit]: 68,
      [Stat.SpellPower]: 115,
      [Stat.CritRating]: 67,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Yellow, SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 7,
    },
    Name: 'Legwraps of the Master Conjurer',
    Id: 45848,
    Phase: 1,
    ItemSlot: ItemSlot.Legs,
  },
  {
    IconName: 'inv_chest_cloth_66',
    Stats: {
      [Stat.Stamina]: 105,
      [Stat.Intellect]: 62,
      [Stat.SpellPower]: 117,
      [Stat.CritRating]: 61,
      [Stat.HitRating]: 76,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Blue],
    SocketBonus: {
      [Stat.HitRating]: 4,
    },
    Name: 'Raiments of the Corrupted',
    Id: 45865,
    Phase: 1,
    ItemSlot: ItemSlot.Chest,
  },
  {
    IconName: 'inv_misc_rune_10',
    Stats: {
      [Stat.HitRating]: 108,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: 'Elemental Focus Stone',
    Id: 45866,
    Phase: 1,
    ItemSlot: ItemSlot.Trinket,
  },
  {
    IconName: 'inv_staff_94',
    Stats: {
      [Stat.Stamina]: 111,
      [Stat.Intellect]: 112,
      [Stat.Spirit]: 84,
      [Stat.SpellPower]: 550,
      [Stat.HasteRating]: 93,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Blue, SocketColor.Red],
    SocketBonus: {
      [Stat.SpellPower]: 7,
    },
    Name: 'Icecore Staff',
    Sources: [ItemSourceName.Ulduar10],
    Id: 45886,
    Phase: 1,
    ItemSlot: ItemSlot.Weapon,
    IsTwoHand: true,
  },
  {
    IconName: 'inv_pants_cloth_30',
    Stats: {
      [Stat.Stamina]: 107,
      [Stat.Intellect]: 81,
      [Stat.Spirit]: 53,
      [Stat.SpellPower]: 124,
      [Stat.CritRating]: 70,
    },
    Quality: Quality.Epic,
    Name: 'Leggings of Unstable Discharge',
    Id: 45894,
    Phase: 1,
    ItemSlot: ItemSlot.Legs,
  },
  {
    IconName: 'inv_gauntlets_55',
    Stats: {
      [Stat.Stamina]: 59,
      [Stat.Intellect]: 60,
      [Stat.Spirit]: 53,
      [Stat.SpellPower]: 99,
      [Stat.CritRating]: 52,
    },
    Quality: Quality.Epic,
    Name: 'Handwraps of Resonance',
    Id: 45927,
    Phase: 1,
    ItemSlot: ItemSlot.Hands,
  },
  {
    IconName: 'spell_ice_rune',
    Stats: {
      [Stat.SpellPower]: 110,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: "Sif's Remembrance",
    Id: 45929,
    Phase: 1,
    ItemSlot: ItemSlot.Trinket,
  },
  {
    IconName: 'inv_jewelry_necklace_46',
    Stats: {
      [Stat.Stamina]: 45,
      [Stat.Intellect]: 43,
      [Stat.SpellPower]: 74,
      [Stat.CritRating]: 41,
      [Stat.HasteRating]: 31,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Yellow],
    SocketBonus: {
      [Stat.CritRating]: 4,
    },
    Name: 'Pendant of the Shallow Grave',
    Sources: [ItemSourceName.Ulduar10Heroic],
    Id: 45933,
    Phase: 1,
    ItemSlot: ItemSlot.Neck,
  },
  {
    IconName: 'inv_staff_94',
    Stats: {
      [Stat.Stamina]: 93,
      [Stat.Intellect]: 76,
      [Stat.Spirit]: 93,
      [Stat.SpellPower]: 487,
      [Stat.HitRating]: 114,
    },
    Quality: Quality.Epic,
    Name: 'Unraveling Reach',
    Sources: [ItemSourceName.Ulduar10],
    Id: 45934,
    Phase: 1,
    ItemSlot: ItemSlot.Weapon,
    IsTwoHand: true,
  },
  {
    IconName: 'inv_jewelry_ring_65',
    Stats: {
      [Stat.Stamina]: 47,
      [Stat.Intellect]: 49,
      [Stat.SpellPower]: 74,
      [Stat.HasteRating]: 30,
      [Stat.Mp5]: 19,
    },
    Quality: Quality.Epic,
    Unique: true,
    Sockets: [SocketColor.Yellow],
    SocketBonus: {
      [Stat.Mp5]: 2,
    },
    Name: 'Fire Orchid Signet',
    Id: 45946,
    Phase: 1,
    ItemSlot: ItemSlot.Finger,
  },
  {
    IconName: 'inv_gauntlets_52',
    Stats: {
      [Stat.Stamina]: 68,
      [Stat.Intellect]: 56,
      [Stat.Spirit]: 39,
      [Stat.SpellPower]: 92,
      [Stat.HitRating]: 60,
    },
    Quality: Quality.Epic,
    Name: 'Static Charge Handwraps',
    Id: 45976,
    Phase: 1,
    ItemSlot: ItemSlot.Hands,
  },
  {
    IconName: 'inv_sword_132',
    Stats: {
      [Stat.Stamina]: 51,
      [Stat.Intellect]: 36,
      [Stat.SpellPower]: 550,
      [Stat.CritRating]: 37,
      [Stat.HitRating]: 52,
    },
    Quality: Quality.Epic,
    Unique: true,
    Sockets: [SocketColor.Yellow],
    SocketBonus: {
      [Stat.HitRating]: 4,
    },
    Name: 'Fusion Blade',
    Sources: [ItemSourceName.Ulduar10Heroic],
    Id: 45990,
    Phase: 1,
    ItemSlot: ItemSlot.Weapon,
  },
  {
    // TODO random enchantments
    IconName: 'inv_jewelry_ring_38',
    Quality: Quality.Rare,
    Unique: true,
    Name: 'Lost Ring',
    Id: 45994,
    Phase: 1,
    ItemSlot: ItemSlot.Finger,
  },
  {
    // TODO random enchantments
    IconName: 'inv_jewelry_necklace_28naxxramas',
    Quality: Quality.Rare,
    Unique: true,
    Name: 'Forgotten Necklace',
    Sources: [ItemSourceName.BoE],
    Id: 45995,
    Phase: 1,
    ItemSlot: ItemSlot.Neck,
  },
  {
    IconName: 'inv_chest_cloth_73',
    Stats: {
      [Stat.Stamina]: 80,
      [Stat.Intellect]: 81,
      [Stat.Spirit]: 76,
      [Stat.SpellPower]: 124,
      [Stat.CritRating]: 62,
    },
    Quality: Quality.Epic,
    Name: 'Vestments of the Piercing Light',
    Id: 46012,
    Phase: 1,
    ItemSlot: ItemSlot.Chest,
  },
  {
    IconName: 'inv_shoulder_97',
    Stats: {
      [Stat.Stamina]: 58,
      [Stat.Intellect]: 60,
      [Stat.Spirit]: 46,
      [Stat.SpellPower]: 92,
      [Stat.HasteRating]: 40,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Yellow],
    SocketBonus: {
      [Stat.Spirit]: 4,
    },
    Name: 'Underworld Mantle',
    Id: 46013,
    Phase: 1,
    ItemSlot: ItemSlot.Shoulders,
  },
  {
    IconName: 'inv_jewelry_necklace_17',
    Stats: {
      [Stat.Stamina]: 58,
      [Stat.Intellect]: 40,
      [Stat.SpellPower]: 70,
      [Stat.CritRating]: 29,
      [Stat.Mp5]: 23,
    },
    Quality: Quality.Epic,
    Name: 'Pendant of Endless Despair',
    Sources: [ItemSourceName.Ulduar10],
    Id: 46015,
    Phase: 1,
    ItemSlot: ItemSlot.Neck,
  },
  {
    IconName: 'inv_staff_92',
    Stats: {
      [Stat.Stamina]: 129,
      [Stat.Intellect]: 81,
      [Stat.Spirit]: 106,
      [Stat.SpellPower]: 487,
      [Stat.HasteRating]: 87,
    },
    Quality: Quality.Epic,
    Name: 'Devotion',
    Sources: [ItemSourceName.Ulduar10],
    Id: 46025,
    Phase: 1,
    ItemSlot: ItemSlot.Weapon,
    IsTwoHand: true,
  },
  {
    IconName: 'inv_boots_cloth_14',
    Stats: {
      [Stat.Stamina]: 69,
      [Stat.Intellect]: 57,
      [Stat.Spirit]: 42,
      [Stat.SpellPower]: 93,
      [Stat.CritRating]: 59,
    },
    Quality: Quality.Epic,
    Name: 'Treads of the Dragon Council',
    Id: 46030,
    Phase: 1,
    ItemSlot: ItemSlot.Feet,
  },
  {
    IconName: 'inv_pants_cloth_31',
    Stats: {
      [Stat.Stamina]: 84,
      [Stat.Intellect]: 82,
      [Stat.Spirit]: 66,
      [Stat.SpellPower]: 132,
      [Stat.CritRating]: 60,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Red, SocketColor.Yellow],
    SocketBonus: {
      [Stat.SpellPower]: 7,
    },
    Name: 'Leggings of Profound Darkness',
    Id: 46034,
    Phase: 1,
    ItemSlot: ItemSlot.Legs,
  },
  {
    IconName: 'inv_misc_cape_06',
    Stats: {
      [Stat.Stamina]: 45,
      [Stat.Intellect]: 36,
      [Stat.SpellPower]: 74,
      [Stat.CritRating]: 49,
      [Stat.HitRating]: 31,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Yellow],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Name: 'Drape of the Messenger',
    Id: 46042,
    Phase: 1,
    ItemSlot: ItemSlot.Back,
  },
  {
    IconName: 'inv_gauntlets_70',
    Stats: {
      [Stat.Stamina]: 75,
      [Stat.Intellect]: 47,
      [Stat.SpellPower]: 100,
      [Stat.HitRating]: 50,
      [Stat.HasteRating]: 46,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Red, SocketColor.Red],
    SocketBonus: {
      [Stat.HitRating]: 6,
    },
    Name: 'Pulsar Gloves',
    Id: 46045,
    Phase: 1,
    ItemSlot: ItemSlot.Hands,
  },
  {
    IconName: 'inv_jewelry_ring_70',
    Stats: {
      [Stat.Stamina]: 48,
      [Stat.Intellect]: 36,
      [Stat.SpellPower]: 74,
      [Stat.CritRating]: 46,
      [Stat.HasteRating]: 36,
    },
    Quality: Quality.Epic,
    Unique: true,
    Sockets: [SocketColor.Yellow],
    SocketBonus: {
      [Stat.CritRating]: 4,
    },
    Name: 'Nebula Band',
    Id: 46046,
    Phase: 1,
    ItemSlot: ItemSlot.Finger,
  },
  {
    IconName: 'inv_jewelry_necklace_42',
    Stats: {
      [Stat.Stamina]: 54,
      [Stat.Intellect]: 46,
      [Stat.SpellPower]: 66,
      [Stat.CritRating]: 36,
      [Stat.Mp5]: 19,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Red],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Name: 'Pendant of the Somber Witness',
    Sources: [ItemSourceName.Ulduar10],
    Id: 46047,
    Phase: 1,
    ItemSlot: ItemSlot.Neck,
  },
  {
    IconName: 'inv_boots_cloth_21',
    Stats: {
      [Stat.Stamina]: 64,
      [Stat.Intellect]: 65,
      [Stat.Spirit]: 45,
      [Stat.SpellPower]: 94,
      [Stat.CritRating]: 57,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Blue, SocketColor.Yellow],
    SocketBonus: {
      [Stat.Spirit]: 6,
    },
    Name: 'Starlight Treads',
    Id: 46050,
    Phase: 1,
    ItemSlot: ItemSlot.Feet,
  },
  {
    IconName: 'achievement_dungeon_ulduarraid_misc_04',
    Stats: {
      [Stat.Intellect]: 111,
      [Stat.Mp5]: 193,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: 'Meteorite Crystal',
    Id: 46051,
    Phase: 1,
    ItemSlot: ItemSlot.Trinket,
  },
  {
    IconName: 'inv_shoulder_25',
    Stats: {
      [Stat.Stamina]: 48,
      [Stat.Intellect]: 49,
      [Stat.Spirit]: 42,
      [Stat.SpellPower]: 100,
      [Stat.HasteRating]: 62,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Red, SocketColor.Yellow],
    SocketBonus: {
      [Stat.Spirit]: 6,
    },
    Name: 'Amice of Inconceivable Horror',
    Id: 46068,
    Phase: 1,
    ItemSlot: ItemSlot.Shoulders,
  },
  {
    IconName: 'inv_misc_rune_10',
    Stats: {
      [Stat.SpellPower]: 111,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: 'Titan-Forged Rune of Audacity',
    Id: 46081,
    Phase: 1,
    ItemSlot: ItemSlot.Trinket,
  },
  {
    IconName: 'inv_misc_rune_07',
    Stats: {
      [Stat.HitRating]: 95,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: 'Titan-Forged Rune of Accuracy',
    Id: 46083,
    Phase: 1,
    ItemSlot: ItemSlot.Trinket,
  },
  {
    IconName: 'inv_misc_rune_06',
    Stats: {
      [Stat.CritRating]: 95,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: 'Titan-Forged Rune of Cruelty',
    Id: 46084,
    Phase: 1,
    ItemSlot: ItemSlot.Trinket,
  },
  {
    IconName: 'inv_misc_rune_05',
    Stats: {
      [Stat.HasteRating]: 95,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: 'Titan-Forged Rune of Alacrity',
    Id: 46085,
    Phase: 1,
    ItemSlot: ItemSlot.Trinket,
  },
  {
    IconName: 'inv_misc_platnumdisks',
    Stats: {
      [Stat.ResilienceRating]: 95,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: 'Platinum Disks of Sorcery',
    Id: 46087,
    Phase: 1,
    ItemSlot: ItemSlot.Trinket,
  },
  {
    IconName: 'inv_misc_platnumdisks',
    Stats: {
      [Stat.ResilienceRating]: 95,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: 'Platinum Disks of Swiftness',
    Id: 46088,
    Phase: 1,
    ItemSlot: ItemSlot.Trinket,
  },
  {
    IconName: 'inv_jewelry_ring_29',
    Stats: {
      [Stat.Stamina]: 54,
      [Stat.Intellect]: 46,
      [Stat.Spirit]: 36,
      [Stat.SpellPower]: 74,
      [Stat.CritRating]: 32,
    },
    Quality: Quality.Epic,
    Unique: true,
    Sockets: [SocketColor.Blue],
    SocketBonus: {
      [Stat.Spirit]: 4,
    },
    Name: 'Signet of Soft Lament',
    Id: 46096,
    Phase: 1,
    ItemSlot: ItemSlot.Finger,
  },
  {
    IconName: 'inv_gauntlets_17',
    Stats: {
      [Stat.Stamina]: 74,
      [Stat.Intellect]: 62,
      [Stat.Spirit]: 27,
      [Stat.SpellPower]: 99,
      [Stat.HitRating]: 65,
    },
    Quality: Quality.Epic,
    Set: ItemSet.T8,
    Sockets: [SocketColor.Blue],
    SocketBonus: {
      [Stat.CritRating]: 4,
    },
    Name: "Conqueror's Deathbringer Gloves",
    Sources: [ItemSourceName.Ulduar25],
    Id: 46135,
    Phase: 1,
    ItemSlot: ItemSlot.Hands,
  },
  {
    IconName: 'inv_shoulder_25',
    Stats: {
      [Stat.Stamina]: 68,
      [Stat.Intellect]: 62,
      [Stat.SpellPower]: 99,
      [Stat.CritRating]: 58,
      [Stat.HasteRating]: 41,
    },
    Quality: Quality.Epic,
    Set: ItemSet.T8,
    Sockets: [SocketColor.Yellow],
    SocketBonus: {
      [Stat.HitRating]: 4,
    },
    Name: "Conqueror's Deathbringer Shoulderpads",
    Sources: [ItemSourceName.Ulduar25],
    Id: 46136,
    Phase: 1,
    ItemSlot: ItemSlot.Shoulders,
  },
  {
    IconName: 'inv_chest_cloth_43',
    Stats: {
      [Stat.Stamina]: 83,
      [Stat.Intellect]: 76,
      [Stat.SpellPower]: 124,
      [Stat.CritRating]: 66,
      [Stat.HitRating]: 73,
    },
    Quality: Quality.Epic,
    Set: ItemSet.T8,
    Sockets: [SocketColor.Red, SocketColor.Yellow],
    SocketBonus: {
      [Stat.SpellPower]: 7,
    },
    Name: "Conqueror's Deathbringer Robe",
    Sources: [ItemSourceName.Ulduar25],
    Id: 46137,
    Phase: 1,
    ItemSlot: ItemSlot.Chest,
  },
  {
    IconName: 'inv_pants_cloth_05',
    Stats: {
      [Stat.Stamina]: 86,
      [Stat.Intellect]: 86,
      [Stat.Spirit]: 49,
      [Stat.SpellPower]: 132,
      [Stat.HasteRating]: 66,
    },
    Quality: Quality.Epic,
    Set: ItemSet.T8,
    Sockets: [SocketColor.Blue, SocketColor.Yellow],
    SocketBonus: {
      [Stat.HasteRating]: 6,
    },
    Name: "Conqueror's Deathbringer Leggings",
    Sources: [ItemSourceName.Ulduar25],
    Id: 46139,
    Phase: 1,
    ItemSlot: ItemSlot.Legs,
  },
  {
    IconName: 'inv_helmet_131',
    Stats: {
      [Stat.Stamina]: 89,
      [Stat.Intellect]: 76,
      [Stat.Spirit]: 41,
      [Stat.SpellPower]: 113,
      [Stat.CritRating]: 86,
    },
    Quality: Quality.Epic,
    Set: ItemSet.T8,
    Sockets: [SocketColor.Meta, SocketColor.Blue],
    SocketBonus: {
      [Stat.CritRating]: 8,
    },
    Name: "Conqueror's Deathbringer Hood",
    Sources: [ItemSourceName.Ulduar25],
    Id: 46140,
    Phase: 1,
    ItemSlot: ItemSlot.Head,
  },
  {
    IconName: 'inv_misc_ahnqirajtrinket_05',
    Stats: {
      [Stat.CritRating]: 136,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: 'Vanquished Clutches of Yogg-Saron',
    Id: 46312,
    Phase: 1,
    ItemSlot: ItemSlot.Trinket,
  },
  {
    IconName: 'inv_misc_cape_06',
    Stats: {
      [Stat.Stamina]: 63,
      [Stat.Intellect]: 42,
      [Stat.Spirit]: 42,
      [Stat.SpellPower]: 64,
      [Stat.HasteRating]: 34,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Name: 'Sunglimmer Drape',
    Id: 46321,
    Phase: 1,
    ItemSlot: ItemSlot.Back,
  },
  {
    IconName: 'inv_jewelry_ring_31',
    Stats: {
      [Stat.Stamina]: 54,
      [Stat.Intellect]: 46,
      [Stat.SpellPower]: 64,
      [Stat.HasteRating]: 32,
      [Stat.Mp5]: 21,
    },
    Quality: Quality.Epic,
    Unique: true,
    Sockets: [SocketColor.Yellow],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Name: 'Starshine Signet',
    Id: 46323,
    Phase: 1,
    ItemSlot: ItemSlot.Finger,
  },
  {
    // TODO random enchantments
    IconName: 'inv_jewelry_ring_62',
    Quality: Quality.Rare,
    Unique: true,
    Name: "Gondria's Spectral Claw",
    Id: 46324,
    Phase: 1,
    ItemSlot: ItemSlot.Finger,
  },
  {
    IconName: 'inv_misc_cape_09',
    Stats: {
      [Stat.Stamina]: 65,
      [Stat.Intellect]: 37,
      [Stat.SpellPower]: 68,
      [Stat.CritRating]: 39,
      [Stat.HasteRating]: 30,
    },
    Quality: Quality.Epic,
    Name: 'Drape of the Spellweaver',
    Id: 46341,
    Phase: 1,
    ItemSlot: ItemSlot.Back,
  },
  {
    IconName: 'inv_shoulder_97',
    Stats: {
      [Stat.Stamina]: 62,
      [Stat.Intellect]: 56,
      [Stat.Spirit]: 55,
      [Stat.SpellPower]: 92,
      [Stat.CritRating]: 47,
    },
    Quality: Quality.Epic,
    Name: 'Iceshear Mantle',
    Id: 46344,
    Phase: 1,
    ItemSlot: ItemSlot.Shoulders,
  },
  {
    IconName: 'inv_misc_cape_09',
    Stats: {
      [Stat.Stamina]: 68,
      [Stat.Intellect]: 30,
      [Stat.SpellPower]: 69,
      [Stat.CritRating]: 29,
      [Stat.Mp5]: 24,
    },
    Quality: Quality.Epic,
    Name: 'Cloak of the Dormant Blaze',
    Id: 46347,
    Phase: 1,
    ItemSlot: ItemSlot.Back,
  },
  {
    IconName: 'inv_staff_94',
    Stats: {
      [Stat.Stamina]: 159,
      [Stat.Intellect]: 106,
      [Stat.Spirit]: 81,
      [Stat.SpellPower]: 487,
      [Stat.CritRating]: 53,
    },
    Quality: Quality.Epic,
    Name: 'Pillar of Fortitude',
    Sources: [ItemSourceName.Ulduar10, ItemSourceName.Ulduar25],
    Id: 46350,
    Phase: 1,
    ItemSlot: ItemSlot.Weapon,
    IsTwoHand: true,
  },
  {
    IconName: 'inv_belt_52',
    Stats: {
      [Stat.Stamina]: 77,
      [Stat.Intellect]: 77,
      [Stat.Spirit]: 67,
      [Stat.SpellPower]: 109,
      [Stat.HasteRating]: 59,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Faction: Faction.Alliance,
    Name: 'Cord of the Tenebrous Mist',
    Id: 46972,
    Phase: 1,
    ItemSlot: ItemSlot.Waist,
  },
  {
    IconName: 'inv_belt_52',
    Stats: {
      [Stat.Stamina]: 86,
      [Stat.Intellect]: 86,
      [Stat.Spirit]: 76,
      [Stat.SpellPower]: 114,
      [Stat.HasteRating]: 60,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Blue, SocketColor.Red],
    SocketBonus: {
      [Stat.SpellPower]: 7,
    },
    Faction: Faction.Alliance,
    Name: 'Cord of the Tenebrous Mist',
    Id: 46973,
    Phase: 1,
    ItemSlot: ItemSlot.Waist,
  },
  {
    IconName: 'inv_misc_cape_16',
    Stats: {
      [Stat.Stamina]: 58,
      [Stat.Intellect]: 58,
      [Stat.Spirit]: 50,
      [Stat.SpellPower]: 89,
      [Stat.HasteRating]: 50,
    },
    Quality: Quality.Epic,
    Faction: Faction.Alliance,
    Name: 'Shawl of the Refreshing Winds',
    Id: 46976,
    Phase: 1,
    ItemSlot: ItemSlot.Back,
  },
  {
    IconName: 'inv_misc_cape_16',
    Stats: {
      [Stat.Stamina]: 65,
      [Stat.Intellect]: 65,
      [Stat.Spirit]: 57,
      [Stat.SpellPower]: 91,
      [Stat.HasteRating]: 49,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Yellow],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Faction: Faction.Alliance,
    Name: 'Shawl of the Refreshing Winds',
    Id: 46977,
    Phase: 1,
    ItemSlot: ItemSlot.Back,
  },
  {
    IconName: 'inv_weapon_shortblade_99',
    Stats: {
      [Stat.Stamina]: 42,
      [Stat.Intellect]: 58,
      [Stat.SpellPower]: 621,
      [Stat.HitRating]: 45,
      [Stat.HasteRating]: 58,
    },
    Quality: Quality.Epic,
    Unique: true,
    Faction: Faction.Alliance,
    Name: 'Blade of Tarasque',
    Sources: [ItemSourceName.TrialOfTheCrusader25],
    Id: 46979,
    Phase: 1,
    ItemSlot: ItemSlot.Weapon,
  },
  {
    IconName: 'inv_weapon_shortblade_99',
    Stats: {
      [Stat.Stamina]: 48,
      [Stat.Intellect]: 65,
      [Stat.SpellPower]: 692,
      [Stat.HitRating]: 51,
      [Stat.HasteRating]: 57,
    },
    Quality: Quality.Epic,
    Unique: true,
    Sockets: [SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Faction: Faction.Alliance,
    Name: 'Blade of Tarasque',
    Sources: [ItemSourceName.TrialOfTheCrusader25Heroic],
    Id: 46980,
    Phase: 1,
    ItemSlot: ItemSlot.Weapon,
  },
  {
    IconName: 'inv_chest_cloth_75',
    Stats: {
      [Stat.Stamina]: 103,
      [Stat.Intellect]: 103,
      [Stat.Spirit]: 90,
      [Stat.SpellPower]: 140,
      [Stat.HasteRating]: 74,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Red, SocketColor.Yellow],
    SocketBonus: {
      [Stat.SpellPower]: 7,
    },
    Faction: Faction.Alliance,
    Name: 'Flowing Vestments of Ascent',
    Id: 46992,
    Phase: 1,
    ItemSlot: ItemSlot.Chest,
  },
  {
    IconName: 'inv_chest_cloth_75',
    Stats: {
      [Stat.Stamina]: 116,
      [Stat.Intellect]: 116,
      [Stat.Spirit]: 94,
      [Stat.SpellPower]: 151,
      [Stat.HasteRating]: 86,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Blue, SocketColor.Red, SocketColor.Yellow],
    SocketBonus: {
      [Stat.SpellPower]: 9,
    },
    Faction: Faction.Alliance,
    Name: 'Flowing Vestments of Ascent',
    Id: 46993,
    Phase: 1,
    ItemSlot: ItemSlot.Chest,
  },
  {
    IconName: 'achievement_dungeon_ulduar77_25man',
    Stats: {
      [Stat.SpellPower]: 150,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: 'Solace of the Defeated',
    Id: 47041,
    Phase: 1,
    ItemSlot: ItemSlot.Trinket,
  },
  {
    IconName: 'inv_pants_cloth_33',
    Stats: {
      [Stat.Stamina]: 103,
      [Stat.Intellect]: 103,
      [Stat.Spirit]: 90,
      [Stat.SpellPower]: 140,
      [Stat.HasteRating]: 74,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Blue, SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 7,
    },
    Faction: Faction.Alliance,
    Name: 'Leggings of the Soothing Touch',
    Id: 47051,
    Phase: 1,
    ItemSlot: ItemSlot.Legs,
  },
  {
    IconName: 'inv_offhand_pvealliance_d_01',
    Stats: {
      [Stat.Stamina]: 58,
      [Stat.Intellect]: 58,
      [Stat.SpellPower]: 89,
      [Stat.CritRating]: 50,
      [Stat.HitRating]: 50,
    },
    Quality: Quality.Epic,
    Faction: Faction.Alliance,
    Name: 'Symbol of Transgression',
    Sources: [ItemSourceName.TrialOfTheCrusader25],
    Id: 47053,
    Phase: 1,
    ItemSlot: ItemSlot.OffHand,
  },
  {
    IconName: 'inv_jewelry_ring_55',
    Stats: {
      [Stat.Stamina]: 58,
      [Stat.Intellect]: 58,
      [Stat.Spirit]: 44,
      [Stat.SpellPower]: 89,
      [Stat.CritRating]: 54,
    },
    Quality: Quality.Epic,
    Unique: true,
    Faction: Faction.Alliance,
    Name: 'Band of Deplorable Violence',
    Id: 47054,
    Phase: 1,
    ItemSlot: ItemSlot.Finger,
  },
  {
    IconName: 'achievement_dungeon_ulduar77_25man',
    Stats: {
      [Stat.SpellPower]: 168,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: 'Solace of the Defeated',
    Id: 47059,
    Phase: 1,
    ItemSlot: ItemSlot.Trinket,
  },
  {
    IconName: 'inv_pants_cloth_33',
    Stats: {
      [Stat.Stamina]: 116,
      [Stat.Intellect]: 116,
      [Stat.Spirit]: 94,
      [Stat.SpellPower]: 151,
      [Stat.HasteRating]: 86,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Red, SocketColor.Blue, SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 9,
    },
    Faction: Faction.Alliance,
    Name: 'Leggings of the Soothing Touch',
    Id: 47062,
    Phase: 1,
    ItemSlot: ItemSlot.Legs,
  },
  {
    IconName: 'inv_offhand_pvealliance_d_01',
    Stats: {
      [Stat.Stamina]: 65,
      [Stat.Intellect]: 65,
      [Stat.SpellPower]: 100,
      [Stat.CritRating]: 57,
      [Stat.HitRating]: 57,
    },
    Quality: Quality.Epic,
    Faction: Faction.Alliance,
    Name: 'Symbol of Transgression',
    Sources: [ItemSourceName.TrialOfTheCrusader25Heroic],
    Id: 47064,
    Phase: 1,
    ItemSlot: ItemSlot.OffHand,
  },
  {
    IconName: 'inv_belt_52',
    Stats: {
      [Stat.Stamina]: 77,
      [Stat.Intellect]: 77,
      [Stat.SpellPower]: 109,
      [Stat.CritRating]: 72,
      [Stat.HitRating]: 51,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Faction: Faction.Alliance,
    Name: 'Cord of Biting Cold',
    Id: 47081,
    Phase: 1,
    ItemSlot: ItemSlot.Waist,
  },
  {
    IconName: 'inv_belt_52',
    Stats: {
      [Stat.Stamina]: 86,
      [Stat.Intellect]: 86,
      [Stat.SpellPower]: 114,
      [Stat.CritRating]: 73,
      [Stat.HitRating]: 58,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Blue, SocketColor.Red],
    SocketBonus: {
      [Stat.SpellPower]: 7,
    },
    Faction: Faction.Alliance,
    Name: 'Cord of Biting Cold',
    Id: 47084,
    Phase: 1,
    ItemSlot: ItemSlot.Waist,
  },
  {
    IconName: 'inv_misc_cape_16',
    Stats: {
      [Stat.Stamina]: 58,
      [Stat.Intellect]: 58,
      [Stat.SpellPower]: 89,
      [Stat.HitRating]: 50,
      [Stat.HasteRating]: 50,
    },
    Quality: Quality.Epic,
    Faction: Faction.Alliance,
    Name: 'Cloak of Displacement',
    Id: 47089,
    Phase: 1,
    ItemSlot: ItemSlot.Back,
  },
  {
    IconName: 'inv_boots_cloth_23',
    Stats: {
      [Stat.Stamina]: 77,
      [Stat.Intellect]: 77,
      [Stat.Spirit]: 67,
      [Stat.SpellPower]: 109,
      [Stat.HasteRating]: 59,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Faction: Faction.Alliance,
    Name: 'Boots of the Mourning Widow',
    Id: 47092,
    Phase: 1,
    ItemSlot: ItemSlot.Feet,
  },
  {
    IconName: 'inv_misc_cape_16',
    Stats: {
      [Stat.Stamina]: 65,
      [Stat.Intellect]: 65,
      [Stat.SpellPower]: 91,
      [Stat.HitRating]: 49,
      [Stat.HasteRating]: 57,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Yellow],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Faction: Faction.Alliance,
    Name: 'Cloak of Displacement',
    Id: 47095,
    Phase: 1,
    ItemSlot: ItemSlot.Back,
  },
  {
    IconName: 'inv_boots_cloth_23',
    Stats: {
      [Stat.Stamina]: 86,
      [Stat.Intellect]: 86,
      [Stat.Spirit]: 76,
      [Stat.SpellPower]: 124,
      [Stat.HasteRating]: 68,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Blue, SocketColor.Red],
    SocketBonus: {
      [Stat.SpellPower]: 7,
    },
    Faction: Faction.Alliance,
    Name: 'Boots of the Mourning Widow',
    Id: 47097,
    Phase: 1,
    ItemSlot: ItemSlot.Feet,
  },
  {
    IconName: 'inv_chest_cloth_75',
    Stats: {
      [Stat.Stamina]: 103,
      [Stat.Intellect]: 103,
      [Stat.SpellPower]: 140,
      [Stat.HitRating]: 82,
      [Stat.HasteRating]: 82,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Blue, SocketColor.Yellow],
    SocketBonus: {
      [Stat.SpellPower]: 7,
    },
    Faction: Faction.Alliance,
    Name: 'Skyweaver Robes',
    Id: 47126,
    Phase: 1,
    ItemSlot: ItemSlot.Chest,
  },
  {
    IconName: 'inv_chest_cloth_75',
    Stats: {
      [Stat.Stamina]: 116,
      [Stat.Intellect]: 116,
      [Stat.SpellPower]: 151,
      [Stat.HitRating]: 86,
      [Stat.HasteRating]: 94,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Blue, SocketColor.Yellow, SocketColor.Red],
    SocketBonus: {
      [Stat.SpellPower]: 9,
    },
    Faction: Faction.Alliance,
    Name: 'Skyweaver Robes',
    Id: 47129,
    Phase: 1,
    ItemSlot: ItemSlot.Chest,
  },
  {
    IconName: 'inv_offhand_pvealliance_d_01',
    Stats: {
      [Stat.Stamina]: 58,
      [Stat.Intellect]: 58,
      [Stat.Spirit]: 50,
      [Stat.SpellPower]: 89,
      [Stat.CritRating]: 50,
    },
    Quality: Quality.Epic,
    Faction: Faction.Alliance,
    Name: 'Chalice of Searing Light',
    Sources: [ItemSourceName.TrialOfTheCrusader25],
    Id: 47138,
    Phase: 1,
    ItemSlot: ItemSlot.OffHand,
  },
  {
    IconName: 'inv_jewelry_necklace_36',
    Stats: {
      [Stat.Stamina]: 58,
      [Stat.Intellect]: 58,
      [Stat.SpellPower]: 89,
      [Stat.CritRating]: 58,
      [Stat.HasteRating]: 38,
    },
    Quality: Quality.Epic,
    Faction: Faction.Alliance,
    Name: "Wail of the Val'kyr",
    Sources: [ItemSourceName.TrialOfTheCrusader25],
    Id: 47139,
    Phase: 1,
    ItemSlot: ItemSlot.Neck,
  },
  {
    IconName: 'inv_bracer_37',
    Stats: {
      [Stat.Stamina]: 58,
      [Stat.Intellect]: 58,
      [Stat.SpellPower]: 89,
      [Stat.CritRating]: 58,
      [Stat.HitRating]: 38,
    },
    Quality: Quality.Epic,
    Faction: Faction.Alliance,
    Name: 'Bindings of Dark Essence',
    Id: 47141,
    Phase: 1,
    ItemSlot: ItemSlot.Wrist,
  },
  {
    IconName: 'inv_bracer_37',
    Stats: {
      [Stat.Stamina]: 65,
      [Stat.Intellect]: 65,
      [Stat.SpellPower]: 91,
      [Stat.CritRating]: 57,
      [Stat.HitRating]: 43,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Yellow],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Faction: Faction.Alliance,
    Name: 'Bindings of Dark Essence',
    Id: 47143,
    Phase: 1,
    ItemSlot: ItemSlot.Wrist,
  },
  {
    IconName: 'inv_jewelry_necklace_36',
    Stats: {
      [Stat.Stamina]: 65,
      [Stat.Intellect]: 65,
      [Stat.SpellPower]: 91,
      [Stat.CritRating]: 57,
      [Stat.HasteRating]: 43,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Yellow],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Faction: Faction.Alliance,
    Name: "Wail of the Val'kyr",
    Sources: [ItemSourceName.TrialOfTheCrusader25Heroic],
    Id: 47144,
    Phase: 1,
    ItemSlot: ItemSlot.Neck,
  },
  {
    IconName: 'inv_offhand_pvealliance_d_01',
    Stats: {
      [Stat.Stamina]: 65,
      [Stat.Intellect]: 65,
      [Stat.Spirit]: 57,
      [Stat.SpellPower]: 100,
      [Stat.CritRating]: 57,
    },
    Quality: Quality.Epic,
    Faction: Faction.Alliance,
    Name: 'Chalice of Searing Light',
    Sources: [ItemSourceName.TrialOfTheCrusader25Heroic],
    Id: 47146,
    Phase: 1,
    ItemSlot: ItemSlot.OffHand,
  },
  {
    IconName: 'inv_bracer_33',
    Stats: {
      [Stat.Stamina]: 41,
      [Stat.Intellect]: 37,
      [Stat.SpellPower]: 58,
      [Stat.CritRating]: 33,
      [Stat.HitRating]: 33,
    },
    Quality: Quality.Epic,
    Name: 'Bindings of the Wicked',
    Id: 47173,
    Phase: 1,
    ItemSlot: ItemSlot.Wrist,
  },
  {
    IconName: 'inv_belt_08',
    Stats: {
      [Stat.Stamina]: 53,
      [Stat.Intellect]: 49,
      [Stat.SpellPower]: 78,
      [Stat.CritRating]: 35,
      [Stat.HitRating]: 50,
    },
    Quality: Quality.Epic,
    Name: 'Belt of the Churning Blaze',
    Id: 47181,
    Phase: 1,
    ItemSlot: ItemSlot.Waist,
  },
  {
    IconName: 'inv_crown_13',
    Stats: {
      [Stat.SpellPower]: 150,
    },
    Quality: Quality.Epic,
    Unique: true,
    Faction: Faction.Alliance,
    Name: 'Reign of the Unliving',
    Id: 47182,
    Phase: 1,
    ItemSlot: ItemSlot.Trinket,
  },
  {
    IconName: 'inv_pants_cloth_27',
    Stats: {
      [Stat.Stamina]: 84,
      [Stat.Intellect]: 49,
      [Stat.Spirit]: 56,
      [Stat.SpellPower]: 96,
      [Stat.CritRating]: 47,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Blue, SocketColor.Yellow],
    SocketBonus: {
      [Stat.SpellPower]: 7,
    },
    Name: 'Leggings of the Haggard Apprentice',
    Id: 47185,
    Phase: 1,
    ItemSlot: ItemSlot.Legs,
  },
  {
    IconName: 'inv_pants_cloth_33',
    Stats: {
      [Stat.Stamina]: 103,
      [Stat.Intellect]: 103,
      [Stat.SpellPower]: 140,
      [Stat.CritRating]: 82,
      [Stat.HitRating]: 82,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Red, SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 7,
    },
    Faction: Faction.Alliance,
    Name: 'Leggings of the Deepening Void',
    Id: 47187,
    Phase: 1,
    ItemSlot: ItemSlot.Legs,
  },
  {
    IconName: 'inv_crown_13',
    Stats: {
      [Stat.SpellPower]: 168,
    },
    Quality: Quality.Epic,
    Unique: true,
    Faction: Faction.Alliance,
    Name: 'Reign of the Unliving',
    Id: 47188,
    Phase: 1,
    ItemSlot: ItemSlot.Trinket,
  },
  {
    IconName: 'inv_pants_cloth_33',
    Stats: {
      [Stat.Stamina]: 116,
      [Stat.Intellect]: 116,
      [Stat.SpellPower]: 151,
      [Stat.CritRating]: 86,
      [Stat.HitRating]: 94,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Red, SocketColor.Blue, SocketColor.Yellow],
    SocketBonus: {
      [Stat.SpellPower]: 9,
    },
    Faction: Faction.Alliance,
    Name: 'Leggings of the Deepening Void',
    Id: 47189,
    Phase: 1,
    ItemSlot: ItemSlot.Legs,
  },
  {
    IconName: 'inv_boots_cloth_23',
    Stats: {
      [Stat.Stamina]: 77,
      [Stat.Intellect]: 77,
      [Stat.SpellPower]: 109,
      [Stat.HitRating]: 59,
      [Stat.HasteRating]: 67,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Faction: Faction.Alliance,
    Name: 'Footpads of the Icy Floe',
    Id: 47194,
    Phase: 1,
    ItemSlot: ItemSlot.Feet,
  },
  {
    IconName: 'inv_jewelry_ring_64',
    Stats: {
      [Stat.Stamina]: 43,
      [Stat.Intellect]: 36,
      [Stat.Spirit]: 30,
      [Stat.SpellPower]: 58,
      [Stat.CritRating]: 35,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: 'Signet of Purity',
    Id: 47200,
    Phase: 1,
    ItemSlot: ItemSlot.Finger,
  },
  {
    IconName: 'inv_bracer_37',
    Stats: {
      [Stat.Stamina]: 58,
      [Stat.Intellect]: 58,
      [Stat.Spirit]: 50,
      [Stat.SpellPower]: 89,
      [Stat.HasteRating]: 50,
    },
    Quality: Quality.Epic,
    Faction: Faction.Alliance,
    Name: 'Armbands of the Ashen Saint',
    Id: 47203,
    Phase: 1,
    ItemSlot: ItemSlot.Wrist,
  },
  {
    IconName: 'inv_boots_cloth_23',
    Stats: {
      [Stat.Stamina]: 86,
      [Stat.Intellect]: 86,
      [Stat.SpellPower]: 114,
      [Stat.HitRating]: 60,
      [Stat.HasteRating]: 76,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Blue, SocketColor.Red],
    SocketBonus: {
      [Stat.SpellPower]: 7,
    },
    Faction: Faction.Alliance,
    Name: 'Footpads of the Icy Floe',
    Id: 47205,
    Phase: 1,
    ItemSlot: ItemSlot.Feet,
  },
  {
    IconName: 'inv_bracer_37',
    Stats: {
      [Stat.Stamina]: 65,
      [Stat.Intellect]: 65,
      [Stat.Spirit]: 57,
      [Stat.SpellPower]: 91,
      [Stat.HasteRating]: 49,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Faction: Faction.Alliance,
    Name: 'Armbands of the Ashen Saint',
    Id: 47208,
    Phase: 1,
    ItemSlot: ItemSlot.Wrist,
  },
  {
    IconName: 'inv_misc_rune_09',
    Stats: {
      [Stat.HasteRating]: 84,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: 'Abyssal Rune',
    Id: 47213,
    Phase: 1,
    ItemSlot: ItemSlot.Trinket,
  },
  {
    IconName: 'inv_belt_48',
    Stats: {
      [Stat.Stamina]: 43,
      [Stat.Intellect]: 53,
      [Stat.Spirit]: 45,
      [Stat.SpellPower]: 69,
      [Stat.CritRating]: 34,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Yellow],
    SocketBonus: {
      [Stat.Spirit]: 4,
    },
    Name: "The Confessor's Binding",
    Id: 47218,
    Phase: 1,
    ItemSlot: ItemSlot.Waist,
  },
  {
    IconName: 'inv_jewelry_necklace_32',
    Stats: {
      [Stat.Stamina]: 38,
      [Stat.Intellect]: 34,
      [Stat.SpellPower]: 53,
      [Stat.CritRating]: 36,
      [Stat.HitRating]: 21,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Yellow],
    SocketBonus: {
      [Stat.HitRating]: 4,
    },
    Name: 'Brilliant Hailstone Amulet',
    Sources: [ItemSourceName.TrialOfTheChampion],
    Id: 47219,
    Phase: 1,
    ItemSlot: ItemSlot.Neck,
  },
  {
    IconName: 'inv_jewelry_ring_80',
    Stats: {
      [Stat.Stamina]: 58,
      [Stat.Intellect]: 58,
      [Stat.SpellPower]: 89,
      [Stat.HasteRating]: 50,
      [Stat.Mp5]: 25,
    },
    Quality: Quality.Epic,
    Unique: true,
    Faction: Faction.Alliance,
    Name: 'Ring of the Darkmender',
    Id: 47223,
    Phase: 1,
    ItemSlot: ItemSlot.Finger,
  },
  {
    IconName: 'inv_jewelry_ring_80',
    Stats: {
      [Stat.Stamina]: 65,
      [Stat.Intellect]: 65,
      [Stat.SpellPower]: 91,
      [Stat.HasteRating]: 49,
      [Stat.Mp5]: 28,
    },
    Quality: Quality.Epic,
    Unique: true,
    Sockets: [SocketColor.Yellow],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Faction: Faction.Alliance,
    Name: 'Ring of the Darkmender',
    Id: 47224,
    Phase: 1,
    ItemSlot: ItemSlot.Finger,
  },
  {
    IconName: 'inv_misc_cape_16',
    Stats: {
      [Stat.Stamina]: 58,
      [Stat.Intellect]: 58,
      [Stat.SpellPower]: 89,
      [Stat.CritRating]: 50,
      [Stat.Mp5]: 25,
    },
    Quality: Quality.Epic,
    Faction: Faction.Alliance,
    Name: "Maiden's Favor",
    Id: 47225,
    Phase: 1,
    ItemSlot: ItemSlot.Back,
  },
  {
    IconName: 'inv_shoulder_31',
    Stats: {
      [Stat.Stamina]: 60,
      [Stat.Intellect]: 47,
      [Stat.SpellPower]: 78,
      [Stat.CritRating]: 37,
      [Stat.HasteRating]: 49,
    },
    Quality: Quality.Epic,
    Name: 'Mantle of Inconsolable Fear',
    Id: 47226,
    Phase: 1,
    ItemSlot: ItemSlot.Shoulders,
  },
  {
    IconName: 'inv_gauntlets_61',
    Stats: {
      [Stat.Stamina]: 63,
      [Stat.Intellect]: 41,
      [Stat.Spirit]: 49,
      [Stat.SpellPower]: 73,
      [Stat.HasteRating]: 29,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Red],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Name: 'Handwraps of Surrendered Hope',
    Id: 47230,
    Phase: 1,
    ItemSlot: ItemSlot.Hands,
  },
  {
    IconName: 'inv_gauntlets_79',
    Stats: {
      [Stat.Stamina]: 77,
      [Stat.Intellect]: 77,
      [Stat.SpellPower]: 109,
      [Stat.CritRating]: 59,
      [Stat.HasteRating]: 67,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Faction: Faction.Alliance,
    Name: 'Gloves of the Lifeless Touch',
    Id: 47235,
    Phase: 1,
    ItemSlot: ItemSlot.Hands,
  },
  {
    IconName: 'inv_gauntlets_79',
    Stats: {
      [Stat.Stamina]: 86,
      [Stat.Intellect]: 86,
      [Stat.SpellPower]: 114,
      [Stat.CritRating]: 60,
      [Stat.HasteRating]: 76,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Blue, SocketColor.Red],
    SocketBonus: {
      [Stat.SpellPower]: 7,
    },
    Faction: Faction.Alliance,
    Name: 'Gloves of the Lifeless Touch',
    Id: 47236,
    Phase: 1,
    ItemSlot: ItemSlot.Hands,
  },
  {
    IconName: 'inv_jewelry_ring_55',
    Stats: {
      [Stat.Stamina]: 65,
      [Stat.Intellect]: 65,
      [Stat.Spirit]: 50,
      [Stat.SpellPower]: 91,
      [Stat.CritRating]: 53,
    },
    Quality: Quality.Epic,
    Unique: true,
    Sockets: [SocketColor.Yellow],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Faction: Faction.Alliance,
    Name: 'Band of Deplorable Violence',
    Id: 47237,
    Phase: 1,
    ItemSlot: ItemSlot.Finger,
  },
  {
    IconName: 'inv_misc_cape_16',
    Stats: {
      [Stat.Stamina]: 65,
      [Stat.Intellect]: 65,
      [Stat.SpellPower]: 91,
      [Stat.CritRating]: 49,
      [Stat.Mp5]: 28,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Faction: Faction.Alliance,
    Name: "Maiden's Favor",
    Id: 47238,
    Phase: 1,
    ItemSlot: ItemSlot.Back,
  },
  {
    IconName: 'inv_misc_cape_18',
    Stats: {
      [Stat.Stamina]: 58,
      [Stat.Intellect]: 58,
      [Stat.Spirit]: 50,
      [Stat.SpellPower]: 89,
      [Stat.HasteRating]: 50,
    },
    Quality: Quality.Epic,
    Faction: Faction.Horde,
    Name: 'Drape of the Refreshing Winds',
    Id: 47256,
    Phase: 1,
    ItemSlot: ItemSlot.Back,
  },
  {
    IconName: 'inv_belt_52',
    Stats: {
      [Stat.Stamina]: 77,
      [Stat.Intellect]: 77,
      [Stat.Spirit]: 67,
      [Stat.SpellPower]: 109,
      [Stat.HasteRating]: 59,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Faction: Faction.Horde,
    Name: 'Belt of the Tenebrous Mist',
    Id: 47258,
    Phase: 1,
    ItemSlot: ItemSlot.Waist,
  },
  {
    IconName: 'inv_weapon_shortblade_93',
    Stats: {
      [Stat.Stamina]: 42,
      [Stat.Intellect]: 58,
      [Stat.SpellPower]: 621,
      [Stat.HitRating]: 45,
      [Stat.HasteRating]: 58,
    },
    Quality: Quality.Epic,
    Unique: true,
    Faction: Faction.Horde,
    Name: 'Barb of Tarasque',
    Sources: [ItemSourceName.TrialOfTheCrusader25],
    Id: 47261,
    Phase: 1,
    ItemSlot: ItemSlot.Weapon,
  },
  {
    IconName: 'inv_chest_cloth_73',
    Stats: {
      [Stat.Stamina]: 103,
      [Stat.Intellect]: 103,
      [Stat.Spirit]: 90,
      [Stat.SpellPower]: 140,
      [Stat.HasteRating]: 74,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Red, SocketColor.Yellow],
    SocketBonus: {
      [Stat.SpellPower]: 7,
    },
    Faction: Faction.Horde,
    Name: 'Flowing Robes of Ascent',
    Id: 47264,
    Phase: 1,
    ItemSlot: ItemSlot.Chest,
  },
  {
    IconName: 'achievement_dungeon_ulduar77_25man',
    Stats: {
      [Stat.SpellPower]: 150,
    },
    Quality: Quality.Epic,
    Unique: true,
    Faction: Faction.Horde,
    Name: 'Solace of the Fallen',
    Id: 47271,
    Phase: 1,
    ItemSlot: ItemSlot.Trinket,
  },
  {
    IconName: 'inv_pants_cloth_06',
    Stats: {
      [Stat.Stamina]: 103,
      [Stat.Intellect]: 103,
      [Stat.Spirit]: 90,
      [Stat.SpellPower]: 140,
      [Stat.HasteRating]: 74,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Blue, SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 7,
    },
    Faction: Faction.Horde,
    Name: 'Pants of the Soothing Touch',
    Id: 47274,
    Phase: 1,
    ItemSlot: ItemSlot.Legs,
  },
  {
    IconName: 'inv_offhand_stratholme_a_02',
    Stats: {
      [Stat.Stamina]: 58,
      [Stat.Intellect]: 58,
      [Stat.SpellPower]: 89,
      [Stat.CritRating]: 50,
      [Stat.HitRating]: 50,
    },
    Quality: Quality.Epic,
    Faction: Faction.Horde,
    Name: 'Talisman of Heedless Sins',
    Sources: [ItemSourceName.TrialOfTheCrusader25],
    Id: 47276,
    Phase: 1,
    ItemSlot: ItemSlot.OffHand,
  },
  {
    IconName: 'inv_jewelry_ring_80',
    Stats: {
      [Stat.Stamina]: 58,
      [Stat.Intellect]: 58,
      [Stat.SpellPower]: 89,
      [Stat.HasteRating]: 50,
      [Stat.Mp5]: 25,
    },
    Quality: Quality.Epic,
    Unique: true,
    Faction: Faction.Horde,
    Name: 'Circle of the Darkmender',
    Id: 47278,
    Phase: 1,
    ItemSlot: ItemSlot.Finger,
  },
  {
    IconName: 'inv_belt_52',
    Stats: {
      [Stat.Stamina]: 77,
      [Stat.Intellect]: 77,
      [Stat.SpellPower]: 109,
      [Stat.CritRating]: 72,
      [Stat.HitRating]: 51,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Faction: Faction.Horde,
    Name: 'Belt of Biting Cold',
    Id: 47286,
    Phase: 1,
    ItemSlot: ItemSlot.Waist,
  },
  {
    IconName: 'inv_misc_cape_18',
    Stats: {
      [Stat.Stamina]: 58,
      [Stat.Intellect]: 58,
      [Stat.SpellPower]: 89,
      [Stat.HitRating]: 50,
      [Stat.HasteRating]: 50,
    },
    Quality: Quality.Epic,
    Faction: Faction.Horde,
    Name: 'Shroud of Displacement',
    Id: 47291,
    Phase: 1,
    ItemSlot: ItemSlot.Back,
  },
  {
    IconName: 'inv_boots_cloth_23',
    Stats: {
      [Stat.Stamina]: 77,
      [Stat.Intellect]: 77,
      [Stat.Spirit]: 67,
      [Stat.SpellPower]: 109,
      [Stat.HasteRating]: 59,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Faction: Faction.Horde,
    Name: 'Sandals of the Mourning Widow',
    Id: 47293,
    Phase: 1,
    ItemSlot: ItemSlot.Feet,
  },
  {
    IconName: 'inv_chest_cloth_64',
    Stats: {
      [Stat.Stamina]: 103,
      [Stat.Intellect]: 103,
      [Stat.SpellPower]: 140,
      [Stat.HitRating]: 82,
      [Stat.HasteRating]: 82,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Blue, SocketColor.Yellow],
    SocketBonus: {
      [Stat.SpellPower]: 7,
    },
    Faction: Faction.Horde,
    Name: 'Skyweaver Vestments',
    Id: 47301,
    Phase: 1,
    ItemSlot: ItemSlot.Chest,
  },
  {
    IconName: 'inv_bracer_32a',
    Stats: {
      [Stat.Stamina]: 58,
      [Stat.Intellect]: 58,
      [Stat.SpellPower]: 89,
      [Stat.CritRating]: 58,
      [Stat.HitRating]: 38,
    },
    Quality: Quality.Epic,
    Faction: Faction.Horde,
    Name: 'Dark Essence Bindings',
    Id: 47306,
    Phase: 1,
    ItemSlot: ItemSlot.Wrist,
  },
  {
    IconName: 'inv_jewelry_necklace_36',
    Stats: {
      [Stat.Stamina]: 58,
      [Stat.Intellect]: 58,
      [Stat.SpellPower]: 89,
      [Stat.CritRating]: 58,
      [Stat.HasteRating]: 38,
    },
    Quality: Quality.Epic,
    Faction: Faction.Horde,
    Name: "Cry of the Val'kyr",
    Sources: [ItemSourceName.TrialOfTheCrusader25],
    Id: 47307,
    Phase: 1,
    ItemSlot: ItemSlot.Neck,
  },
  {
    IconName: 'inv_offhand_stratholme_a_02',
    Stats: {
      [Stat.Stamina]: 58,
      [Stat.Intellect]: 58,
      [Stat.Spirit]: 50,
      [Stat.SpellPower]: 89,
      [Stat.CritRating]: 50,
    },
    Quality: Quality.Epic,
    Faction: Faction.Horde,
    Name: 'Mystifying Charm',
    Sources: [ItemSourceName.TrialOfTheCrusader25],
    Id: 47309,
    Phase: 1,
    ItemSlot: ItemSlot.OffHand,
  },
  {
    IconName: 'inv_crown_13',
    Stats: {
      [Stat.SpellPower]: 150,
    },
    Quality: Quality.Epic,
    Unique: true,
    Faction: Faction.Horde,
    Name: 'Reign of the Dead',
    Id: 47316,
    Phase: 1,
    ItemSlot: ItemSlot.Trinket,
  },
  {
    IconName: 'inv_pants_cloth_02',
    Stats: {
      [Stat.Stamina]: 103,
      [Stat.Intellect]: 103,
      [Stat.SpellPower]: 140,
      [Stat.CritRating]: 82,
      [Stat.HitRating]: 82,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Red, SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 7,
    },
    Faction: Faction.Horde,
    Name: 'Breeches of the Deepening Void',
    Id: 47317,
    Phase: 1,
    ItemSlot: ItemSlot.Legs,
  },
  {
    IconName: 'inv_boots_cloth_17',
    Stats: {
      [Stat.Stamina]: 77,
      [Stat.Intellect]: 77,
      [Stat.SpellPower]: 109,
      [Stat.HitRating]: 59,
      [Stat.HasteRating]: 67,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Faction: Faction.Horde,
    Name: 'Boots of the Icy Floe',
    Id: 47321,
    Phase: 1,
    ItemSlot: ItemSlot.Feet,
  },
  {
    IconName: 'inv_bracer_24b',
    Stats: {
      [Stat.Stamina]: 58,
      [Stat.Intellect]: 58,
      [Stat.Spirit]: 50,
      [Stat.SpellPower]: 89,
      [Stat.HasteRating]: 50,
    },
    Quality: Quality.Epic,
    Faction: Faction.Horde,
    Name: 'Bindings of the Ashen Saint',
    Id: 47324,
    Phase: 1,
    ItemSlot: ItemSlot.Wrist,
  },
  {
    IconName: 'inv_gauntlets_56',
    Stats: {
      [Stat.Stamina]: 77,
      [Stat.Intellect]: 77,
      [Stat.SpellPower]: 109,
      [Stat.CritRating]: 59,
      [Stat.HasteRating]: 67,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Faction: Faction.Horde,
    Name: 'Handwraps of the Lifeless Touch',
    Id: 47326,
    Phase: 1,
    ItemSlot: ItemSlot.Hands,
  },
  {
    IconName: 'inv_jewelry_ring_55',
    Stats: {
      [Stat.Stamina]: 58,
      [Stat.Intellect]: 58,
      [Stat.Spirit]: 44,
      [Stat.SpellPower]: 89,
      [Stat.CritRating]: 54,
    },
    Quality: Quality.Epic,
    Unique: true,
    Faction: Faction.Horde,
    Name: 'Lurid Manifestation',
    Id: 47327,
    Phase: 1,
    ItemSlot: ItemSlot.Finger,
  },
  {
    IconName: 'inv_misc_cape_18',
    Stats: {
      [Stat.Stamina]: 58,
      [Stat.Intellect]: 58,
      [Stat.SpellPower]: 89,
      [Stat.CritRating]: 50,
      [Stat.Mp5]: 25,
    },
    Quality: Quality.Epic,
    Faction: Faction.Horde,
    Name: "Maiden's Adoration",
    Id: 47328,
    Phase: 1,
    ItemSlot: ItemSlot.Back,
  },
  {
    IconName: 'inv_misc_cape_18',
    Stats: {
      [Stat.Stamina]: 65,
      [Stat.Intellect]: 65,
      [Stat.Spirit]: 57,
      [Stat.SpellPower]: 91,
      [Stat.HasteRating]: 49,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Yellow],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Faction: Faction.Horde,
    Name: 'Drape of the Refreshing Winds',
    Id: 47417,
    Phase: 1,
    ItemSlot: ItemSlot.Back,
  },
  {
    IconName: 'inv_belt_52',
    Stats: {
      [Stat.Stamina]: 86,
      [Stat.Intellect]: 86,
      [Stat.Spirit]: 76,
      [Stat.SpellPower]: 114,
      [Stat.HasteRating]: 60,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Blue, SocketColor.Red],
    SocketBonus: {
      [Stat.SpellPower]: 7,
    },
    Faction: Faction.Horde,
    Name: 'Belt of the Tenebrous Mist',
    Id: 47419,
    Phase: 1,
    ItemSlot: ItemSlot.Waist,
  },
  {
    IconName: 'inv_weapon_shortblade_93',
    Stats: {
      [Stat.Stamina]: 48,
      [Stat.Intellect]: 65,
      [Stat.SpellPower]: 692,
      [Stat.HitRating]: 51,
      [Stat.HasteRating]: 57,
    },
    Quality: Quality.Epic,
    Unique: true,
    Sockets: [SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Faction: Faction.Horde,
    Name: 'Barb of Tarasque',
    Sources: [ItemSourceName.TrialOfTheCrusader25Heroic],
    Id: 47422,
    Phase: 1,
    ItemSlot: ItemSlot.Weapon,
  },
  {
    IconName: 'inv_chest_cloth_73',
    Stats: {
      [Stat.Stamina]: 116,
      [Stat.Intellect]: 116,
      [Stat.Spirit]: 94,
      [Stat.SpellPower]: 151,
      [Stat.HasteRating]: 86,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Blue, SocketColor.Red, SocketColor.Yellow],
    SocketBonus: {
      [Stat.SpellPower]: 9,
    },
    Faction: Faction.Horde,
    Name: 'Flowing Robes of Ascent',
    Id: 47425,
    Phase: 1,
    ItemSlot: ItemSlot.Chest,
  },
  {
    IconName: 'achievement_dungeon_ulduar77_25man',
    Stats: {
      [Stat.SpellPower]: 168,
    },
    Quality: Quality.Epic,
    Unique: true,
    Faction: Faction.Horde,
    Name: 'Solace of the Fallen',
    Id: 47432,
    Phase: 1,
    ItemSlot: ItemSlot.Trinket,
  },
  {
    IconName: 'inv_pants_cloth_06',
    Stats: {
      [Stat.Stamina]: 116,
      [Stat.Intellect]: 116,
      [Stat.Spirit]: 94,
      [Stat.SpellPower]: 151,
      [Stat.HasteRating]: 86,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Red, SocketColor.Blue, SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 9,
    },
    Faction: Faction.Horde,
    Name: 'Pants of the Soothing Touch',
    Id: 47435,
    Phase: 1,
    ItemSlot: ItemSlot.Legs,
  },
  {
    IconName: 'inv_offhand_stratholme_a_02',
    Stats: {
      [Stat.Stamina]: 65,
      [Stat.Intellect]: 65,
      [Stat.SpellPower]: 100,
      [Stat.CritRating]: 57,
      [Stat.HitRating]: 57,
    },
    Quality: Quality.Epic,
    Faction: Faction.Horde,
    Name: 'Talisman of Heedless Sins',
    Sources: [ItemSourceName.TrialOfTheCrusader25Heroic],
    Id: 47437,
    Phase: 1,
    ItemSlot: ItemSlot.OffHand,
  },
  {
    IconName: 'inv_jewelry_ring_80',
    Stats: {
      [Stat.Stamina]: 65,
      [Stat.Intellect]: 65,
      [Stat.SpellPower]: 91,
      [Stat.HasteRating]: 49,
      [Stat.Mp5]: 28,
    },
    Quality: Quality.Epic,
    Unique: true,
    Sockets: [SocketColor.Yellow],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Faction: Faction.Horde,
    Name: 'Circle of the Darkmender',
    Id: 47439,
    Phase: 1,
    ItemSlot: ItemSlot.Finger,
  },
  {
    IconName: 'inv_belt_52',
    Stats: {
      [Stat.Stamina]: 86,
      [Stat.Intellect]: 86,
      [Stat.SpellPower]: 114,
      [Stat.CritRating]: 73,
      [Stat.HitRating]: 58,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Blue, SocketColor.Red],
    SocketBonus: {
      [Stat.SpellPower]: 7,
    },
    Faction: Faction.Horde,
    Name: 'Belt of Biting Cold',
    Id: 47447,
    Phase: 1,
    ItemSlot: ItemSlot.Waist,
  },
  {
    IconName: 'inv_misc_cape_18',
    Stats: {
      [Stat.Stamina]: 65,
      [Stat.Intellect]: 65,
      [Stat.SpellPower]: 91,
      [Stat.HitRating]: 49,
      [Stat.HasteRating]: 57,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Yellow],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Faction: Faction.Horde,
    Name: 'Shroud of Displacement',
    Id: 47452,
    Phase: 1,
    ItemSlot: ItemSlot.Back,
  },
  {
    IconName: 'inv_boots_cloth_23',
    Stats: {
      [Stat.Stamina]: 86,
      [Stat.Intellect]: 86,
      [Stat.Spirit]: 76,
      [Stat.SpellPower]: 124,
      [Stat.HasteRating]: 68,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Blue, SocketColor.Red],
    SocketBonus: {
      [Stat.SpellPower]: 7,
    },
    Faction: Faction.Horde,
    Name: 'Sandals of the Mourning Widow',
    Id: 47454,
    Phase: 1,
    ItemSlot: ItemSlot.Feet,
  },
  {
    IconName: 'inv_chest_cloth_64',
    Stats: {
      [Stat.Stamina]: 116,
      [Stat.Intellect]: 116,
      [Stat.SpellPower]: 151,
      [Stat.HitRating]: 86,
      [Stat.HasteRating]: 94,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Blue, SocketColor.Yellow, SocketColor.Red],
    SocketBonus: {
      [Stat.SpellPower]: 9,
    },
    Faction: Faction.Horde,
    Name: 'Skyweaver Vestments',
    Id: 47462,
    Phase: 1,
    ItemSlot: ItemSlot.Chest,
  },
  {
    IconName: 'inv_bracer_32a',
    Stats: {
      [Stat.Stamina]: 65,
      [Stat.Intellect]: 65,
      [Stat.SpellPower]: 91,
      [Stat.CritRating]: 57,
      [Stat.HitRating]: 43,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Yellow],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Faction: Faction.Horde,
    Name: 'Dark Essence Bindings',
    Id: 47467,
    Phase: 1,
    ItemSlot: ItemSlot.Wrist,
  },
  {
    IconName: 'inv_jewelry_necklace_36',
    Stats: {
      [Stat.Stamina]: 65,
      [Stat.Intellect]: 65,
      [Stat.SpellPower]: 91,
      [Stat.CritRating]: 57,
      [Stat.HasteRating]: 43,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Yellow],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Faction: Faction.Horde,
    Name: "Cry of the Val'kyr",
    Sources: [ItemSourceName.TrialOfTheCrusader25Heroic],
    Id: 47468,
    Phase: 1,
    ItemSlot: ItemSlot.Neck,
  },
  {
    IconName: 'inv_offhand_stratholme_a_02',
    Stats: {
      [Stat.Stamina]: 65,
      [Stat.Intellect]: 65,
      [Stat.Spirit]: 57,
      [Stat.SpellPower]: 100,
      [Stat.CritRating]: 57,
    },
    Quality: Quality.Epic,
    Faction: Faction.Horde,
    Name: 'Mystifying Charm',
    Sources: [ItemSourceName.TrialOfTheCrusader25Heroic],
    Id: 47470,
    Phase: 1,
    ItemSlot: ItemSlot.OffHand,
  },
  {
    IconName: 'inv_crown_13',
    Stats: {
      [Stat.SpellPower]: 168,
    },
    Quality: Quality.Epic,
    Unique: true,
    Faction: Faction.Horde,
    Name: 'Reign of the Dead',
    Id: 47477,
    Phase: 1,
    ItemSlot: ItemSlot.Trinket,
  },
  {
    IconName: 'inv_pants_cloth_02',
    Stats: {
      [Stat.Stamina]: 116,
      [Stat.Intellect]: 116,
      [Stat.SpellPower]: 151,
      [Stat.CritRating]: 86,
      [Stat.HitRating]: 94,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Red, SocketColor.Blue, SocketColor.Yellow],
    SocketBonus: {
      [Stat.SpellPower]: 9,
    },
    Faction: Faction.Horde,
    Name: 'Breeches of the Deepening Void',
    Id: 47478,
    Phase: 1,
    ItemSlot: ItemSlot.Legs,
  },
  {
    IconName: 'inv_boots_cloth_17',
    Stats: {
      [Stat.Stamina]: 86,
      [Stat.Intellect]: 86,
      [Stat.SpellPower]: 114,
      [Stat.HitRating]: 60,
      [Stat.HasteRating]: 76,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Blue, SocketColor.Red],
    SocketBonus: {
      [Stat.SpellPower]: 7,
    },
    Faction: Faction.Horde,
    Name: 'Boots of the Icy Floe',
    Id: 47482,
    Phase: 1,
    ItemSlot: ItemSlot.Feet,
  },
  {
    IconName: 'inv_bracer_24b',
    Stats: {
      [Stat.Stamina]: 65,
      [Stat.Intellect]: 65,
      [Stat.Spirit]: 57,
      [Stat.SpellPower]: 91,
      [Stat.HasteRating]: 49,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Faction: Faction.Horde,
    Name: 'Bindings of the Ashen Saint',
    Id: 47485,
    Phase: 1,
    ItemSlot: ItemSlot.Wrist,
  },
  {
    IconName: 'inv_gauntlets_56',
    Stats: {
      [Stat.Stamina]: 86,
      [Stat.Intellect]: 86,
      [Stat.SpellPower]: 114,
      [Stat.CritRating]: 60,
      [Stat.HasteRating]: 76,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Blue, SocketColor.Red],
    SocketBonus: {
      [Stat.SpellPower]: 7,
    },
    Faction: Faction.Horde,
    Name: 'Handwraps of the Lifeless Touch',
    Id: 47487,
    Phase: 1,
    ItemSlot: ItemSlot.Hands,
  },
  {
    IconName: 'inv_jewelry_ring_55',
    Stats: {
      [Stat.Stamina]: 65,
      [Stat.Intellect]: 65,
      [Stat.Spirit]: 50,
      [Stat.SpellPower]: 91,
      [Stat.CritRating]: 53,
    },
    Quality: Quality.Epic,
    Unique: true,
    Sockets: [SocketColor.Yellow],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Faction: Faction.Horde,
    Name: 'Lurid Manifestation',
    Id: 47489,
    Phase: 1,
    ItemSlot: ItemSlot.Finger,
  },
  {
    IconName: 'inv_misc_cape_18',
    Stats: {
      [Stat.Stamina]: 65,
      [Stat.Intellect]: 65,
      [Stat.SpellPower]: 91,
      [Stat.CritRating]: 49,
      [Stat.Mp5]: 28,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Faction: Faction.Horde,
    Name: "Maiden's Adoration",
    Id: 47490,
    Phase: 1,
    ItemSlot: ItemSlot.Back,
  },
  {
    IconName: 'inv_misc_cape_18',
    Stats: {
      [Stat.Stamina]: 52,
      [Stat.Intellect]: 42,
      [Stat.SpellPower]: 70,
      [Stat.CritRating]: 33,
      [Stat.HitRating]: 44,
    },
    Quality: Quality.Epic,
    Name: "Kurisu's Indecision",
    Id: 47501,
    Phase: 1,
    ItemSlot: ItemSlot.Back,
  },
  {
    IconName: 'inv_jewelry_ring_44',
    Stats: {
      [Stat.Stamina]: 47,
      [Stat.Intellect]: 45,
      [Stat.SpellPower]: 70,
      [Stat.CritRating]: 33,
      [Stat.HitRating]: 44,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: "Sinner's Confession",
    Id: 47512,
    Phase: 1,
    ItemSlot: ItemSlot.Finger,
  },
  {
    IconName: 'inv_sword_144',
    Stats: {
      [Stat.Stamina]: 58,
      [Stat.Intellect]: 66,
      [Stat.SpellPower]: 701,
      [Stat.CritRating]: 58,
      [Stat.HasteRating]: 39,
    },
    Quality: Quality.Epic,
    Unique: true,
    Sockets: [SocketColor.Yellow],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Faction: Faction.Alliance,
    Name: 'Blade of the Unbroken Covenant',
    Sources: [ItemSourceName.TrialOfTheCrusader25Heroic],
    Id: 47517,
    Phase: 1,
    ItemSlot: ItemSlot.Weapon,
  },
  {
    IconName: 'inv_sword_137',
    Stats: {
      [Stat.Stamina]: 58,
      [Stat.Intellect]: 66,
      [Stat.SpellPower]: 701,
      [Stat.CritRating]: 58,
      [Stat.HasteRating]: 39,
    },
    Quality: Quality.Epic,
    Unique: true,
    Sockets: [SocketColor.Yellow],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Faction: Faction.Horde,
    Name: 'Mortalis',
    Sources: [ItemSourceName.TrialOfTheCrusader25Heroic],
    Id: 47518,
    Phase: 1,
    ItemSlot: ItemSlot.Weapon,
  },
  {
    IconName: 'inv_staff_98',
    Stats: {
      [Stat.Stamina]: 153,
      [Stat.Intellect]: 153,
      [Stat.Spirit]: 86,
      [Stat.SpellPower]: 701,
      [Stat.CritRating]: 137,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Blue, SocketColor.Red],
    SocketBonus: {
      [Stat.SpellPower]: 7,
    },
    Faction: Faction.Alliance,
    Name: 'Clemency',
    Sources: [ItemSourceName.TrialOfTheCrusader25Heroic],
    Id: 47524,
    Phase: 1,
    ItemSlot: ItemSlot.Weapon,
    IsTwoHand: true,
  },
  {
    IconName: 'inv_staff_102',
    Stats: {
      [Stat.Stamina]: 153,
      [Stat.Intellect]: 153,
      [Stat.Spirit]: 86,
      [Stat.SpellPower]: 701,
      [Stat.CritRating]: 137,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Blue, SocketColor.Red],
    SocketBonus: {
      [Stat.SpellPower]: 7,
    },
    Faction: Faction.Horde,
    Name: 'Sufferance',
    Sources: [ItemSourceName.TrialOfTheCrusader25Heroic],
    Id: 47525,
    Phase: 1,
    ItemSlot: ItemSlot.Weapon,
    IsTwoHand: true,
  },
  {
    IconName: 'inv_chest_cloth_68',
    Stats: {
      [Stat.Stamina]: 74,
      [Stat.Intellect]: 70,
      [Stat.Spirit]: 56,
      [Stat.SpellPower]: 124,
      [Stat.CritRating]: 69,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Blue, SocketColor.Blue],
    SocketBonus: {
      [Stat.Intellect]: 6,
    },
    Name: 'Embrace of Madness',
    Id: 47527,
    Phase: 1,
    ItemSlot: ItemSlot.Chest,
  },
  {
    IconName: 'inv_misc_cape_18',
    Stats: {
      [Stat.Stamina]: 74,
      [Stat.Intellect]: 74,
      [Stat.SpellPower]: 105,
      [Stat.CritRating]: 65,
      [Stat.HasteRating]: 57,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Red],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Faction: Faction.Horde,
    Name: "Aethas' Intensity",
    Id: 47551,
    Phase: 1,
    ItemSlot: ItemSlot.Back,
  },
  {
    IconName: 'inv_misc_cape_16',
    Stats: {
      [Stat.Stamina]: 74,
      [Stat.Intellect]: 74,
      [Stat.SpellPower]: 105,
      [Stat.CritRating]: 65,
      [Stat.HasteRating]: 57,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Red],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Faction: Faction.Alliance,
    Name: "Jaina's Radiance",
    Id: 47552,
    Phase: 1,
    ItemSlot: ItemSlot.Back,
  },
  {
    IconName: 'inv_misc_cape_16',
    Stats: {
      [Stat.Stamina]: 74,
      [Stat.Intellect]: 74,
      [Stat.Spirit]: 65,
      [Stat.SpellPower]: 105,
      [Stat.HasteRating]: 57,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Red],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Faction: Faction.Alliance,
    Name: "Bolvar's Devotion",
    Id: 47553,
    Phase: 1,
    ItemSlot: ItemSlot.Back,
  },
  {
    IconName: 'inv_misc_cape_18',
    Stats: {
      [Stat.Stamina]: 74,
      [Stat.Intellect]: 74,
      [Stat.Spirit]: 65,
      [Stat.SpellPower]: 105,
      [Stat.HasteRating]: 57,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Red],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Faction: Faction.Horde,
    Name: "Lady Liadrin's Conviction",
    Id: 47554,
    Phase: 1,
    ItemSlot: ItemSlot.Back,
  },
  {
    IconName: 'inv_boots_cloth_22',
    Stats: {
      [Stat.Stamina]: 58,
      [Stat.Intellect]: 61,
      [Stat.SpellPower]: 92,
      [Stat.CritRating]: 51,
      [Stat.HitRating]: 35,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Yellow],
    SocketBonus: {
      [Stat.HitRating]: 4,
    },
    Name: 'Boots of the Crackling Flame',
    Id: 47560,
    Phase: 1,
    ItemSlot: ItemSlot.Feet,
  },
  {
    IconName: 'inv_jewelry_necklace_31',
    Stats: {
      [Stat.Stamina]: 43,
      [Stat.Intellect]: 41,
      [Stat.SpellPower]: 67,
      [Stat.CritRating]: 29,
      [Stat.Mp5]: 21,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Blue],
    SocketBonus: {
      [Stat.Intellect]: 4,
    },
    Name: 'Symbol of Redemption',
    Sources: [ItemSourceName.TrialOfTheChampionHeroic],
    Id: 47562,
    Phase: 1,
    ItemSlot: ItemSlot.Neck,
  },
  {
    IconName: 'inv_helmet_133',
    Stats: {
      [Stat.Stamina]: 54,
      [Stat.Intellect]: 74,
      [Stat.SpellPower]: 115,
      [Stat.CritRating]: 67,
      [Stat.HitRating]: 57,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Meta, SocketColor.Red],
    SocketBonus: {
      [Stat.HitRating]: 8,
    },
    Name: 'Gaze of the Unknown',
    Sources: [ItemSourceName.TrialOfTheChampionHeroic],
    Id: 47564,
    Phase: 1,
    ItemSlot: ItemSlot.Head,
  },
  {
    IconName: 'inv_weapon_shortblade_96',
    Stats: {
      [Stat.Stamina]: 30,
      [Stat.Intellect]: 30,
      [Stat.SpellPower]: 487,
      [Stat.CritRating]: 36,
      [Stat.HasteRating]: 46,
    },
    Quality: Quality.Epic,
    Unique: true,
    Sockets: [SocketColor.Blue],
    SocketBonus: {
      [Stat.CritRating]: 4,
    },
    Name: 'Spectral Kris',
    Sources: [ItemSourceName.TrialOfTheChampionHeroic],
    Id: 47569,
    Phase: 1,
    ItemSlot: ItemSlot.Weapon,
  },
  {
    IconName: 'inv_bracer_37',
    Stats: {
      [Stat.Stamina]: 58,
      [Stat.Intellect]: 58,
      [Stat.SpellPower]: 80,
      [Stat.CritRating]: 42,
      [Stat.HasteRating]: 50,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Faction: Faction.Alliance,
    Name: "Bejeweled Wizard's Bracers",
    Id: 47585,
    Phase: 1,
    ItemSlot: ItemSlot.Wrist,
  },
  {
    IconName: 'inv_bracer_32a',
    Stats: {
      [Stat.Stamina]: 58,
      [Stat.Intellect]: 58,
      [Stat.SpellPower]: 80,
      [Stat.CritRating]: 42,
      [Stat.HasteRating]: 50,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Faction: Faction.Horde,
    Name: "Bejeweled Wizard's Bracers",
    Id: 47586,
    Phase: 1,
    ItemSlot: ItemSlot.Wrist,
  },
  {
    IconName: 'inv_bracer_37',
    Stats: {
      [Stat.Stamina]: 58,
      [Stat.Intellect]: 58,
      [Stat.Spirit]: 50,
      [Stat.SpellPower]: 80,
      [Stat.CritRating]: 42,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Faction: Faction.Alliance,
    Name: 'Royal Moonshroud Bracers',
    Id: 47587,
    Phase: 1,
    ItemSlot: ItemSlot.Wrist,
  },
  {
    IconName: 'inv_bracer_24b',
    Stats: {
      [Stat.Stamina]: 58,
      [Stat.Intellect]: 58,
      [Stat.Spirit]: 50,
      [Stat.SpellPower]: 80,
      [Stat.CritRating]: 42,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Faction: Faction.Horde,
    Name: 'Royal Moonshroud Bracers',
    Id: 47588,
    Phase: 1,
    ItemSlot: ItemSlot.Wrist,
  },
  {
    IconName: 'inv_chest_cloth_75',
    Stats: {
      [Stat.Stamina]: 103,
      [Stat.Intellect]: 103,
      [Stat.SpellPower]: 131,
      [Stat.CritRating]: 66,
      [Stat.HasteRating]: 90,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Blue, SocketColor.Yellow, SocketColor.Red],
    SocketBonus: {
      [Stat.SpellPower]: 9,
    },
    Faction: Faction.Alliance,
    Name: "Merlin's Robe",
    Id: 47603,
    Phase: 1,
    ItemSlot: ItemSlot.Chest,
  },
  {
    IconName: 'inv_chest_cloth_64',
    Stats: {
      [Stat.Stamina]: 103,
      [Stat.Intellect]: 103,
      [Stat.SpellPower]: 131,
      [Stat.CritRating]: 66,
      [Stat.HasteRating]: 90,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Blue, SocketColor.Yellow, SocketColor.Red],
    SocketBonus: {
      [Stat.SpellPower]: 9,
    },
    Faction: Faction.Horde,
    Name: "Merlin's Robe",
    Id: 47604,
    Phase: 1,
    ItemSlot: ItemSlot.Chest,
  },
  {
    IconName: 'inv_chest_cloth_75',
    Stats: {
      [Stat.Stamina]: 103,
      [Stat.Intellect]: 103,
      [Stat.Spirit]: 90,
      [Stat.SpellPower]: 131,
      [Stat.CritRating]: 66,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Red, SocketColor.Yellow, SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 9,
    },
    Faction: Faction.Alliance,
    Name: 'Royal Moonshroud Robe',
    Id: 47605,
    Phase: 1,
    ItemSlot: ItemSlot.Chest,
  },
  {
    IconName: 'inv_chest_cloth_73',
    Stats: {
      [Stat.Stamina]: 103,
      [Stat.Intellect]: 103,
      [Stat.Spirit]: 90,
      [Stat.SpellPower]: 131,
      [Stat.CritRating]: 66,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Red, SocketColor.Yellow, SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 9,
    },
    Faction: Faction.Horde,
    Name: 'Royal Moonshroud Robe',
    Id: 47606,
    Phase: 1,
    ItemSlot: ItemSlot.Chest,
  },
  {
    IconName: 'inv_wand_15',
    Stats: {
      [Stat.Stamina]: 36,
      [Stat.Intellect]: 26,
      [Stat.SpellPower]: 44,
      [Stat.CritRating]: 28,
      [Stat.HasteRating]: 21,
    },
    Quality: Quality.Epic,
    Faction: Faction.Alliance,
    Name: 'Rod of Imprisoned Souls',
    Id: 47612,
    Phase: 1,
    ItemSlot: ItemSlot.Wand,
  },
  {
    IconName: 'inv_belt_52',
    Stats: {
      [Stat.Stamina]: 68,
      [Stat.Intellect]: 63,
      [Stat.SpellPower]: 96,
      [Stat.HitRating]: 57,
      [Stat.HasteRating]: 60,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Yellow],
    SocketBonus: {
      [Stat.HasteRating]: 4,
    },
    Faction: Faction.Alliance,
    Name: 'Icehowl Cinch',
    Id: 47617,
    Phase: 1,
    ItemSlot: ItemSlot.Waist,
  },
  {
    IconName: 'inv_jewelry_ring_57',
    Stats: {
      [Stat.Stamina]: 48,
      [Stat.Intellect]: 52,
      [Stat.SpellPower]: 78,
      [Stat.CritRating]: 36,
      [Stat.HitRating]: 50,
    },
    Quality: Quality.Epic,
    Unique: true,
    Faction: Faction.Alliance,
    Name: 'Firestorm Ring',
    Id: 47618,
    Phase: 1,
    ItemSlot: ItemSlot.Finger,
  },
  {
    IconName: 'inv_jewelry_necklace_46',
    Stats: {
      [Stat.Stamina]: 52,
      [Stat.Intellect]: 50,
      [Stat.SpellPower]: 78,
      [Stat.CritRating]: 45,
      [Stat.Mp5]: 22,
    },
    Quality: Quality.Epic,
    Faction: Faction.Alliance,
    Name: 'Amulet of Binding Elements',
    Sources: [ItemSourceName.TrialOfTheCrusader10],
    Id: 47619,
    Phase: 1,
    ItemSlot: ItemSlot.Neck,
  },
  {
    IconName: 'inv_pants_cloth_33',
    Stats: {
      [Stat.Stamina]: 106,
      [Stat.Intellect]: 86,
      [Stat.Spirit]: 86,
      [Stat.SpellPower]: 132,
      [Stat.CritRating]: 62,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Yellow],
    SocketBonus: {
      [Stat.Spirit]: 4,
    },
    Faction: Faction.Alliance,
    Name: 'Leggings of the Demonic Messenger',
    Id: 47620,
    Phase: 1,
    ItemSlot: ItemSlot.Legs,
  },
  {
    IconName: 'inv_wand_32',
    Stats: {
      [Stat.Stamina]: 32,
      [Stat.Intellect]: 32,
      [Stat.Spirit]: 28,
      [Stat.SpellPower]: 50,
      [Stat.HitRating]: 28,
    },
    Quality: Quality.Epic,
    Name: 'Brimstone Igniter',
    Id: 47658,
    Phase: 1,
    ItemSlot: ItemSlot.Wand,
  },
  {
    IconName: 'inv_bracer_37',
    Stats: {
      [Stat.Stamina]: 49,
      [Stat.Intellect]: 51,
      [Stat.SpellPower]: 78,
      [Stat.HitRating]: 36,
      [Stat.HasteRating]: 50,
    },
    Quality: Quality.Epic,
    Faction: Faction.Alliance,
    Name: 'Felspark Bindings',
    Id: 47663,
    Phase: 1,
    ItemSlot: ItemSlot.Wrist,
  },
  {
    IconName: 'inv_helmet_139',
    Stats: {
      [Stat.Stamina]: 103,
      [Stat.Intellect]: 103,
      [Stat.SpellPower]: 131,
      [Stat.HitRating]: 74,
      [Stat.HasteRating]: 82,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Meta, SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 9,
    },
    Faction: Faction.Horde,
    Name: 'Hood of Smoldering Aftermath',
    Sources: [ItemSourceName.EmblemOfTriumph],
    Id: 47692,
    Phase: 1,
    ItemSlot: ItemSlot.Head,
  },
  {
    IconName: 'inv_helmet_146',
    Stats: {
      [Stat.Stamina]: 103,
      [Stat.Intellect]: 103,
      [Stat.SpellPower]: 131,
      [Stat.HitRating]: 74,
      [Stat.HasteRating]: 82,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Meta, SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 9,
    },
    Faction: Faction.Alliance,
    Name: 'Hood of Fiery Aftermath',
    Sources: [ItemSourceName.EmblemOfTriumph],
    Id: 47693,
    Phase: 1,
    ItemSlot: ItemSlot.Head,
  },
  {
    IconName: 'inv_helmet_146',
    Stats: {
      [Stat.Stamina]: 103,
      [Stat.Intellect]: 103,
      [Stat.Spirit]: 90,
      [Stat.SpellPower]: 131,
      [Stat.CritRating]: 66,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Meta, SocketColor.Yellow],
    SocketBonus: {
      [Stat.SpellPower]: 9,
    },
    Faction: Faction.Alliance,
    Name: 'Helm of Clouded Sight',
    Sources: [ItemSourceName.EmblemOfTriumph],
    Id: 47694,
    Phase: 1,
    ItemSlot: ItemSlot.Head,
  },
  {
    IconName: 'inv_helmet_87',
    Stats: {
      [Stat.Stamina]: 103,
      [Stat.Intellect]: 103,
      [Stat.Spirit]: 90,
      [Stat.SpellPower]: 131,
      [Stat.CritRating]: 66,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Meta, SocketColor.Yellow],
    SocketBonus: {
      [Stat.SpellPower]: 9,
    },
    Faction: Faction.Horde,
    Name: 'Hood of Clouded Sight',
    Sources: [ItemSourceName.EmblemOfTriumph],
    Id: 47695,
    Phase: 1,
    ItemSlot: ItemSlot.Head,
  },
  {
    IconName: 'inv_shoulder_110',
    Stats: {
      [Stat.Stamina]: 77,
      [Stat.Intellect]: 77,
      [Stat.SpellPower]: 109,
      [Stat.CritRating]: 59,
      [Stat.HitRating]: 67,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Yellow],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Faction: Faction.Alliance,
    Name: 'Mantle of Catastrophic Emanation',
    Id: 47713,
    Phase: 1,
    ItemSlot: ItemSlot.Shoulders,
  },
  {
    IconName: 'inv_shoulder_35',
    Stats: {
      [Stat.Stamina]: 77,
      [Stat.Intellect]: 77,
      [Stat.SpellPower]: 109,
      [Stat.CritRating]: 59,
      [Stat.HitRating]: 67,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Yellow],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Faction: Faction.Horde,
    Name: 'Pauldrons of Catastrophic Emanation',
    Id: 47714,
    Phase: 1,
    ItemSlot: ItemSlot.Shoulders,
  },
  {
    IconName: 'inv_shoulder_110',
    Stats: {
      [Stat.Stamina]: 77,
      [Stat.Intellect]: 77,
      [Stat.Spirit]: 67,
      [Stat.SpellPower]: 109,
      [Stat.HasteRating]: 59,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Faction: Faction.Alliance,
    Name: 'Pauldrons of Revered Mortality',
    Id: 47715,
    Phase: 1,
    ItemSlot: ItemSlot.Shoulders,
  },
  {
    IconName: 'inv_shoulder_90',
    Stats: {
      [Stat.Stamina]: 77,
      [Stat.Intellect]: 77,
      [Stat.Spirit]: 67,
      [Stat.SpellPower]: 109,
      [Stat.HasteRating]: 59,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Faction: Faction.Horde,
    Name: 'Mantle of Revered Mortality',
    Id: 47716,
    Phase: 1,
    ItemSlot: ItemSlot.Shoulders,
  },
  {
    IconName: 'inv_boots_cloth_17',
    Stats: {
      [Stat.Stamina]: 64,
      [Stat.Intellect]: 69,
      [Stat.SpellPower]: 100,
      [Stat.CritRating]: 64,
      [Stat.HitRating]: 40,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Yellow],
    SocketBonus: {
      [Stat.CritRating]: 4,
    },
    Faction: Faction.Alliance,
    Name: 'Sandals of the Silver Magus',
    Id: 47721,
    Phase: 1,
    ItemSlot: ItemSlot.Feet,
  },
  {
    IconName: 'inv_weapon_shortblade_99',
    Stats: {
      [Stat.Stamina]: 39,
      [Stat.Intellect]: 43,
      [Stat.SpellPower]: 550,
      [Stat.CritRating]: 32,
      [Stat.HasteRating]: 52,
    },
    Quality: Quality.Epic,
    Unique: true,
    Sockets: [SocketColor.Red],
    SocketBonus: {
      [Stat.CritRating]: 4,
    },
    Faction: Faction.Alliance,
    Name: 'Blade of the Silver Disciple',
    Sources: [ItemSourceName.TrialOfTheCrusader10],
    Id: 47724,
    Phase: 1,
    ItemSlot: ItemSlot.Weapon,
  },
  {
    IconName: 'inv_jewelry_necklace_27',
    Stats: {
      [Stat.CritRating]: 114,
    },
    Quality: Quality.Epic,
    Unique: true,
    Faction: Faction.Alliance,
    Name: 'Talisman of Volatile Power',
    Id: 47726,
    Phase: 1,
    ItemSlot: ItemSlot.Trinket,
  },
  {
    IconName: 'inv_jewelry_ring_54',
    Stats: {
      [Stat.Stamina]: 58,
      [Stat.Intellect]: 58,
      [Stat.Spirit]: 50,
      [Stat.SpellPower]: 89,
      [Stat.HasteRating]: 50,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: 'Band of the Invoker',
    Id: 47732,
    Phase: 1,
    ItemSlot: ItemSlot.Finger,
  },
  {
    IconName: 'inv_jewelry_ring_57',
    Stats: {
      [Stat.Stamina]: 58,
      [Stat.Intellect]: 58,
      [Stat.SpellPower]: 89,
      [Stat.CritRating]: 50,
      [Stat.Mp5]: 25,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: 'Heartmender Circle',
    Id: 47733,
    Phase: 1,
    ItemSlot: ItemSlot.Finger,
  },
  {
    IconName: 'inv_offhand_pvealliance_d_01',
    Stats: {
      [Stat.Stamina]: 51,
      [Stat.Intellect]: 48,
      [Stat.SpellPower]: 69,
      [Stat.HitRating]: 37,
      [Stat.HasteRating]: 45,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Yellow],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Faction: Faction.Alliance,
    Name: 'Chalice of Benedictus',
    Sources: [ItemSourceName.TrialOfTheCrusader10],
    Id: 47742,
    Phase: 1,
    ItemSlot: ItemSlot.OffHand,
  },
  {
    IconName: 'inv_staff_98',
    Stats: {
      [Stat.Stamina]: 72,
      [Stat.Intellect]: 92,
      [Stat.SpellPower]: 550,
      [Stat.CritRating]: 113,
      [Stat.HasteRating]: 108,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Blue, SocketColor.Yellow],
    SocketBonus: {
      [Stat.HasteRating]: 6,
    },
    Faction: Faction.Alliance,
    Name: 'Enlightenment',
    Sources: [ItemSourceName.TrialOfTheCrusader10],
    Id: 47743,
    Phase: 1,
    ItemSlot: ItemSlot.Weapon,
    IsTwoHand: true,
  },
  {
    IconName: 'inv_gauntlets_79',
    Stats: {
      [Stat.Stamina]: 68,
      [Stat.Intellect]: 60,
      [Stat.SpellPower]: 96,
      [Stat.HitRating]: 44,
      [Stat.HasteRating]: 60,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Yellow, SocketColor.Red],
    SocketBonus: {
      [Stat.HasteRating]: 6,
    },
    Faction: Faction.Alliance,
    Name: 'Gloves of Looming Shadow',
    Id: 47745,
    Phase: 1,
    ItemSlot: ItemSlot.Hands,
  },
  {
    IconName: 'inv_jewelry_necklace_46',
    Stats: {
      [Stat.Stamina]: 47,
      [Stat.Intellect]: 51,
      [Stat.SpellPower]: 69,
      [Stat.CritRating]: 46,
      [Stat.HitRating]: 36,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Blue],
    SocketBonus: {
      [Stat.Intellect]: 4,
    },
    Faction: Faction.Alliance,
    Name: 'Darkbane Pendant',
    Sources: [ItemSourceName.TrialOfTheCrusader10],
    Id: 47747,
    Phase: 1,
    ItemSlot: ItemSlot.Neck,
  },
  {
    IconName: 'inv_helmet_146',
    Stats: {
      [Stat.Stamina]: 103,
      [Stat.Intellect]: 103,
      [Stat.Spirit]: 74,
      [Stat.SpellPower]: 131,
      [Stat.CritRating]: 82,
    },
    Quality: Quality.Epic,
    Set: ItemSet.T9Alliance,
    Sockets: [SocketColor.Meta, SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 9,
    },
    Faction: Faction.Alliance,
    Name: "Kel'Thuzad's Hood of Triumph",
    Sources: [ItemSourceName.TrialOfTheCrusader25],
    Id: 47778,
    Phase: 1,
    ItemSlot: ItemSlot.Head,
  },
  {
    IconName: 'inv_chest_cloth_75',
    Stats: {
      [Stat.Stamina]: 103,
      [Stat.Intellect]: 103,
      [Stat.Spirit]: 82,
      [Stat.SpellPower]: 140,
      [Stat.HitRating]: 82,
    },
    Quality: Quality.Epic,
    Set: ItemSet.T9Alliance,
    Sockets: [SocketColor.Red, SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 7,
    },
    Faction: Faction.Alliance,
    Name: "Kel'Thuzad's Robe of Triumph",
    Id: 47779,
    Phase: 1,
    ItemSlot: ItemSlot.Chest,
  },
  {
    IconName: 'inv_pants_cloth_33',
    Stats: {
      [Stat.Stamina]: 103,
      [Stat.Intellect]: 103,
      [Stat.SpellPower]: 140,
      [Stat.CritRating]: 90,
      [Stat.HasteRating]: 74,
    },
    Quality: Quality.Epic,
    Set: ItemSet.T9Alliance,
    Sockets: [SocketColor.Red, SocketColor.Yellow],
    SocketBonus: {
      [Stat.SpellPower]: 7,
    },
    Faction: Faction.Alliance,
    Name: "Kel'Thuzad's Leggings of Triumph",
    Id: 47780,
    Phase: 1,
    ItemSlot: ItemSlot.Legs,
  },
  {
    IconName: 'inv_shoulder_110',
    Stats: {
      [Stat.Stamina]: 77,
      [Stat.Intellect]: 77,
      [Stat.Spirit]: 59,
      [Stat.SpellPower]: 109,
      [Stat.CritRating]: 67,
    },
    Quality: Quality.Epic,
    Set: ItemSet.T9Alliance,
    Sockets: [SocketColor.Yellow],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Faction: Faction.Alliance,
    Name: "Kel'Thuzad's Shoulderpads of Triumph",
    Id: 47781,
    Phase: 1,
    ItemSlot: ItemSlot.Shoulders,
  },
  {
    IconName: 'inv_gauntlets_79',
    Stats: {
      [Stat.Stamina]: 77,
      [Stat.Intellect]: 77,
      [Stat.SpellPower]: 109,
      [Stat.CritRating]: 67,
      [Stat.HitRating]: 59,
    },
    Quality: Quality.Epic,
    Set: ItemSet.T9Alliance,
    Sockets: [SocketColor.Red],
    SocketBonus: {
      [Stat.CritRating]: 4,
    },
    Faction: Faction.Alliance,
    Name: "Kel'Thuzad's Gloves of Triumph",
    Id: 47782,
    Phase: 1,
    ItemSlot: ItemSlot.Hands,
  },
  {
    IconName: 'inv_gauntlets_79',
    Stats: {
      [Stat.Stamina]: 68,
      [Stat.Intellect]: 68,
      [Stat.SpellPower]: 96,
      [Stat.CritRating]: 60,
      [Stat.HitRating]: 52,
    },
    Quality: Quality.Epic,
    Set: ItemSet.T9Alliance,
    Sockets: [SocketColor.Red],
    SocketBonus: {
      [Stat.CritRating]: 4,
    },
    Faction: Faction.Alliance,
    Name: "Kel'Thuzad's Gloves of Conquest",
    Id: 47783,
    Phase: 1,
    ItemSlot: ItemSlot.Hands,
  },
  {
    IconName: 'inv_helmet_146',
    Stats: {
      [Stat.Stamina]: 92,
      [Stat.Intellect]: 92,
      [Stat.Spirit]: 64,
      [Stat.SpellPower]: 113,
      [Stat.CritRating]: 72,
    },
    Quality: Quality.Epic,
    Set: ItemSet.T9Alliance,
    Sockets: [SocketColor.Meta, SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 9,
    },
    Faction: Faction.Alliance,
    Name: "Kel'Thuzad's Hood of Conquest",
    Sources: [ItemSourceName.EmblemOfTriumph],
    Id: 47784,
    Phase: 1,
    ItemSlot: ItemSlot.Head,
  },
  {
    IconName: 'inv_pants_cloth_33',
    Stats: {
      [Stat.Stamina]: 92,
      [Stat.Intellect]: 92,
      [Stat.SpellPower]: 122,
      [Stat.CritRating]: 80,
      [Stat.HasteRating]: 64,
    },
    Quality: Quality.Epic,
    Set: ItemSet.T9Alliance,
    Sockets: [SocketColor.Red, SocketColor.Yellow],
    SocketBonus: {
      [Stat.SpellPower]: 7,
    },
    Faction: Faction.Alliance,
    Name: "Kel'Thuzad's Leggings of Conquest",
    Id: 47785,
    Phase: 1,
    ItemSlot: ItemSlot.Legs,
  },
  {
    IconName: 'inv_chest_cloth_75',
    Stats: {
      [Stat.Stamina]: 92,
      [Stat.Intellect]: 92,
      [Stat.Spirit]: 72,
      [Stat.SpellPower]: 122,
      [Stat.HitRating]: 72,
    },
    Quality: Quality.Epic,
    Set: ItemSet.T9Alliance,
    Sockets: [SocketColor.Red, SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 7,
    },
    Faction: Faction.Alliance,
    Name: "Kel'Thuzad's Robe of Conquest",
    Id: 47786,
    Phase: 1,
    ItemSlot: ItemSlot.Chest,
  },
  {
    IconName: 'inv_shoulder_110',
    Stats: {
      [Stat.Stamina]: 68,
      [Stat.Intellect]: 68,
      [Stat.Spirit]: 52,
      [Stat.SpellPower]: 96,
      [Stat.CritRating]: 60,
    },
    Quality: Quality.Epic,
    Set: ItemSet.T9Alliance,
    Sockets: [SocketColor.Yellow],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Faction: Faction.Alliance,
    Name: "Kel'Thuzad's Shoulderpads of Conquest",
    Id: 47787,
    Phase: 1,
    ItemSlot: ItemSlot.Shoulders,
  },
  {
    IconName: 'inv_gauntlets_79',
    Stats: {
      [Stat.Stamina]: 86,
      [Stat.Intellect]: 86,
      [Stat.SpellPower]: 124,
      [Stat.CritRating]: 76,
      [Stat.HitRating]: 68,
    },
    Quality: Quality.Epic,
    Set: ItemSet.T9Alliance,
    Sockets: [SocketColor.Red],
    SocketBonus: {
      [Stat.CritRating]: 4,
    },
    Faction: Faction.Alliance,
    Name: "Kel'Thuzad's Gloves of Triumph",
    Id: 47788,
    Phase: 1,
    ItemSlot: ItemSlot.Hands,
  },
  {
    IconName: 'inv_helmet_146',
    Stats: {
      [Stat.Stamina]: 116,
      [Stat.Intellect]: 116,
      [Stat.Spirit]: 86,
      [Stat.SpellPower]: 151,
      [Stat.CritRating]: 94,
    },
    Quality: Quality.Epic,
    Set: ItemSet.T9Alliance,
    Sockets: [SocketColor.Meta, SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 9,
    },
    Faction: Faction.Alliance,
    Name: "Kel'Thuzad's Hood of Triumph",
    Sources: [ItemSourceName.TrialOfTheCrusader25Heroic],
    Id: 47789,
    Phase: 1,
    ItemSlot: ItemSlot.Head,
  },
  {
    IconName: 'inv_pants_cloth_33',
    Stats: {
      [Stat.Stamina]: 116,
      [Stat.Intellect]: 116,
      [Stat.SpellPower]: 160,
      [Stat.CritRating]: 102,
      [Stat.HasteRating]: 86,
    },
    Quality: Quality.Epic,
    Set: ItemSet.T9Alliance,
    Sockets: [SocketColor.Red, SocketColor.Yellow],
    SocketBonus: {
      [Stat.SpellPower]: 7,
    },
    Faction: Faction.Alliance,
    Name: "Kel'Thuzad's Leggings of Triumph",
    Id: 47790,
    Phase: 1,
    ItemSlot: ItemSlot.Legs,
  },
  {
    IconName: 'inv_chest_cloth_75',
    Stats: {
      [Stat.Stamina]: 116,
      [Stat.Intellect]: 116,
      [Stat.Spirit]: 94,
      [Stat.SpellPower]: 160,
      [Stat.HitRating]: 94,
    },
    Quality: Quality.Epic,
    Set: ItemSet.T9Alliance,
    Sockets: [SocketColor.Red, SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 7,
    },
    Faction: Faction.Alliance,
    Name: "Kel'Thuzad's Robe of Triumph",
    Id: 47791,
    Phase: 1,
    ItemSlot: ItemSlot.Chest,
  },
  {
    IconName: 'inv_shoulder_110',
    Stats: {
      [Stat.Stamina]: 86,
      [Stat.Intellect]: 86,
      [Stat.Spirit]: 68,
      [Stat.SpellPower]: 124,
      [Stat.CritRating]: 76,
    },
    Quality: Quality.Epic,
    Set: ItemSet.T9Alliance,
    Sockets: [SocketColor.Yellow],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Faction: Faction.Alliance,
    Name: "Kel'Thuzad's Shoulderpads of Triumph",
    Id: 47792,
    Phase: 1,
    ItemSlot: ItemSlot.Shoulders,
  },
  {
    IconName: 'inv_shoulder_35',
    Stats: {
      [Stat.Stamina]: 86,
      [Stat.Intellect]: 86,
      [Stat.Spirit]: 68,
      [Stat.SpellPower]: 124,
      [Stat.CritRating]: 76,
    },
    Quality: Quality.Epic,
    Set: ItemSet.T9Horde,
    Sockets: [SocketColor.Yellow],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Faction: Faction.Horde,
    Name: "Gul'dan's Shoulderpads of Triumph",
    Id: 47793,
    Phase: 1,
    ItemSlot: ItemSlot.Shoulders,
  },
  {
    IconName: 'inv_chest_cloth_63',
    Stats: {
      [Stat.Stamina]: 116,
      [Stat.Intellect]: 116,
      [Stat.Spirit]: 94,
      [Stat.SpellPower]: 160,
      [Stat.HitRating]: 94,
    },
    Quality: Quality.Epic,
    Set: ItemSet.T9Horde,
    Sockets: [SocketColor.Red, SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 7,
    },
    Faction: Faction.Horde,
    Name: "Gul'dan's Robe of Triumph",
    Id: 47794,
    Phase: 1,
    ItemSlot: ItemSlot.Chest,
  },
  {
    IconName: 'inv_pants_cloth_02',
    Stats: {
      [Stat.Stamina]: 116,
      [Stat.Intellect]: 116,
      [Stat.SpellPower]: 160,
      [Stat.CritRating]: 102,
      [Stat.HasteRating]: 86,
    },
    Quality: Quality.Epic,
    Set: ItemSet.T9Horde,
    Sockets: [SocketColor.Red, SocketColor.Yellow],
    SocketBonus: {
      [Stat.SpellPower]: 7,
    },
    Faction: Faction.Horde,
    Name: "Gul'dan's Leggings of Triumph",
    Id: 47795,
    Phase: 1,
    ItemSlot: ItemSlot.Legs,
  },
  {
    IconName: 'inv_helmet_139',
    Stats: {
      [Stat.Stamina]: 116,
      [Stat.Intellect]: 116,
      [Stat.Spirit]: 86,
      [Stat.SpellPower]: 151,
      [Stat.CritRating]: 94,
    },
    Quality: Quality.Epic,
    Set: ItemSet.T9Horde,
    Sockets: [SocketColor.Meta, SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 9,
    },
    Faction: Faction.Horde,
    Name: "Gul'dan's Hood of Triumph",
    Sources: [ItemSourceName.TrialOfTheCrusader25],
    Id: 47796,
    Phase: 1,
    ItemSlot: ItemSlot.Head,
  },
  {
    Phase: 1,
    Id: 34362,
    ItemSlot: ItemSlot.Finger,
    Name: 'Loop of Forged Power',
    Stats: {
      [Stat.Stamina]: 27,
      [Stat.Intellect]: 28,
      [Stat.SpellPower]: 34,
      [Stat.HitRating]: 19,
      [Stat.HasteRating]: 30,
    },
    Unique: true,
    Sources: [ItemSourceName.JewelcraftingBoE],
    Quality: Quality.Epic,
    IconName: 'inv_jewelry_ring_35',
  },
  {
    IconName: 'inv_gauntlets_61',
    Stats: {
      [Stat.Stamina]: 86,
      [Stat.Intellect]: 86,
      [Stat.SpellPower]: 124,
      [Stat.CritRating]: 76,
      [Stat.HitRating]: 68,
    },
    Quality: Quality.Epic,
    Set: ItemSet.T9Horde,
    Sockets: [SocketColor.Red],
    SocketBonus: {
      [Stat.CritRating]: 4,
    },
    Faction: Faction.Horde,
    Name: "Gul'dan's Gloves of Triumph",
    Id: 47797,
    Phase: 1,
    ItemSlot: ItemSlot.Hands,
  },
  {
    IconName: 'inv_shoulder_35',
    Stats: {
      [Stat.Stamina]: 68,
      [Stat.Intellect]: 68,
      [Stat.Spirit]: 52,
      [Stat.SpellPower]: 96,
      [Stat.CritRating]: 60,
    },
    Quality: Quality.Epic,
    Set: ItemSet.T9Horde,
    Sockets: [SocketColor.Yellow],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Faction: Faction.Horde,
    Name: "Gul'dan's Shoulderpads of Conquest",
    Id: 47798,
    Phase: 1,
    ItemSlot: ItemSlot.Shoulders,
  },
  {
    IconName: 'inv_chest_cloth_63',
    Stats: {
      [Stat.Stamina]: 92,
      [Stat.Intellect]: 92,
      [Stat.Spirit]: 72,
      [Stat.SpellPower]: 122,
      [Stat.HitRating]: 72,
    },
    Quality: Quality.Epic,
    Set: ItemSet.T9Horde,
    Sockets: [SocketColor.Red, SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 7,
    },
    Faction: Faction.Horde,
    Name: "Gul'dan's Robe of Conquest",
    Id: 47799,
    Phase: 1,
    ItemSlot: ItemSlot.Chest,
  },
  {
    IconName: 'inv_pants_cloth_02',
    Stats: {
      [Stat.Stamina]: 92,
      [Stat.Intellect]: 92,
      [Stat.SpellPower]: 122,
      [Stat.CritRating]: 80,
      [Stat.HasteRating]: 64,
    },
    Quality: Quality.Epic,
    Set: ItemSet.T9Horde,
    Sockets: [SocketColor.Red, SocketColor.Yellow],
    SocketBonus: {
      [Stat.SpellPower]: 7,
    },
    Faction: Faction.Horde,
    Name: "Gul'dan's Leggings of Conquest",
    Id: 47800,
    Phase: 1,
    ItemSlot: ItemSlot.Legs,
  },
  {
    IconName: 'inv_helmet_139',
    Stats: {
      [Stat.Stamina]: 92,
      [Stat.Intellect]: 92,
      [Stat.Spirit]: 64,
      [Stat.SpellPower]: 113,
      [Stat.CritRating]: 72,
    },
    Quality: Quality.Epic,
    Set: ItemSet.T9Horde,
    Sockets: [SocketColor.Meta, SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 9,
    },
    Faction: Faction.Horde,
    Name: "Gul'dan's Hood of Conquest",
    Sources: [ItemSourceName.EmblemOfTriumph],
    Id: 47801,
    Phase: 1,
    ItemSlot: ItemSlot.Head,
  },
  {
    IconName: 'inv_gauntlets_61',
    Stats: {
      [Stat.Stamina]: 68,
      [Stat.Intellect]: 68,
      [Stat.SpellPower]: 96,
      [Stat.CritRating]: 60,
      [Stat.HitRating]: 52,
    },
    Quality: Quality.Epic,
    Set: ItemSet.T9Horde,
    Sockets: [SocketColor.Red],
    SocketBonus: {
      [Stat.CritRating]: 4,
    },
    Faction: Faction.Horde,
    Name: "Gul'dan's Gloves of Conquest",
    Id: 47802,
    Phase: 1,
    ItemSlot: ItemSlot.Hands,
  },
  {
    IconName: 'inv_gauntlets_61',
    Stats: {
      [Stat.Stamina]: 77,
      [Stat.Intellect]: 77,
      [Stat.SpellPower]: 109,
      [Stat.CritRating]: 67,
      [Stat.HitRating]: 59,
    },
    Quality: Quality.Epic,
    Set: ItemSet.T9Horde,
    Sockets: [SocketColor.Red],
    SocketBonus: {
      [Stat.CritRating]: 4,
    },
    Faction: Faction.Horde,
    Name: "Gul'dan's Gloves of Triumph",
    Id: 47803,
    Phase: 1,
    ItemSlot: ItemSlot.Hands,
  },
  {
    IconName: 'inv_helmet_139',
    Stats: {
      [Stat.Stamina]: 103,
      [Stat.Intellect]: 103,
      [Stat.Spirit]: 74,
      [Stat.SpellPower]: 131,
      [Stat.CritRating]: 82,
    },
    Quality: Quality.Epic,
    Set: ItemSet.T9Horde,
    Sockets: [SocketColor.Meta, SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 9,
    },
    Faction: Faction.Horde,
    Name: "Gul'dan's Hood of Triumph",
    Sources: [ItemSourceName.TrialOfTheCrusader25],
    Id: 47804,
    Phase: 1,
    ItemSlot: ItemSlot.Head,
  },
  {
    IconName: 'inv_pants_cloth_02',
    Stats: {
      [Stat.Stamina]: 103,
      [Stat.Intellect]: 103,
      [Stat.SpellPower]: 140,
      [Stat.CritRating]: 90,
      [Stat.HasteRating]: 74,
    },
    Quality: Quality.Epic,
    Set: ItemSet.T9Horde,
    Sockets: [SocketColor.Red, SocketColor.Yellow],
    SocketBonus: {
      [Stat.SpellPower]: 7,
    },
    Faction: Faction.Horde,
    Name: "Gul'dan's Leggings of Triumph",
    Id: 47805,
    Phase: 1,
    ItemSlot: ItemSlot.Legs,
  },
  {
    IconName: 'inv_chest_cloth_63',
    Stats: {
      [Stat.Stamina]: 103,
      [Stat.Intellect]: 103,
      [Stat.Spirit]: 82,
      [Stat.SpellPower]: 140,
      [Stat.HitRating]: 82,
    },
    Quality: Quality.Epic,
    Set: ItemSet.T9Horde,
    Sockets: [SocketColor.Red, SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 7,
    },
    Faction: Faction.Horde,
    Name: "Gul'dan's Robe of Triumph",
    Id: 47806,
    Phase: 1,
    ItemSlot: ItemSlot.Chest,
  },
  {
    IconName: 'inv_shoulder_35',
    Stats: {
      [Stat.Stamina]: 77,
      [Stat.Intellect]: 77,
      [Stat.Spirit]: 59,
      [Stat.SpellPower]: 109,
      [Stat.CritRating]: 67,
    },
    Quality: Quality.Epic,
    Set: ItemSet.T9Horde,
    Sockets: [SocketColor.Yellow],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Faction: Faction.Horde,
    Name: "Gul'dan's Shoulderpads of Triumph",
    Id: 47807,
    Phase: 1,
    ItemSlot: ItemSlot.Shoulders,
  },
  {
    IconName: 'inv_staff_98',
    Stats: {
      [Stat.Stamina]: 92,
      [Stat.Intellect]: 112,
      [Stat.SpellPower]: 550,
      [Stat.CritRating]: 88,
      [Stat.HasteRating]: 116,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Yellow],
    SocketBonus: {
      [Stat.CritRating]: 4,
    },
    Faction: Faction.Alliance,
    Name: 'Cold Convergence',
    Sources: [ItemSourceName.TrialOfTheCrusader10],
    Id: 47815,
    Phase: 1,
    ItemSlot: ItemSlot.Weapon,
    IsTwoHand: true,
  },
  {
    IconName: 'inv_belt_52',
    Stats: {
      [Stat.Stamina]: 68,
      [Stat.Intellect]: 64,
      [Stat.Spirit]: 64,
      [Stat.SpellPower]: 105,
      [Stat.CritRating]: 40,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Yellow],
    SocketBonus: {
      [Stat.Intellect]: 4,
    },
    Faction: Faction.Alliance,
    Name: 'Cinch of the Undying',
    Id: 47837,
    Phase: 1,
    ItemSlot: ItemSlot.Waist,
  },
  {
    IconName: 'inv_chest_cloth_75',
    Stats: {
      [Stat.Stamina]: 92,
      [Stat.Intellect]: 88,
      [Stat.SpellPower]: 132,
      [Stat.CritRating]: 65,
      [Stat.HitRating]: 86,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Faction: Faction.Alliance,
    Name: 'Vestments of the Sleepless',
    Id: 47838,
    Phase: 1,
    ItemSlot: ItemSlot.Chest,
  },
  {
    IconName: 'inv_belt_52',
    Stats: {
      [Stat.Stamina]: 68,
      [Stat.Intellect]: 63,
      [Stat.SpellPower]: 96,
      [Stat.HitRating]: 57,
      [Stat.HasteRating]: 60,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Yellow],
    SocketBonus: {
      [Stat.HasteRating]: 4,
    },
    Faction: Faction.Horde,
    Name: 'Icehowl Binding',
    Id: 47855,
    Phase: 1,
    ItemSlot: ItemSlot.Waist,
  },
  {
    IconName: 'inv_wand_31',
    Stats: {
      [Stat.Stamina]: 36,
      [Stat.Intellect]: 26,
      [Stat.SpellPower]: 44,
      [Stat.CritRating]: 28,
      [Stat.HasteRating]: 21,
    },
    Quality: Quality.Epic,
    Faction: Faction.Horde,
    Name: 'Scepter of Imprisoned Souls',
    Id: 47856,
    Phase: 1,
    ItemSlot: ItemSlot.Wand,
  },
  {
    IconName: 'inv_bracer_32a',
    Stats: {
      [Stat.Stamina]: 49,
      [Stat.Intellect]: 51,
      [Stat.SpellPower]: 78,
      [Stat.HitRating]: 36,
      [Stat.HasteRating]: 50,
    },
    Quality: Quality.Epic,
    Faction: Faction.Horde,
    Name: 'Felspark Bracers',
    Id: 47861,
    Phase: 1,
    ItemSlot: ItemSlot.Wrist,
  },
  {
    IconName: 'inv_jewelry_ring_57',
    Stats: {
      [Stat.Stamina]: 48,
      [Stat.Intellect]: 52,
      [Stat.SpellPower]: 78,
      [Stat.CritRating]: 36,
      [Stat.HitRating]: 50,
    },
    Quality: Quality.Epic,
    Unique: true,
    Faction: Faction.Horde,
    Name: 'Firestorm Band',
    Id: 47862,
    Phase: 1,
    ItemSlot: ItemSlot.Finger,
  },
  {
    IconName: 'inv_jewelry_necklace_46',
    Stats: {
      [Stat.Stamina]: 52,
      [Stat.Intellect]: 50,
      [Stat.SpellPower]: 78,
      [Stat.CritRating]: 45,
      [Stat.Mp5]: 22,
    },
    Quality: Quality.Epic,
    Faction: Faction.Horde,
    Name: 'Pendant of Binding Elements',
    Sources: [ItemSourceName.TrialOfTheCrusader10],
    Id: 47864,
    Phase: 1,
    ItemSlot: ItemSlot.Neck,
  },
  {
    IconName: 'inv_pants_cloth_06',
    Stats: {
      [Stat.Stamina]: 106,
      [Stat.Intellect]: 86,
      [Stat.Spirit]: 86,
      [Stat.SpellPower]: 132,
      [Stat.CritRating]: 62,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Yellow],
    SocketBonus: {
      [Stat.Spirit]: 4,
    },
    Faction: Faction.Horde,
    Name: 'Legwraps of the Demonic Messenger',
    Id: 47865,
    Phase: 1,
    ItemSlot: ItemSlot.Legs,
  },
  {
    IconName: 'inv_boots_cloth_17',
    Stats: {
      [Stat.Stamina]: 64,
      [Stat.Intellect]: 69,
      [Stat.SpellPower]: 100,
      [Stat.CritRating]: 64,
      [Stat.HitRating]: 40,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Yellow],
    SocketBonus: {
      [Stat.CritRating]: 4,
    },
    Faction: Faction.Horde,
    Name: "Sunreaver Magus' Sandals",
    Id: 47873,
    Phase: 1,
    ItemSlot: ItemSlot.Feet,
  },
  {
    IconName: 'inv_weapon_shortblade_93',
    Stats: {
      [Stat.Stamina]: 39,
      [Stat.Intellect]: 43,
      [Stat.SpellPower]: 550,
      [Stat.CritRating]: 32,
      [Stat.HasteRating]: 52,
    },
    Quality: Quality.Epic,
    Unique: true,
    Sockets: [SocketColor.Red],
    SocketBonus: {
      [Stat.CritRating]: 4,
    },
    Faction: Faction.Horde,
    Name: "Sunreaver Disciple's Blade",
    Sources: [ItemSourceName.TrialOfTheCrusader10],
    Id: 47874,
    Phase: 1,
    ItemSlot: ItemSlot.Weapon,
  },
  {
    IconName: 'inv_jewelry_necklace_27',
    Stats: {
      [Stat.CritRating]: 114,
    },
    Quality: Quality.Epic,
    Unique: true,
    Faction: Faction.Horde,
    Name: 'Fetish of Volatile Power',
    Id: 47879,
    Phase: 1,
    ItemSlot: ItemSlot.Trinket,
  },
  {
    IconName: 'inv_gauntlets_61',
    Stats: {
      [Stat.Stamina]: 68,
      [Stat.Intellect]: 60,
      [Stat.SpellPower]: 96,
      [Stat.HitRating]: 44,
      [Stat.HasteRating]: 60,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Yellow, SocketColor.Red],
    SocketBonus: {
      [Stat.HasteRating]: 6,
    },
    Faction: Faction.Horde,
    Name: 'Looming Shadow Wraps',
    Id: 47889,
    Phase: 1,
    ItemSlot: ItemSlot.Hands,
  },
  {
    IconName: 'inv_jewelry_necklace_46',
    Stats: {
      [Stat.Stamina]: 47,
      [Stat.Intellect]: 51,
      [Stat.SpellPower]: 69,
      [Stat.CritRating]: 46,
      [Stat.HitRating]: 36,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Blue],
    SocketBonus: {
      [Stat.Intellect]: 4,
    },
    Faction: Faction.Horde,
    Name: 'Darkbane Amulet',
    Sources: [ItemSourceName.TrialOfTheCrusader10],
    Id: 47890,
    Phase: 1,
    ItemSlot: ItemSlot.Neck,
  },
  {
    IconName: 'inv_staff_102',
    Stats: {
      [Stat.Stamina]: 72,
      [Stat.Intellect]: 92,
      [Stat.SpellPower]: 550,
      [Stat.CritRating]: 113,
      [Stat.HasteRating]: 108,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Blue, SocketColor.Yellow],
    SocketBonus: {
      [Stat.HasteRating]: 6,
    },
    Faction: Faction.Horde,
    Name: 'Illumination',
    Sources: [ItemSourceName.TrialOfTheCrusader10],
    Id: 47892,
    Phase: 1,
    ItemSlot: ItemSlot.Weapon,
    IsTwoHand: true,
  },
  {
    IconName: 'inv_staff_102',
    Stats: {
      [Stat.Stamina]: 92,
      [Stat.Intellect]: 112,
      [Stat.SpellPower]: 550,
      [Stat.CritRating]: 88,
      [Stat.HasteRating]: 116,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Yellow],
    SocketBonus: {
      [Stat.CritRating]: 4,
    },
    Faction: Faction.Horde,
    Name: 'Perdition',
    Sources: [ItemSourceName.TrialOfTheCrusader10],
    Id: 47900,
    Phase: 1,
    ItemSlot: ItemSlot.Weapon,
    IsTwoHand: true,
  },
  {
    IconName: 'inv_chest_cloth_68',
    Stats: {
      [Stat.Stamina]: 92,
      [Stat.Intellect]: 88,
      [Stat.SpellPower]: 132,
      [Stat.CritRating]: 65,
      [Stat.HitRating]: 86,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Faction: Faction.Horde,
    Name: 'Robes of the Sleepless',
    Id: 47906,
    Phase: 1,
    ItemSlot: ItemSlot.Chest,
  },
  {
    IconName: 'inv_belt_52',
    Stats: {
      [Stat.Stamina]: 68,
      [Stat.Intellect]: 64,
      [Stat.Spirit]: 64,
      [Stat.SpellPower]: 105,
      [Stat.CritRating]: 40,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Yellow],
    SocketBonus: {
      [Stat.Intellect]: 4,
    },
    Faction: Faction.Horde,
    Name: 'Belt of the Eternal',
    Id: 47909,
    Phase: 1,
    ItemSlot: ItemSlot.Waist,
  },
  {
    IconName: 'inv_offhand_stratholme_a_02',
    Stats: {
      [Stat.Stamina]: 51,
      [Stat.Intellect]: 48,
      [Stat.SpellPower]: 69,
      [Stat.HitRating]: 37,
      [Stat.HasteRating]: 45,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Yellow],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Faction: Faction.Horde,
    Name: 'Lightbane Focus',
    Sources: [ItemSourceName.TrialOfTheCrusader10],
    Id: 47913,
    Phase: 1,
    ItemSlot: ItemSlot.OffHand,
  },
  {
    IconName: 'inv_belt_52',
    Stats: {
      [Stat.Stamina]: 77,
      [Stat.Intellect]: 67,
      [Stat.SpellPower]: 99,
      [Stat.HitRating]: 61,
      [Stat.HasteRating]: 67,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Yellow, SocketColor.Red],
    SocketBonus: {
      [Stat.HasteRating]: 6,
    },
    Faction: Faction.Alliance,
    Name: 'Icehowl Cinch',
    Id: 47921,
    Phase: 1,
    ItemSlot: ItemSlot.Waist,
  },
  {
    IconName: 'inv_wand_15',
    Stats: {
      [Stat.Stamina]: 40,
      [Stat.Intellect]: 29,
      [Stat.SpellPower]: 50,
      [Stat.CritRating]: 31,
      [Stat.HasteRating]: 24,
    },
    Quality: Quality.Epic,
    Faction: Faction.Alliance,
    Name: 'Rod of Imprisoned Souls',
    Id: 47922,
    Phase: 1,
    ItemSlot: ItemSlot.Wand,
  },
  {
    IconName: 'inv_bracer_37',
    Stats: {
      [Stat.Stamina]: 56,
      [Stat.Intellect]: 58,
      [Stat.SpellPower]: 80,
      [Stat.HitRating]: 33,
      [Stat.HasteRating]: 56,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Yellow],
    SocketBonus: {
      [Stat.CritRating]: 4,
    },
    Faction: Faction.Alliance,
    Name: 'Felspark Bindings',
    Id: 47927,
    Phase: 1,
    ItemSlot: ItemSlot.Wrist,
  },
  {
    IconName: 'inv_jewelry_ring_57',
    Stats: {
      [Stat.Stamina]: 54,
      [Stat.Intellect]: 59,
      [Stat.SpellPower]: 80,
      [Stat.CritRating]: 33,
      [Stat.HitRating]: 56,
    },
    Quality: Quality.Epic,
    Unique: true,
    Sockets: [SocketColor.Red],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Faction: Faction.Alliance,
    Name: 'Firestorm Ring',
    Id: 47928,
    Phase: 1,
    ItemSlot: ItemSlot.Finger,
  },
  {
    IconName: 'inv_jewelry_necklace_46',
    Stats: {
      [Stat.Stamina]: 59,
      [Stat.Intellect]: 57,
      [Stat.SpellPower]: 80,
      [Stat.CritRating]: 50,
      [Stat.Mp5]: 21,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Yellow],
    SocketBonus: {
      [Stat.Intellect]: 4,
    },
    Faction: Faction.Alliance,
    Name: 'Amulet of Binding Elements',
    Sources: [ItemSourceName.TrialOfTheCrusader10Heroic],
    Id: 47930,
    Phase: 1,
    ItemSlot: ItemSlot.Neck,
  },
  {
    IconName: 'inv_pants_cloth_33',
    Stats: {
      [Stat.Stamina]: 119,
      [Stat.Intellect]: 89,
      [Stat.Spirit]: 89,
      [Stat.SpellPower]: 150,
      [Stat.CritRating]: 71,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Yellow, SocketColor.Red],
    SocketBonus: {
      [Stat.Spirit]: 6,
    },
    Faction: Faction.Alliance,
    Name: 'Leggings of the Demonic Messenger',
    Id: 47931,
    Phase: 1,
    ItemSlot: ItemSlot.Legs,
  },
  {
    IconName: 'inv_boots_cloth_17',
    Stats: {
      [Stat.Stamina]: 72,
      [Stat.Intellect]: 70,
      [Stat.SpellPower]: 104,
      [Stat.CritRating]: 72,
      [Stat.HitRating]: 47,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Yellow, SocketColor.Red],
    SocketBonus: {
      [Stat.CritRating]: 6,
    },
    Faction: Faction.Alliance,
    Name: 'Sandals of the Silver Magus',
    Id: 47940,
    Phase: 1,
    ItemSlot: ItemSlot.Feet,
  },
  {
    IconName: 'inv_weapon_shortblade_99',
    Stats: {
      [Stat.Stamina]: 44,
      [Stat.Intellect]: 49,
      [Stat.SpellPower]: 621,
      [Stat.CritRating]: 37,
      [Stat.HasteRating]: 58,
    },
    Quality: Quality.Epic,
    Unique: true,
    Sockets: [SocketColor.Red],
    SocketBonus: {
      [Stat.CritRating]: 4,
    },
    Faction: Faction.Alliance,
    Name: 'Blade of the Silver Disciple',
    Sources: [ItemSourceName.TrialOfTheCrusader10Heroic],
    Id: 47941,
    Phase: 1,
    ItemSlot: ItemSlot.Weapon,
  },
  {
    IconName: 'inv_jewelry_necklace_27',
    Stats: {
      [Stat.CritRating]: 126,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: 'Talisman of Volatile Power',
    Id: 47946,
    Phase: 1,
    ItemSlot: ItemSlot.Trinket,
  },
  {
    IconName: 'inv_gauntlets_79',
    Stats: {
      [Stat.Stamina]: 77,
      [Stat.Intellect]: 69,
      [Stat.SpellPower]: 109,
      [Stat.HitRating]: 51,
      [Stat.HasteRating]: 67,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Yellow, SocketColor.Red],
    SocketBonus: {
      [Stat.HasteRating]: 6,
    },
    Faction: Faction.Alliance,
    Name: 'Gloves of Looming Shadow',
    Id: 47956,
    Phase: 1,
    ItemSlot: ItemSlot.Hands,
  },
  {
    IconName: 'inv_jewelry_necklace_46',
    Stats: {
      [Stat.Stamina]: 54,
      [Stat.Intellect]: 58,
      [Stat.SpellPower]: 80,
      [Stat.CritRating]: 52,
      [Stat.HitRating]: 42,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Blue],
    SocketBonus: {
      [Stat.Intellect]: 4,
    },
    Faction: Faction.Alliance,
    Name: 'Darkbane Pendant',
    Sources: [ItemSourceName.TrialOfTheCrusader10Heroic],
    Id: 47957,
    Phase: 1,
    ItemSlot: ItemSlot.Neck,
  },
  {
    IconName: 'inv_offhand_pvealliance_d_01',
    Stats: {
      [Stat.Stamina]: 58,
      [Stat.Intellect]: 55,
      [Stat.SpellPower]: 80,
      [Stat.HitRating]: 43,
      [Stat.HasteRating]: 51,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Yellow],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Faction: Faction.Alliance,
    Name: 'Chalice of Benedictus',
    Sources: [ItemSourceName.TrialOfTheCrusader10Heroic],
    Id: 47958,
    Phase: 1,
    ItemSlot: ItemSlot.OffHand,
  },
  {
    IconName: 'inv_staff_98',
    Stats: {
      [Stat.Stamina]: 73,
      [Stat.Intellect]: 103,
      [Stat.SpellPower]: 621,
      [Stat.CritRating]: 122,
      [Stat.HasteRating]: 117,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Blue, SocketColor.Yellow, SocketColor.Yellow],
    SocketBonus: {
      [Stat.HasteRating]: 8,
    },
    Faction: Faction.Alliance,
    Name: 'Enlightenment',
    Sources: [ItemSourceName.TrialOfTheCrusader10Heroic],
    Id: 47960,
    Phase: 1,
    ItemSlot: ItemSlot.Weapon,
    IsTwoHand: true,
  },
  {
    IconName: 'inv_staff_98',
    Stats: {
      [Stat.Stamina]: 103,
      [Stat.Intellect]: 120,
      [Stat.SpellPower]: 621,
      [Stat.CritRating]: 95,
      [Stat.HasteRating]: 128,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Yellow, SocketColor.Red],
    SocketBonus: {
      [Stat.CritRating]: 6,
    },
    Faction: Faction.Alliance,
    Name: 'Cold Convergence',
    Sources: [ItemSourceName.TrialOfTheCrusader10Heroic],
    Id: 47968,
    Phase: 1,
    ItemSlot: ItemSlot.Weapon,
    IsTwoHand: true,
  },
  {
    IconName: 'inv_chest_cloth_75',
    Stats: {
      [Stat.Stamina]: 103,
      [Stat.Intellect]: 95,
      [Stat.SpellPower]: 140,
      [Stat.CritRating]: 71,
      [Stat.HitRating]: 96,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Blue, SocketColor.Red],
    SocketBonus: {
      [Stat.SpellPower]: 7,
    },
    Name: 'Vestments of the Sleepless',
    Id: 47974,
    Phase: 1,
    ItemSlot: ItemSlot.Chest,
  },
  {
    IconName: 'inv_belt_52',
    Stats: {
      [Stat.Stamina]: 77,
      [Stat.Intellect]: 73,
      [Stat.Spirit]: 72,
      [Stat.SpellPower]: 118,
      [Stat.CritRating]: 47,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Yellow],
    SocketBonus: {
      [Stat.Intellect]: 4,
    },
    Faction: Faction.Alliance,
    Name: 'Cinch of the Undying',
    Id: 47977,
    Phase: 1,
    ItemSlot: ItemSlot.Waist,
  },
  {
    IconName: 'inv_belt_52',
    Stats: {
      [Stat.Stamina]: 77,
      [Stat.Intellect]: 67,
      [Stat.SpellPower]: 99,
      [Stat.HitRating]: 61,
      [Stat.HasteRating]: 67,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Yellow, SocketColor.Red],
    SocketBonus: {
      [Stat.HasteRating]: 6,
    },
    Faction: Faction.Horde,
    Name: 'Icehowl Binding',
    Id: 47994,
    Phase: 1,
    ItemSlot: ItemSlot.Waist,
  },
  {
    IconName: 'inv_wand_31',
    Stats: {
      [Stat.Stamina]: 40,
      [Stat.Intellect]: 29,
      [Stat.SpellPower]: 50,
      [Stat.CritRating]: 31,
      [Stat.HasteRating]: 24,
    },
    Quality: Quality.Epic,
    Faction: Faction.Horde,
    Name: 'Scepter of Imprisoned Souls',
    Id: 47995,
    Phase: 1,
    ItemSlot: ItemSlot.Wand,
  },
  {
    IconName: 'inv_bracer_32a',
    Stats: {
      [Stat.Stamina]: 56,
      [Stat.Intellect]: 58,
      [Stat.SpellPower]: 80,
      [Stat.HitRating]: 33,
      [Stat.HasteRating]: 56,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Yellow],
    SocketBonus: {
      [Stat.CritRating]: 4,
    },
    Faction: Faction.Horde,
    Name: 'Felspark Bracers',
    Id: 48000,
    Phase: 1,
    ItemSlot: ItemSlot.Wrist,
  },
  {
    IconName: 'inv_jewelry_ring_57',
    Stats: {
      [Stat.Stamina]: 54,
      [Stat.Intellect]: 59,
      [Stat.SpellPower]: 80,
      [Stat.CritRating]: 33,
      [Stat.HitRating]: 56,
    },
    Quality: Quality.Epic,
    Unique: true,
    Sockets: [SocketColor.Red],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Faction: Faction.Horde,
    Name: 'Firestorm Band',
    Id: 48001,
    Phase: 1,
    ItemSlot: ItemSlot.Finger,
  },
  {
    IconName: 'inv_jewelry_necklace_46',
    Stats: {
      [Stat.Stamina]: 59,
      [Stat.Intellect]: 57,
      [Stat.SpellPower]: 80,
      [Stat.CritRating]: 50,
      [Stat.Mp5]: 21,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Yellow],
    SocketBonus: {
      [Stat.Intellect]: 4,
    },
    Faction: Faction.Horde,
    Name: 'Pendant of Binding Elements',
    Sources: [ItemSourceName.TrialOfTheCrusader10Heroic],
    Id: 48003,
    Phase: 1,
    ItemSlot: ItemSlot.Neck,
  },
  {
    IconName: 'inv_pants_cloth_06',
    Stats: {
      [Stat.Stamina]: 119,
      [Stat.Intellect]: 89,
      [Stat.Spirit]: 89,
      [Stat.SpellPower]: 150,
      [Stat.CritRating]: 71,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Yellow, SocketColor.Red],
    SocketBonus: {
      [Stat.Spirit]: 6,
    },
    Faction: Faction.Horde,
    Name: 'Legwraps of the Demonic Messenger',
    Id: 48004,
    Phase: 1,
    ItemSlot: ItemSlot.Legs,
  },
  {
    IconName: 'inv_boots_cloth_17',
    Stats: {
      [Stat.Stamina]: 72,
      [Stat.Intellect]: 70,
      [Stat.SpellPower]: 104,
      [Stat.CritRating]: 72,
      [Stat.HitRating]: 47,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Yellow, SocketColor.Red],
    SocketBonus: {
      [Stat.CritRating]: 6,
    },
    Faction: Faction.Horde,
    Name: "Sunreaver Magus' Sandals",
    Id: 48012,
    Phase: 1,
    ItemSlot: ItemSlot.Feet,
  },
  {
    IconName: 'inv_weapon_shortblade_93',
    Stats: {
      [Stat.Stamina]: 44,
      [Stat.Intellect]: 49,
      [Stat.SpellPower]: 621,
      [Stat.CritRating]: 37,
      [Stat.HasteRating]: 58,
    },
    Quality: Quality.Epic,
    Unique: true,
    Sockets: [SocketColor.Red],
    SocketBonus: {
      [Stat.CritRating]: 4,
    },
    Faction: Faction.Horde,
    Name: "Sunreaver Disciple's Blade",
    Sources: [ItemSourceName.TrialOfTheCrusader10Heroic],
    Id: 48013,
    Phase: 1,
    ItemSlot: ItemSlot.Weapon,
  },
  {
    IconName: 'inv_jewelry_necklace_27',
    Stats: {
      [Stat.CritRating]: 126,
    },
    Quality: Quality.Epic,
    Unique: true,
    Faction: Faction.Horde,
    Name: 'Fetish of Volatile Power',
    Id: 48018,
    Phase: 1,
    ItemSlot: ItemSlot.Trinket,
  },
  {
    IconName: 'inv_gauntlets_61',
    Stats: {
      [Stat.Stamina]: 77,
      [Stat.Intellect]: 69,
      [Stat.SpellPower]: 109,
      [Stat.HitRating]: 51,
      [Stat.HasteRating]: 67,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Yellow, SocketColor.Red],
    SocketBonus: {
      [Stat.HasteRating]: 6,
    },
    Faction: Faction.Horde,
    Name: 'Looming Shadow Wraps',
    Id: 48028,
    Phase: 1,
    ItemSlot: ItemSlot.Hands,
  },
  {
    IconName: 'inv_jewelry_necklace_46',
    Stats: {
      [Stat.Stamina]: 54,
      [Stat.Intellect]: 58,
      [Stat.SpellPower]: 80,
      [Stat.CritRating]: 52,
      [Stat.HitRating]: 42,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Blue],
    SocketBonus: {
      [Stat.Intellect]: 4,
    },
    Faction: Faction.Horde,
    Name: 'Darkbane Amulet',
    Sources: [ItemSourceName.TrialOfTheCrusader10Heroic],
    Id: 48030,
    Phase: 1,
    ItemSlot: ItemSlot.Neck,
  },
  {
    IconName: 'inv_offhand_stratholme_a_02',
    Stats: {
      [Stat.Stamina]: 58,
      [Stat.Intellect]: 55,
      [Stat.SpellPower]: 80,
      [Stat.HitRating]: 43,
      [Stat.HasteRating]: 51,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Yellow],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Faction: Faction.Horde,
    Name: 'Lightbane Focus',
    Sources: [ItemSourceName.TrialOfTheCrusader10Heroic],
    Id: 48032,
    Phase: 1,
    ItemSlot: ItemSlot.OffHand,
  },
  {
    IconName: 'inv_staff_102',
    Stats: {
      [Stat.Stamina]: 73,
      [Stat.Intellect]: 103,
      [Stat.SpellPower]: 621,
      [Stat.CritRating]: 122,
      [Stat.HasteRating]: 117,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Blue, SocketColor.Yellow, SocketColor.Yellow],
    SocketBonus: {
      [Stat.HasteRating]: 8,
    },
    Faction: Faction.Horde,
    Name: 'Illumination',
    Sources: [ItemSourceName.TrialOfTheCrusader10Heroic],
    Id: 48036,
    Phase: 1,
    ItemSlot: ItemSlot.Weapon,
    IsTwoHand: true,
  },
  {
    IconName: 'inv_staff_102',
    Stats: {
      [Stat.Stamina]: 103,
      [Stat.Intellect]: 120,
      [Stat.SpellPower]: 621,
      [Stat.CritRating]: 95,
      [Stat.HasteRating]: 128,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Yellow, SocketColor.Red],
    SocketBonus: {
      [Stat.CritRating]: 6,
    },
    Faction: Faction.Horde,
    Name: 'Perdition',
    Sources: [ItemSourceName.TrialOfTheCrusader10Heroic],
    Id: 48045,
    Phase: 1,
    ItemSlot: ItemSlot.Weapon,
    IsTwoHand: true,
  },
  {
    IconName: 'inv_chest_cloth_68',
    Stats: {
      [Stat.Stamina]: 103,
      [Stat.Intellect]: 95,
      [Stat.SpellPower]: 140,
      [Stat.CritRating]: 71,
      [Stat.HitRating]: 96,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Blue, SocketColor.Red],
    SocketBonus: {
      [Stat.SpellPower]: 7,
    },
    Name: 'Robes of the Sleepless',
    Id: 48051,
    Phase: 1,
    ItemSlot: ItemSlot.Chest,
  },
  {
    IconName: 'inv_belt_52',
    Stats: {
      [Stat.Stamina]: 77,
      [Stat.Intellect]: 73,
      [Stat.Spirit]: 72,
      [Stat.SpellPower]: 118,
      [Stat.CritRating]: 47,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Yellow],
    SocketBonus: {
      [Stat.Intellect]: 4,
    },
    Faction: Faction.Horde,
    Name: 'Belt of the Eternal',
    Id: 48054,
    Phase: 1,
    ItemSlot: ItemSlot.Waist,
  },
  {
    IconName: 'inv_misc_cape_18',
    Stats: {
      [Stat.Stamina]: 65,
      [Stat.Intellect]: 65,
      [Stat.SpellPower]: 91,
      [Stat.CritRating]: 57,
      [Stat.HasteRating]: 49,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Red],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Faction: Faction.Horde,
    Name: 'Drape of the Sunreavers',
    Id: 48666,
    Phase: 1,
    ItemSlot: ItemSlot.Back,
  },
  {
    IconName: 'inv_misc_cape_18',
    Stats: {
      [Stat.Stamina]: 65,
      [Stat.Intellect]: 65,
      [Stat.Spirit]: 57,
      [Stat.SpellPower]: 91,
      [Stat.HasteRating]: 49,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Red],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Faction: Faction.Horde,
    Name: 'Shawl of the Devout Crusader',
    Id: 48667,
    Phase: 1,
    ItemSlot: ItemSlot.Back,
  },
  {
    IconName: 'inv_misc_cape_16',
    Stats: {
      [Stat.Stamina]: 65,
      [Stat.Intellect]: 65,
      [Stat.SpellPower]: 91,
      [Stat.CritRating]: 57,
      [Stat.HasteRating]: 49,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Red],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Faction: Faction.Alliance,
    Name: 'Drape of Bitter Incantation',
    Id: 48671,
    Phase: 1,
    ItemSlot: ItemSlot.Back,
  },
  {
    IconName: 'inv_misc_cape_16',
    Stats: {
      [Stat.Stamina]: 65,
      [Stat.Intellect]: 65,
      [Stat.Spirit]: 57,
      [Stat.SpellPower]: 91,
      [Stat.HasteRating]: 49,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Red],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Faction: Faction.Alliance,
    Name: 'Shawl of Fervent Crusader',
    Id: 48672,
    Phase: 1,
    ItemSlot: ItemSlot.Back,
  },
  {
    IconName: 'inv_chest_cloth_49',
    Stats: {
      [Stat.Stamina]: 52,
      [Stat.Intellect]: 52,
      [Stat.Spirit]: 68,
      [Stat.SpellPower]: 80,
    },
    Quality: Quality.Heirloom,
    Name: 'Tattered Dreadmist Robe',
    Id: 48691,
    Phase: 1,
    ItemSlot: ItemSlot.Chest,
  },
  {
    IconName: 'inv_sword_137',
    Stats: {
      [Stat.Stamina]: 51,
      [Stat.Intellect]: 58,
      [Stat.SpellPower]: 621,
      [Stat.HitRating]: 32,
      [Stat.HasteRating]: 52,
    },
    Quality: Quality.Epic,
    Unique: true,
    Sockets: [SocketColor.Yellow],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Faction: Faction.Horde,
    Name: 'Spellharvest',
    Sources: [ItemSourceName.TrialOfTheCrusader10Heroic],
    Id: 48701,
    Phase: 1,
    ItemSlot: ItemSlot.Weapon,
  },
  {
    IconName: 'inv_sword_144',
    Stats: {
      [Stat.Stamina]: 51,
      [Stat.Intellect]: 58,
      [Stat.SpellPower]: 621,
      [Stat.HitRating]: 32,
      [Stat.HasteRating]: 52,
    },
    Quality: Quality.Epic,
    Unique: true,
    Sockets: [SocketColor.Yellow],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Faction: Faction.Alliance,
    Name: 'Spellstorm Blade',
    Sources: [ItemSourceName.TrialOfTheCrusader10Heroic],
    Id: 48708,
    Phase: 1,
    ItemSlot: ItemSlot.Weapon,
  },
  {
    IconName: 'inv_spiritshard_01',
    Stats: {
      [Stat.HitRating]: 128,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: 'Shard of the Crystal Heart',
    Id: 48722,
    Phase: 1,
    ItemSlot: ItemSlot.Trinket,
  },
  {
    IconName: 'inv_misc_gem_bloodstone_03',
    Stats: {
      [Stat.Intellect]: 128,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: 'Talisman of Resurgence',
    Id: 48724,
    Phase: 1,
    ItemSlot: ItemSlot.Trinket,
  },
  {
    IconName: 'inv_jewelry_ring_73',
    Stats: {
      [Stat.Stamina]: 62,
      [Stat.Intellect]: 43,
      [Stat.Spirit]: 43,
      [Stat.SpellPower]: 74,
      [Stat.Mp5]: 21,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: 'Etched Loop of the Kirin Tor',
    Id: 48955,
    Phase: 1,
    ItemSlot: ItemSlot.Finger,
  },
  {
    IconName: 'inv_jewelry_ring_73',
    Stats: {
      [Stat.Stamina]: 62,
      [Stat.Intellect]: 43,
      [Stat.SpellPower]: 74,
      [Stat.CritRating]: 41,
      [Stat.HasteRating]: 43,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: 'Etched Signet of the Kirin Tor',
    Id: 48957,
    Phase: 1,
    ItemSlot: ItemSlot.Finger,
  },
  {
    IconName: 'inv_jewelry_ring_60',
    Stats: {
      [Stat.Stamina]: 72,
      [Stat.Intellect]: 32,
      [Stat.SpellPower]: 74,
      [Stat.ResilienceRating]: 42,
      [Stat.HasteRating]: 42,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: 'Titan-Forged Band of Ascendancy',
    Id: 48999,
    Phase: 1,
    ItemSlot: ItemSlot.Finger,
  },
  {
    IconName: 'inv_misc_pocketwatch_02',
    Stats: {
      [Stat.CritRating]: 84,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: 'Mithril Pocketwatch',
    Id: 49076,
    Phase: 1,
    ItemSlot: ItemSlot.Trinket,
  },
  {
    // TODO random enchantments
    IconName: 'inv_weapon_shortblade_70',
    Stats: {
      [Stat.SpellPower]: 315,
    },
    Quality: Quality.Rare,
    Name: "Skoll's Fang",
    Sources: [ItemSourceName.BoE],
    Id: 49227,
    Phase: 1,
    ItemSlot: ItemSlot.Weapon,
  },
  {
    IconName: 'inv_boots_cloth_23',
    Stats: {
      [Stat.Stamina]: 68,
      [Stat.Intellect]: 68,
      [Stat.Spirit]: 52,
      [Stat.SpellPower]: 105,
      [Stat.CritRating]: 64,
    },
    Quality: Quality.Epic,
    Faction: Faction.Alliance,
    Name: 'Boots of the Grieving Soul',
    Id: 49231,
    Phase: 1,
    ItemSlot: ItemSlot.Feet,
  },
  {
    IconName: 'inv_boots_cloth_23',
    Stats: {
      [Stat.Stamina]: 68,
      [Stat.Intellect]: 68,
      [Stat.Spirit]: 52,
      [Stat.SpellPower]: 105,
      [Stat.CritRating]: 64,
    },
    Quality: Quality.Epic,
    Faction: Faction.Horde,
    Name: 'Sandals of the Grieving Soul',
    Id: 49232,
    Phase: 1,
    ItemSlot: ItemSlot.Feet,
  },
  {
    IconName: 'inv_boots_cloth_23',
    Stats: {
      [Stat.Stamina]: 77,
      [Stat.Intellect]: 77,
      [Stat.Spirit]: 51,
      [Stat.SpellPower]: 109,
      [Stat.CritRating]: 72,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Yellow],
    SocketBonus: {
      [Stat.Intellect]: 4,
    },
    Faction: Faction.Horde,
    Name: 'Sandals of the Grieving Soul',
    Id: 49233,
    Phase: 1,
    ItemSlot: ItemSlot.Feet,
  },
  {
    IconName: 'inv_boots_cloth_23',
    Stats: {
      [Stat.Stamina]: 77,
      [Stat.Intellect]: 77,
      [Stat.Spirit]: 51,
      [Stat.SpellPower]: 109,
      [Stat.CritRating]: 72,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Yellow],
    SocketBonus: {
      [Stat.Intellect]: 4,
    },
    Faction: Faction.Alliance,
    Name: 'Boots of the Grieving Soul',
    Id: 49234,
    Phase: 1,
    ItemSlot: ItemSlot.Feet,
  },
  {
    IconName: 'inv_sword_39',
    Stats: {
      [Stat.Stamina]: 39,
      [Stat.Intellect]: 55,
      [Stat.SpellPower]: 550,
      [Stat.CritRating]: 45,
      [Stat.HitRating]: 39,
    },
    Quality: Quality.Epic,
    Name: 'Glinting Azuresong Mageblade',
    Sources: [ItemSourceName.Onyxia10],
    Id: 49298,
    Phase: 1,
    ItemSlot: ItemSlot.Weapon,
  },
  {
    IconName: 'inv_weapon_shortblade_06',
    Stats: {
      [Stat.Stamina]: 36,
      [Stat.Intellect]: 52,
      [Stat.SpellPower]: 550,
      [Stat.CritRating]: 40,
      [Stat.Mp5]: 26,
    },
    Quality: Quality.Epic,
    Name: 'Sharpened Fang of the Mystics',
    Sources: [ItemSourceName.Onyxia10],
    Id: 49304,
    Phase: 1,
    ItemSlot: ItemSlot.Weapon,
  },
  {
    IconName: 'inv_misc_cape_16',
    Stats: {
      [Stat.Stamina]: 59,
      [Stat.Intellect]: 48,
      [Stat.SpellPower]: 78,
      [Stat.CritRating]: 44,
      [Stat.HasteRating]: 30,
      [Stat.FrostResist]: 6,
      [Stat.ArcaneResist]: 6,
    },
    Quality: Quality.Epic,
    Name: 'Fluttering Sapphiron Drape',
    Id: 49307,
    Phase: 1,
    ItemSlot: ItemSlot.Back,
  },
  {
    IconName: 'inv_misc_book_07',
    Stats: {
      [Stat.Stamina]: 44,
      [Stat.Intellect]: 57,
      [Stat.Spirit]: 40,
      [Stat.SpellPower]: 64,
    },
    Quality: Quality.Epic,
    Name: 'Antique Cornerstone Grimoire',
    Sources: [ItemSourceName.Onyxia10],
    Id: 49308,
    Phase: 1,
    ItemSlot: ItemSlot.OffHand,
  },
  {
    IconName: 'inv_helmet_08',
    Stats: {
      [Stat.Stamina]: 78,
      [Stat.Intellect]: 77,
      [Stat.Spirit]: 88,
      [Stat.SpellPower]: 132,
      [Stat.CritRating]: 47,
      [Stat.FrostResist]: 10,
      [Stat.ShadowResist]: 10,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Meta, SocketColor.Red],
    SocketBonus: {
      [Stat.CritRating]: 8,
    },
    Name: 'Nemesis Skullcover',
    Sources: [ItemSourceName.Onyxia10],
    Id: 49315,
    Phase: 1,
    ItemSlot: ItemSlot.Head,
  },
  {
    IconName: 'inv_helmet_08',
    Stats: {
      [Stat.Stamina]: 91,
      [Stat.Intellect]: 89,
      [Stat.Spirit]: 99,
      [Stat.SpellPower]: 150,
      [Stat.CritRating]: 55,
      [Stat.FrostResist]: 10,
      [Stat.ShadowResist]: 10,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Meta, SocketColor.Red],
    SocketBonus: {
      [Stat.CritRating]: 8,
    },
    Name: 'Nemesis Skullcap',
    Sources: [ItemSourceName.Onyxia25],
    Id: 49484,
    Phase: 1,
    ItemSlot: ItemSlot.Head,
  },
  {
    IconName: 'inv_jewelry_ring_27',
    Stats: {
      [Stat.Stamina]: 61,
      [Stat.Intellect]: 56,
      [Stat.Spirit]: 36,
      [Stat.SpellPower]: 89,
      [Stat.CritRating]: 53,
      [Stat.FireResist]: 10,
    },
    Quality: Quality.Epic,
    Name: "Polished Dragonslayer's Signet",
    Id: 49486,
    Phase: 1,
    ItemSlot: ItemSlot.Finger,
  },
  {
    IconName: 'inv_misc_book_07',
    Stats: {
      [Stat.Stamina]: 51,
      [Stat.Intellect]: 66,
      [Stat.Spirit]: 46,
      [Stat.SpellPower]: 75,
    },
    Quality: Quality.Epic,
    Name: 'Antediluvian Cornerstone Grimoire',
    Sources: [ItemSourceName.Onyxia25],
    Id: 49490,
    Phase: 1,
    ItemSlot: ItemSlot.OffHand,
  },
  {
    IconName: 'inv_misc_cape_16',
    Stats: {
      [Stat.Stamina]: 66,
      [Stat.Intellect]: 54,
      [Stat.SpellPower]: 89,
      [Stat.CritRating]: 50,
      [Stat.HasteRating]: 35,
      [Stat.FrostResist]: 6,
      [Stat.ArcaneResist]: 6,
    },
    Quality: Quality.Epic,
    Name: 'Flowing Sapphiron Drape',
    Id: 49491,
    Phase: 1,
    ItemSlot: ItemSlot.Back,
  },
  {
    IconName: 'inv_weapon_shortblade_06',
    Stats: {
      [Stat.Stamina]: 40,
      [Stat.Intellect]: 58,
      [Stat.SpellPower]: 621,
      [Stat.CritRating]: 46,
      [Stat.Mp5]: 29,
    },
    Quality: Quality.Epic,
    Name: 'Honed Fang of the Mystics',
    Sources: [ItemSourceName.Onyxia25],
    Id: 49494,
    Phase: 1,
    ItemSlot: ItemSlot.Weapon,
  },
  {
    IconName: 'inv_sword_39',
    Stats: {
      [Stat.Stamina]: 44,
      [Stat.Intellect]: 63,
      [Stat.SpellPower]: 621,
      [Stat.CritRating]: 51,
      [Stat.HitRating]: 44,
    },
    Quality: Quality.Epic,
    Name: 'Polished Azuresong Mageblade',
    Sources: [ItemSourceName.Onyxia25],
    Id: 49499,
    Phase: 1,
    ItemSlot: ItemSlot.Weapon,
  },
  {
    IconName: 'inv_gauntlets_51',
    Stats: {
      [Stat.Stamina]: 67,
      [Stat.Intellect]: 57,
      [Stat.SpellPower]: 92,
      [Stat.CritRating]: 56,
      [Stat.HitRating]: 47,
    },
    Quality: Quality.Epic,
    Name: 'Cold Sweat Grips',
    Id: 49788,
    Phase: 1,
    ItemSlot: ItemSlot.Hands,
  },
  {
    IconName: 'inv_staff_86',
    Stats: {
      [Stat.Stamina]: 118,
      [Stat.Intellect]: 96,
      [Stat.Spirit]: 83,
      [Stat.SpellPower]: 487,
      [Stat.CritRating]: 94,
    },
    Quality: Quality.Epic,
    Name: 'Blood Boil Lancet',
    Sources: [ItemSourceName.ForgeOfSouls],
    Id: 49790,
    Phase: 1,
    ItemSlot: ItemSlot.Weapon,
    IsTwoHand: true,
  },
  {
    IconName: 'inv_belt_67',
    Stats: {
      [Stat.Stamina]: 60,
      [Stat.Intellect]: 60,
      [Stat.SpellPower]: 92,
      [Stat.HitRating]: 45,
      [Stat.HasteRating]: 57,
    },
    Quality: Quality.Epic,
    Name: 'Essence of Anger',
    Id: 49796,
    Phase: 1,
    ItemSlot: ItemSlot.Waist,
  },
  {
    IconName: 'inv_jewelry_necklace_45',
    Stats: {
      [Stat.Stamina]: 54,
      [Stat.Intellect]: 42,
      [Stat.SpellPower]: 70,
      [Stat.CritRating]: 41,
      [Stat.HitRating]: 38,
    },
    Quality: Quality.Epic,
    Name: 'Coil of Missing Gems',
    Sources: [ItemSourceName.ForgeOfSouls],
    Id: 49799,
    Phase: 1,
    ItemSlot: ItemSlot.Neck,
  },
  {
    IconName: 'inv_jewelry_ring_44',
    Stats: {
      [Stat.Stamina]: 45,
      [Stat.Intellect]: 45,
      [Stat.SpellPower]: 70,
      [Stat.CritRating]: 36,
      [Stat.Mp5]: 21,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: 'Spiteful Signet',
    Id: 49800,
    Phase: 1,
    ItemSlot: ItemSlot.Finger,
  },
  {
    IconName: 'inv_staff_82',
    Stats: {
      [Stat.Stamina]: 81,
      [Stat.Intellect]: 81,
      [Stat.SpellPower]: 487,
      [Stat.CritRating]: 114,
      [Stat.HasteRating]: 93,
    },
    Quality: Quality.Epic,
    Name: 'Unspeakable Secret',
    Sources: [ItemSourceName.ForgeOfSouls],
    Id: 49801,
    Phase: 1,
    ItemSlot: ItemSlot.Weapon,
    IsTwoHand: true,
  },
  {
    IconName: 'inv_boots_cloth_26',
    Stats: {
      [Stat.Stamina]: 62,
      [Stat.Intellect]: 59,
      [Stat.Spirit]: 45,
      [Stat.SpellPower]: 92,
      [Stat.HasteRating]: 57,
    },
    Quality: Quality.Epic,
    Name: 'Ice-Steeped Sandals',
    Id: 49805,
    Phase: 1,
    ItemSlot: ItemSlot.Feet,
  },
  {
    IconName: 'inv_bracer_32a',
    Stats: {
      [Stat.Stamina]: 48,
      [Stat.Intellect]: 44,
      [Stat.Spirit]: 41,
      [Stat.SpellPower]: 70,
      [Stat.HasteRating]: 37,
    },
    Quality: Quality.Epic,
    Name: 'Wristguards of Subterranean Moss',
    Id: 49809,
    Phase: 1,
    ItemSlot: ItemSlot.Wrist,
  },
  {
    IconName: 'inv_pants_cloth_01',
    Stats: {
      [Stat.Stamina]: 93,
      [Stat.Intellect]: 76,
      [Stat.SpellPower]: 115,
      [Stat.CritRating]: 71,
      [Stat.HasteRating]: 63,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Blue],
    SocketBonus: {
      [Stat.HasteRating]: 4,
    },
    Name: 'Rimewoven Silks',
    Id: 49822,
    Phase: 1,
    ItemSlot: ItemSlot.Legs,
  },
  {
    IconName: 'inv_misc_cape_18',
    Stats: {
      [Stat.Stamina]: 59,
      [Stat.Intellect]: 40,
      [Stat.SpellPower]: 70,
      [Stat.CritRating]: 35,
      [Stat.Mp5]: 21,
    },
    Quality: Quality.Epic,
    Name: 'Cloak of the Fallen Cardinal',
    Id: 49823,
    Phase: 1,
    ItemSlot: ItemSlot.Back,
  },
  {
    IconName: 'inv_chest_cloth_79',
    Stats: {
      [Stat.Stamina]: 86,
      [Stat.Intellect]: 79,
      [Stat.SpellPower]: 124,
      [Stat.CritRating]: 71,
      [Stat.HasteRating]: 71,
    },
    Quality: Quality.Epic,
    Name: 'Palebone Robes',
    Id: 49825,
    Phase: 1,
    ItemSlot: ItemSlot.Chest,
  },
  {
    IconName: 'inv_gauntlets_91',
    Stats: {
      [Stat.Stamina]: 69,
      [Stat.Intellect]: 56,
      [Stat.Spirit]: 53,
      [Stat.SpellPower]: 83,
      [Stat.CritRating]: 45,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Red],
    SocketBonus: {
      [Stat.Intellect]: 4,
    },
    Name: "Marwyn's Macabre Fingertips",
    Id: 49828,
    Phase: 1,
    ItemSlot: ItemSlot.Hands,
  },
  {
    IconName: 'inv_sword_85',
    Stats: {
      [Stat.Stamina]: 69,
      [Stat.Intellect]: 46,
      [Stat.SpellPower]: 487,
      [Stat.CritRating]: 31,
      [Stat.HasteRating]: 31,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: 'Splintered Icecrown Parapet',
    Sources: [ItemSourceName.HallsOfReflection],
    Id: 49833,
    Phase: 1,
    ItemSlot: ItemSlot.Weapon,
  },
  {
    IconName: 'inv_shoulder_118',
    Stats: {
      [Stat.Stamina]: 69,
      [Stat.Intellect]: 56,
      [Stat.SpellPower]: 92,
      [Stat.CritRating]: 60,
      [Stat.HasteRating]: 40,
    },
    Quality: Quality.Epic,
    Name: 'Frayed Abomination Stitching Shoulders',
    Id: 49834,
    Phase: 1,
    ItemSlot: ItemSlot.Shoulders,
  },
  {
    IconName: 'inv_weapon_shortblade_79',
    Stats: {
      [Stat.Stamina]: 54,
      [Stat.Intellect]: 28,
      [Stat.SpellPower]: 487,
      [Stat.HitRating]: 28,
      [Stat.HasteRating]: 46,
    },
    Quality: Quality.Epic,
    Unique: true,
    Sockets: [SocketColor.Blue],
    SocketBonus: {
      [Stat.CritRating]: 4,
    },
    Name: 'Chilled Heart of the Glacier',
    Sources: [ItemSourceName.HallsOfReflection],
    Id: 49846,
    Phase: 1,
    ItemSlot: ItemSlot.Weapon,
  },
  {
    IconName: 'inv_helmet_155',
    Stats: {
      [Stat.Stamina]: 81,
      [Stat.Intellect]: 68,
      [Stat.Spirit]: 66,
      [Stat.SpellPower]: 105,
      [Stat.HasteRating]: 58,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Meta, SocketColor.Yellow],
    SocketBonus: {
      [Stat.SpellPower]: 9,
    },
    Name: 'Tattered Glacial-Woven Hood',
    Sources: [ItemSourceName.HallsOfReflectionHeroic],
    Id: 49849,
    Phase: 1,
    ItemSlot: ItemSlot.Head,
  },
  {
    IconName: 'inv_wand_1h_stratholme_d_01',
    Stats: {
      [Stat.Stamina]: 30,
      [Stat.Intellect]: 24,
      [Stat.Spirit]: 22,
      [Stat.SpellPower]: 39,
      [Stat.HasteRating]: 22,
    },
    Quality: Quality.Epic,
    Name: 'Coffin Nail',
    Id: 49852,
    Phase: 1,
    ItemSlot: ItemSlot.Wand,
  },
  {
    IconName: 'inv_shoulder_118',
    Stats: {
      [Stat.Stamina]: 64,
      [Stat.Intellect]: 59,
      [Stat.Spirit]: 53,
      [Stat.SpellPower]: 92,
      [Stat.CritRating]: 53,
    },
    Quality: Quality.Epic,
    Name: 'Mantle of Tattered Feathers',
    Id: 49854,
    Phase: 1,
    ItemSlot: ItemSlot.Shoulders,
  },
  {
    IconName: 'inv_boots_cloth_25',
    Stats: {
      [Stat.Stamina]: 92,
      [Stat.Intellect]: 92,
      [Stat.SpellPower]: 122,
      [Stat.CritRating]: 80,
      [Stat.HitRating]: 64,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Red, SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 7,
    },
    Name: 'Deathfrost Boots',
    Id: 49890,
    Phase: 1,
    ItemSlot: ItemSlot.Feet,
  },
  {
    IconName: 'inv_pants_cloth_34',
    Stats: {
      [Stat.Stamina]: 123,
      [Stat.Intellect]: 123,
      [Stat.SpellPower]: 162,
      [Stat.CritRating]: 84,
      [Stat.HasteRating]: 108,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Red, SocketColor.Yellow, SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 9,
    },
    Name: 'Leggings of Woven Death',
    Id: 49891,
    Phase: 1,
    ItemSlot: ItemSlot.Legs,
  },
  {
    IconName: 'inv_pants_cloth_12',
    Stats: {
      [Stat.Stamina]: 123,
      [Stat.Intellect]: 123,
      [Stat.Spirit]: 108,
      [Stat.SpellPower]: 162,
      [Stat.CritRating]: 84,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Red, SocketColor.Yellow, SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 9,
    },
    Name: 'Lightweave Leggings',
    Id: 49892,
    Phase: 1,
    ItemSlot: ItemSlot.Legs,
  },
  {
    IconName: 'inv_boots_cloth_26',
    Stats: {
      [Stat.Stamina]: 92,
      [Stat.Intellect]: 92,
      [Stat.Spirit]: 80,
      [Stat.SpellPower]: 122,
      [Stat.CritRating]: 64,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Yellow, SocketColor.Yellow],
    SocketBonus: {
      [Stat.SpellPower]: 7,
    },
    Name: 'Sandals of Consecration',
    Id: 49893,
    Phase: 1,
    ItemSlot: ItemSlot.Feet,
  },
  {
    IconName: 'item_icecrownringb',
    Stats: {
      [Stat.Stamina]: 69,
      [Stat.Intellect]: 69,
      [Stat.SpellPower]: 97,
      [Stat.HasteRating]: 60,
      [Stat.Mp5]: 26,
    },
    Quality: Quality.Epic,
    Unique: true,
    Sockets: [SocketColor.Yellow],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    UniqueId: [49967, 50610],
    Phase: 1,
    Name: "Marrowgar's Frigid Eye",
    Id: 49967,
    ItemSlot: ItemSlot.Finger,
  },
  {
    IconName: 'inv_weapon_shortblade_101',
    Stats: {
      [Stat.Stamina]: 67,
      [Stat.Intellect]: 67,
      [Stat.Spirit]: 59,
      [Stat.SpellPower]: 741,
      [Stat.CritRating]: 59,
    },
    Quality: Quality.Epic,
    Unique: true,
    UniqueId: [49968, 50608],
    Phase: 1,
    Name: 'Frozen Bonespike',
    Sources: [ItemSourceName.IcecrownCitadel25],
    Id: 49968,
    ItemSlot: ItemSlot.Weapon,
  },
  {
    IconName: 'inv_jewelry_necklace_53',
    Stats: {
      [Stat.Stamina]: 69,
      [Stat.Intellect]: 69,
      [Stat.Spirit]: 60,
      [Stat.SpellPower]: 97,
      [Stat.HasteRating]: 52,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Name: "Bone Sentinel's Amulet",
    Sources: [ItemSourceName.IcecrownCitadel25],
    Id: 49975,
    Phase: 1,
    ItemSlot: ItemSlot.Neck,
  },
  {
    IconName: 'inv_jewelry_ring_82',
    Stats: {
      [Stat.Stamina]: 69,
      [Stat.Intellect]: 69,
      [Stat.SpellPower]: 97,
      [Stat.CritRating]: 65,
      [Stat.HitRating]: 45,
    },
    Quality: Quality.Epic,
    Unique: true,
    Sockets: [SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    UniqueId: [49977, 50614],
    Phase: 1,
    Name: 'Loop of the Endless Labyrinth',
    Id: 49977,
    ItemSlot: ItemSlot.Finger,
  },
  {
    IconName: 'inv_belt_66',
    Stats: {
      [Stat.Stamina]: 92,
      [Stat.Intellect]: 92,
      [Stat.SpellPower]: 122,
      [Stat.CritRating]: 64,
      [Stat.HasteRating]: 80,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Blue, SocketColor.Red],
    SocketBonus: {
      [Stat.SpellPower]: 7,
    },
    Name: 'Crushing Coldwraith Belt',
    Id: 49978,
    Phase: 1,
    ItemSlot: ItemSlot.Waist,
  },
  {
    IconName: 'inv_jewelry_ring_ahnqiraj_05',
    Stats: {
      [Stat.Stamina]: 69,
      [Stat.Intellect]: 69,
      [Stat.Spirit]: 60,
      [Stat.SpellPower]: 97,
      [Stat.CritRating]: 52,
    },
    Quality: Quality.Epic,
    Unique: true,
    Sockets: [SocketColor.Yellow],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    UniqueId: [49990, 50644],
    Phase: 1,
    Name: 'Ring of Maddening Whispers',
    Id: 49990,
    ItemSlot: ItemSlot.Finger,
  },
  {
    IconName: 'inv_shoulder_116',
    Stats: {
      [Stat.Stamina]: 92,
      [Stat.Intellect]: 92,
      [Stat.SpellPower]: 122,
      [Stat.HitRating]: 64,
      [Stat.HasteRating]: 80,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Blue, SocketColor.Red],
    SocketBonus: {
      [Stat.SpellPower]: 7,
    },
    Name: 'Shoulders of Mercy Killing',
    Id: 49991,
    Phase: 1,
    ItemSlot: ItemSlot.Shoulders,
  },
  {
    IconName: 'inv_staff_109',
    Stats: {
      [Stat.Stamina]: 99,
      [Stat.Intellect]: 107,
      [Stat.SpellPower]: 741,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Red, SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 7,
    },
    Name: 'Nibelung',
    Sources: [ItemSourceName.IcecrownCitadel25],
    Id: 49992,
    Phase: 1,
    ItemSlot: ItemSlot.Weapon,
    IsTwoHand: true,
  },
  {
    IconName: 'inv_bracer_45',
    Stats: {
      [Stat.Stamina]: 69,
      [Stat.Intellect]: 69,
      [Stat.SpellPower]: 97,
      [Stat.CritRating]: 65,
      [Stat.HitRating]: 45,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Yellow],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Name: "The Lady's Brittle Bracers",
    Id: 49994,
    Phase: 1,
    ItemSlot: ItemSlot.Wrist,
  },
  {
    IconName: 'item_icecrownnecklaced',
    Stats: {
      [Stat.Stamina]: 69,
      [Stat.Intellect]: 69,
      [Stat.SpellPower]: 97,
      [Stat.HitRating]: 52,
      [Stat.HasteRating]: 60,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Yellow],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Name: 'Amulet of the Silent Eulogy',
    Sources: [ItemSourceName.IcecrownCitadel25],
    Id: 50005,
    Phase: 1,
    ItemSlot: ItemSlot.Neck,
  },
  {
    IconName: 'inv_helmet_156',
    Stats: {
      [Stat.Stamina]: 123,
      [Stat.Intellect]: 123,
      [Stat.Spirit]: 100,
      [Stat.SpellPower]: 162,
      [Stat.CritRating]: 92,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Meta, SocketColor.Yellow],
    SocketBonus: {
      [Stat.SpellPower]: 9,
    },
    Name: "Corp'rethar Ceremonial Crown",
    Sources: [ItemSourceName.IcecrownCitadel25],
    Id: 50006,
    Phase: 1,
    ItemSlot: ItemSlot.Head,
  },
  {
    IconName: 'inv_jewelry_ring_86',
    Stats: {
      [Stat.Stamina]: 69,
      [Stat.Intellect]: 69,
      [Stat.SpellPower]: 97,
      [Stat.CritRating]: 60,
      [Stat.HasteRating]: 52,
    },
    Quality: Quality.Epic,
    Unique: true,
    Sockets: [SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    UniqueId: [50008, 50664],
    Phase: 1,
    Name: 'Ring of Rapid Ascent',
    Id: 50008,
    ItemSlot: ItemSlot.Finger,
  },
  {
    IconName: 'inv_gauntlets_90',
    Stats: {
      [Stat.Stamina]: 92,
      [Stat.Intellect]: 92,
      [Stat.SpellPower]: 122,
      [Stat.HitRating]: 64,
      [Stat.HasteRating]: 80,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Blue, SocketColor.Red],
    SocketBonus: {
      [Stat.SpellPower]: 7,
    },
    Name: "Gunship Captain's Mittens",
    Id: 50011,
    Phase: 1,
    ItemSlot: ItemSlot.Hands,
  },
  {
    IconName: 'item_icecrowncape',
    Stats: {
      [Stat.Stamina]: 69,
      [Stat.Intellect]: 69,
      [Stat.Spirit]: 60,
      [Stat.SpellPower]: 97,
      [Stat.HasteRating]: 52,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Name: 'Greatcloak of the Turned Champion',
    Id: 50014,
    Phase: 1,
    ItemSlot: ItemSlot.Back,
  },
  {
    IconName: 'inv_bracer_47',
    Stats: {
      [Stat.Stamina]: 69,
      [Stat.Intellect]: 69,
      [Stat.Spirit]: 60,
      [Stat.SpellPower]: 97,
      [Stat.CritRating]: 52,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Name: "Death Surgeon's Sleeves",
    Id: 50032,
    Phase: 1,
    ItemSlot: ItemSlot.Wrist,
  },
  {
    IconName: 'inv_wand_35',
    Stats: {
      [Stat.Stamina]: 39,
      [Stat.Intellect]: 39,
      [Stat.SpellPower]: 60,
      [Stat.CritRating]: 34,
      [Stat.HasteRating]: 34,
    },
    Quality: Quality.Epic,
    Name: 'Corpse-Impaling Spike',
    Id: 50033,
    Phase: 1,
    ItemSlot: ItemSlot.Wand,
  },
  {
    IconName: 'inv_sword_155',
    Stats: {
      [Stat.Stamina]: 59,
      [Stat.Intellect]: 59,
      [Stat.SpellPower]: 657,
      [Stat.CritRating]: 54,
      [Stat.HasteRating]: 49,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: "Quel'Delar, Lens of the Mind",
    Sources: [ItemSourceName.Quest],
    Id: 50047,
    Phase: 1,
    ItemSlot: ItemSlot.Weapon,
  },
  {
    IconName: 'inv_pants_cloth_34',
    Stats: {
      [Stat.Stamina]: 123,
      [Stat.Intellect]: 123,
      [Stat.SpellPower]: 171,
      [Stat.HitRating]: 98,
      [Stat.HasteRating]: 102,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Red, SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 7,
    },
    Name: "Plaguebringer's Stained Pants",
    Id: 50056,
    Phase: 1,
    ItemSlot: ItemSlot.Legs,
  },
  {
    IconName: 'inv_jewelry_necklace_49',
    Stats: {
      [Stat.Stamina]: 69,
      [Stat.Intellect]: 69,
      [Stat.SpellPower]: 97,
      [Stat.CritRating]: 52,
      [Stat.Mp5]: 30,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Yellow],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Name: "Holiday's Grace",
    Sources: [ItemSourceName.IcecrownCitadel25],
    Id: 50061,
    Phase: 1,
    ItemSlot: ItemSlot.Neck,
  },
  {
    IconName: 'inv_boots_cloth_25',
    Stats: {
      [Stat.Stamina]: 92,
      [Stat.Intellect]: 92,
      [Stat.SpellPower]: 122,
      [Stat.CritRating]: 64,
      [Stat.HasteRating]: 80,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Blue, SocketColor.Red],
    SocketBonus: {
      [Stat.SpellPower]: 7,
    },
    Name: "Plague Scientist's Boots",
    Id: 50062,
    Phase: 1,
    ItemSlot: ItemSlot.Feet,
  },
  {
    IconName: 'inv_belt_68',
    Stats: {
      [Stat.Stamina]: 92,
      [Stat.Intellect]: 92,
      [Stat.Spirit]: 80,
      [Stat.SpellPower]: 122,
      [Stat.CritRating]: 64,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Yellow, SocketColor.Red],
    SocketBonus: {
      [Stat.SpellPower]: 7,
    },
    Name: 'Lingering Illness',
    Id: 50063,
    Phase: 1,
    ItemSlot: ItemSlot.Waist,
  },
  {
    IconName: 'inv_sword_152',
    Stats: {
      [Stat.Stamina]: 67,
      [Stat.Intellect]: 67,
      [Stat.SpellPower]: 741,
      [Stat.HitRating]: 59,
      [Stat.HasteRating]: 59,
    },
    Quality: Quality.Epic,
    Unique: true,
    UniqueId: [50068, 50704],
    Phase: 1,
    Name: 'Rigormortis',
    Sources: [ItemSourceName.IcecrownCitadel25],
    Id: 50068,
    ItemSlot: ItemSlot.Weapon,
  },
  {
    IconName: 'inv_jewelry_ring_81',
    Stats: {
      [Stat.Stamina]: 69,
      [Stat.Intellect]: 69,
      [Stat.SpellPower]: 97,
      [Stat.HitRating]: 38,
      [Stat.HasteRating]: 69,
    },
    Quality: Quality.Epic,
    Unique: true,
    Sockets: [SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    UniqueId: [50170, 50714],
    Phase: 1,
    Name: "Valanar's Other Signet Ring",
    Id: 50170,
    ItemSlot: ItemSlot.Finger,
  },
  {
    IconName: 'inv_chest_cloth_80',
    Stats: {
      [Stat.Stamina]: 123,
      [Stat.Intellect]: 123,
      [Stat.Spirit]: 108,
      [Stat.SpellPower]: 162,
      [Stat.HasteRating]: 84,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Blue, SocketColor.Red, SocketColor.Yellow],
    SocketBonus: {
      [Stat.SpellPower]: 9,
    },
    Name: 'Sanguine Silk Robes',
    Id: 50172,
    Phase: 1,
    ItemSlot: ItemSlot.Chest,
  },
  {
    IconName: 'inv_misc_thread_01',
    Stats: {
      [Stat.Stamina]: 69,
      [Stat.Intellect]: 69,
      [Stat.SpellPower]: 106,
      [Stat.CritRating]: 60,
      [Stat.HasteRating]: 60,
    },
    Quality: Quality.Epic,
    Name: 'Shadow Silk Spindle',
    Sources: [ItemSourceName.IcecrownCitadel25],
    Id: 50173,
    Phase: 1,
    ItemSlot: ItemSlot.OffHand,
  },
  {
    IconName: 'inv_jewelry_ring_84',
    Stats: {
      [Stat.Stamina]: 69,
      [Stat.Intellect]: 69,
      [Stat.SpellPower]: 97,
      [Stat.CritRating]: 52,
      [Stat.Mp5]: 30,
    },
    Quality: Quality.Epic,
    Unique: true,
    Sockets: [SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    UniqueId: [50174, 50720],
    Phase: 1,
    Name: 'Incarnadine Band of Mending',
    Id: 50174,
    ItemSlot: ItemSlot.Finger,
  },
  {
    IconName: 'inv_gauntlets_92',
    Stats: {
      [Stat.Stamina]: 92,
      [Stat.Intellect]: 92,
      [Stat.Spirit]: 64,
      [Stat.SpellPower]: 122,
      [Stat.HasteRating]: 80,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Yellow, SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 7,
    },
    Name: "San'layn Ritualist Gloves",
    Id: 50176,
    Phase: 1,
    ItemSlot: ItemSlot.Hands,
  },
  {
    IconName: 'inv_staff_106',
    Stats: {
      [Stat.Stamina]: 156,
      [Stat.Intellect]: 156,
      [Stat.Spirit]: 121,
      [Stat.SpellPower]: 741,
      [Stat.HasteRating]: 121,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Yellow, SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 7,
    },
    Name: 'Dying Light',
    Sources: [ItemSourceName.IcecrownCitadel25],
    Id: 50181,
    Phase: 1,
    ItemSlot: ItemSlot.Weapon,
    IsTwoHand: true,
  },
  {
    IconName: 'inv_jewelcrafting_crimsonspinel_02',
    Stats: {
      [Stat.Stamina]: 69,
      [Stat.Intellect]: 69,
      [Stat.SpellPower]: 97,
      [Stat.CritRating]: 57,
      [Stat.HasteRating]: 53,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Yellow],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Name: "Blood Queen's Crimson Choker",
    Sources: [ItemSourceName.IcecrownCitadel25],
    Id: 50182,
    Phase: 1,
    ItemSlot: ItemSlot.Neck,
  },
  {
    IconName: 'inv_shoulder_118',
    Stats: {
      [Stat.Stamina]: 68,
      [Stat.Intellect]: 68,
      [Stat.SpellPower]: 105,
      [Stat.HitRating]: 62,
      [Stat.HasteRating]: 55,
    },
    Quality: Quality.Epic,
    Name: 'Very Fashionable Shoulders',
    Id: 50193,
    Phase: 1,
    ItemSlot: ItemSlot.Shoulders,
  },
  {
    IconName: 'inv_spiritshard_02',
    Stats: {
      [Stat.Stamina]: 51,
      [Stat.Intellect]: 51,
      [Stat.SpellPower]: 78,
      [Stat.HasteRating]: 34,
      [Stat.Mp5]: 25,
    },
    Quality: Quality.Epic,
    Name: "Love's Prisoner",
    Sources: [ItemSourceName.ForgeOfSoulsHeroic],
    Id: 50196,
    Phase: 1,
    ItemSlot: ItemSlot.Neck,
  },
  {
    IconName: 'inv_misc_cape_16',
    Stats: {
      [Stat.Stamina]: 69,
      [Stat.Intellect]: 69,
      [Stat.SpellPower]: 97,
      [Stat.CritRating]: 60,
      [Stat.HasteRating]: 52,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Yellow],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Name: "Frostbinder's Shredded Cape",
    Id: 50205,
    Phase: 1,
    ItemSlot: ItemSlot.Back,
  },
  {
    IconName: 'inv_sword_120',
    Stats: {
      [Stat.Stamina]: 39,
      [Stat.Intellect]: 52,
      [Stat.SpellPower]: 550,
      [Stat.HitRating]: 39,
      [Stat.HasteRating]: 52,
    },
    Quality: Quality.Epic,
    Name: 'Seethe',
    Sources: [ItemSourceName.ForgeOfSoulsHeroic],
    Id: 50210,
    Phase: 1,
    ItemSlot: ItemSlot.Weapon,
  },
  {
    IconName: 'inv_jewelry_necklace_39',
    Stats: {
      [Stat.Stamina]: 59,
      [Stat.Intellect]: 48,
      [Stat.SpellPower]: 78,
      [Stat.CritRating]: 45,
      [Stat.HasteRating]: 45,
    },
    Quality: Quality.Epic,
    Name: 'Arcane Loops of Anger',
    Sources: [ItemSourceName.ForgeOfSoulsHeroic],
    Id: 50211,
    Phase: 1,
    ItemSlot: ItemSlot.Neck,
  },
  {
    IconName: 'inv_chest_cloth_48',
    Stats: {
      [Stat.Stamina]: 92,
      [Stat.Intellect]: 92,
      [Stat.Spirit]: 86,
      [Stat.SpellPower]: 141,
      [Stat.CritRating]: 70,
    },
    Quality: Quality.Epic,
    Name: "Mord'rethar Robes",
    Id: 50213,
    Phase: 1,
    ItemSlot: ItemSlot.Chest,
  },
  {
    IconName: 'inv_weapon_shortblade_100',
    Stats: {
      [Stat.Stamina]: 39,
      [Stat.Intellect]: 52,
      [Stat.SpellPower]: 550,
      [Stat.CritRating]: 39,
      [Stat.Mp5]: 26,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: "Surgeon's Needle",
    Sources: [ItemSourceName.PitOfSaronHeroic],
    Id: 50227,
    Phase: 1,
    ItemSlot: ItemSlot.Weapon,
  },
  {
    IconName: 'inv_gauntlets_88',
    Stats: {
      [Stat.Stamina]: 81,
      [Stat.Intellect]: 81,
      [Stat.SpellPower]: 116,
      [Stat.CritRating]: 71,
      [Stat.HitRating]: 63,
    },
    Quality: Quality.Epic,
    Set: ItemSet.T10,
    Sockets: [SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Name: 'Dark Coven Gloves',
    Id: 50240,
    Phase: 1,
    ItemSlot: ItemSlot.Hands,
  },
  {
    IconName: 'inv_helmet_152',
    Stats: {
      [Stat.Stamina]: 109,
      [Stat.Intellect]: 109,
      [Stat.SpellPower]: 140,
      [Stat.CritRating]: 88,
      [Stat.HasteRating]: 80,
    },
    Quality: Quality.Epic,
    Set: ItemSet.T10,
    Sockets: [SocketColor.Meta, SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 9,
    },
    Name: 'Dark Coven Hood',
    Sources: [ItemSourceName.EmblemOfFrost],
    Id: 50241,
    Phase: 1,
    ItemSlot: ItemSlot.Head,
  },
  {
    IconName: 'inv_kilt_cloth_02',
    Stats: {
      [Stat.Stamina]: 109,
      [Stat.Intellect]: 109,
      [Stat.SpellPower]: 149,
      [Stat.CritRating]: 96,
      [Stat.HitRating]: 80,
    },
    Quality: Quality.Epic,
    Set: ItemSet.T10,
    Sockets: [SocketColor.Blue, SocketColor.Yellow],
    SocketBonus: {
      [Stat.SpellPower]: 7,
    },
    Name: 'Dark Coven Leggings',
    Id: 50242,
    Phase: 1,
    ItemSlot: ItemSlot.Legs,
  },
  {
    IconName: 'inv_chest_cloth_77',
    Stats: {
      [Stat.Stamina]: 109,
      [Stat.Intellect]: 109,
      [Stat.SpellPower]: 149,
      [Stat.CritRating]: 96,
      [Stat.HasteRating]: 80,
    },
    Quality: Quality.Epic,
    Set: ItemSet.T10,
    Sockets: [SocketColor.Red, SocketColor.Yellow],
    SocketBonus: {
      [Stat.SpellPower]: 7,
    },
    Name: 'Dark Coven Robe',
    Id: 50243,
    Phase: 1,
    ItemSlot: ItemSlot.Chest,
  },
  {
    IconName: 'inv_shoulder_114',
    Stats: {
      [Stat.Stamina]: 81,
      [Stat.Intellect]: 81,
      [Stat.SpellPower]: 116,
      [Stat.CritRating]: 71,
      [Stat.HasteRating]: 63,
    },
    Quality: Quality.Epic,
    Set: ItemSet.T10,
    Sockets: [SocketColor.Yellow],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Name: 'Dark Coven Shoulderpads',
    Id: 50244,
    Phase: 1,
    ItemSlot: ItemSlot.Shoulders,
  },
  {
    IconName: 'inv_jewelry_ring_39',
    Quality: Quality.Heirloom,
    Unique: true,
    Name: 'Dread Pirate Ring',
    Id: 50255,
    Phase: 1,
    ItemSlot: ItemSlot.Finger,
  },
  {
    IconName: 'inv_datacrystal09',
    Stats: {
      [Stat.SpellPower]: 111,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: 'Nevermelting Ice Crystal',
    Id: 50259,
    Phase: 1,
    ItemSlot: ItemSlot.Trinket,
  },
  {
    IconName: 'inv_jewelcrafting_empyreansapphire_01',
    Quality: Quality.Epic,
    Unique: true,
    Name: 'Ephemeral Snowflake',
    Id: 50260,
    Phase: 1,
    ItemSlot: ItemSlot.Trinket,
  },
  {
    IconName: 'inv_belt_67',
    Stats: {
      [Stat.Stamina]: 78,
      [Stat.Intellect]: 64,
      [Stat.Spirit]: 60,
      [Stat.SpellPower]: 105,
      [Stat.HasteRating]: 60,
    },
    Quality: Quality.Epic,
    Name: 'Braid of Salt and Fire',
    Id: 50263,
    Phase: 1,
    ItemSlot: ItemSlot.Waist,
  },
  {
    IconName: 'inv_chest_cloth_79',
    Stats: {
      [Stat.Stamina]: 92,
      [Stat.Intellect]: 92,
      [Stat.SpellPower]: 141,
      [Stat.HitRating]: 61,
      [Stat.HasteRating]: 92,
    },
    Quality: Quality.Epic,
    Name: 'Ancient Polar Bear Hide',
    Id: 50266,
    Phase: 1,
    ItemSlot: ItemSlot.Chest,
  },
  {
    IconName: 'inv_staff_81',
    Stats: {
      [Stat.Stamina]: 110,
      [Stat.Intellect]: 121,
      [Stat.SpellPower]: 550,
      [Stat.HitRating]: 113,
      [Stat.HasteRating]: 86,
    },
    Quality: Quality.Epic,
    Name: 'Engraved Gargoyle Femur',
    Sources: [ItemSourceName.PitOfSaronHeroic],
    Id: 50273,
    Phase: 1,
    ItemSlot: ItemSlot.Weapon,
    IsTwoHand: true,
  },
  {
    IconName: 'inv_boots_cloth_26',
    Stats: {
      [Stat.Stamina]: 68,
      [Stat.Intellect]: 68,
      [Stat.Spirit]: 61,
      [Stat.SpellPower]: 105,
      [Stat.HasteRating]: 57,
    },
    Quality: Quality.Epic,
    Name: "Prelate's Snowshoes",
    Id: 50286,
    Phase: 1,
    ItemSlot: ItemSlot.Feet,
  },
  {
    IconName: 'inv_wand_1h_stratholme_d_02',
    Stats: {
      [Stat.Stamina]: 33,
      [Stat.Intellect]: 27,
      [Stat.SpellPower]: 44,
      [Stat.CritRating]: 22,
      [Stat.HitRating]: 27,
    },
    Quality: Quality.Epic,
    Name: 'Soulsplinter',
    Id: 50291,
    Phase: 1,
    ItemSlot: ItemSlot.Wand,
  },
  {
    IconName: 'inv_bracer_32a',
    Stats: {
      [Stat.Stamina]: 51,
      [Stat.Intellect]: 51,
      [Stat.SpellPower]: 78,
      [Stat.CritRating]: 45,
      [Stat.HitRating]: 43,
    },
    Quality: Quality.Epic,
    Name: 'Bracer of Worn Molars',
    Id: 50292,
    Phase: 1,
    ItemSlot: ItemSlot.Wrist,
  },
  {
    IconName: 'inv_helmet_155',
    Stats: {
      [Stat.Stamina]: 80,
      [Stat.Intellect]: 84,
      [Stat.SpellPower]: 122,
      [Stat.HitRating]: 62,
      [Stat.HasteRating]: 78,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Meta, SocketColor.Blue],
    SocketBonus: {
      [Stat.CritRating]: 8,
    },
    Name: 'Sightless Crown of Ulmaas',
    Sources: [ItemSourceName.HallsOfReflectionHeroic],
    Id: 50298,
    Phase: 1,
    ItemSlot: ItemSlot.Head,
  },
  {
    IconName: 'inv_gauntlets_91',
    Stats: {
      [Stat.Stamina]: 68,
      [Stat.Intellect]: 68,
      [Stat.Spirit]: 57,
      [Stat.SpellPower]: 105,
      [Stat.CritRating]: 61,
    },
    Quality: Quality.Epic,
    Name: 'Suspiciously Soft Gloves',
    Id: 50299,
    Phase: 1,
    ItemSlot: ItemSlot.Hands,
  },
  {
    IconName: 'inv_ore_feliron_01',
    Stats: {
      [Stat.Stamina]: 54,
      [Stat.Intellect]: 34,
      [Stat.SpellPower]: 78,
      [Stat.CritRating]: 51,
      [Stat.HasteRating]: 50,
    },
    Quality: Quality.Epic,
    Name: 'Shriveled Heart',
    Sources: [ItemSourceName.HallsOfReflectionHeroic],
    Id: 50309,
    Phase: 1,
    ItemSlot: ItemSlot.OffHand,
  },
  {
    IconName: 'inv_jewelry_ring_68',
    Stats: {
      [Stat.Stamina]: 48,
      [Stat.Intellect]: 52,
      [Stat.SpellPower]: 78,
      [Stat.CritRating]: 36,
      [Stat.Mp5]: 25,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: 'Oath of Empress Zoe',
    Id: 50313,
    Phase: 1,
    ItemSlot: ItemSlot.Finger,
  },
  {
    IconName: 'inv_belt_67',
    Stats: {
      [Stat.Stamina]: 68,
      [Stat.Intellect]: 68,
      [Stat.SpellPower]: 105,
      [Stat.CritRating]: 55,
      [Stat.HasteRating]: 62,
    },
    Quality: Quality.Epic,
    Name: 'Strip of Remorse',
    Id: 50314,
    Phase: 1,
    ItemSlot: ItemSlot.Waist,
  },
  {
    IconName: 'inv_jewelry_trinket_05',
    Stats: {
      [Stat.SpellPower]: 158,
    },
    Quality: Quality.Epic,
    Unique: true,
    UniqueId: [50339, 50346],
    Phase: 1,
    Name: 'Sliver of Pure Ice',
    Id: 50339,
    ItemSlot: ItemSlot.Trinket,
  },
  {
    IconName: 'inv_misc_spyglass_02',
    Stats: {
      [Stat.CritRating]: 131,
    },
    Quality: Quality.Epic,
    Unique: true,
    UniqueId: [50340, 50345],
    Phase: 1,
    Name: "Muradin's Spyglass",
    Id: 50340,
    ItemSlot: ItemSlot.Trinket,
  },
  {
    IconName: 'inv_misc_spyglass_02',
    Stats: {
      [Stat.CritRating]: 152,
    },
    Quality: Quality.Epic,
    Unique: true,
    UniqueId: [50340, 50345],
    Phase: 1,
    Name: "Muradin's Spyglass",
    Id: 50345,
    ItemSlot: ItemSlot.Trinket,
  },
  {
    IconName: 'inv_jewelry_trinket_05',
    Stats: {
      [Stat.SpellPower]: 178,
    },
    Quality: Quality.Epic,
    Unique: true,
    UniqueId: [50339, 50346],
    Phase: 1,
    Name: 'Sliver of Pure Ice',
    Id: 50346,
    ItemSlot: ItemSlot.Trinket,
  },
  {
    IconName: 'inv_jewelry_trinket_01',
    Stats: {
      [Stat.HasteRating]: 170,
    },
    Quality: Quality.Epic,
    Unique: true,
    UniqueId: [50353, 50348],
    Phase: 1,
    Name: 'Dislodged Foreign Object',
    Id: 50348,
    ItemSlot: ItemSlot.Trinket,
  },
  {
    IconName: 'inv_jewelry_trinket_01',
    Stats: {
      [Stat.HasteRating]: 155,
    },
    Quality: Quality.Epic,
    Unique: true,
    UniqueId: [50353, 50348],
    Phase: 1,
    Name: 'Dislodged Foreign Object',
    Id: 50353,
    ItemSlot: ItemSlot.Trinket,
  },
  {
    IconName: 'inv_jewelry_trinket_02',
    Stats: {
      [Stat.HitRating]: 152,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: "Maghia's Misguided Quill",
    Id: 50357,
    Phase: 1,
    ItemSlot: ItemSlot.Trinket,
  },
  {
    IconName: 'inv_misc_ammo_gunpowder_05',
    Stats: {
      [Stat.SpellPower]: 179,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: 'Purified Lunar Dust',
    Id: 50358,
    Phase: 1,
    ItemSlot: ItemSlot.Trinket,
  },
  {
    IconName: 'inv_jewelry_trinket_03',
    Stats: {
      [Stat.CritRating]: 152,
    },
    Quality: Quality.Epic,
    Unique: true,
    UniqueId: [50360, 50365],
    Phase: 1,
    Name: 'Phylactery of the Nameless Lich',
    Id: 50360,
    ItemSlot: ItemSlot.Trinket,
  },
  {
    IconName: 'inv_jewelry_trinket_03',
    Stats: {
      [Stat.CritRating]: 172,
    },
    Quality: Quality.Epic,
    Unique: true,
    UniqueId: [50360, 50365],
    Phase: 1,
    Name: 'Phylactery of the Nameless Lich',
    Id: 50365,
    ItemSlot: ItemSlot.Trinket,
  },
  {
    IconName: 'inv_jewelry_ring_83',
    Stats: {
      [Stat.Stamina]: 61,
      [Stat.Intellect]: 61,
      [Stat.SpellPower]: 94,
      [Stat.HitRating]: 47,
      [Stat.HasteRating]: 57,
    },
    Quality: Quality.Epic,
    Unique: true,
    UniqueId: [50377, 50398, 50384, 50397],
    Phase: 1,
    Name: 'Ashen Band of Destruction',
    Id: 50377,
    ItemSlot: ItemSlot.Finger,
  },
  {
    IconName: 'inv_jewelry_ring_85',
    Stats: {
      [Stat.Stamina]: 61,
      [Stat.Intellect]: 61,
      [Stat.SpellPower]: 94,
      [Stat.HasteRating]: 53,
      [Stat.Mp5]: 27,
    },
    Quality: Quality.Epic,
    Unique: true,
    UniqueId: [50400, 50386, 50399, 50378],
    Phase: 1,
    Name: 'Ashen Band of Wisdom',
    Id: 50378,
    ItemSlot: ItemSlot.Finger,
  },
  {
    IconName: 'inv_jewelry_ring_83',
    Stats: {
      [Stat.Stamina]: 66,
      [Stat.Intellect]: 66,
      [Stat.SpellPower]: 101,
      [Stat.HitRating]: 50,
      [Stat.HasteRating]: 62,
    },
    Quality: Quality.Epic,
    Unique: true,
    UniqueId: [50377, 50398, 50384, 50397],
    Phase: 1,
    Name: 'Ashen Band of Greater Destruction',
    Id: 50384,
    ItemSlot: ItemSlot.Finger,
  },
  {
    IconName: 'inv_jewelry_ring_85',
    Stats: {
      [Stat.Stamina]: 66,
      [Stat.Intellect]: 66,
      [Stat.SpellPower]: 101,
      [Stat.HasteRating]: 57,
      [Stat.Mp5]: 29,
    },
    Quality: Quality.Epic,
    Unique: true,
    UniqueId: [50400, 50386, 50399, 50378],
    Phase: 1,
    Name: 'Ashen Band of Greater Wisdom',
    Id: 50386,
    ItemSlot: ItemSlot.Finger,
  },
  {
    IconName: 'inv_jewelry_ring_83',
    Stats: {
      [Stat.Stamina]: 66,
      [Stat.Intellect]: 66,
      [Stat.SpellPower]: 101,
      [Stat.HitRating]: 50,
      [Stat.HasteRating]: 62,
    },
    Quality: Quality.Epic,
    Unique: true,
    UniqueId: [50377, 50398, 50384, 50397],
    Phase: 1,
    Name: 'Ashen Band of Unmatched Destruction',
    Id: 50397,
    ItemSlot: ItemSlot.Finger,
  },
  {
    IconName: 'inv_jewelry_ring_83',
    Stats: {
      [Stat.Stamina]: 73,
      [Stat.Intellect]: 73,
      [Stat.SpellPower]: 101,
      [Stat.HitRating]: 51,
      [Stat.HasteRating]: 64,
    },
    Quality: Quality.Epic,
    Unique: true,
    Sockets: [SocketColor.Yellow],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    UniqueId: [50377, 50398, 50384, 50397],
    Phase: 1,
    Name: 'Ashen Band of Endless Destruction',
    Id: 50398,
    ItemSlot: ItemSlot.Finger,
  },
  {
    IconName: 'inv_jewelry_ring_85',
    Stats: {
      [Stat.Stamina]: 66,
      [Stat.Intellect]: 66,
      [Stat.SpellPower]: 101,
      [Stat.HasteRating]: 57,
      [Stat.Mp5]: 29,
    },
    Quality: Quality.Epic,
    Unique: true,
    UniqueId: [50400, 50386, 50399, 50378],
    Phase: 1,
    Name: 'Ashen Band of Unmatched Wisdom',
    Id: 50399,
    ItemSlot: ItemSlot.Finger,
  },
  {
    IconName: 'inv_jewelry_ring_85',
    Stats: {
      [Stat.Stamina]: 73,
      [Stat.Intellect]: 73,
      [Stat.SpellPower]: 101,
      [Stat.HasteRating]: 59,
      [Stat.Mp5]: 30,
    },
    Quality: Quality.Epic,
    Unique: true,
    Sockets: [SocketColor.Yellow],
    SocketBonus: {
      [Stat.Mp5]: 2,
    },
    UniqueId: [50400, 50386, 50399, 50378],
    Phase: 1,
    Name: 'Ashen Band of Endless Wisdom',
    Id: 50400,
    ItemSlot: ItemSlot.Finger,
  },
  {
    IconName: 'inv_chest_cloth_78',
    Stats: {
      [Stat.Stamina]: 123,
      [Stat.Intellect]: 123,
      [Stat.SpellPower]: 162,
      [Stat.CritRating]: 108,
      [Stat.HitRating]: 84,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Red, SocketColor.Blue, SocketColor.Yellow],
    SocketBonus: {
      [Stat.SpellPower]: 9,
    },
    Name: 'Robe of the Waking Nightmare',
    Id: 50418,
    Phase: 1,
    ItemSlot: ItemSlot.Chest,
  },
  {
    IconName: 'inv_offhand_zulaman_d_02',
    Stats: {
      [Stat.Stamina]: 69,
      [Stat.Intellect]: 69,
      [Stat.Spirit]: 60,
      [Stat.SpellPower]: 106,
      [Stat.HasteRating]: 60,
    },
    Quality: Quality.Epic,
    Name: 'Sundial of Eternal Dusk',
    Sources: [ItemSourceName.IcecrownCitadel25],
    Id: 50423,
    Phase: 1,
    ItemSlot: ItemSlot.OffHand,
  },
  {
    IconName: 'inv_jewelry_ring_40',
    Stats: {
      [Stat.Stamina]: 69,
      [Stat.Intellect]: 69,
      [Stat.Spirit]: 60,
      [Stat.SpellPower]: 97,
      [Stat.HasteRating]: 52,
    },
    Quality: Quality.Epic,
    Unique: true,
    Sockets: [SocketColor.Yellow],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    UniqueId: [50424, 50636],
    Phase: 1,
    Name: 'Memory of Malygos',
    Id: 50424,
    ItemSlot: ItemSlot.Finger,
  },
  {
    IconName: 'inv_sword_150',
    Stats: {
      [Stat.Stamina]: 71,
      [Stat.Intellect]: 71,
      [Stat.SpellPower]: 792,
      [Stat.CritRating]: 63,
      [Stat.HasteRating]: 63,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: "Bloodsurge, Kel'Thuzad's Blade of Agony",
    Sources: [ItemSourceName.IcecrownCitadel25],
    Id: 50427,
    Phase: 1,
    ItemSlot: ItemSlot.Weapon,
  },
  {
    IconName: 'inv_staff_108',
    Stats: {
      [Stat.Stamina]: 167,
      [Stat.Intellect]: 167,
      [Stat.Spirit]: 130,
      [Stat.SpellPower]: 792,
      [Stat.HasteRating]: 130,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Red, SocketColor.Red],
    SocketBonus: {
      [Stat.SpellPower]: 7,
    },
    Name: 'Archus, Greatstaff of Antonidas',
    Sources: [ItemSourceName.IcecrownCitadel25],
    Id: 50429,
    Phase: 1,
    ItemSlot: ItemSlot.Weapon,
    IsTwoHand: true,
  },
  {
    IconName: 'inv_shoulder_119',
    Stats: {
      [Stat.Stamina]: 92,
      [Stat.Intellect]: 92,
      [Stat.Spirit]: 80,
      [Stat.SpellPower]: 122,
      [Stat.CritRating]: 64,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Yellow, SocketColor.Yellow],
    SocketBonus: {
      [Stat.SpellPower]: 7,
    },
    Name: 'Stiffened Corpse Shoulderpads',
    Id: 50449,
    Phase: 1,
    ItemSlot: ItemSlot.Shoulders,
  },
  {
    IconName: 'inv_misc_cape_16',
    Stats: {
      [Stat.Stamina]: 69,
      [Stat.Intellect]: 69,
      [Stat.SpellPower]: 97,
      [Stat.CritRating]: 52,
      [Stat.Mp5]: 30,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Name: 'Drape of the Violet Tower',
    Id: 50468,
    Phase: 1,
    ItemSlot: ItemSlot.Back,
  },
  {
    IconName: 'inv_misc_cape_16',
    Stats: {
      [Stat.Stamina]: 69,
      [Stat.Intellect]: 69,
      [Stat.Spirit]: 60,
      [Stat.SpellPower]: 97,
      [Stat.CritRating]: 52,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Yellow],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Name: "Volde's Cloak of the Night Sky",
    Id: 50469,
    Phase: 1,
    ItemSlot: ItemSlot.Back,
  },
  {
    IconName: 'inv_wand_34',
    Stats: {
      [Stat.Stamina]: 39,
      [Stat.Intellect]: 39,
      [Stat.Spirit]: 34,
      [Stat.SpellPower]: 60,
      [Stat.CritRating]: 34,
    },
    Quality: Quality.Epic,
    Name: 'Nightmare Ender',
    Id: 50472,
    Phase: 1,
    ItemSlot: ItemSlot.Wand,
  },
  {
    IconName: 'inv_weapon_shortblade_101',
    Stats: {
      [Stat.Stamina]: 75,
      [Stat.Intellect]: 75,
      [Stat.Spirit]: 66,
      [Stat.SpellPower]: 836,
      [Stat.CritRating]: 50,
    },
    Quality: Quality.Epic,
    Unique: true,
    Sockets: [SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    UniqueId: [49968, 50608],
    Phase: 1,
    Name: 'Frozen Bonespike',
    Sources: [ItemSourceName.IcecrownCitadel25Heroic],
    Id: 50608,
    ItemSlot: ItemSlot.Weapon,
  },
  {
    IconName: 'inv_jewelry_necklace_53',
    Stats: {
      [Stat.Stamina]: 78,
      [Stat.Intellect]: 78,
      [Stat.Spirit]: 68,
      [Stat.SpellPower]: 110,
      [Stat.HasteRating]: 60,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Name: "Bone Sentinel's Amulet",
    Sources: [ItemSourceName.IcecrownCitadel25Heroic],
    Id: 50609,
    Phase: 1,
    ItemSlot: ItemSlot.Neck,
  },
  {
    IconName: 'item_icecrownringb',
    Stats: {
      [Stat.Stamina]: 78,
      [Stat.Intellect]: 78,
      [Stat.SpellPower]: 110,
      [Stat.HasteRating]: 68,
      [Stat.Mp5]: 30,
    },
    Quality: Quality.Epic,
    Unique: true,
    Sockets: [SocketColor.Yellow],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    UniqueId: [49967, 50610],
    Phase: 1,
    Name: "Marrowgar's Frigid Eye",
    Id: 50610,
    ItemSlot: ItemSlot.Finger,
  },
  {
    IconName: 'inv_belt_64',
    Stats: {
      [Stat.Stamina]: 103,
      [Stat.Intellect]: 103,
      [Stat.SpellPower]: 140,
      [Stat.CritRating]: 74,
      [Stat.HasteRating]: 90,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Blue, SocketColor.Red],
    SocketBonus: {
      [Stat.SpellPower]: 7,
    },
    Name: 'Crushing Coldwraith Belt',
    Id: 50613,
    Phase: 1,
    ItemSlot: ItemSlot.Waist,
  },
  {
    IconName: 'inv_jewelry_ring_82',
    Stats: {
      [Stat.Stamina]: 78,
      [Stat.Intellect]: 78,
      [Stat.SpellPower]: 110,
      [Stat.CritRating]: 73,
      [Stat.HitRating]: 52,
    },
    Quality: Quality.Epic,
    Unique: true,
    Sockets: [SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    UniqueId: [49977, 50614],
    Phase: 1,
    Name: 'Loop of the Endless Labyrinth',
    Id: 50614,
    ItemSlot: ItemSlot.Finger,
  },
  {
    IconName: 'inv_misc_cape_16',
    Stats: {
      [Stat.Stamina]: 78,
      [Stat.Intellect]: 78,
      [Stat.SpellPower]: 110,
      [Stat.CritRating]: 68,
      [Stat.HasteRating]: 60,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Yellow],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Name: "Frostbinder's Shredded Cape",
    Id: 50628,
    Phase: 1,
    ItemSlot: ItemSlot.Back,
  },
  {
    IconName: 'inv_chest_cloth_77',
    Stats: {
      [Stat.Stamina]: 139,
      [Stat.Intellect]: 139,
      [Stat.SpellPower]: 186,
      [Stat.CritRating]: 122,
      [Stat.HitRating]: 98,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Red, SocketColor.Blue, SocketColor.Yellow],
    SocketBonus: {
      [Stat.SpellPower]: 9,
    },
    Name: 'Robe of the Waking Nightmare',
    Id: 50629,
    Phase: 1,
    ItemSlot: ItemSlot.Chest,
  },
  {
    IconName: 'inv_wand_34',
    Stats: {
      [Stat.Stamina]: 44,
      [Stat.Intellect]: 44,
      [Stat.Spirit]: 30,
      [Stat.SpellPower]: 58,
      [Stat.CritRating]: 38,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Yellow],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Name: 'Nightmare Ender',
    Id: 50631,
    Phase: 1,
    ItemSlot: ItemSlot.Wand,
  },
  {
    IconName: 'inv_offhand_zulaman_d_02',
    Stats: {
      [Stat.Stamina]: 78,
      [Stat.Intellect]: 78,
      [Stat.Spirit]: 68,
      [Stat.SpellPower]: 119,
      [Stat.HasteRating]: 68,
    },
    Quality: Quality.Epic,
    Name: 'Sundial of Eternal Dusk',
    Sources: [ItemSourceName.IcecrownCitadel25Heroic],
    Id: 50635,
    Phase: 1,
    ItemSlot: ItemSlot.OffHand,
  },
  {
    IconName: 'inv_jewelry_ring_40',
    Stats: {
      [Stat.Stamina]: 78,
      [Stat.Intellect]: 78,
      [Stat.Spirit]: 68,
      [Stat.SpellPower]: 110,
      [Stat.HasteRating]: 60,
    },
    Quality: Quality.Epic,
    Unique: true,
    Sockets: [SocketColor.Yellow],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    UniqueId: [50424, 50636],
    Phase: 1,
    Name: 'Memory of Malygos',
    Id: 50636,
    ItemSlot: ItemSlot.Finger,
  },
  {
    IconName: 'inv_shoulder_114',
    Stats: {
      [Stat.Stamina]: 103,
      [Stat.Intellect]: 103,
      [Stat.SpellPower]: 140,
      [Stat.HitRating]: 74,
      [Stat.HasteRating]: 90,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Blue, SocketColor.Red],
    SocketBonus: {
      [Stat.SpellPower]: 7,
    },
    Name: 'Shoulders of Mercy Killing',
    Id: 50643,
    Phase: 1,
    ItemSlot: ItemSlot.Shoulders,
  },
  {
    IconName: 'inv_jewelry_ring_ahnqiraj_05',
    Stats: {
      [Stat.Stamina]: 78,
      [Stat.Intellect]: 78,
      [Stat.Spirit]: 68,
      [Stat.SpellPower]: 110,
      [Stat.CritRating]: 60,
    },
    Quality: Quality.Epic,
    Unique: true,
    Sockets: [SocketColor.Yellow],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    UniqueId: [49990, 50644],
    Phase: 1,
    Name: 'Ring of Maddening Whispers',
    Id: 50644,
    ItemSlot: ItemSlot.Finger,
  },
  {
    IconName: 'inv_staff_109',
    Stats: {
      [Stat.Stamina]: 103,
      [Stat.Intellect]: 115,
      [Stat.SpellPower]: 837,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Red, SocketColor.Blue, SocketColor.Yellow],
    SocketBonus: {
      [Stat.SpellPower]: 9,
    },
    Name: 'Nibelung',
    Sources: [ItemSourceName.IcecrownCitadel25Heroic],
    Id: 50648,
    Phase: 1,
    ItemSlot: ItemSlot.Weapon,
    IsTwoHand: true,
  },
  {
    IconName: 'inv_bracer_44',
    Stats: {
      [Stat.Stamina]: 78,
      [Stat.Intellect]: 78,
      [Stat.SpellPower]: 110,
      [Stat.CritRating]: 73,
      [Stat.HitRating]: 52,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Yellow],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Name: "The Lady's Brittle Bracers",
    Id: 50651,
    Phase: 1,
    ItemSlot: ItemSlot.Wrist,
  },
  {
    IconName: 'item_icecrownnecklaced',
    Stats: {
      [Stat.Stamina]: 78,
      [Stat.Intellect]: 78,
      [Stat.SpellPower]: 110,
      [Stat.HitRating]: 60,
      [Stat.HasteRating]: 68,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Yellow],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Name: 'Amulet of the Silent Eulogy',
    Sources: [ItemSourceName.IcecrownCitadel25Heroic],
    Id: 50658,
    Phase: 1,
    ItemSlot: ItemSlot.Neck,
  },
  {
    IconName: 'inv_helmet_156',
    Stats: {
      [Stat.Stamina]: 139,
      [Stat.Intellect]: 139,
      [Stat.Spirit]: 114,
      [Stat.SpellPower]: 186,
      [Stat.CritRating]: 106,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Meta, SocketColor.Yellow],
    SocketBonus: {
      [Stat.SpellPower]: 9,
    },
    Name: "Corp'rethar Ceremonial Crown",
    Sources: [ItemSourceName.IcecrownCitadel25Heroic],
    Id: 50661,
    Phase: 1,
    ItemSlot: ItemSlot.Head,
  },
  {
    IconName: 'inv_gauntlets_88',
    Stats: {
      [Stat.Stamina]: 103,
      [Stat.Intellect]: 103,
      [Stat.SpellPower]: 140,
      [Stat.HitRating]: 74,
      [Stat.HasteRating]: 90,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Blue, SocketColor.Red],
    SocketBonus: {
      [Stat.SpellPower]: 7,
    },
    Name: "Gunship Captain's Mittens",
    Id: 50663,
    Phase: 1,
    ItemSlot: ItemSlot.Hands,
  },
  {
    IconName: 'inv_jewelry_ring_86',
    Stats: {
      [Stat.Stamina]: 78,
      [Stat.Intellect]: 78,
      [Stat.SpellPower]: 110,
      [Stat.CritRating]: 68,
      [Stat.HasteRating]: 60,
    },
    Quality: Quality.Epic,
    Unique: true,
    Sockets: [SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    UniqueId: [50008, 50664],
    Phase: 1,
    Name: 'Ring of Rapid Ascent',
    Id: 50664,
    ItemSlot: ItemSlot.Finger,
  },
  {
    IconName: 'item_icecrowncape',
    Stats: {
      [Stat.Stamina]: 78,
      [Stat.Intellect]: 78,
      [Stat.Spirit]: 68,
      [Stat.SpellPower]: 110,
      [Stat.HasteRating]: 60,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Name: 'Greatcloak of the Turned Champion',
    Id: 50668,
    Phase: 1,
    ItemSlot: ItemSlot.Back,
  },
  {
    IconName: 'inv_wand_35',
    Stats: {
      [Stat.Stamina]: 44,
      [Stat.Intellect]: 44,
      [Stat.SpellPower]: 58,
      [Stat.CritRating]: 38,
      [Stat.HasteRating]: 30,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Yellow],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Name: 'Corpse-Impaling Spike',
    Id: 50684,
    Phase: 1,
    ItemSlot: ItemSlot.Wand,
  },
  {
    IconName: 'inv_bracer_47',
    Stats: {
      [Stat.Stamina]: 78,
      [Stat.Intellect]: 78,
      [Stat.Spirit]: 68,
      [Stat.SpellPower]: 110,
      [Stat.CritRating]: 60,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Name: "Death Surgeon's Sleeves",
    Id: 50686,
    Phase: 1,
    ItemSlot: ItemSlot.Wrist,
  },
  {
    IconName: 'inv_kilt_cloth_02',
    Stats: {
      [Stat.Stamina]: 139,
      [Stat.Intellect]: 139,
      [Stat.SpellPower]: 185,
      [Stat.HitRating]: 104,
      [Stat.HasteRating]: 116,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Red, SocketColor.Blue, SocketColor.Yellow],
    SocketBonus: {
      [Stat.SpellPower]: 9,
    },
    Name: "Plaguebringer's Stained Pants",
    Id: 50694,
    Phase: 1,
    ItemSlot: ItemSlot.Legs,
  },
  {
    IconName: 'inv_boots_cloth_24',
    Stats: {
      [Stat.Stamina]: 103,
      [Stat.Intellect]: 103,
      [Stat.SpellPower]: 140,
      [Stat.CritRating]: 74,
      [Stat.HasteRating]: 90,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Blue, SocketColor.Red],
    SocketBonus: {
      [Stat.SpellPower]: 7,
    },
    Name: "Plague Scientist's Boots",
    Id: 50699,
    Phase: 1,
    ItemSlot: ItemSlot.Feet,
  },
  {
    IconName: 'inv_jewelry_necklace_49',
    Stats: {
      [Stat.Stamina]: 78,
      [Stat.Intellect]: 78,
      [Stat.SpellPower]: 110,
      [Stat.CritRating]: 60,
      [Stat.Mp5]: 34,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Yellow],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Name: "Holiday's Grace",
    Sources: [ItemSourceName.IcecrownCitadel25Heroic],
    Id: 50700,
    Phase: 1,
    ItemSlot: ItemSlot.Neck,
  },
  {
    IconName: 'inv_belt_68',
    Stats: {
      [Stat.Stamina]: 103,
      [Stat.Intellect]: 103,
      [Stat.Spirit]: 90,
      [Stat.SpellPower]: 140,
      [Stat.CritRating]: 74,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Yellow, SocketColor.Red],
    SocketBonus: {
      [Stat.SpellPower]: 7,
    },
    Name: 'Lingering Illness',
    Id: 50702,
    Phase: 1,
    ItemSlot: ItemSlot.Waist,
  },
  {
    IconName: 'inv_sword_152',
    Stats: {
      [Stat.Stamina]: 76,
      [Stat.Intellect]: 76,
      [Stat.SpellPower]: 836,
      [Stat.HitRating]: 50,
      [Stat.HasteRating]: 66,
    },
    Quality: Quality.Epic,
    Unique: true,
    Sockets: [SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    UniqueId: [50068, 50704],
    Phase: 1,
    Name: 'Rigormortis',
    Sources: [ItemSourceName.IcecrownCitadel25Heroic],
    Id: 50704,
    ItemSlot: ItemSlot.Weapon,
  },
  {
    IconName: 'inv_jewelry_ring_81',
    Stats: {
      [Stat.Stamina]: 78,
      [Stat.Intellect]: 78,
      [Stat.SpellPower]: 110,
      [Stat.HitRating]: 44,
      [Stat.HasteRating]: 78,
    },
    Quality: Quality.Epic,
    Unique: true,
    Sockets: [SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    UniqueId: [50170, 50714],
    Phase: 1,
    Name: "Valanar's Other Signet Ring",
    Id: 50714,
    ItemSlot: ItemSlot.Finger,
  },
  {
    IconName: 'inv_chest_cloth_80',
    Stats: {
      [Stat.Stamina]: 139,
      [Stat.Intellect]: 139,
      [Stat.Spirit]: 122,
      [Stat.SpellPower]: 186,
      [Stat.HasteRating]: 98,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Blue, SocketColor.Red, SocketColor.Yellow],
    SocketBonus: {
      [Stat.SpellPower]: 9,
    },
    Name: 'Sanguine Silk Robes',
    Id: 50717,
    Phase: 1,
    ItemSlot: ItemSlot.Chest,
  },
  {
    IconName: 'inv_misc_thread_01',
    Stats: {
      [Stat.Stamina]: 78,
      [Stat.Intellect]: 78,
      [Stat.SpellPower]: 119,
      [Stat.CritRating]: 68,
      [Stat.HasteRating]: 68,
    },
    Quality: Quality.Epic,
    Name: 'Shadow Silk Spindle',
    Sources: [ItemSourceName.IcecrownCitadel25Heroic],
    Id: 50719,
    Phase: 1,
    ItemSlot: ItemSlot.OffHand,
  },
  {
    IconName: 'inv_jewelry_ring_84',
    Stats: {
      [Stat.Stamina]: 78,
      [Stat.Intellect]: 78,
      [Stat.SpellPower]: 110,
      [Stat.CritRating]: 60,
      [Stat.Mp5]: 34,
    },
    Quality: Quality.Epic,
    Unique: true,
    Sockets: [SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    UniqueId: [50174, 50720],
    Phase: 1,
    Name: 'Incarnadine Band of Mending',
    Id: 50720,
    ItemSlot: ItemSlot.Finger,
  },
  {
    IconName: 'inv_gauntlets_92',
    Stats: {
      [Stat.Stamina]: 103,
      [Stat.Intellect]: 103,
      [Stat.Spirit]: 74,
      [Stat.SpellPower]: 140,
      [Stat.HasteRating]: 90,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Yellow, SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 7,
    },
    Name: "San'layn Ritualist Gloves",
    Id: 50722,
    Phase: 1,
    ItemSlot: ItemSlot.Hands,
  },
  {
    IconName: 'inv_jewelcrafting_crimsonspinel_02',
    Stats: {
      [Stat.Stamina]: 78,
      [Stat.Intellect]: 78,
      [Stat.SpellPower]: 110,
      [Stat.CritRating]: 65,
      [Stat.HasteRating]: 60,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Name: "Blood Queen's Crimson Choker",
    Sources: [ItemSourceName.IcecrownCitadel25Heroic],
    Id: 50724,
    Phase: 1,
    ItemSlot: ItemSlot.Neck,
  },
  {
    IconName: 'inv_staff_106',
    Stats: {
      [Stat.Stamina]: 176,
      [Stat.Intellect]: 176,
      [Stat.Spirit]: 131,
      [Stat.SpellPower]: 837,
      [Stat.HasteRating]: 131,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Yellow, SocketColor.Blue, SocketColor.Red],
    SocketBonus: {
      [Stat.SpellPower]: 9,
    },
    Name: 'Dying Light',
    Sources: [ItemSourceName.IcecrownCitadel25Heroic],
    Id: 50725,
    Phase: 1,
    ItemSlot: ItemSlot.Weapon,
    IsTwoHand: true,
  },
  {
    IconName: 'inv_staff_108',
    Stats: {
      [Stat.Stamina]: 188,
      [Stat.Intellect]: 188,
      [Stat.Spirit]: 141,
      [Stat.SpellPower]: 893,
      [Stat.HasteRating]: 141,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Red, SocketColor.Red, SocketColor.Red],
    SocketBonus: {
      [Stat.SpellPower]: 9,
    },
    Name: 'Archus, Greatstaff of Antonidas',
    Sources: [ItemSourceName.IcecrownCitadel25Heroic],
    Id: 50731,
    Phase: 1,
    ItemSlot: ItemSlot.Weapon,
    IsTwoHand: true,
  },
  {
    IconName: 'inv_sword_150',
    Stats: {
      [Stat.Stamina]: 81,
      [Stat.Intellect]: 81,
      [Stat.SpellPower]: 893,
      [Stat.CritRating]: 55,
      [Stat.HasteRating]: 71,
    },
    Quality: Quality.Epic,
    Unique: true,
    Sockets: [SocketColor.Red],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Name: "Bloodsurge, Kel'Thuzad's Blade of Agony",
    Sources: [ItemSourceName.IcecrownCitadel25Heroic],
    Id: 50732,
    Phase: 1,
    ItemSlot: ItemSlot.Weapon,
  },
  {
    IconName: 'inv_sword_152',
    Stats: {
      [Stat.Stamina]: 59,
      [Stat.Intellect]: 59,
      [Stat.SpellPower]: 657,
      [Stat.HitRating]: 49,
      [Stat.HasteRating]: 54,
    },
    Quality: Quality.Epic,
    Unique: true,
    UniqueId: [50771, 51932],
    Phase: 1,
    Name: 'Frost Needle',
    Sources: [ItemSourceName.IcecrownCitadel10],
    Id: 50771,
    ItemSlot: ItemSlot.Weapon,
  },
  {
    IconName: 'inv_belt_68',
    Stats: {
      [Stat.Stamina]: 81,
      [Stat.Intellect]: 81,
      [Stat.Spirit]: 54,
      [Stat.SpellPower]: 106,
      [Stat.HasteRating]: 68,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Blue, SocketColor.Yellow],
    SocketBonus: {
      [Stat.SpellPower]: 7,
    },
    Name: 'Cord of the Patronizing Practitioner',
    Id: 50773,
    Phase: 1,
    ItemSlot: ItemSlot.Waist,
  },
  {
    IconName: 'inv_misc_bone_elfskull_01',
    Stats: {
      [Stat.Stamina]: 61,
      [Stat.Intellect]: 61,
      [Stat.SpellPower]: 94,
      [Stat.CritRating]: 47,
      [Stat.HitRating]: 57,
    },
    Quality: Quality.Epic,
    Name: "Scourgelord's Baton",
    Sources: [ItemSourceName.IcecrownCitadel10],
    Id: 50781,
    Phase: 1,
    ItemSlot: ItemSlot.OffHand,
  },
  {
    IconName: 'inv_gauntlets_90purple',
    Stats: {
      [Stat.Stamina]: 81,
      [Stat.Intellect]: 81,
      [Stat.SpellPower]: 106,
      [Stat.HitRating]: 71,
      [Stat.HasteRating]: 55,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Yellow, SocketColor.Yellow],
    SocketBonus: {
      [Stat.SpellPower]: 7,
    },
    Name: "Sister's Handshrouds",
    Id: 50782,
    Phase: 1,
    ItemSlot: ItemSlot.Hands,
  },
  {
    IconName: 'inv_bracer_47',
    Stats: {
      [Stat.Stamina]: 61,
      [Stat.Intellect]: 61,
      [Stat.Spirit]: 51,
      [Stat.SpellPower]: 85,
      [Stat.CritRating]: 47,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Blue],
    SocketBonus: {
      [Stat.Spirit]: 4,
    },
    Name: 'Bracers of Dark Blessings',
    Id: 50785,
    Phase: 1,
    ItemSlot: ItemSlot.Wrist,
  },
  {
    IconName: 'inv_weapon_shortblade_103',
    Stats: {
      [Stat.Stamina]: 59,
      [Stat.Intellect]: 59,
      [Stat.SpellPower]: 657,
      [Stat.HasteRating]: 46,
      [Stat.Mp5]: 28,
    },
    Quality: Quality.Epic,
    Unique: true,
    UniqueId: [50793, 51910],
    Phase: 1,
    Name: 'Midnight Sun',
    Sources: [ItemSourceName.IcecrownCitadel10],
    Id: 50793,
    ItemSlot: ItemSlot.Weapon,
  },
  {
    IconName: 'inv_boots_cloth_25purple',
    Stats: {
      [Stat.Stamina]: 81,
      [Stat.Intellect]: 81,
      [Stat.SpellPower]: 106,
      [Stat.CritRating]: 76,
      [Stat.HitRating]: 46,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Yellow, SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 7,
    },
    Name: 'Icecrown Spire Sandals',
    Id: 50804,
    Phase: 1,
    ItemSlot: ItemSlot.Feet,
  },
  {
    IconName: 'inv_staff_107',
    Stats: {
      [Stat.Stamina]: 97,
      [Stat.Intellect]: 101,
      [Stat.Spirit]: 136,
      [Stat.SpellPower]: 657,
      [Stat.HasteRating]: 136,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Blue, SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 7,
    },
    Name: "Mag'hari Chieftain's Staff",
    Sources: [ItemSourceName.IcecrownCitadel10],
    Id: 50805,
    Phase: 1,
    ItemSlot: ItemSlot.Weapon,
    IsTwoHand: true,
  },
  {
    IconName: 'inv_helmet_156',
    Stats: {
      [Stat.Stamina]: 109,
      [Stat.Intellect]: 109,
      [Stat.Spirit]: 88,
      [Stat.SpellPower]: 149,
      [Stat.HasteRating]: 72,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Meta, SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 9,
    },
    Name: "Thaumaturge's Crackling Cowl",
    Sources: [ItemSourceName.IcecrownCitadel10],
    Id: 50807,
    Phase: 1,
    ItemSlot: ItemSlot.Head,
  },
  {
    IconName: 'item_icecrownnecklacea',
    Stats: {
      [Stat.Stamina]: 61,
      [Stat.Intellect]: 61,
      [Stat.SpellPower]: 85,
      [Stat.CritRating]: 55,
      [Stat.HasteRating]: 43,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Yellow],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Name: 'Soulcleave Pendant',
    Sources: [ItemSourceName.IcecrownCitadel10],
    Id: 50809,
    Phase: 1,
    ItemSlot: ItemSlot.Neck,
  },
  {
    IconName: 'inv_staff_107',
    Stats: {
      [Stat.Stamina]: 109,
      [Stat.Intellect]: 128,
      [Stat.SpellPower]: 657,
      [Stat.HitRating]: 101,
      [Stat.HasteRating]: 136,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Red, SocketColor.Blue],
    SocketBonus: {
      [Stat.HasteRating]: 6,
    },
    Name: 'Abracadaver',
    Sources: [ItemSourceName.IcecrownCitadel10],
    Id: 50966,
    Phase: 1,
    ItemSlot: ItemSlot.Weapon,
    IsTwoHand: true,
  },
  {
    IconName: 'inv_chest_cloth_78',
    Stats: {
      [Stat.Stamina]: 123,
      [Stat.Intellect]: 123,
      [Stat.SpellPower]: 162,
      [Stat.CritRating]: 84,
      [Stat.HasteRating]: 108,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Red, SocketColor.Yellow, SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 9,
    },
    Name: "Meteor Chaser's Raiment",
    Id: 50974,
    Phase: 1,
    ItemSlot: ItemSlot.Chest,
  },
  {
    IconName: 'inv_chest_cloth_80',
    Stats: {
      [Stat.Stamina]: 123,
      [Stat.Intellect]: 123,
      [Stat.Spirit]: 84,
      [Stat.SpellPower]: 162,
      [Stat.CritRating]: 108,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Yellow, SocketColor.Red, SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 9,
    },
    Name: 'Ermine Coronation Robes',
    Id: 50975,
    Phase: 1,
    ItemSlot: ItemSlot.Chest,
  },
  {
    IconName: 'inv_gauntlets_90',
    Stats: {
      [Stat.Stamina]: 92,
      [Stat.Intellect]: 92,
      [Stat.SpellPower]: 122,
      [Stat.CritRating]: 80,
      [Stat.HasteRating]: 64,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Yellow, SocketColor.Yellow],
    SocketBonus: {
      [Stat.SpellPower]: 7,
    },
    Name: 'Gloves of False Gestures',
    Id: 50983,
    Phase: 1,
    ItemSlot: ItemSlot.Hands,
  },
  {
    IconName: 'inv_gauntlets_92',
    Stats: {
      [Stat.Stamina]: 92,
      [Stat.Intellect]: 92,
      [Stat.Spirit]: 80,
      [Stat.SpellPower]: 122,
      [Stat.CritRating]: 64,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Yellow, SocketColor.Yellow],
    SocketBonus: {
      [Stat.SpellPower]: 7,
    },
    Name: 'Gloves of Ambivalence',
    Id: 50984,
    Phase: 1,
    ItemSlot: ItemSlot.Hands,
  },
  {
    IconName: 'inv_jewelry_ring_82',
    Stats: {
      [Stat.Stamina]: 61,
      [Stat.Intellect]: 61,
      [Stat.SpellPower]: 85,
      [Stat.HasteRating]: 45,
      [Stat.Mp5]: 27,
    },
    Quality: Quality.Epic,
    Unique: true,
    Sockets: [SocketColor.Red],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    UniqueId: [50986, 51884],
    Phase: 1,
    Name: 'Signet of Putrefaction',
    Id: 50986,
    ItemSlot: ItemSlot.Finger,
  },
  {
    IconName: 'inv_shoulder_119',
    Stats: {
      [Stat.Stamina]: 81,
      [Stat.Intellect]: 81,
      [Stat.Spirit]: 75,
      [Stat.SpellPower]: 106,
      [Stat.CritRating]: 48,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Yellow, SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 7,
    },
    Name: "Bloodstained Surgeon's Shoulderguards",
    Id: 50988,
    Phase: 1,
    ItemSlot: ItemSlot.Shoulders,
  },
  {
    IconName: 'inv_pants_cloth_34purple',
    Stats: {
      [Stat.Stamina]: 109,
      [Stat.Intellect]: 109,
      [Stat.SpellPower]: 140,
      [Stat.CritRating]: 84,
      [Stat.HasteRating]: 84,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Yellow, SocketColor.Yellow, SocketColor.Red],
    SocketBonus: {
      [Stat.SpellPower]: 9,
    },
    Name: 'Kilt of Untreated Wounds',
    Id: 50990,
    Phase: 1,
    ItemSlot: ItemSlot.Legs,
  },
  {
    IconName: 'inv_belt_66',
    Stats: {
      [Stat.Stamina]: 92,
      [Stat.Intellect]: 92,
      [Stat.SpellPower]: 122,
      [Stat.CritRating]: 80,
      [Stat.HitRating]: 64,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Red, SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 7,
    },
    Name: 'Belt of Omission',
    Id: 50996,
    Phase: 1,
    ItemSlot: ItemSlot.Waist,
  },
  {
    IconName: 'inv_belt_68',
    Stats: {
      [Stat.Stamina]: 92,
      [Stat.Intellect]: 92,
      [Stat.Spirit]: 64,
      [Stat.SpellPower]: 122,
      [Stat.HasteRating]: 80,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Blue, SocketColor.Red],
    SocketBonus: {
      [Stat.SpellPower]: 7,
    },
    Name: 'Circle of Ossus',
    Id: 50997,
    Phase: 1,
    ItemSlot: ItemSlot.Waist,
  },
  {
    IconName: 'inv_gauntlets_92',
    Stats: {
      [Stat.Stamina]: 81,
      [Stat.Intellect]: 81,
      [Stat.Spirit]: 46,
      [Stat.SpellPower]: 106,
      [Stat.HasteRating]: 76,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Blue, SocketColor.Red],
    Name: 'Gloves of Broken Fingers',
    Id: 51005,
    Phase: 1,
    ItemSlot: ItemSlot.Hands,
  },
  {
    IconName: 'inv_bracer_45purple',
    Stats: {
      [Stat.Stamina]: 61,
      [Stat.Intellect]: 61,
      [Stat.SpellPower]: 94,
      [Stat.HitRating]: 40,
      [Stat.HasteRating]: 61,
    },
    Quality: Quality.Epic,
    Name: 'Ether-Soaked Bracers',
    Id: 51007,
    Phase: 1,
    ItemSlot: ItemSlot.Wrist,
  },
  {
    IconName: 'inv_jewelry_necklace_49',
    Stats: {
      [Stat.Stamina]: 63,
      [Stat.Intellect]: 60,
      [Stat.SpellPower]: 85,
      [Stat.HasteRating]: 53,
      [Stat.Mp5]: 23,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Name: 'Choker of Filthy Diamonds',
    Sources: [ItemSourceName.IcecrownCitadel10],
    Id: 51008,
    Phase: 1,
    ItemSlot: ItemSlot.Neck,
  },
  {
    IconName: 'inv_jewelry_talisman_16',
    Stats: {
      [Stat.Stamina]: 63,
      [Stat.Intellect]: 60,
      [Stat.SpellPower]: 85,
      [Stat.CritRating]: 53,
      [Stat.HitRating]: 45,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Name: 'Pendant of Split Veins',
    Sources: [ItemSourceName.IcecrownCitadel10],
    Id: 51016,
    Phase: 1,
    ItemSlot: ItemSlot.Neck,
  },
  {
    IconName: 'inv_belt_66green',
    Stats: {
      [Stat.Stamina]: 81,
      [Stat.Intellect]: 81,
      [Stat.SpellPower]: 106,
      [Stat.CritRating]: 76,
      [Stat.HasteRating]: 46,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Yellow, SocketColor.Red],
    SocketBonus: {
      [Stat.SpellPower]: 7,
    },
    Name: 'Cauterized Cord',
    Id: 51017,
    Phase: 1,
    ItemSlot: ItemSlot.Waist,
  },
  {
    IconName: 'inv_shoulder_116purple',
    Stats: {
      [Stat.Stamina]: 81,
      [Stat.Intellect]: 81,
      [Stat.SpellPower]: 106,
      [Stat.HitRating]: 55,
      [Stat.HasteRating]: 71,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Yellow, SocketColor.Yellow],
    SocketBonus: {
      [Stat.SpellPower]: 7,
    },
    Name: 'Shoulders of Ruinous Senility',
    Id: 51020,
    Phase: 1,
    ItemSlot: ItemSlot.Shoulders,
  },
  {
    IconName: 'inv_shoulder_114',
    Stats: {
      [Stat.Stamina]: 92,
      [Stat.Intellect]: 92,
      [Stat.SpellPower]: 132,
      [Stat.CritRating]: 80,
      [Stat.HasteRating]: 72,
    },
    Quality: Quality.Epic,
    Set: ItemSet.T10,
    Sockets: [SocketColor.Yellow],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Name: 'Sanctified Dark Coven Shoulderpads',
    Id: 51205,
    Phase: 1,
    ItemSlot: ItemSlot.Shoulders,
  },
  {
    IconName: 'inv_chest_cloth_77',
    Stats: {
      [Stat.Stamina]: 123,
      [Stat.Intellect]: 123,
      [Stat.SpellPower]: 171,
      [Stat.CritRating]: 108,
      [Stat.HasteRating]: 92,
    },
    Quality: Quality.Epic,
    Set: ItemSet.T10,
    Sockets: [SocketColor.Red, SocketColor.Yellow],
    SocketBonus: {
      [Stat.SpellPower]: 7,
    },
    Name: 'Sanctified Dark Coven Robe',
    Id: 51206,
    Phase: 1,
    ItemSlot: ItemSlot.Chest,
  },
  {
    IconName: 'inv_kilt_cloth_02',
    Stats: {
      [Stat.Stamina]: 123,
      [Stat.Intellect]: 123,
      [Stat.SpellPower]: 171,
      [Stat.CritRating]: 108,
      [Stat.HitRating]: 92,
    },
    Quality: Quality.Epic,
    Set: ItemSet.T10,
    Sockets: [SocketColor.Blue, SocketColor.Yellow],
    SocketBonus: {
      [Stat.SpellPower]: 7,
    },
    Name: 'Sanctified Dark Coven Leggings',
    Id: 51207,
    Phase: 1,
    ItemSlot: ItemSlot.Legs,
  },
  {
    IconName: 'inv_helmet_152',
    Stats: {
      [Stat.Stamina]: 123,
      [Stat.Intellect]: 123,
      [Stat.SpellPower]: 162,
      [Stat.CritRating]: 100,
      [Stat.HasteRating]: 92,
    },
    Quality: Quality.Epic,
    Set: ItemSet.T10,
    Sockets: [SocketColor.Meta, SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 9,
    },
    Name: 'Sanctified Dark Coven Hood',
    Sources: [
      ItemSourceName.IcecrownCitadel10Heroic,
      ItemSourceName.IcecrownCitadel25,
    ],
    Id: 51208,
    Phase: 1,
    ItemSlot: ItemSlot.Head,
  },
  {
    IconName: 'inv_gauntlets_88',
    Stats: {
      [Stat.Stamina]: 92,
      [Stat.Intellect]: 92,
      [Stat.SpellPower]: 132,
      [Stat.CritRating]: 80,
      [Stat.HitRating]: 72,
    },
    Quality: Quality.Epic,
    Set: ItemSet.T10,
    Sockets: [SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Name: 'Sanctified Dark Coven Gloves',
    Id: 51209,
    Phase: 1,
    ItemSlot: ItemSlot.Hands,
  },
  {
    IconName: 'inv_gauntlets_88',
    Stats: {
      [Stat.Stamina]: 103,
      [Stat.Intellect]: 103,
      [Stat.SpellPower]: 150,
      [Stat.CritRating]: 90,
      [Stat.HitRating]: 82,
    },
    Quality: Quality.Epic,
    Set: ItemSet.T10,
    Sockets: [SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Name: 'Sanctified Dark Coven Gloves',
    Id: 51230,
    Phase: 1,
    ItemSlot: ItemSlot.Hands,
  },
  {
    IconName: 'inv_helmet_152',
    Stats: {
      [Stat.Stamina]: 139,
      [Stat.Intellect]: 139,
      [Stat.SpellPower]: 186,
      [Stat.CritRating]: 114,
      [Stat.HasteRating]: 106,
    },
    Quality: Quality.Epic,
    Set: ItemSet.T10,
    Sockets: [SocketColor.Meta, SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 9,
    },
    Name: 'Sanctified Dark Coven Hood',
    Sources: [ItemSourceName.IcecrownCitadel25Heroic],
    Id: 51231,
    Phase: 1,
    ItemSlot: ItemSlot.Head,
  },
  {
    IconName: 'inv_kilt_cloth_02',
    Stats: {
      [Stat.Stamina]: 139,
      [Stat.Intellect]: 139,
      [Stat.SpellPower]: 195,
      [Stat.CritRating]: 122,
      [Stat.HitRating]: 106,
    },
    Quality: Quality.Epic,
    Set: ItemSet.T10,
    Sockets: [SocketColor.Blue, SocketColor.Yellow],
    SocketBonus: {
      [Stat.SpellPower]: 7,
    },
    Name: 'Sanctified Dark Coven Leggings',
    Id: 51232,
    Phase: 1,
    ItemSlot: ItemSlot.Legs,
  },
  {
    IconName: 'inv_chest_cloth_77',
    Stats: {
      [Stat.Stamina]: 139,
      [Stat.Intellect]: 139,
      [Stat.SpellPower]: 195,
      [Stat.CritRating]: 122,
      [Stat.HasteRating]: 106,
    },
    Quality: Quality.Epic,
    Set: ItemSet.T10,
    Sockets: [SocketColor.Red, SocketColor.Yellow],
    SocketBonus: {
      [Stat.SpellPower]: 7,
    },
    Name: 'Sanctified Dark Coven Robe',
    Id: 51233,
    Phase: 1,
    ItemSlot: ItemSlot.Chest,
  },
  {
    IconName: 'inv_shoulder_114',
    Stats: {
      [Stat.Stamina]: 103,
      [Stat.Intellect]: 103,
      [Stat.SpellPower]: 150,
      [Stat.CritRating]: 90,
      [Stat.HasteRating]: 82,
    },
    Quality: Quality.Epic,
    Set: ItemSet.T10,
    Sockets: [SocketColor.Yellow],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Name: 'Sanctified Dark Coven Shoulderpads',
    Id: 51234,
    Phase: 1,
    ItemSlot: ItemSlot.Shoulders,
  },
  {
    IconName: 'inv_wand_34',
    Stats: {
      [Stat.Stamina]: 43,
      [Stat.Intellect]: 31,
      [Stat.SpellPower]: 53,
      [Stat.HitRating]: 33,
      [Stat.HasteRating]: 25,
    },
    Quality: Quality.Epic,
    Name: 'Wand of Ruby Claret',
    Id: 51326,
    Phase: 1,
    ItemSlot: ItemSlot.Wand,
  },
  {
    IconName: 'inv_misc_cape_20',
    Stats: {
      [Stat.Stamina]: 103,
      [Stat.Intellect]: 46,
      [Stat.SpellPower]: 106,
      [Stat.CritRating]: 60,
      [Stat.ResilienceRating]: 60,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: "Wrathful Gladiator's Cloak of Dominance",
    Id: 51330,
    Phase: 1,
    ItemSlot: ItemSlot.Back,
  },
  {
    IconName: 'inv_jewelry_necklace_36',
    Stats: {
      [Stat.Stamina]: 103,
      [Stat.Intellect]: 46,
      [Stat.SpellPower]: 106,
      [Stat.CritRating]: 60,
      [Stat.ResilienceRating]: 60,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: "Wrathful Gladiator's Pendant of Dominance",
    Id: 51331,
    Phase: 1,
    ItemSlot: ItemSlot.Neck,
  },
  {
    IconName: 'inv_misc_cape_16',
    Stats: {
      [Stat.Stamina]: 103,
      [Stat.Intellect]: 46,
      [Stat.SpellPower]: 106,
      [Stat.ResilienceRating]: 60,
      [Stat.HasteRating]: 60,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: "Wrathful Gladiator's Cloak of Subjugation",
    Id: 51332,
    Phase: 1,
    ItemSlot: ItemSlot.Back,
  },
  {
    IconName: 'inv_jewelry_necklace_36',
    Stats: {
      [Stat.Stamina]: 103,
      [Stat.Intellect]: 46,
      [Stat.SpellPower]: 106,
      [Stat.ResilienceRating]: 60,
      [Stat.HasteRating]: 60,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: "Wrathful Gladiator's Pendant of Subjugation",
    Id: 51333,
    Phase: 1,
    ItemSlot: ItemSlot.Neck,
  },
  {
    IconName: 'inv_misc_cape_06',
    Stats: {
      [Stat.Stamina]: 103,
      [Stat.Intellect]: 46,
      [Stat.SpellPower]: 106,
      [Stat.HitRating]: 60,
      [Stat.ResilienceRating]: 60,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: "Wrathful Gladiator's Cloak of Ascendancy",
    Id: 51334,
    Phase: 1,
    ItemSlot: ItemSlot.Back,
  },
  {
    IconName: 'inv_jewelry_necklace_36',
    Stats: {
      [Stat.Stamina]: 103,
      [Stat.Intellect]: 46,
      [Stat.SpellPower]: 106,
      [Stat.HitRating]: 60,
      [Stat.ResilienceRating]: 60,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: "Wrathful Gladiator's Pendant of Ascendancy",
    Id: 51335,
    Phase: 1,
    ItemSlot: ItemSlot.Neck,
  },
  {
    IconName: 'inv_jewelry_ring_60',
    Stats: {
      [Stat.Stamina]: 103,
      [Stat.Intellect]: 46,
      [Stat.SpellPower]: 106,
      [Stat.CritRating]: 60,
      [Stat.ResilienceRating]: 60,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: "Wrathful Gladiator's Band of Dominance",
    Id: 51336,
    Phase: 1,
    ItemSlot: ItemSlot.Finger,
  },
  {
    IconName: 'inv_misc_cape_16',
    Stats: {
      [Stat.Stamina]: 103,
      [Stat.Intellect]: 46,
      [Stat.SpellPower]: 106,
      [Stat.ResilienceRating]: 60,
      [Stat.Mp5]: 30,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: "Wrathful Gladiator's Cloak of Salvation",
    Id: 51346,
    Phase: 1,
    ItemSlot: ItemSlot.Back,
  },
  {
    IconName: 'inv_jewelry_necklace_36',
    Stats: {
      [Stat.Stamina]: 103,
      [Stat.Intellect]: 46,
      [Stat.SpellPower]: 106,
      [Stat.ResilienceRating]: 60,
      [Stat.Mp5]: 30,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: "Wrathful Gladiator's Pendant of Salvation",
    Id: 51347,
    Phase: 1,
    ItemSlot: ItemSlot.Neck,
  },
  {
    IconName: 'inv_misc_cape_20',
    Stats: {
      [Stat.Stamina]: 103,
      [Stat.Intellect]: 46,
      [Stat.Spirit]: 60,
      [Stat.SpellPower]: 106,
      [Stat.ResilienceRating]: 60,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: "Wrathful Gladiator's Cloak of Deliverance",
    Id: 51348,
    Phase: 1,
    ItemSlot: ItemSlot.Back,
  },
  {
    IconName: 'inv_jewelry_necklace_36',
    Stats: {
      [Stat.Stamina]: 103,
      [Stat.Intellect]: 46,
      [Stat.Spirit]: 60,
      [Stat.SpellPower]: 106,
      [Stat.ResilienceRating]: 60,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: "Wrathful Gladiator's Pendant of Deliverance",
    Id: 51349,
    Phase: 1,
    ItemSlot: ItemSlot.Neck,
  },
  {
    IconName: 'inv_chest_cloth_80',
    Stats: {
      [Stat.Stamina]: 109,
      [Stat.Intellect]: 109,
      [Stat.Spirit]: 78,
      [Stat.SpellPower]: 140,
      [Stat.HasteRating]: 90,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Red, SocketColor.Red, SocketColor.Yellow],
    SocketBonus: {
      [Stat.SpellPower]: 9,
    },
    Name: 'Bloodsoul Raiment',
    Id: 51379,
    Phase: 1,
    ItemSlot: ItemSlot.Chest,
  },
  {
    IconName: 'inv_boots_cloth_27',
    Stats: {
      [Stat.Stamina]: 81,
      [Stat.Intellect]: 81,
      [Stat.Spirit]: 55,
      [Stat.SpellPower]: 106,
      [Stat.CritRating]: 71,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Blue, SocketColor.Yellow],
    SocketBonus: {
      [Stat.Spirit]: 6,
    },
    Name: 'Pale Corpse Boots',
    Id: 51380,
    Phase: 1,
    ItemSlot: ItemSlot.Feet,
  },
  {
    IconName: 'item_icecrownringc',
    Stats: {
      [Stat.Stamina]: 57,
      [Stat.Intellect]: 62,
      [Stat.SpellPower]: 85,
      [Stat.CritRating]: 59,
      [Stat.HasteRating]: 35,
    },
    Quality: Quality.Epic,
    Unique: true,
    Sockets: [SocketColor.Red],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    UniqueId: [51381, 51849],
    Phase: 1,
    Name: 'Cerise Coiled Ring',
    Id: 51381,
    ItemSlot: ItemSlot.Finger,
  },
  {
    IconName: 'inv_misc_cape_20',
    Stats: {
      [Stat.Stamina]: 61,
      [Stat.Intellect]: 61,
      [Stat.SpellPower]: 85,
      [Stat.HasteRating]: 45,
      [Stat.Mp5]: 27,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Red],
    SocketBonus: {
      [Stat.Mp5]: 2,
    },
    Name: "Heartsick Mender's Cape",
    Id: 51382,
    Phase: 1,
    ItemSlot: ItemSlot.Back,
  },
  {
    IconName: 'inv_misc_book_06',
    Stats: {
      [Stat.Stamina]: 109,
      [Stat.Intellect]: 48,
      [Stat.SpellPower]: 111,
      [Stat.CritRating]: 63,
      [Stat.ResilienceRating]: 63,
    },
    Quality: Quality.Epic,
    Name: "Wrathful Gladiator's Endgame",
    Id: 51396,
    Phase: 1,
    ItemSlot: ItemSlot.OffHand,
  },
  {
    IconName: 'inv_weapon_shortblade_107',
    Stats: {
      [Stat.Stamina]: 88,
      [Stat.Intellect]: 59,
      [Stat.SpellPower]: 738,
      [Stat.CritRating]: 51,
      [Stat.ResilienceRating]: 51,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Name: "Wrathful Gladiator's Spellblade",
    Id: 51397,
    Phase: 1,
    ItemSlot: ItemSlot.Weapon,
  },
  {
    IconName: 'inv_weapon_shortblade_107',
    Stats: {
      [Stat.Stamina]: 99,
      [Stat.Intellect]: 66,
      [Stat.SpellPower]: 836,
      [Stat.ResilienceRating]: 58,
      [Stat.HasteRating]: 58,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Name: "Wrathful Gladiator's Blade of Celerity",
    Id: 51398,
    Phase: 1,
    ItemSlot: ItemSlot.Weapon,
  },
  {
    IconName: 'inv_weapon_shortblade_107',
    Stats: {
      [Stat.Stamina]: 99,
      [Stat.Intellect]: 66,
      [Stat.SpellPower]: 836,
      [Stat.CritRating]: 58,
      [Stat.ResilienceRating]: 58,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Name: "Wrathful Gladiator's Mageblade",
    Id: 51399,
    Phase: 1,
    ItemSlot: ItemSlot.Weapon,
  },
  {
    IconName: 'inv_staff_112',
    Stats: {
      [Stat.Stamina]: 234,
      [Stat.Intellect]: 104,
      [Stat.SpellPower]: 741,
      [Stat.ResilienceRating]: 121,
      [Stat.HasteRating]: 121,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Red, SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 7,
    },
    Name: "Wrathful Gladiator's War Staff",
    Id: 51400,
    Phase: 1,
    ItemSlot: ItemSlot.Weapon,
    IsTwoHand: true,
  },
  {
    IconName: 'inv_staff_112',
    Stats: {
      [Stat.Stamina]: 265,
      [Stat.Intellect]: 118,
      [Stat.SpellPower]: 838,
      [Stat.ResilienceRating]: 139,
      [Stat.HasteRating]: 139,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Red, SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 7,
    },
    Name: "Wrathful Gladiator's Combat Staff",
    Id: 51401,
    Phase: 1,
    ItemSlot: ItemSlot.Weapon,
    IsTwoHand: true,
  },
  {
    IconName: 'inv_staff_111',
    Stats: {
      [Stat.Stamina]: 234,
      [Stat.Intellect]: 104,
      [Stat.SpellPower]: 741,
      [Stat.HitRating]: 121,
      [Stat.ResilienceRating]: 121,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Red, SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 7,
    },
    Name: "Wrathful Gladiator's Focus Staff",
    Id: 51402,
    Phase: 1,
    ItemSlot: ItemSlot.Weapon,
    IsTwoHand: true,
  },
  {
    IconName: 'inv_staff_111',
    Stats: {
      [Stat.Stamina]: 265,
      [Stat.Intellect]: 118,
      [Stat.SpellPower]: 838,
      [Stat.HitRating]: 139,
      [Stat.ResilienceRating]: 139,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Red, SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 7,
    },
    Name: "Wrathful Gladiator's Acute Staff",
    Id: 51403,
    Phase: 1,
    ItemSlot: ItemSlot.Weapon,
    IsTwoHand: true,
  },
  {
    IconName: 'inv_staff_112',
    Stats: {
      [Stat.Stamina]: 234,
      [Stat.Intellect]: 104,
      [Stat.SpellPower]: 741,
      [Stat.CritRating]: 121,
      [Stat.ResilienceRating]: 121,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Red, SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 7,
    },
    Name: "Wrathful Gladiator's Battle Staff",
    Id: 51404,
    Phase: 1,
    ItemSlot: ItemSlot.Weapon,
    IsTwoHand: true,
  },
  {
    IconName: 'inv_staff_112',
    Stats: {
      [Stat.Stamina]: 265,
      [Stat.Intellect]: 118,
      [Stat.SpellPower]: 838,
      [Stat.CritRating]: 139,
      [Stat.ResilienceRating]: 139,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Red, SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 7,
    },
    Name: "Wrathful Gladiator's Skirmish Staff",
    Id: 51405,
    Phase: 1,
    ItemSlot: ItemSlot.Weapon,
    IsTwoHand: true,
  },
  {
    IconName: 'inv_weapon_shortblade_107',
    Stats: {
      [Stat.Stamina]: 88,
      [Stat.Intellect]: 59,
      [Stat.SpellPower]: 738,
      [Stat.ResilienceRating]: 51,
      [Stat.HasteRating]: 51,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Name: "Wrathful Gladiator's Blade of Alacrity",
    Id: 51406,
    Phase: 1,
    ItemSlot: ItemSlot.Weapon,
  },
  {
    IconName: 'inv_misc_book_06',
    Stats: {
      [Stat.Stamina]: 109,
      [Stat.Intellect]: 48,
      [Stat.SpellPower]: 111,
      [Stat.ResilienceRating]: 63,
      [Stat.HasteRating]: 63,
    },
    Quality: Quality.Epic,
    Name: "Wrathful Gladiator's Compendium",
    Id: 51407,
    Phase: 1,
    ItemSlot: ItemSlot.OffHand,
  },
  {
    IconName: 'inv_misc_book_06',
    Stats: {
      [Stat.Stamina]: 109,
      [Stat.Intellect]: 48,
      [Stat.SpellPower]: 111,
      [Stat.SpellPenetration]: 79,
      [Stat.ResilienceRating]: 63,
    },
    Quality: Quality.Epic,
    Name: "Wrathful Gladiator's Grimoire",
    Id: 51408,
    Phase: 1,
    ItemSlot: ItemSlot.OffHand,
  },
  {
    IconName: 'inv_misc_book_06',
    Stats: {
      [Stat.Stamina]: 109,
      [Stat.Intellect]: 48,
      [Stat.Spirit]: 63,
      [Stat.SpellPower]: 111,
      [Stat.ResilienceRating]: 63,
    },
    Quality: Quality.Epic,
    Name: "Wrathful Gladiator's Reprieve",
    Id: 51409,
    Phase: 1,
    ItemSlot: ItemSlot.OffHand,
  },
  {
    IconName: 'inv_wand_36',
    Stats: {
      [Stat.Stamina]: 58,
      [Stat.Intellect]: 26,
      [Stat.SpellPower]: 60,
      [Stat.CritRating]: 34,
      [Stat.ResilienceRating]: 34,
    },
    Quality: Quality.Epic,
    Name: "Wrathful Gladiator's Touch of Defeat",
    Id: 51410,
    Phase: 1,
    ItemSlot: ItemSlot.Wand,
  },
  {
    IconName: 'inv_wand_36',
    Stats: {
      [Stat.Stamina]: 58,
      [Stat.Intellect]: 26,
      [Stat.SpellPower]: 60,
      [Stat.ResilienceRating]: 34,
      [Stat.HasteRating]: 34,
    },
    Quality: Quality.Epic,
    Name: "Wrathful Gladiator's Wand of Alacrity",
    Id: 51451,
    Phase: 1,
    ItemSlot: ItemSlot.Wand,
  },
  {
    IconName: 'inv_staff_112',
    Stats: {
      [Stat.Stamina]: 234,
      [Stat.Intellect]: 104,
      [Stat.Spirit]: 120,
      [Stat.SpellPower]: 741,
      [Stat.ResilienceRating]: 120,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Red, SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 7,
    },
    Name: "Wrathful Gladiator's Energy Staff",
    Id: 51456,
    Phase: 1,
    ItemSlot: ItemSlot.Weapon,
    IsTwoHand: true,
  },
  {
    IconName: 'inv_staff_112',
    Stats: {
      [Stat.Stamina]: 265,
      [Stat.Intellect]: 118,
      [Stat.Spirit]: 139,
      [Stat.SpellPower]: 838,
      [Stat.ResilienceRating]: 139,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Red, SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 7,
    },
    Name: "Wrathful Gladiator's Light Staff",
    Id: 51457,
    Phase: 1,
    ItemSlot: ItemSlot.Weapon,
    IsTwoHand: true,
  },
  {
    IconName: 'inv_wand_36',
    Stats: {
      [Stat.Stamina]: 58,
      [Stat.Intellect]: 26,
      [Stat.SpellPower]: 60,
      [Stat.SpellPenetration]: 43,
      [Stat.ResilienceRating]: 34,
    },
    Quality: Quality.Epic,
    Name: "Wrathful Gladiator's Piercing Touch",
    Id: 51531,
    Phase: 1,
    ItemSlot: ItemSlot.Wand,
  },
  {
    IconName: 'inv_wand_36',
    Stats: {
      [Stat.Stamina]: 58,
      [Stat.Intellect]: 26,
      [Stat.Spirit]: 34,
      [Stat.SpellPower]: 60,
      [Stat.ResilienceRating]: 34,
    },
    Quality: Quality.Epic,
    Name: "Wrathful Gladiator's Baton of Light",
    Id: 51532,
    Phase: 1,
    ItemSlot: ItemSlot.Wand,
  },
  {
    IconName: 'inv_chest_cloth_85',
    Stats: {
      [Stat.Stamina]: 195,
      [Stat.Intellect]: 87,
      [Stat.SpellPower]: 182,
      [Stat.CritRating]: 98,
      [Stat.ResilienceRating]: 114,
    },
    Quality: Quality.Epic,
    Set: ItemSet.GladiatorsFelshroud,
    Sockets: [SocketColor.Red, SocketColor.Yellow],
    SocketBonus: {
      [Stat.Stamina]: 9,
    },
    Name: "Wrathful Gladiator's Felweave Raiment",
    Id: 51536,
    Phase: 1,
    ItemSlot: ItemSlot.Chest,
  },
  {
    IconName: 'inv_gauntlets_94',
    Stats: {
      [Stat.Stamina]: 145,
      [Stat.Intellect]: 64,
      [Stat.SpellPower]: 140,
      [Stat.CritRating]: 77,
      [Stat.ResilienceRating]: 85,
    },
    Quality: Quality.Epic,
    Set: ItemSet.GladiatorsFelshroud,
    Sockets: [SocketColor.Blue],
    Name: "Wrathful Gladiator's Felweave Handguards",
    Id: 51537,
    Phase: 1,
    ItemSlot: ItemSlot.Hands,
  },
  {
    IconName: 'inv_helmet_168',
    Stats: {
      [Stat.Stamina]: 195,
      [Stat.Intellect]: 87,
      [Stat.SpellPower]: 182,
      [Stat.CritRating]: 98,
      [Stat.ResilienceRating]: 98,
    },
    Quality: Quality.Epic,
    Set: ItemSet.GladiatorsFelshroud,
    Sockets: [SocketColor.Meta, SocketColor.Red],
    SocketBonus: {
      [Stat.ResilienceRating]: 8,
    },
    Name: "Wrathful Gladiator's Felweave Cowl",
    Id: 51538,
    Phase: 1,
    ItemSlot: ItemSlot.Head,
  },
  {
    IconName: 'inv_pants_cloth_35',
    Stats: {
      [Stat.Stamina]: 195,
      [Stat.Intellect]: 87,
      [Stat.SpellPower]: 182,
      [Stat.CritRating]: 98,
      [Stat.ResilienceRating]: 114,
    },
    Quality: Quality.Epic,
    Set: ItemSet.GladiatorsFelshroud,
    Sockets: [SocketColor.Red, SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 7,
    },
    Name: "Wrathful Gladiator's Felweave Trousers",
    Id: 51539,
    Phase: 1,
    ItemSlot: ItemSlot.Legs,
  },
  {
    IconName: 'inv_shoulder_132',
    Stats: {
      [Stat.Stamina]: 145,
      [Stat.Intellect]: 64,
      [Stat.SpellPower]: 140,
      [Stat.CritRating]: 77,
      [Stat.ResilienceRating]: 85,
    },
    Quality: Quality.Epic,
    Set: ItemSet.GladiatorsFelshroud,
    Sockets: [SocketColor.Yellow],
    SocketBonus: {
      [Stat.Stamina]: 6,
    },
    Name: "Wrathful Gladiator's Felweave Amice",
    Id: 51540,
    Phase: 1,
    ItemSlot: ItemSlot.Shoulders,
  },
  {
    IconName: 'inv_wand_35',
    Stats: {
      [Stat.Stamina]: 43,
      [Stat.Intellect]: 31,
      [Stat.Spirit]: 33,
      [Stat.SpellPower]: 53,
      [Stat.CritRating]: 25,
    },
    Quality: Quality.Epic,
    Name: "Lana'thel's Bloody Nail",
    Id: 51553,
    Phase: 1,
    ItemSlot: ItemSlot.Wand,
  },
  {
    IconName: 'inv_helmet_150purple',
    Stats: {
      [Stat.Stamina]: 109,
      [Stat.Intellect]: 109,
      [Stat.SpellPower]: 140,
      [Stat.CritRating]: 72,
      [Stat.HasteRating]: 96,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Meta, SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 9,
    },
    Name: 'Cowl of Malefic Repose',
    Sources: [ItemSourceName.IcecrownCitadel10],
    Id: 51554,
    Phase: 1,
    ItemSlot: ItemSlot.Head,
  },
  {
    IconName: 'inv_jewelry_ring_73',
    Stats: {
      [Stat.Stamina]: 78,
      [Stat.Intellect]: 54,
      [Stat.SpellPower]: 94,
      [Stat.CritRating]: 53,
      [Stat.HasteRating]: 54,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: 'Runed Signet of the Kirin Tor',
    Id: 51557,
    Phase: 1,
    ItemSlot: ItemSlot.Finger,
  },
  {
    IconName: 'inv_jewelry_ring_73',
    Stats: {
      [Stat.Stamina]: 78,
      [Stat.Intellect]: 54,
      [Stat.Spirit]: 54,
      [Stat.SpellPower]: 94,
      [Stat.Mp5]: 27,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: 'Runed Loop of the Kirin Tor',
    Id: 51558,
    Phase: 1,
    ItemSlot: ItemSlot.Finger,
  },
  {
    IconName: 'inv_jewelry_necklace_36',
    Stats: {
      [Stat.Stamina]: 86,
      [Stat.Intellect]: 38,
      [Stat.SpellPower]: 80,
      [Stat.ResilienceRating]: 50,
      [Stat.HasteRating]: 42,
    },
    Quality: Quality.Epic,
    Unique: true,
    Sockets: [SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Name: 'Titan-Forged Pendant of Ascendancy',
    Id: 51568,
    Phase: 1,
    ItemSlot: ItemSlot.Neck,
  },
  {
    IconName: 'inv_misc_cape_16',
    Stats: {
      [Stat.Stamina]: 86,
      [Stat.Intellect]: 38,
      [Stat.SpellPower]: 80,
      [Stat.ResilienceRating]: 50,
      [Stat.HasteRating]: 42,
    },
    Quality: Quality.Epic,
    Unique: true,
    Sockets: [SocketColor.Yellow],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Name: 'Titan-Forged Cloak of Ascendancy',
    Id: 51570,
    Phase: 1,
    ItemSlot: ItemSlot.Back,
  },
  {
    IconName: 'inv_staff_106',
    Stats: {
      [Stat.Stamina]: 109,
      [Stat.Intellect]: 128,
      [Stat.SpellPower]: 657,
      [Stat.CritRating]: 101,
      [Stat.HitRating]: 136,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Red, SocketColor.Yellow],
    SocketBonus: {
      [Stat.SpellPower]: 7,
    },
    Name: "Sister Svalna's Aether Staff",
    Sources: [ItemSourceName.IcecrownCitadel10],
    Id: 51582,
    Phase: 1,
    ItemSlot: ItemSlot.Weapon,
    IsTwoHand: true,
  },
  {
    IconName: 'inv_misc_cape_19',
    Stats: {
      [Stat.Stamina]: 61,
      [Stat.Intellect]: 61,
      [Stat.SpellPower]: 85,
      [Stat.HitRating]: 41,
      [Stat.HasteRating]: 56,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Yellow],
    SocketBonus: {
      [Stat.HitRating]: 4,
    },
    Name: 'Lich Wrappings',
    Id: 51584,
    Phase: 1,
    ItemSlot: ItemSlot.Back,
  },
  {
    IconName: 'inv_pants_cloth_35',
    Stats: {
      [Stat.Stamina]: 97,
      [Stat.Intellect]: 101,
      [Stat.Spirit]: 80,
      [Stat.SpellPower]: 149,
      [Stat.CritRating]: 96,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Yellow, SocketColor.Red, SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 9,
    },
    Name: 'Leggings of the Refracted Mind',
    Id: 51777,
    Phase: 1,
    ItemSlot: ItemSlot.Legs,
  },
  {
    IconName: 'inv_weapon_shortblade_101',
    Stats: {
      [Stat.Stamina]: 44,
      [Stat.Intellect]: 61,
      [Stat.SpellPower]: 657,
      [Stat.CritRating]: 47,
      [Stat.HitRating]: 61,
    },
    Quality: Quality.Epic,
    Unique: true,
    UniqueId: [51788, 51815],
    Phase: 1,
    Name: 'Bleak Coldarra Carver',
    Sources: [ItemSourceName.IcecrownCitadel10],
    Id: 51788,
    ItemSlot: ItemSlot.Weapon,
  },
  {
    IconName: 'inv_chest_cloth_78purple',
    Stats: {
      [Stat.Stamina]: 109,
      [Stat.Intellect]: 101,
      [Stat.SpellPower]: 140,
      [Stat.CritRating]: 76,
      [Stat.HasteRating]: 95,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Yellow, SocketColor.Red, SocketColor.Red],
    SocketBonus: {
      [Stat.SpellPower]: 9,
    },
    Name: 'Robes of Azure Downfall',
    Id: 51790,
    Phase: 1,
    ItemSlot: ItemSlot.Chest,
  },
  {
    IconName: 'inv_staff_109',
    Stats: {
      [Stat.Stamina]: 116,
      [Stat.Intellect]: 137,
      [Stat.SpellPower]: 701,
      [Stat.CritRating]: 145,
      [Stat.HasteRating]: 108,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Red, SocketColor.Yellow],
    SocketBonus: {
      [Stat.SpellPower]: 7,
    },
    Name: 'Halion, Staff of Forgotten Love',
    Sources: [ItemSourceName.IcecrownCitadel10],
    Id: 51799,
    Phase: 1,
    ItemSlot: ItemSlot.Weapon,
    IsTwoHand: true,
  },
  {
    IconName: 'inv_weapon_shortblade_101',
    Stats: {
      [Stat.Stamina]: 47,
      [Stat.Intellect]: 65,
      [Stat.SpellPower]: 701,
      [Stat.CritRating]: 51,
      [Stat.HasteRating]: 65,
    },
    Quality: Quality.Epic,
    Unique: true,
    Name: "Tel'thas, Dagger of the Blood King",
    Sources: [ItemSourceName.IcecrownCitadel10],
    Id: 51803,
    Phase: 1,
    ItemSlot: ItemSlot.Weapon,
  },
  {
    IconName: 'inv_chest_cloth_77',
    Stats: {
      [Stat.Stamina]: 123,
      [Stat.Intellect]: 115,
      [Stat.SpellPower]: 162,
      [Stat.CritRating]: 87,
      [Stat.HasteRating]: 108,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Yellow, SocketColor.Red, SocketColor.Red],
    SocketBonus: {
      [Stat.SpellPower]: 9,
    },
    Name: 'Robes of Azure Downfall',
    Id: 51813,
    Phase: 1,
    ItemSlot: ItemSlot.Chest,
  },
  {
    IconName: 'inv_weapon_shortblade_101',
    Stats: {
      [Stat.Stamina]: 50,
      [Stat.Intellect]: 61,
      [Stat.SpellPower]: 741,
      [Stat.CritRating]: 46,
      [Stat.HitRating]: 69,
    },
    Quality: Quality.Epic,
    Unique: true,
    Sockets: [SocketColor.Red],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    UniqueId: [51788, 51815],
    Phase: 1,
    Name: 'Bleak Coldarra Carver',
    Sources: [ItemSourceName.IcecrownCitadel10Heroic],
    Id: 51815,
    ItemSlot: ItemSlot.Weapon,
  },
  {
    IconName: 'inv_pants_cloth_35',
    Stats: {
      [Stat.Stamina]: 111,
      [Stat.Intellect]: 115,
      [Stat.Spirit]: 92,
      [Stat.SpellPower]: 171,
      [Stat.CritRating]: 108,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Yellow, SocketColor.Red, SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 9,
    },
    Name: 'Leggings of the Refracted Mind',
    Id: 51823,
    Phase: 1,
    ItemSlot: ItemSlot.Legs,
  },
  {
    IconName: 'inv_misc_cape_19',
    Stats: {
      [Stat.Stamina]: 69,
      [Stat.Intellect]: 69,
      [Stat.SpellPower]: 97,
      [Stat.HitRating]: 48,
      [Stat.HasteRating]: 63,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Yellow],
    SocketBonus: {
      [Stat.HitRating]: 4,
    },
    Name: 'Lich Wrappings',
    Id: 51826,
    Phase: 1,
    ItemSlot: ItemSlot.Back,
  },
  {
    IconName: 'inv_staff_106',
    Stats: {
      [Stat.Stamina]: 123,
      [Stat.Intellect]: 138,
      [Stat.SpellPower]: 741,
      [Stat.CritRating]: 111,
      [Stat.HitRating]: 150,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Red, SocketColor.Red, SocketColor.Yellow],
    SocketBonus: {
      [Stat.SpellPower]: 9,
    },
    Name: "Sister Svalna's Aether Staff",
    Sources: [ItemSourceName.IcecrownCitadel10Heroic],
    Id: 51828,
    Phase: 1,
    ItemSlot: ItemSlot.Weapon,
    IsTwoHand: true,
  },
  {
    IconName: 'inv_helmet_152',
    Stats: {
      [Stat.Stamina]: 123,
      [Stat.Intellect]: 123,
      [Stat.SpellPower]: 162,
      [Stat.CritRating]: 84,
      [Stat.HasteRating]: 108,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Meta, SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 9,
    },
    Name: 'Cowl of Malefic Repose',
    Sources: [ItemSourceName.IcecrownCitadel10Heroic],
    Id: 51837,
    Phase: 1,
    ItemSlot: ItemSlot.Head,
  },
  {
    IconName: 'inv_wand_35',
    Stats: {
      [Stat.Stamina]: 48,
      [Stat.Intellect]: 35,
      [Stat.Spirit]: 37,
      [Stat.SpellPower]: 51,
      [Stat.CritRating]: 20,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Blue],
    SocketBonus: {
      [Stat.Spirit]: 4,
    },
    Name: "Lana'thel's Bloody Nail",
    Id: 51838,
    Phase: 1,
    ItemSlot: ItemSlot.Wand,
  },
  {
    IconName: 'inv_misc_cape_20',
    Stats: {
      [Stat.Stamina]: 69,
      [Stat.Intellect]: 69,
      [Stat.SpellPower]: 97,
      [Stat.HasteRating]: 52,
      [Stat.Mp5]: 30,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Red],
    SocketBonus: {
      [Stat.Mp5]: 2,
    },
    Name: "Heartsick Mender's Cape",
    Id: 51848,
    Phase: 1,
    ItemSlot: ItemSlot.Back,
  },
  {
    IconName: 'item_icecrownringc',
    Stats: {
      [Stat.Stamina]: 65,
      [Stat.Intellect]: 70,
      [Stat.SpellPower]: 97,
      [Stat.CritRating]: 67,
      [Stat.HasteRating]: 41,
    },
    Quality: Quality.Epic,
    Unique: true,
    Sockets: [SocketColor.Red],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    UniqueId: [51381, 51849],
    Phase: 1,
    Name: 'Cerise Coiled Ring',
    Id: 51849,
    ItemSlot: ItemSlot.Finger,
  },
  {
    IconName: 'inv_boots_cloth_27',
    Stats: {
      [Stat.Stamina]: 92,
      [Stat.Intellect]: 92,
      [Stat.Spirit]: 64,
      [Stat.SpellPower]: 122,
      [Stat.CritRating]: 80,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Blue, SocketColor.Yellow],
    Name: 'Pale Corpse Boots',
    Id: 51850,
    Phase: 1,
    ItemSlot: ItemSlot.Feet,
  },
  {
    IconName: 'inv_chest_cloth_80',
    Stats: {
      [Stat.Stamina]: 123,
      [Stat.Intellect]: 123,
      [Stat.Spirit]: 90,
      [Stat.SpellPower]: 162,
      [Stat.HasteRating]: 102,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Red, SocketColor.Red, SocketColor.Yellow],
    SocketBonus: {
      [Stat.SpellPower]: 9,
    },
    Name: 'Bloodsoul Raiment',
    Id: 51851,
    Phase: 1,
    ItemSlot: ItemSlot.Chest,
  },
  {
    IconName: 'inv_wand_34',
    Stats: {
      [Stat.Stamina]: 48,
      [Stat.Intellect]: 35,
      [Stat.SpellPower]: 51,
      [Stat.HitRating]: 29,
      [Stat.HasteRating]: 28,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Yellow],
    SocketBonus: {
      [Stat.HasteRating]: 4,
    },
    Name: 'Wand of Ruby Claret',
    Id: 51852,
    Phase: 1,
    ItemSlot: ItemSlot.Wand,
  },
  {
    IconName: 'inv_shoulder_114',
    Stats: {
      [Stat.Stamina]: 92,
      [Stat.Intellect]: 92,
      [Stat.SpellPower]: 122,
      [Stat.HitRating]: 64,
      [Stat.HasteRating]: 80,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Yellow, SocketColor.Yellow],
    SocketBonus: {
      [Stat.SpellPower]: 7,
    },
    Name: 'Shoulders of Ruinous Senility',
    Id: 51859,
    Phase: 1,
    ItemSlot: ItemSlot.Shoulders,
  },
  {
    IconName: 'inv_belt_64',
    Stats: {
      [Stat.Stamina]: 92,
      [Stat.Intellect]: 92,
      [Stat.SpellPower]: 122,
      [Stat.CritRating]: 86,
      [Stat.HasteRating]: 54,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Red, SocketColor.Yellow],
    SocketBonus: {
      [Stat.SpellPower]: 7,
    },
    Name: 'Cauterized Cord',
    Id: 51862,
    Phase: 1,
    ItemSlot: ItemSlot.Waist,
  },
  {
    IconName: 'inv_jewelry_talisman_16',
    Stats: {
      [Stat.Stamina]: 71,
      [Stat.Intellect]: 68,
      [Stat.SpellPower]: 97,
      [Stat.CritRating]: 60,
      [Stat.HitRating]: 52,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Name: 'Pendant of Split Veins',
    Sources: [ItemSourceName.IcecrownCitadel10Heroic],
    Id: 51863,
    Phase: 1,
    ItemSlot: ItemSlot.Neck,
  },
  {
    IconName: 'inv_jewelry_necklace_49',
    Stats: {
      [Stat.Stamina]: 71,
      [Stat.Intellect]: 68,
      [Stat.SpellPower]: 97,
      [Stat.HasteRating]: 60,
      [Stat.Mp5]: 26,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Name: 'Choker of Filthy Diamonds',
    Sources: [ItemSourceName.IcecrownCitadel10Heroic],
    Id: 51871,
    Phase: 1,
    ItemSlot: ItemSlot.Neck,
  },
  {
    IconName: 'inv_bracer_44',
    Stats: {
      [Stat.Stamina]: 69,
      [Stat.Intellect]: 69,
      [Stat.SpellPower]: 97,
      [Stat.HitRating]: 38,
      [Stat.HasteRating]: 69,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Red],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Name: 'Ether-Soaked Bracers',
    Id: 51872,
    Phase: 1,
    ItemSlot: ItemSlot.Wrist,
  },
  {
    IconName: 'inv_gauntlets_92',
    Stats: {
      [Stat.Stamina]: 92,
      [Stat.Intellect]: 92,
      [Stat.Spirit]: 54,
      [Stat.SpellPower]: 122,
      [Stat.HasteRating]: 86,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Blue, SocketColor.Red],
    SocketBonus: {
      [Stat.Spirit]: 6,
    },
    Name: 'Gloves of Broken Fingers',
    Id: 51874,
    Phase: 1,
    ItemSlot: ItemSlot.Hands,
  },
  {
    IconName: 'inv_kilt_cloth_02',
    Stats: {
      [Stat.Stamina]: 123,
      [Stat.Intellect]: 123,
      [Stat.SpellPower]: 162,
      [Stat.CritRating]: 96,
      [Stat.HasteRating]: 96,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Yellow, SocketColor.Yellow, SocketColor.Red],
    SocketBonus: {
      [Stat.SpellPower]: 9,
    },
    Name: 'Kilt of Untreated Wounds',
    Id: 51882,
    Phase: 1,
    ItemSlot: ItemSlot.Legs,
  },
  {
    IconName: 'inv_shoulder_119',
    Stats: {
      [Stat.Stamina]: 92,
      [Stat.Intellect]: 92,
      [Stat.Spirit]: 85,
      [Stat.SpellPower]: 122,
      [Stat.CritRating]: 56,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Yellow, SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 7,
    },
    Name: "Bloodstained Surgeon's Shoulderguards",
    Id: 51883,
    Phase: 1,
    ItemSlot: ItemSlot.Shoulders,
  },
  {
    IconName: 'inv_jewelry_ring_82',
    Stats: {
      [Stat.Stamina]: 69,
      [Stat.Intellect]: 69,
      [Stat.SpellPower]: 97,
      [Stat.HasteRating]: 52,
      [Stat.Mp5]: 30,
    },
    Quality: Quality.Epic,
    Unique: true,
    Sockets: [SocketColor.Red],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    UniqueId: [50986, 51884],
    Phase: 1,
    Name: 'Signet of Putrefaction',
    Id: 51884,
    ItemSlot: ItemSlot.Finger,
  },
  {
    IconName: 'inv_staff_107',
    Stats: {
      [Stat.Stamina]: 123,
      [Stat.Intellect]: 138,
      [Stat.SpellPower]: 741,
      [Stat.HitRating]: 111,
      [Stat.HasteRating]: 150,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Red, SocketColor.Blue, SocketColor.Yellow],
    SocketBonus: {
      [Stat.HasteRating]: 8,
    },
    Name: 'Abracadaver',
    Sources: [ItemSourceName.IcecrownCitadel10Heroic],
    Id: 51887,
    Phase: 1,
    ItemSlot: ItemSlot.Weapon,
    IsTwoHand: true,
  },
  {
    IconName: 'item_icecrownnecklacea',
    Stats: {
      [Stat.Stamina]: 69,
      [Stat.Intellect]: 69,
      [Stat.SpellPower]: 97,
      [Stat.CritRating]: 62,
      [Stat.HasteRating]: 49,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Yellow],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Name: 'Soulcleave Pendant',
    Sources: [ItemSourceName.IcecrownCitadel10Heroic],
    Id: 51894,
    Phase: 1,
    ItemSlot: ItemSlot.Neck,
  },
  {
    IconName: 'inv_helmet_156',
    Stats: {
      [Stat.Stamina]: 123,
      [Stat.Intellect]: 123,
      [Stat.Spirit]: 100,
      [Stat.SpellPower]: 171,
      [Stat.HasteRating]: 84,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Meta, SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 9,
    },
    Name: "Thaumaturge's Crackling Cowl",
    Sources: [ItemSourceName.IcecrownCitadel10Heroic],
    Id: 51896,
    Phase: 1,
    ItemSlot: ItemSlot.Head,
  },
  {
    IconName: 'inv_staff_107',
    Stats: {
      [Stat.Stamina]: 105,
      [Stat.Intellect]: 111,
      [Stat.Spirit]: 150,
      [Stat.SpellPower]: 741,
      [Stat.HasteRating]: 150,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Blue, SocketColor.Blue, SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 9,
    },
    Name: "Mag'hari Chieftain's Staff",
    Sources: [ItemSourceName.IcecrownCitadel10Heroic],
    Id: 51898,
    Phase: 1,
    ItemSlot: ItemSlot.Weapon,
    IsTwoHand: true,
  },
  {
    IconName: 'inv_boots_cloth_24',
    Stats: {
      [Stat.Stamina]: 92,
      [Stat.Intellect]: 92,
      [Stat.SpellPower]: 122,
      [Stat.CritRating]: 86,
      [Stat.HitRating]: 54,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Yellow, SocketColor.Blue],
    SocketBonus: {
      [Stat.SpellPower]: 7,
    },
    Name: 'Icecrown Spire Sandals',
    Id: 51899,
    Phase: 1,
    ItemSlot: ItemSlot.Feet,
  },
  {
    IconName: 'inv_weapon_shortblade_103',
    Stats: {
      [Stat.Stamina]: 67,
      [Stat.Intellect]: 59,
      [Stat.SpellPower]: 741,
      [Stat.HasteRating]: 51,
      [Stat.Mp5]: 27,
    },
    Quality: Quality.Epic,
    Unique: true,
    Sockets: [SocketColor.Yellow],
    SocketBonus: {
      [Stat.HasteRating]: 4,
    },
    UniqueId: [50793, 51910],
    Phase: 1,
    Name: 'Midnight Sun',
    Sources: [ItemSourceName.IcecrownCitadel10Heroic],
    Id: 51910,
    ItemSlot: ItemSlot.Weapon,
  },
  {
    IconName: 'inv_bracer_47',
    Stats: {
      [Stat.Stamina]: 69,
      [Stat.Intellect]: 69,
      [Stat.Spirit]: 58,
      [Stat.SpellPower]: 97,
      [Stat.CritRating]: 53,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Blue],
    SocketBonus: {
      [Stat.Spirit]: 4,
    },
    Name: 'Bracers of Dark Blessings',
    Id: 51918,
    Phase: 1,
    ItemSlot: ItemSlot.Wrist,
  },
  {
    IconName: 'inv_gauntlets_88',
    Stats: {
      [Stat.Stamina]: 92,
      [Stat.Intellect]: 92,
      [Stat.SpellPower]: 122,
      [Stat.HitRating]: 80,
      [Stat.HasteRating]: 64,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Yellow, SocketColor.Yellow],
    SocketBonus: {
      [Stat.SpellPower]: 7,
    },
    Name: "Sister's Handshrouds",
    Id: 51921,
    Phase: 1,
    ItemSlot: ItemSlot.Hands,
  },
  {
    IconName: 'inv_misc_bone_elfskull_01',
    Stats: {
      [Stat.Stamina]: 69,
      [Stat.Intellect]: 69,
      [Stat.SpellPower]: 97,
      [Stat.CritRating]: 45,
      [Stat.HitRating]: 65,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Red],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Name: "Scourgelord's Baton",
    Sources: [ItemSourceName.IcecrownCitadel10Heroic],
    Id: 51922,
    Phase: 1,
    ItemSlot: ItemSlot.OffHand,
  },
  {
    IconName: 'inv_belt_68',
    Stats: {
      [Stat.Stamina]: 92,
      [Stat.Intellect]: 92,
      [Stat.Spirit]: 62,
      [Stat.SpellPower]: 122,
      [Stat.HasteRating]: 78,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Blue, SocketColor.Yellow],
    SocketBonus: {
      [Stat.SpellPower]: 7,
    },
    Name: 'Cord of the Patronizing Practitioner',
    Id: 51930,
    Phase: 1,
    ItemSlot: ItemSlot.Waist,
  },
  {
    IconName: 'inv_sword_152',
    Stats: {
      [Stat.Stamina]: 67,
      [Stat.Intellect]: 59,
      [Stat.SpellPower]: 741,
      [Stat.HitRating]: 52,
      [Stat.HasteRating]: 56,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Yellow],
    SocketBonus: {
      [Stat.HasteRating]: 4,
    },
    UniqueId: [50771, 51932],
    Phase: 1,
    Name: 'Frost Needle',
    Sources: [ItemSourceName.IcecrownCitadel10Heroic],
    Id: 51932,
    ItemSlot: ItemSlot.Weapon,
  },
  {
    IconName: 'inv_weapon_shortblade_101',
    Stats: {
      [Stat.Stamina]: 53,
      [Stat.Intellect]: 66,
      [Stat.SpellPower]: 791,
      [Stat.CritRating]: 49,
      [Stat.HasteRating]: 74,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Red],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Name: "Tel'thas, Dagger of the Blood King",
    Sources: [ItemSourceName.IcecrownCitadel10Heroic],
    Id: 51939,
    Phase: 1,
    ItemSlot: ItemSlot.Weapon,
  },
  {
    IconName: 'inv_staff_109',
    Stats: {
      [Stat.Stamina]: 126,
      [Stat.Intellect]: 153,
      [Stat.SpellPower]: 793,
      [Stat.CritRating]: 161,
      [Stat.HasteRating]: 120,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Red, SocketColor.Red, SocketColor.Red],
    SocketBonus: {
      [Stat.SpellPower]: 9,
    },
    Name: 'Halion, Staff of Forgotten Love',
    Sources: [ItemSourceName.IcecrownCitadel10Heroic],
    Id: 51943,
    Phase: 1,
    ItemSlot: ItemSlot.Weapon,
    IsTwoHand: true,
  },
  {
    IconName: 'inv_misc_cape_20',
    Stats: {
      [Stat.Stamina]: 65,
      [Stat.Intellect]: 65,
      [Stat.SpellPower]: 91,
      [Stat.HasteRating]: 57,
      [Stat.Mp5]: 24,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Red],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Name: "Abduction's Cover",
    Id: 53115,
    Phase: 1,
    ItemSlot: ItemSlot.Back,
  },
  {
    IconName: 'item_icecrownringc',
    Stats: {
      [Stat.Stamina]: 65,
      [Stat.Intellect]: 65,
      [Stat.SpellPower]: 91,
      [Stat.CritRating]: 57,
      [Stat.HitRating]: 49,
    },
    Quality: Quality.Epic,
    Unique: true,
    Sockets: [SocketColor.Red],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    UniqueId: [53116, 54563],
    Phase: 1,
    Name: "Saviana's Tribute",
    Id: 53116,
    ItemSlot: ItemSlot.Finger,
  },
  {
    IconName: 'inv_belt_66green',
    Stats: {
      [Stat.Stamina]: 86,
      [Stat.Intellect]: 86,
      [Stat.SpellPower]: 114,
      [Stat.CritRating]: 81,
      [Stat.HitRating]: 50,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Red, SocketColor.Red],
    SocketBonus: {
      [Stat.SpellPower]: 7,
    },
    Name: 'Misbegotten Belt',
    Id: 53118,
    Phase: 1,
    ItemSlot: ItemSlot.Waist,
  },
  {
    IconName: 'inv_bracer_45',
    Stats: {
      [Stat.Stamina]: 73,
      [Stat.Intellect]: 73,
      [Stat.SpellPower]: 104,
      [Stat.CritRating]: 56,
      [Stat.HasteRating]: 64,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Red],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Name: 'Bracers of Fiery Night',
    Id: 53486,
    Phase: 1,
    ItemSlot: ItemSlot.Wrist,
  },
  {
    IconName: 'inv_misc_cape_16',
    Stats: {
      [Stat.Stamina]: 73,
      [Stat.Intellect]: 73,
      [Stat.SpellPower]: 104,
      [Stat.CritRating]: 56,
      [Stat.HasteRating]: 64,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Red],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Name: 'Cloak of Burning Dusk',
    Id: 53489,
    Phase: 1,
    ItemSlot: ItemSlot.Back,
  },
  {
    IconName: 'item_icecrownringb',
    Stats: {
      [Stat.Stamina]: 73,
      [Stat.Intellect]: 73,
      [Stat.SpellPower]: 104,
      [Stat.CritRating]: 56,
      [Stat.Mp5]: 32,
    },
    Quality: Quality.Epic,
    Unique: true,
    Sockets: [SocketColor.Red],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    UniqueId: [53490, 54585],
    Phase: 1,
    Name: 'Ring of Phased Regeneration',
    Id: 53490,
    ItemSlot: ItemSlot.Finger,
  },
  {
    IconName: 'inv_misc_cape_20',
    Stats: {
      [Stat.Stamina]: 73,
      [Stat.Intellect]: 73,
      [Stat.SpellPower]: 104,
      [Stat.HasteRating]: 64,
      [Stat.Mp5]: 28,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Red],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Name: "Abduction's Cover",
    Id: 54556,
    Phase: 1,
    ItemSlot: ItemSlot.Back,
  },
  {
    IconName: 'inv_belt_66green',
    Stats: {
      [Stat.Stamina]: 98,
      [Stat.Intellect]: 98,
      [Stat.SpellPower]: 131,
      [Stat.CritRating]: 92,
      [Stat.HitRating]: 59,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Red, SocketColor.Red],
    SocketBonus: {
      [Stat.SpellPower]: 7,
    },
    Name: 'Misbegotten Belt',
    Id: 54562,
    Phase: 1,
    ItemSlot: ItemSlot.Waist,
  },
  {
    IconName: 'item_icecrownringc',
    Stats: {
      [Stat.Stamina]: 73,
      [Stat.Intellect]: 73,
      [Stat.SpellPower]: 104,
      [Stat.CritRating]: 64,
      [Stat.HitRating]: 56,
    },
    Quality: Quality.Epic,
    Unique: true,
    Sockets: [SocketColor.Red],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    UniqueId: [53116, 54563],
    Phase: 1,
    Name: "Saviana's Tribute",
    Id: 54563,
    ItemSlot: ItemSlot.Finger,
  },
  {
    IconName: 'inv_misc_rubysanctum2',
    Stats: {
      [Stat.HasteRating]: 163,
    },
    Quality: Quality.Epic,
    Unique: true,
    UniqueId: [54572, 54588],
    Phase: 1,
    Name: 'Charred Twilight Scale',
    Id: 54572,
    ItemSlot: ItemSlot.Trinket,
  },
  {
    IconName: 'inv_bracer_45',
    Stats: {
      [Stat.Stamina]: 83,
      [Stat.Intellect]: 83,
      [Stat.SpellPower]: 118,
      [Stat.CritRating]: 65,
      [Stat.HasteRating]: 73,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Red],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Name: 'Bracers of Fiery Night',
    Id: 54582,
    Phase: 1,
    ItemSlot: ItemSlot.Wrist,
  },
  {
    IconName: 'inv_misc_cape_16',
    Stats: {
      [Stat.Stamina]: 83,
      [Stat.Intellect]: 83,
      [Stat.SpellPower]: 118,
      [Stat.CritRating]: 65,
      [Stat.HasteRating]: 73,
    },
    Quality: Quality.Epic,
    Sockets: [SocketColor.Red],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    Name: 'Cloak of Burning Dusk',
    Id: 54583,
    Phase: 1,
    ItemSlot: ItemSlot.Back,
  },
  {
    IconName: 'item_icecrownringb',
    Stats: {
      [Stat.Stamina]: 83,
      [Stat.Intellect]: 83,
      [Stat.SpellPower]: 118,
      [Stat.HasteRating]: 65,
      [Stat.Mp5]: 36,
    },
    Quality: Quality.Epic,
    Unique: true,
    Sockets: [SocketColor.Red],
    SocketBonus: {
      [Stat.SpellPower]: 5,
    },
    UniqueId: [53490, 54585],
    Phase: 1,
    Name: 'Ring of Phased Regeneration',
    Id: 54585,
    ItemSlot: ItemSlot.Finger,
  },
  {
    IconName: 'inv_misc_rubysanctum2',
    Stats: {
      [Stat.HasteRating]: 184,
    },
    Quality: Quality.Epic,
    Unique: true,
    UniqueId: [54572, 54588],
    Phase: 1,
    Name: 'Charred Twilight Scale',
    Id: 54588,
    ItemSlot: ItemSlot.Trinket,
  },
  {
    IconName: 'inv_misc_cape_16',
    Stats: {
      [Stat.Stamina]: 51,
      [Stat.Intellect]: 51,
      [Stat.SpellPower]: 78,
      [Stat.CritRating]: 45,
      [Stat.HasteRating]: 45,
    },
    Quality: Quality.Epic,
    Name: "Shroud of Winter's Chill",
    Id: 54804,
    Phase: 1,
    ItemSlot: ItemSlot.Back,
  },
  {
    IconName: 'inv_misc_cape_16',
    Stats: {
      [Stat.Stamina]: 51,
      [Stat.Intellect]: 51,
      [Stat.Spirit]: 45,
      [Stat.SpellPower]: 78,
      [Stat.HasteRating]: 45,
    },
    Quality: Quality.Epic,
    Name: 'Cloak of the Frigid Winds',
    Id: 54805,
    Phase: 1,
    ItemSlot: ItemSlot.Back,
  },
  {
    IconName: 'inv_staff_78',
    Stats: {
      [Stat.Stamina]: 92,
      [Stat.Intellect]: 92,
      [Stat.SpellPower]: 550,
      [Stat.CritRating]: 80,
      [Stat.HasteRating]: 80,
    },
    Quality: Quality.Epic,
    Name: 'Frostscythe of Lord Ahune',
    Sources: [ItemSourceName.Ahune],
    Id: 54806,
    Phase: 1,
    ItemSlot: ItemSlot.Weapon,
    IsTwoHand: true,
  },
]
